/**
 * @file 垫片集合
 * @author quda
 * TODO: 临时处理，后续用插件代替
 */
if (!Object.values) {
  Object.values = function (obj) {
    if (obj !== Object(obj)) {
      throw new TypeError('Object.values called on a non-object');
    }

    var val = [];
    var key;

    for (key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        val.push(obj[key]);
      }
    }

    return val;
  };
}

if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target) {
      // .length of function is 2
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 0; index < (arguments.length <= 1 ? 0 : arguments.length - 1); index++) {
        var nextSource = index + 1 < 1 || arguments.length <= index + 1 ? undefined : arguments[index + 1];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }

      return to;
    },
    writable: true,
    configurable: true
  });
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass;

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var inheritsLoose = _inheritsLoose;

/**
 * @file 关于Dom元素尺寸类文件.
 * @author quda
 */

/**
 * Dom元素大小（以像素表示)
 * @param {Number} width
 * @param {Number} height
 */
var Size = function Size(width, height) {
  var _this = this;

  this.width = void 0;
  this.height = void 0;

  this.equals = function (size) {
    return size && _this.width === size.width && _this.height === size.height;
  };

  this.width = width || 0;
  this.height = height || 0;
}
/**
 * 判断两个Size对象的大小是否相等
 * @param {Size} 需要对比的Size对象
 */
;

/**
 * @file 关于地理点坐标类文件.
 * @author quda
 */

/**
 * 基本点类,代表地理点坐标;
 * 坐标支持base64编码
 * @param {number} lng - 墨卡托X(经度).
 * @param {number} lat - 墨卡托Y(纬度);.
 */
var Point =
/*#__PURE__*/
function () {
  function Point(lng, lat) {
    this.lng = void 0;
    this.lat = void 0;
    this.lng = +lng;
    this.lat = +lat;
  }
  /**
   * 坐标点对比
   * @param {Point} other - 待比较的坐标点
   * @return {boolean} - 是否为同一点
   */


  var _proto = Point.prototype;

  _proto.equals = function equals(other) {
    return other && this.lat === other.lat && this.lng === other.lng;
  };

  return Point;
}();

/**
 * @file 派发的事件类型常量
 * @author quda
 */
var EVENT_TYPE = {
  /**
   * 页面刷新，启动渲染线程
   */
  REFRESH: 'refresh',

  /**
   * 场景点数据加载成功
   */
  DATA_LOADED: 'dataload',

  /**
   * 缩略图加载成功
   */
  THUMB_LOADED: 'thumb_loaded',

  /**
   * 设置视口动作
   * 内部事件
   */
  SET_POV: 'set_pov',

  /**
   * 视口内容改变，对应相机的调整
   */
  POV_CHANGED: 'pov_changed',

  /**
   * 视口内容改变结束，一般用于开启惯性动画的场景
   */
  POV_CHANGED_END: 'pov_changed_end',

  /**
   * zoom等级改变
   */
  ZOOM_CHANGED: 'zoom_changed',

  /**
   * 视口容器尺寸改变
   */
  SIZE_CHANGED: 'size_changed',

  /**
   * 设置全景PID
   */
  SET_ID: 'set_id',

  /**
   * 全景PID改变
   */
  ID_CHANGED: 'id_changed',

  /**
   * touchstart or mousedown
   */
  TOUCH_START: 'touchstart',

  /**
   * touchend or mouseup
   */
  TOUCH_END: 'touchend',

  /**
   * 全景图单击
   */
  CLICK: 'click',

  /**
   * 双击
   */
  DOUBLE_CLICK: 'dblclick',

  /**
   * 道路箭头点击
   */
  LINK_CLICK: 'link_click',

  /**
   * 添加覆盖物
   */
  OVERLAY_ADD: 'overlay_add',

  /**
   * 删除覆盖物
   */
  OVERLAY_REMOVE: 'overlay_remove',

  /**
   * 清除所有覆盖物
   */
  OVERLAYS_CLEAR: 'overlays_clear',

  /**
   * 全景渲染异常
   */
  PANO_ERROR: 'pano_error',

  /**
   * 道路箭头是否显示发生变更
   */
  LINK_VISIBLE_CHANGE: 'links_visible_changed',

  /**
   * 销毁事件
   */
  DESTROY: 'destroy',

  /**
   * 场景过渡完成
   */
  SCENE_CHANGE_END: 'scene_change_end'
};

/**
 * @file 全景引擎常量配置
 * @author quda
 */
var ConstantConfig = {
  /**
   * 内景标识
   * @type {string}
   */
  TYPE_INNER: 'inter',

  /**
   * 外景标识
   * @type {string}
   */
  TYPE_STREET: 'street',

  /**
   * 球模型半径
   * @type {number}
   */
  RADIUS: 3000,

  /**
   * 球模型列数，固定为16
   * @type {number}
   */
  COLS: 16,

  /**
   * 球模型行数，固定为8
   * @type {number}
   */
  ROWS: 8,

  /**
   * 全景图允许的最大级别
   * @type {number}
   */
  TILE_MAX_ZOOM: 4,

  /**
   * 全景图允许的最小级别
   * @type {number}
   */
  TILE_MIN_ZOOM: 1,

  /**
   * 全景允许的最小垂直视角
   * @type {number}
   */
  MIN_PITCH: -90,

  /**
   * 全景允许的最大垂直视角
   * @type {number}
   */
  MAX_PITCH: 90,

  /**
   * 全景允许的最大级别
   * @type {number}
   */
  MAX_ZOOM: 4,

  /**
   * 全景允许的最小级别
   * @type {number}
   */
  MIN_ZOOM: 1,

  /**
   * 全景图块地址
   * @type {Array}
   */
  TILE_BASE_URLS: ['//mapsv0.bdimg.com/scape/', '//mapsv1.bdimg.com/scape/'],

  /**
   * 道路箭头纹理
   * @type {string}
   * @description 包含箭头主体、箭头阴影、箭头文字
   */
  TOPO_ARROW_TEXTURE: '//webmap0.bdimg.com/wolfman/static/pano/images/webgl/topo_arrow_06f0f2e.png',

  /**
   * 全景鱼眼动画持续时间
   * @type {number} - ms
   */
  FISHEYE_DURATION: 1500,

  /**
   * 全景鱼眼动画持续时间
   * @type {number} - ms
   */
  FISHEYE_DELAY: 2000
};

/**
 * @file 工具函数集合
 * @author quda
 */
/**
 * 当前浏览器环境判断
 */

var plat = function () {
  var res = {};
  var ua = (navigator.userAgent || '').toLowerCase();
  /* eslint-disable */

  var mobileReg = /android|webos|ip(hone|ad|od)|opera (mini|mobi|tablet)|iemobile|windows.+(phone|touch)|mobile|fennec|kindle (Fire)|Silk|maemo|blackberry|playbook; (touch|kbd)|Symbian(OS)|Ubuntu Touch/i;
  /* eslint-enable */

  var iosReg = /ip(hone|ad|od)/i;
  res.isAndroid = ua.includes('android');
  res.isIos = iosReg.test(ua);
  res.isWeixin = ua.includes('micromessenger');
  res.isWeibo = ua.includes('weibo');
  res.isWeChatOrWeiBo = res.isWeixin && res.isWeibo;
  res.isBaiduMap = ua.includes('baidumap_');
  res.isMobile = mobileReg.test(ua);
  res.isPc = !res.isMobile;
  return res;
}();
/**
 * 判断目标参数是否为function或Function实例
 * @param {Any} source 目标参数
 * @return {boolean} 类型判断结果
 */

var isFunction = function isFunction(source) {
  // chrome下,'function' == typeof /a/ 为true，同时注意async function
  var isFn = '[object Function]' === Object.prototype.toString.call(source);
  var isAsyncFn = '[object AsyncFunction]' === Object.prototype.toString.call(source);
  return isFn || isAsyncFn;
};
/**
 * 对象合并
 * @param {Object} target - 目标对象
 * @param {...Object} args - 源对象
 * @return {Object} - 目标对象
 */

var extend = function extend(target) {
  var argsLen = arguments.length <= 1 ? 0 : arguments.length - 1;

  for (var i = 0; i < argsLen; i++) {
    var source = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
}; // ============ ↓↓角度计算相关方法↓↓ ============
/**
 * 角度转弧度
 * @method degToRad
 * @param  {number} degree - 角度
 * @return {number} - 弧度
 */

var degToRad = function degToRad(degree) {
  return degree * Math.PI / 180;
};
/**
 * 弧度转角度
 * @method radToDeg
 * @param  {number} rad - 弧度
 * @return {number} - 角度
 */

var radToDeg = function radToDeg(rad) {
  return rad * 180 / Math.PI;
};
/**
 * 角度[0,360)归一化，转换角度到[0,360)区间对应的值
 * @param  {number} degree   角度值制的值
 * @return {number}
 */

var degreeNormalized = function degreeNormalized(degree) {
  return degree - Math.floor(degree / 360) * 360;
};

/**
 * 获取当前时间戳
 * @return {number} - time (ms)
 */

var getNow = function getNow() {
  return Date.now();
};
/**
 * 获取设备屏幕的像素密度信息，如果没有则返回1
 *
 * @return {number} 设备像素密度
 */

function getDeviceRatio() {
  return window.devicePixelRatio || 1;
}
/**
 * 粗略计算两点之距离
 * @param {Pixel} px1 - 点1
 * @param {Pixel} px2 - 点2
 * @return {number} - 距离
 */

var getDistanceByPixel = function getDistanceByPixel(px1, px2) {
  if (!px1 || !px2) {
    return 0;
  }

  return Math.round(Math.sqrt(Math.pow(px1.x - px2.x, 2) + Math.pow(px1.y - px2.y, 2)));
};
/**
 * 判断当前环境是否支持webGL
 * @return {boolean} - 是否支持webGL
 */

var isSupportWebGL = function isSupportWebGL() {
  var self = isSupportWebGL;

  if (typeof self._supportWebGL === 'boolean') {
    return self._supportWebGL;
  }

  if (!window.WebGLRenderingContext) {
    self._supportWebGL = false;
    return false;
  } // 检测创建gl环境是否成功


  var gl = null;
  var canvas = document.createElement('canvas');

  try {
    gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

    if (gl && gl instanceof WebGLRenderingContext) {
      self._supportWebGL = true;
    }
  } catch (e) {
    self._supportWebGL = false;
  }

  if (gl === null) {
    self._supportWebGL = false;
  }

  return self._supportWebGL;
};
/**
 * 获取一个数组中的最大和最小值
 *     {
 *         min:'',
 *         max:''
 *     }
 * @param  {Array} arr - 求最大和最小值的数组
 * @return {Object} - 包含最大和最小值的对象
 */

var getMinAndMax = function getMinAndMax(arr) {
  var min = Number.MAX_VALUE;
  var max = -Number.MAX_VALUE;
  var iterator;

  for (var i = arr.length - 1; i >= 0; i--) {
    iterator = arr[i];

    if (min > iterator) {
      min = iterator;
    }

    if (max < iterator) {
      max = iterator;
    }
  }

  return {
    min: min,
    max: max
  };
};
/**
 * 封装dom相关操作
 */

var dom = {
  /**
   * 从文档中获取指定的DOM元素
   * @param {string|HTMLElement} id - 元素的id或DOM元素
   * @return {HTMLElement|null} - 获取的元素，查找不到时返回null,如果参数不合法，直接返回参数
   */
  g: function g(id) {
    if ('string' === typeof id || id instanceof String) {
      return document.getElementById(id);
    } else if (id && id.nodeName && (id.nodeType === 1 || id.nodeType === 9)) {
      return id;
    }

    return null;
  },

  /**
   * 显示目标元素，即将目标元素的display属性还原成默认值
   * @param {HTMLElement|string} element 目标元素或目标元素的id
   * @returns {HTMLElement} 目标元素
   */
  show: function show(element) {
    var $el = dom.g(element);
    $el && ($el.style.display = '');
    return $el;
  },

  /**
   * 隐藏目标元素
   * @param {HTMLElement|string} element 目标元素或目标元素的id
   * @returns {HTMLElement} 目标元素
   */
  hide: function hide(element) {
    var $el = dom.g(element);
    $el && ($el.style.display = 'none');
    return element;
  },
  create: function create(tagName) {
    var attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var e = document.createElement(tagName);

    for (var key in attr) {
      if (Object.prototype.hasOwnProperty.call(attr, key)) {
        e.setAttribute(key, attr[key]);
      }
    }

    return e;
  },

  /**
   * 获取元素的currentStyle
   * @TODO: 与老版本实现不一致
   *
   * @param {HTMLElement} el - 元素
   * @return {CSSStyleDeclaration} - 元素currentStyle
   */
  getCurrentStyle: function getCurrentStyle(el) {
    return window.getComputedStyle(el, null);
  }
};

/**
 * @file jsonp跨域请求
 * @author quda
 *
 * @param {string} url 请求url
 * @param {Object} param 请求参数
 * @param {Function} callback 回调函数
 * @return {boolean} false
 */
var jsonp = function jsonp(url, param, options) {
  var timer;
  var script;
  var target;
  var query = '';
  var queries = [];
  var md5 = Math.ceil(Math.random() * 100000);
  var callbackName = 'jsonp' + md5;
  var mark = url.indexOf('?') > 0 ? '&' : '?';
  var defaultOptions = {
    jsonpCallback: 'jsonp',
    // 全局回调函数前缀
    timeout: 50000,
    // 默认超时时间
    jsonp: 'callback' // JSONP回调查询参数的名称

  };
  options = Object.assign({}, defaultOptions, options);

  for (var key in param) {
    if ({}.hasOwnProperty.call(param, key)) {
      if (_typeof_1(param[key]) === 'object') {
        query = key + '=' + JSON.stringify(param[key]);
      } else {
        query = key + '=' + param[key];
      }

      queries.push(query);
    }
  }

  url += mark + queries.join('&');
  target = document.getElementsByTagName('script')[0] || document.head;
  url = url + '&' + options.jsonp + '=' + callbackName;
  script = document.createElement('script');
  script.src = url;
  script.type = 'text/javascript';
  target.parentNode.appendChild(script, target);

  function clean() {
    script.parentNode && script.parentNode.removeChild(script);
    timer && clearTimeout(timer);
    window[callbackName] = null;
  }

  return new Promise(function (resolve, reject) {
    window[callbackName] = function (data) {
      if (data && 'string' === typeof data) {
        try {
          data = JSON.parse(data);
        } catch (e) {
          data = {};
          console.error('[ERROR] Parse Error.');
        }
      }

      resolve(data);
      clean();
    }; // 加载错误


    script.onerror = function (err) {
      clean();
      reject({
        errno: -2,
        errmsg: "[ERROR] Load Error: ".concat(err),
        data: {}
      });
    }; // 超时


    if (options.timeout) {
      timer = setTimeout(function () {
        clean();
        reject({
          errno: -3,
          errmsg: '[ERROR] Time out.',
          data: {}
        });
      }, options.timeout);
    }
  });
};

/**
 * @file 缓存管理器
 * @author mawenjie01, quda
 */
var CachePool =
/*#__PURE__*/
function () {
  /**
   * cache pool 容量
   * @type {number}
   */

  /**
   * 存储对象
   * @type {Map}
   */

  /**
   * 存储Key快照
   * @type {Map}
   */

  /**
   * cache pool 配置项
   * @type {Map}
   */
  function CachePool() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this._size = 0;
    this._cache = void 0;
    this.keyList = [];
    this._options = void 0;
    this._size = size;
    this._cache = new Map();
    var defaultOptions = {
      // 清除的回调函数
      clearCallback: null
    };
    this._options = Object.assign({}, defaultOptions, options);
  }
  /**
   * 获取当前缓存数据长度
   * @return {number} - 数据长度
   */


  var _proto = CachePool.prototype;

  /**
   * 设置数据
   * @param {string} key 数据的key
   * @param {any} data 数据内容
   */
  _proto.setData = function setData(key, data) {
    if (this._size === 0) {
      return;
    }

    if (this._cache.size >= this._size) {
      this._removeOld();
    }

    if (!this._cache.has(key)) {
      this.keyList.push(key);
    }

    this._cache.set(key, data); // Map会自动去重

  }
  /**
   * 获取数据
   * @param {string} key 数据的key
   * @return {any} 数据内容
   */
  ;

  _proto.getData = function getData(key) {
    return this._cache.get(key);
  }
  /**
   * 删除旧数据
   */
  ;

  _proto._removeOld = function _removeOld() {
    // 清除较老的部分数据
    var numRemoved = Math.round(this._size * 0.6); // 向下取整

    for (var i = 0; i < numRemoved; i++) {
      var key = this.keyList[i];

      if (this._options.clearCallback) {
        this._options.clearCallback(this.getData(key));
      }

      this._cache["delete"](key);
    }

    this.keyList.splice(0, numRemoved);
  }
  /**
   * 清空数据
   */
  ;

  _proto.clear = function clear() {
    this._cache.clear();

    this.keyList = [];
  };

  createClass(CachePool, [{
    key: "cacheCount",
    get: function get() {
      return this._cache.size;
    }
  }]);

  return CachePool;
}();

/**
 * @file 道路数据定义
 * @author quda
 */
var RoadData =
/*#__PURE__*/
function () {
  function RoadData() {
    var _this = this;

    this.rid = '';
    this.roadName = '';
    this.roadWidth = 5;
    this.isCurrentRoad = 0;
    this.pointList = [];

    this.getTopoInRoad = function (panoId) {
      var result = [];
      var pointList = _this.pointList;
      var length = pointList.length;

      var selectedPonit = _this.getPointByPanoId(panoId); // 如果要查找的点不存在，直接返回空数组；
      // 如果仅有一个点，且这个点是要取拓扑的点的场景点，直接返回空数组；


      if (!selectedPonit || length <= 1) {
        return result;
      }

      var order = selectedPonit.order; // 在道路的两端

      if (order === 0) {
        result.push(_this.generateTopoData(selectedPonit.dir, pointList[1]));
      } // 在道路的两端
      else if (order === length - 1) {
          result.push(_this.generateTopoData(pointList[order - 1].dir + 180, pointList[order - 1]));
        } else {
          result.push(_this.generateTopoData((pointList[order - 1].dir + 180) % 360, pointList[order - 1]));
          result.push(_this.generateTopoData(pointList[order].dir, pointList[order + 1]));
        }

      return result;
    };

    this.getPointByPanoId = function (panoId) {
      var pointList = _this.pointList;
      var pointData;

      for (var i = 0, len = pointList.length; i < len; i++) {
        if (pointList[i].panoId === panoId) {
          pointData = pointList[i];
          break;
        }
      }

      return pointData;
    };
  }

  var _proto = RoadData.prototype;

  /**
   * 生成一个拓扑对象， 用来生成拓扑数据对象。
   * @method generateTopoData
   * @param {number} degree - 拓扑箭头的朝向
   * @param {Object} pointData - 道路上的场景点对象
   * @return {Object} - 添加了topoDir和roadName的pointData
   */
  _proto.generateTopoData = function generateTopoData(degree, pointData) {
    if (undefined !== pointData) {
      pointData.topoDir = degree;
      pointData.roadName = this.roadName;
    }

    return pointData;
  }
  /**
   * 获取场景点ID对应在当前道路上的场景点信息，
   * 如果查找不到，则返回undefined
   * @method getPointBypanoId
   * @param  {string}  panoId - 场景点ID
   * @return  {Object} - 道路上的单点对象
   */
  ;

  return RoadData;
}();

/**
 * @file 全景引擎输入数据结构定义
 * @author quda
 */
var PanoramaData = function PanoramaData() {
  var _this = this;

  this.image = void 0;
  this.panoId = '';
  this.iid = '';
  this.panoType = '';
  this.panoX = 0;
  this.panoY = 0;
  this.panoZ = 0;
  this.heading = 0;
  this.pitch = 0;
  this.defaultHeading = void 0;
  this.defaultPitch = void 0;
  this.northDir = 0;
  this.fixHeading = 0;
  this.fixPitch = 0;
  this.fixRoll = 0;
  this.deviceHeight = 0;
  this.date = '20130822';
  this.time = '';
  this.provider = 1;
  this.admission = 'GS(2013)6021';
  this.photos = [];
  this.roadName = '';
  this.roads = [];
  this.vpoints = [];
  this.topoArray = undefined;
  this.currentRoad = undefined;
  this.roadWidth = undefined;

  this.getCurrentRoad = function () {
    if (_this.currentRoad) {
      return _this.currentRoad;
    }

    var roads = _this.roads;

    for (var i = 0, len = roads.length; i < len; i++) {
      if (roads[i].isCurrentRoad) {
        _this.currentRoad = roads[i];
        break;
      }
    }

    return _this.currentRoad;
  };

  this.getTopos = function () {
    if (_this.topoArray) {
      return _this.topoArray;
    }

    if (!_this.currentRoad) {
      _this.currentRoad = _this.getCurrentRoad();
    }

    if (!_this.currentRoad) {
      return [];
    } // 第一步求当前道路的拓扑点:Roads上的拓扑点；


    _this.topoArray = _this.currentRoad.getTopoInRoad(_this.panoId);

    if (_this.vpoints.length < 1) {
      return _this.topoArray;
    } // 求 链接点道路方向  ：Links上的拓扑点


    var point;

    for (var i = _this.vpoints.length - 1; i >= 0; i--) {
      point = _this.vpoints[i];
      point.topoDir = point.dir;

      _this.topoArray.push(point);
    }

    return _this.topoArray;
  };

  this.getRoadWidth = function () {
    if (undefined === _this.roadWidth) {
      if (!_this.currentRoad) {
        _this.currentRoad = _this.getCurrentRoad();
      }

      if (_this.currentRoad) {
        _this.roadWidth = _this.currentRoad.roadWidth;
      } else {
        _this.roadWidth = 0;
      }
    } // // FIXME: 无路宽就无法做TIP动画，这里暂时给一个默认值
    // if (this.roadWidth <= 0) {
    //     this.roadWidth = 10;
    // }


    return _this.roadWidth;
  };
};

/**
 * @file 全景数据预处理
 * @author quda
 */
/**
 * 解析道路上的单点信息
 * {
 *     pid: '',    // String   道路上的单点对应的场景点ID
 *     type:'',    // String  类型：街景点（street）还是内景点（inter）
 *     rid:'',      // String   当前街景点所属的道路ID
 *     dir:'',      // Number 朝向（单位是角度）
 *     roadName: '',      // String   该点所在道路名称
 *     order:'',               // Number 该点在道路单点数组上的顺序位置
 *     merX:'',               // Number  当前点的摩卡拖坐标X（单位是米）
 *     merY:'',               // Number  当前点的摩卡拖坐标Y（单位是米）
 *     cPoint: {x:'', y:''}  // Object cPoint表示link路口的连接点坐标，通过该点的坐标与link的dir形成 道路前进的可前进范围（单位是米）
 *                               // 如果不是link或者不是link路口，cPoint为undefined
 * }
 * @method parsePointData
 * @param {Object} data 要解析的JSON对象
 * @return {Object} 单点对象
 */

function parsePointData(data) {
  var pointData = {};
  pointData.panoId = data.PID;
  pointData.panoType = data.Type;
  pointData.rid = data.RID;
  pointData.dir = data.DIR;
  pointData.roadName = data.RoadName;
  pointData.order = data.Order;
  pointData.panoX = data.X / 100;
  pointData.panoY = data.Y / 100;

  if (undefined !== data.CPointX && undefined !== data.CPointY) {
    pointData.cPoint = {
      x: data.CPointX / 100,
      y: data.CPointY / 100
    };
  }

  return pointData;
}
/**
 * 解析道路数据
 * @param {Object} data   被解析对象
 * @return {RoadData}     道路信息对象
 */


function parseRoadData(data) {
  var road = new RoadData();
  road.rid = data.ID;
  road.roadName = data.Name;
  road.roadWidth = undefined !== data.Width ? data.Width / 100 : 0;
  road.isCurrentRoad = data.IsCurrent || 0;

  if (data.Panos) {
    var points = data.Panos;

    for (var i = 0, length = points.length; i < length; i++) {
      road.pointList.push(parsePointData(points[i]));
    }
  }

  return road;
}
/**
 * sdata类型请求响应解析
 * @param {Object} sdata - 要解析的JSON对象
 * @return {PanoData | null} - 解析出来PanoData对象
 */


function parseSData(sdata) {
  if (!sdata) {
    console.error('Get none from server');
    return null;
  }

  var sdataResult = sdata.result;

  if (sdataResult && sdataResult.error !== 0) {
    console.error('Get error from server');
    return null;
  }

  var sdataContents = sdata.content;

  if (undefined === sdataContents || 0 === sdataContents.length || undefined === sdataContents[0]) {
    console.error('Get empty data from server');
    return null;
  }

  var data = sdataContents[0];
  var panoData = new PanoramaData();
  var roll = data.Roll;
  var roadNamesForLinks = {}; // 场景基本信息

  panoData.panoId = data.ID;

  if (data.Inters instanceof Array) {
    var inter = data.Inters[0];

    if (undefined !== inter) {
      panoData.iid = inter.IID;
    }
  }

  panoData.panoType = data.Type; // 墨卡托位置信息，服务器给的是厘米，需要转换为米
  // 如果是非街景数据，XYZ接口下发为0，此处兼容处理

  panoData.panoX = (data.X || 0) / 100;
  panoData.panoY = (data.Y || 0) / 100;
  panoData.panoZ = (data.Z || 0) / 100; // 角度信息

  panoData.heading = undefined !== data.MoveDir ? data.MoveDir : 0;
  panoData.northDir = data.NorthDir;
  panoData.fixHeading = undefined !== data.Heading ? data.Heading : 270 - data.NorthDir;
  panoData.fixPitch = data.Pitch;
  panoData.fixRoll = 90 < roll || -90 > roll ? 0 : roll; // 采集信息

  panoData.deviceHeight = data.DeviceHeight;
  panoData.date = data.Date || panoData.date;
  panoData.time = data.Time;
  panoData.provider = undefined !== data.Provider ? data.Provider : panoData.provider;
  panoData.admission = data.Admission || panoData.admission; // 时光机数据

  panoData.timeLine = data.TimeLine || []; // 道路信息

  panoData.roadName = data.Rname;

  if (data.Roads) {
    var roads = data.Roads;
    panoData.roads = roads.map(function (road) {
      // 保留道路名称与道路ID的映射关系
      roadNamesForLinks[road.ID] = road.Name;
      return parseRoadData(road);
    });
  }

  if (data.Links) {
    var vpoints = data.Links;
    var len = vpoints.length;

    for (var i = 0; i < len; i++) {
      var iterator = vpoints[i];
      iterator.RoadName = roadNamesForLinks[iterator.RID];
      panoData.vpoints.push(parsePointData(iterator));
    }
  } // 相册信息


  panoData.photos = data.Photos || [];
  return panoData;
}

/**
 * @file 全景内置接口与请求模块
 * @author quda
 */

var PanoService =
/*#__PURE__*/
function () {
  /**
   * 默认请求域名
   */
  function PanoService(pano) {
    var _this = this;

    this.getPanoById = function (panoId) {
      var serviceUrl = "".concat(PanoService.SERVICE_URL, "?qt=sdata&sid=").concat(panoId);

      _this.getDataByUrl(serviceUrl).then(function (res) {
        var parseData = parseSData(res);

        if (parseData === null) {
          // 数据解析异常
          throw new Error('数据解析异常');
        }

        _this._cache.setData(serviceUrl, res);

        _this._pano.dispatchEvent(EVENT_TYPE.DATA_LOADED, {
          data: parseData
        });

        _this._pano.dispatchEvent(EVENT_TYPE.ID_CHANGED, parseData.panoId);

        return parseData;
      })["catch"](function (e) {
        _this._pano.dispatchEvent({
          type: EVENT_TYPE.PANO_ERROR,
          data: e
        });
      });
    };

    this._pano = pano;
    this._cache = new CachePool(10);
  }
  /**
   * 根据panoId请求全景数据
   * @param {string} panoId - 全景ID
   */


  var _proto = PanoService.prototype;

  /**
   * 数据请求封装
   * @param {string} url - 请求地址
   * @return {Promise} 请求状态机
   */
  _proto.getDataByUrl = function getDataByUrl(url) {
    var cacheData = this._cache.getData(url);

    return cacheData ? Promise.resolve(cacheData) : jsonp(url, {}, {
      jsonp: 'fn'
    });
  };

  return PanoService;
}();

PanoService.SERVICE_URL = '//mapsv0.bdimg.com/scape/';

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var regenerator = runtime_1;

function assert(condition, message) {
  if (!condition) {
    throw new Error(`math.gl assertion ${message}`);
  }
}

const config = {};
config.EPSILON = 1e-12;
config.debug = false;
config.precision = 4;
config.printTypes = false;
config.printDegrees = false;
config.printRowMajor = true;

function round(value) {
  return Math.round(value / config.EPSILON) * config.EPSILON;
}

function formatValue(value, {
  precision = config.precision || 4
} = {}) {
  value = round(value);
  return `${parseFloat(value.toPrecision(precision))}`;
}
function isArray(value) {
  return Array.isArray(value) || ArrayBuffer.isView(value) && !(value instanceof DataView);
}
function equals(a, b, epsilon) {
  const oldEpsilon = config.EPSILON;

  if (epsilon) {
    config.EPSILON = epsilon;
  }

  try {
    if (a === b) {
      return true;
    }

    if (isArray(a) && isArray(b)) {
      if (a.length !== b.length) {
        return false;
      }

      for (let i = 0; i < a.length; ++i) {
        if (!equals(a[i], b[i])) {
          return false;
        }
      }

      return true;
    }

    if (a && a.equals) {
      return a.equals(b);
    }

    if (b && b.equals) {
      return b.equals(a);
    }

    if (Number.isFinite(a) && Number.isFinite(b)) {
      return Math.abs(a - b) <= config.EPSILON * Math.max(1.0, Math.abs(a), Math.abs(b));
    }

    return false;
  } finally {
    config.EPSILON = oldEpsilon;
  }
}

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = Reflect.construct(cls, Array.from(arguments));
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}
class MathArray extends _extendableBuiltin(Array) {
  get ELEMENTS() {
    assert(false);
    return 0;
  }

  clone() {
    return new this.constructor().copy(this);
  }

  from(arrayOrObject) {
    return Array.isArray(arrayOrObject) ? this.copy(arrayOrObject) : this.fromObject(arrayOrObject);
  }

  fromArray(array, offset = 0) {
    for (let i = 0; i < this.ELEMENTS; ++i) {
      this[i] = array[i + offset];
    }

    return this.check();
  }

  to(arrayOrObject) {
    if (arrayOrObject === this) {
      return this;
    }

    return isArray(arrayOrObject) ? this.toArray(arrayOrObject) : this.toObject(arrayOrObject);
  }

  toTarget(target) {
    return target ? this.to(target) : this;
  }

  toArray(array = [], offset = 0) {
    for (let i = 0; i < this.ELEMENTS; ++i) {
      array[offset + i] = this[i];
    }

    return array;
  }

  toFloat32Array() {
    return new Float32Array(this);
  }

  toString() {
    return this.formatString(config);
  }

  formatString(opts) {
    let string = '';

    for (let i = 0; i < this.ELEMENTS; ++i) {
      string += (i > 0 ? ', ' : '') + formatValue(this[i], opts);
    }

    return `${opts.printTypes ? this.constructor.name : ''}[${string}]`;
  }

  equals(array) {
    if (!array || this.length !== array.length) {
      return false;
    }

    for (let i = 0; i < this.ELEMENTS; ++i) {
      if (!equals(this[i], array[i])) {
        return false;
      }
    }

    return true;
  }

  exactEquals(array) {
    if (!array || this.length !== array.length) {
      return false;
    }

    for (let i = 0; i < this.ELEMENTS; ++i) {
      if (this[i] !== array[i]) {
        return false;
      }
    }

    return true;
  }

  negate() {
    for (let i = 0; i < this.ELEMENTS; ++i) {
      this[i] = -this[i];
    }

    return this.check();
  }

  lerp(a, b, t) {
    if (t === undefined) {
      t = b;
      b = a;
      a = this;
    }

    for (let i = 0; i < this.ELEMENTS; ++i) {
      const ai = a[i];
      this[i] = ai + t * (b[i] - ai);
    }

    return this.check();
  }

  min(vector) {
    for (let i = 0; i < this.ELEMENTS; ++i) {
      this[i] = Math.min(vector[i], this[i]);
    }

    return this.check();
  }

  max(vector) {
    for (let i = 0; i < this.ELEMENTS; ++i) {
      this[i] = Math.max(vector[i], this[i]);
    }

    return this.check();
  }

  clamp(minVector, maxVector) {
    for (let i = 0; i < this.ELEMENTS; ++i) {
      this[i] = Math.min(Math.max(this[i], minVector[i]), maxVector[i]);
    }

    return this.check();
  }

  add(...vectors) {
    for (const vector of vectors) {
      for (let i = 0; i < this.ELEMENTS; ++i) {
        this[i] += vector[i];
      }
    }

    return this.check();
  }

  subtract(...vectors) {
    for (const vector of vectors) {
      for (let i = 0; i < this.ELEMENTS; ++i) {
        this[i] -= vector[i];
      }
    }

    return this.check();
  }

  scale(scale) {
    if (Array.isArray(scale)) {
      return this.multiply(scale);
    }

    for (let i = 0; i < this.ELEMENTS; ++i) {
      this[i] *= scale;
    }

    return this.check();
  }

  sub(a) {
    return this.subtract(a);
  }

  setScalar(a) {
    for (let i = 0; i < this.ELEMENTS; ++i) {
      this[i] = a;
    }

    return this.check();
  }

  addScalar(a) {
    for (let i = 0; i < this.ELEMENTS; ++i) {
      this[i] += a;
    }

    return this.check();
  }

  subScalar(a) {
    return this.addScalar(-a);
  }

  multiplyScalar(scalar) {
    for (let i = 0; i < this.ELEMENTS; ++i) {
      this[i] *= scalar;
    }

    return this.check();
  }

  divideScalar(a) {
    return this.scale(1 / a);
  }

  clampScalar(min, max) {
    for (let i = 0; i < this.ELEMENTS; ++i) {
      this[i] = Math.min(Math.max(this[i], min), max);
    }

    return this.check();
  }

  multiplyByScalar(scalar) {
    return this.scale(scalar);
  }

  get elements() {
    return this;
  }

  check() {
    if (config.debug && !this.validate()) {
      throw new Error(`math.gl: ${this.constructor.name} some fields set to invalid numbers'`);
    }

    return this;
  }

  validate() {
    let valid = this.length === this.ELEMENTS;

    for (let i = 0; i < this.ELEMENTS; ++i) {
      valid = valid && Number.isFinite(this[i]);
    }

    return valid;
  }

}

function validateVector(v, length) {
  if (v.length !== length) {
    return false;
  }

  for (let i = 0; i < v.length; ++i) {
    if (!Number.isFinite(v[i])) {
      return false;
    }
  }

  return true;
}
function checkNumber(value) {
  if (!Number.isFinite(value)) {
    throw new Error(`Invalid number ${value}`);
  }

  return value;
}
function checkVector(v, length, callerName = '') {
  if (config.debug && !validateVector(v, length)) {
    throw new Error(`math.gl: ${callerName} some fields set to invalid numbers'`);
  }

  return v;
}
const map = {};
function deprecated(method, version) {
  if (!map[method]) {
    map[method] = true;
    console.warn(`${method} has been removed in version ${version}, see upgrade guide for more information`);
  }
}

class Vector extends MathArray {
  get ELEMENTS() {
    assert(false);
    return 0;
  }

  copy(vector) {
    assert(false);
    return this;
  }

  get x() {
    return this[0];
  }

  set x(value) {
    this[0] = checkNumber(value);
  }

  get y() {
    return this[1];
  }

  set y(value) {
    this[1] = checkNumber(value);
  }

  len() {
    return Math.sqrt(this.lengthSquared());
  }

  magnitude() {
    return this.len();
  }

  lengthSquared() {
    let length = 0;

    for (let i = 0; i < this.ELEMENTS; ++i) {
      length += this[i] * this[i];
    }

    return length;
  }

  magnitudeSquared() {
    return this.lengthSquared();
  }

  distance(mathArray) {
    return Math.sqrt(this.distanceSquared(mathArray));
  }

  distanceSquared(mathArray) {
    let length = 0;

    for (let i = 0; i < this.ELEMENTS; ++i) {
      const dist = this[i] - mathArray[i];
      length += dist * dist;
    }

    return checkNumber(length);
  }

  dot(mathArray) {
    let product = 0;

    for (let i = 0; i < this.ELEMENTS; ++i) {
      product += this[i] * mathArray[i];
    }

    return checkNumber(product);
  }

  normalize() {
    const length = this.magnitude();

    if (length !== 0) {
      for (let i = 0; i < this.ELEMENTS; ++i) {
        this[i] /= length;
      }
    }

    return this.check();
  }

  multiply(...vectors) {
    for (const vector of vectors) {
      for (let i = 0; i < this.ELEMENTS; ++i) {
        this[i] *= vector[i];
      }
    }

    return this.check();
  }

  divide(...vectors) {
    for (const vector of vectors) {
      for (let i = 0; i < this.ELEMENTS; ++i) {
        this[i] /= vector[i];
      }
    }

    return this.check();
  }

  lengthSq() {
    return this.lengthSquared();
  }

  distanceTo(vector) {
    return this.distance(vector);
  }

  distanceToSquared(vector) {
    return this.distanceSquared(vector);
  }

  getComponent(i) {
    assert(i >= 0 && i < this.ELEMENTS, 'index is out of range');
    return checkNumber(this[i]);
  }

  setComponent(i, value) {
    assert(i >= 0 && i < this.ELEMENTS, 'index is out of range');
    this[i] = value;
    return this.check();
  }

  addVectors(a, b) {
    return this.copy(a).add(b);
  }

  subVectors(a, b) {
    return this.copy(a).subtract(b);
  }

  multiplyVectors(a, b) {
    return this.copy(a).multiply(b);
  }

  addScaledVector(a, b) {
    return this.add(new this.constructor(a).multiplyScalar(b));
  }

}

/**
 * Common utilities
 * @module glMatrix
 */
// Configuration Constants
var EPSILON = 0.000001;
var ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
var RANDOM = Math.random;
if (!Math.hypot) Math.hypot = function () {
  var y = 0,
      i = arguments.length;

  while (i--) {
    y += arguments[i] * arguments[i];
  }

  return Math.sqrt(y);
};

/**
 * 2 Dimensional Vector
 * @module vec2
 */

/**
 * Creates a new, empty vec2
 *
 * @returns {vec2} a new 2D vector
 */

function create() {
  var out = new ARRAY_TYPE(2);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
  }

  return out;
}
/**
 * Creates a new vec2 initialized with values from an existing vector
 *
 * @param {ReadonlyVec2} a vector to clone
 * @returns {vec2} a new 2D vector
 */

function clone(a) {
  var out = new ARRAY_TYPE(2);
  out[0] = a[0];
  out[1] = a[1];
  return out;
}
/**
 * Creates a new vec2 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} a new 2D vector
 */

function fromValues(x, y) {
  var out = new ARRAY_TYPE(2);
  out[0] = x;
  out[1] = y;
  return out;
}
/**
 * Copy the values from one vec2 to another
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the source vector
 * @returns {vec2} out
 */

function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  return out;
}
/**
 * Set the components of a vec2 to the given values
 *
 * @param {vec2} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} out
 */

function set(out, x, y) {
  out[0] = x;
  out[1] = y;
  return out;
}
/**
 * Adds two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  return out;
}
/**
 * Multiplies two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function multiply(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  return out;
}
/**
 * Divides two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function divide(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  return out;
}
/**
 * Math.ceil the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to ceil
 * @returns {vec2} out
 */

function ceil(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  return out;
}
/**
 * Math.floor the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to floor
 * @returns {vec2} out
 */

function floor(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  return out;
}
/**
 * Returns the minimum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function min(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  return out;
}
/**
 * Returns the maximum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function max(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  return out;
}
/**
 * Math.round the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to round
 * @returns {vec2} out
 */

function round$1(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  return out;
}
/**
 * Scales a vec2 by a scalar number
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec2} out
 */

function scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  return out;
}
/**
 * Adds two vec2's after scaling the second operand by a scalar value
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec2} out
 */

function scaleAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  return out;
}
/**
 * Calculates the euclidian distance between two vec2's
 *
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {Number} distance between a and b
 */

function distance(a, b) {
  var x = b[0] - a[0],
      y = b[1] - a[1];
  return Math.hypot(x, y);
}
/**
 * Calculates the squared euclidian distance between two vec2's
 *
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {Number} squared distance between a and b
 */

function squaredDistance(a, b) {
  var x = b[0] - a[0],
      y = b[1] - a[1];
  return x * x + y * y;
}
/**
 * Calculates the length of a vec2
 *
 * @param {ReadonlyVec2} a vector to calculate length of
 * @returns {Number} length of a
 */

function length(a) {
  var x = a[0],
      y = a[1];
  return Math.hypot(x, y);
}
/**
 * Calculates the squared length of a vec2
 *
 * @param {ReadonlyVec2} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function squaredLength(a) {
  var x = a[0],
      y = a[1];
  return x * x + y * y;
}
/**
 * Negates the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to negate
 * @returns {vec2} out
 */

function negate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  return out;
}
/**
 * Returns the inverse of the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to invert
 * @returns {vec2} out
 */

function inverse(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  return out;
}
/**
 * Normalize a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to normalize
 * @returns {vec2} out
 */

function normalize(out, a) {
  var x = a[0],
      y = a[1];
  var len = x * x + y * y;

  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
  }

  out[0] = a[0] * len;
  out[1] = a[1] * len;
  return out;
}
/**
 * Calculates the dot product of two vec2's
 *
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {Number} dot product of a and b
 */

function dot(a, b) {
  return a[0] * b[0] + a[1] * b[1];
}
/**
 * Computes the cross product of two vec2's
 * Note that the cross product must by definition produce a 3D vector
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec3} out
 */

function cross(out, a, b) {
  var z = a[0] * b[1] - a[1] * b[0];
  out[0] = out[1] = 0;
  out[2] = z;
  return out;
}
/**
 * Performs a linear interpolation between two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec2} out
 */

function lerp(out, a, b, t) {
  var ax = a[0],
      ay = a[1];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec2} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec2} out
 */

function random(out, scale) {
  scale = scale || 1.0;
  var r = RANDOM() * 2.0 * Math.PI;
  out[0] = Math.cos(r) * scale;
  out[1] = Math.sin(r) * scale;
  return out;
}
/**
 * Transforms the vec2 with a mat2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat2} m matrix to transform with
 * @returns {vec2} out
 */

function transformMat2(out, a, m) {
  var x = a[0],
      y = a[1];
  out[0] = m[0] * x + m[2] * y;
  out[1] = m[1] * x + m[3] * y;
  return out;
}
/**
 * Transforms the vec2 with a mat2d
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat2d} m matrix to transform with
 * @returns {vec2} out
 */

function transformMat2d(out, a, m) {
  var x = a[0],
      y = a[1];
  out[0] = m[0] * x + m[2] * y + m[4];
  out[1] = m[1] * x + m[3] * y + m[5];
  return out;
}
/**
 * Transforms the vec2 with a mat3
 * 3rd vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat3} m matrix to transform with
 * @returns {vec2} out
 */

function transformMat3(out, a, m) {
  var x = a[0],
      y = a[1];
  out[0] = m[0] * x + m[3] * y + m[6];
  out[1] = m[1] * x + m[4] * y + m[7];
  return out;
}
/**
 * Transforms the vec2 with a mat4
 * 3rd vector component is implicitly '0'
 * 4th vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec2} out
 */

function transformMat4(out, a, m) {
  var x = a[0];
  var y = a[1];
  out[0] = m[0] * x + m[4] * y + m[12];
  out[1] = m[1] * x + m[5] * y + m[13];
  return out;
}
/**
 * Rotate a 2D vector
 * @param {vec2} out The receiving vec2
 * @param {ReadonlyVec2} a The vec2 point to rotate
 * @param {ReadonlyVec2} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec2} out
 */

function rotate(out, a, b, rad) {
  //Translate point to the origin
  var p0 = a[0] - b[0],
      p1 = a[1] - b[1],
      sinC = Math.sin(rad),
      cosC = Math.cos(rad); //perform rotation and translate to correct position

  out[0] = p0 * cosC - p1 * sinC + b[0];
  out[1] = p0 * sinC + p1 * cosC + b[1];
  return out;
}
/**
 * Get the angle between two 2D vectors
 * @param {ReadonlyVec2} a The first operand
 * @param {ReadonlyVec2} b The second operand
 * @returns {Number} The angle in radians
 */

function angle(a, b) {
  var x1 = a[0],
      y1 = a[1],
      x2 = b[0],
      y2 = b[1],
      // mag is the product of the magnitudes of a and b
  mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2),
      // mag &&.. short circuits if mag == 0
  cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1

  return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
/**
 * Set the components of a vec2 to zero
 *
 * @param {vec2} out the receiving vector
 * @returns {vec2} out
 */

function zero(out) {
  out[0] = 0.0;
  out[1] = 0.0;
  return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec2} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function str(a) {
  return "vec2(" + a[0] + ", " + a[1] + ")";
}
/**
 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec2} a The first vector.
 * @param {ReadonlyVec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec2} a The first vector.
 * @param {ReadonlyVec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function equals$1(a, b) {
  var a0 = a[0],
      a1 = a[1];
  var b0 = b[0],
      b1 = b[1];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
/**
 * Alias for {@link vec2.length}
 * @function
 */

var len = length;
/**
 * Alias for {@link vec2.subtract}
 * @function
 */

var sub = subtract;
/**
 * Alias for {@link vec2.multiply}
 * @function
 */

var mul = multiply;
/**
 * Alias for {@link vec2.divide}
 * @function
 */

var div = divide;
/**
 * Alias for {@link vec2.distance}
 * @function
 */

var dist = distance;
/**
 * Alias for {@link vec2.squaredDistance}
 * @function
 */

var sqrDist = squaredDistance;
/**
 * Alias for {@link vec2.squaredLength}
 * @function
 */

var sqrLen = squaredLength;
/**
 * Perform some operation over an array of vec2s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec2. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec2s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var forEach = function () {
  var vec = create();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 2;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
    }

    return a;
  };
}();

var vec2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    create: create,
    clone: clone,
    fromValues: fromValues,
    copy: copy,
    set: set,
    add: add,
    subtract: subtract,
    multiply: multiply,
    divide: divide,
    ceil: ceil,
    floor: floor,
    min: min,
    max: max,
    round: round$1,
    scale: scale,
    scaleAndAdd: scaleAndAdd,
    distance: distance,
    squaredDistance: squaredDistance,
    length: length,
    squaredLength: squaredLength,
    negate: negate,
    inverse: inverse,
    normalize: normalize,
    dot: dot,
    cross: cross,
    lerp: lerp,
    random: random,
    transformMat2: transformMat2,
    transformMat2d: transformMat2d,
    transformMat3: transformMat3,
    transformMat4: transformMat4,
    rotate: rotate,
    angle: angle,
    zero: zero,
    str: str,
    exactEquals: exactEquals,
    equals: equals$1,
    len: len,
    sub: sub,
    mul: mul,
    div: div,
    dist: dist,
    sqrDist: sqrDist,
    sqrLen: sqrLen,
    forEach: forEach
});

function vec2_transformMat4AsVector(out, a, m) {
  const x = a[0];
  const y = a[1];
  const w = m[3] * x + m[7] * y || 1.0;
  out[0] = (m[0] * x + m[4] * y) / w;
  out[1] = (m[1] * x + m[5] * y) / w;
  return out;
}
function vec3_transformMat4AsVector(out, a, m) {
  const x = a[0];
  const y = a[1];
  const z = a[2];
  const w = m[3] * x + m[7] * y + m[11] * z || 1.0;
  out[0] = (m[0] * x + m[4] * y + m[8] * z) / w;
  out[1] = (m[1] * x + m[5] * y + m[9] * z) / w;
  out[2] = (m[2] * x + m[6] * y + m[10] * z) / w;
  return out;
}
function vec3_transformMat2(out, a, m) {
  const x = a[0];
  const y = a[1];
  out[0] = m[0] * x + m[2] * y;
  out[1] = m[1] * x + m[3] * y;
  out[2] = a[2];
  return out;
}
function vec4_transformMat2(out, a, m) {
  const x = a[0];
  const y = a[1];
  out[0] = m[0] * x + m[2] * y;
  out[1] = m[1] * x + m[3] * y;
  out[2] = a[2];
  out[3] = a[3];
  return out;
}
function vec4_transformMat3(out, a, m) {
  const x = a[0];
  const y = a[1];
  const z = a[2];
  out[0] = m[0] * x + m[3] * y + m[6] * z;
  out[1] = m[1] * x + m[4] * y + m[7] * z;
  out[2] = m[2] * x + m[5] * y + m[8] * z;
  out[3] = a[3];
  return out;
}

/**
 * 3 Dimensional Vector
 * @module vec3
 */

/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */

function create$1() {
  var out = new ARRAY_TYPE(3);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
  }

  return out;
}
/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {ReadonlyVec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */

function clone$1(a) {
  var out = new ARRAY_TYPE(3);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
/**
 * Calculates the length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate length of
 * @returns {Number} length of a
 */

function length$1(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  return Math.hypot(x, y, z);
}
/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */

function fromValues$1(x, y, z) {
  var out = new ARRAY_TYPE(3);
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
/**
 * Copy the values from one vec3 to another
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the source vector
 * @returns {vec3} out
 */

function copy$1(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
/**
 * Set the components of a vec3 to the given values
 *
 * @param {vec3} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} out
 */

function set$1(out, x, y, z) {
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function add$1(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function subtract$1(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  return out;
}
/**
 * Multiplies two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function multiply$1(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  out[2] = a[2] * b[2];
  return out;
}
/**
 * Divides two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function divide$1(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  out[2] = a[2] / b[2];
  return out;
}
/**
 * Math.ceil the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to ceil
 * @returns {vec3} out
 */

function ceil$1(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  out[2] = Math.ceil(a[2]);
  return out;
}
/**
 * Math.floor the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to floor
 * @returns {vec3} out
 */

function floor$1(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  out[2] = Math.floor(a[2]);
  return out;
}
/**
 * Returns the minimum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function min$1(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  out[2] = Math.min(a[2], b[2]);
  return out;
}
/**
 * Returns the maximum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function max$1(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  out[2] = Math.max(a[2], b[2]);
  return out;
}
/**
 * Math.round the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to round
 * @returns {vec3} out
 */

function round$2(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  out[2] = Math.round(a[2]);
  return out;
}
/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */

function scale$1(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  return out;
}
/**
 * Adds two vec3's after scaling the second operand by a scalar value
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec3} out
 */

function scaleAndAdd$1(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  return out;
}
/**
 * Calculates the euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} distance between a and b
 */

function distance$1(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  return Math.hypot(x, y, z);
}
/**
 * Calculates the squared euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} squared distance between a and b
 */

function squaredDistance$1(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  return x * x + y * y + z * z;
}
/**
 * Calculates the squared length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function squaredLength$1(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  return x * x + y * y + z * z;
}
/**
 * Negates the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to negate
 * @returns {vec3} out
 */

function negate$1(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  return out;
}
/**
 * Returns the inverse of the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to invert
 * @returns {vec3} out
 */

function inverse$1(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  out[2] = 1.0 / a[2];
  return out;
}
/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to normalize
 * @returns {vec3} out
 */

function normalize$1(out, a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var len = x * x + y * y + z * z;

  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
  }

  out[0] = a[0] * len;
  out[1] = a[1] * len;
  out[2] = a[2] * len;
  return out;
}
/**
 * Calculates the dot product of two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} dot product of a and b
 */

function dot$1(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function cross$1(out, a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2];
  var bx = b[0],
      by = b[1],
      bz = b[2];
  out[0] = ay * bz - az * by;
  out[1] = az * bx - ax * bz;
  out[2] = ax * by - ay * bx;
  return out;
}
/**
 * Performs a linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function lerp$1(out, a, b, t) {
  var ax = a[0];
  var ay = a[1];
  var az = a[2];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  out[2] = az + t * (b[2] - az);
  return out;
}
/**
 * Performs a hermite interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function hermite(out, a, b, c, d, t) {
  var factorTimes2 = t * t;
  var factor1 = factorTimes2 * (2 * t - 3) + 1;
  var factor2 = factorTimes2 * (t - 2) + t;
  var factor3 = factorTimes2 * (t - 1);
  var factor4 = factorTimes2 * (3 - 2 * t);
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  return out;
}
/**
 * Performs a bezier interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function bezier(out, a, b, c, d, t) {
  var inverseFactor = 1 - t;
  var inverseFactorTimesTwo = inverseFactor * inverseFactor;
  var factorTimes2 = t * t;
  var factor1 = inverseFactorTimesTwo * inverseFactor;
  var factor2 = 3 * t * inverseFactorTimesTwo;
  var factor3 = 3 * factorTimes2 * inverseFactor;
  var factor4 = factorTimes2 * t;
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec3} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec3} out
 */

function random$1(out, scale) {
  scale = scale || 1.0;
  var r = RANDOM() * 2.0 * Math.PI;
  var z = RANDOM() * 2.0 - 1.0;
  var zScale = Math.sqrt(1.0 - z * z) * scale;
  out[0] = Math.cos(r) * zScale;
  out[1] = Math.sin(r) * zScale;
  out[2] = z * scale;
  return out;
}
/**
 * Transforms the vec3 with a mat4.
 * 4th vector component is implicitly '1'
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec3} out
 */

function transformMat4$1(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2];
  var w = m[3] * x + m[7] * y + m[11] * z + m[15];
  w = w || 1.0;
  out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
  out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
  out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
  return out;
}
/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat3} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */

function transformMat3$1(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2];
  out[0] = x * m[0] + y * m[3] + z * m[6];
  out[1] = x * m[1] + y * m[4] + z * m[7];
  out[2] = x * m[2] + y * m[5] + z * m[8];
  return out;
}
/**
 * Transforms the vec3 with a quat
 * Can also be used for dual quaternions. (Multiply it with the real part)
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyQuat} q quaternion to transform with
 * @returns {vec3} out
 */

function transformQuat(out, a, q) {
  // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
  var qx = q[0],
      qy = q[1],
      qz = q[2],
      qw = q[3];
  var x = a[0],
      y = a[1],
      z = a[2]; // var qvec = [qx, qy, qz];
  // var uv = vec3.cross([], qvec, a);

  var uvx = qy * z - qz * y,
      uvy = qz * x - qx * z,
      uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);

  var uuvx = qy * uvz - qz * uvy,
      uuvy = qz * uvx - qx * uvz,
      uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);

  var w2 = qw * 2;
  uvx *= w2;
  uvy *= w2;
  uvz *= w2; // vec3.scale(uuv, uuv, 2);

  uuvx *= 2;
  uuvy *= 2;
  uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));

  out[0] = x + uvx + uuvx;
  out[1] = y + uvy + uuvy;
  out[2] = z + uvz + uuvz;
  return out;
}
/**
 * Rotate a 3D vector around the x-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function rotateX(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[0];
  r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
  r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Rotate a 3D vector around the y-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function rotateY(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
  r[1] = p[1];
  r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Rotate a 3D vector around the z-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function rotateZ(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
  r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
  r[2] = p[2]; //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Get the angle between two 3D vectors
 * @param {ReadonlyVec3} a The first operand
 * @param {ReadonlyVec3} b The second operand
 * @returns {Number} The angle in radians
 */

function angle$1(a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2],
      bx = b[0],
      by = b[1],
      bz = b[2],
      mag1 = Math.sqrt(ax * ax + ay * ay + az * az),
      mag2 = Math.sqrt(bx * bx + by * by + bz * bz),
      mag = mag1 * mag2,
      cosine = mag && dot$1(a, b) / mag;
  return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
/**
 * Set the components of a vec3 to zero
 *
 * @param {vec3} out the receiving vector
 * @returns {vec3} out
 */

function zero$1(out) {
  out[0] = 0.0;
  out[1] = 0.0;
  out[2] = 0.0;
  return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec3} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function str$1(a) {
  return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function exactEquals$1(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function equals$2(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
/**
 * Alias for {@link vec3.subtract}
 * @function
 */

var sub$1 = subtract$1;
/**
 * Alias for {@link vec3.multiply}
 * @function
 */

var mul$1 = multiply$1;
/**
 * Alias for {@link vec3.divide}
 * @function
 */

var div$1 = divide$1;
/**
 * Alias for {@link vec3.distance}
 * @function
 */

var dist$1 = distance$1;
/**
 * Alias for {@link vec3.squaredDistance}
 * @function
 */

var sqrDist$1 = squaredDistance$1;
/**
 * Alias for {@link vec3.length}
 * @function
 */

var len$1 = length$1;
/**
 * Alias for {@link vec3.squaredLength}
 * @function
 */

var sqrLen$1 = squaredLength$1;
/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var forEach$1 = function () {
  var vec = create$1();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 3;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      vec[2] = a[i + 2];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
      a[i + 2] = vec[2];
    }

    return a;
  };
}();

var vec3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    create: create$1,
    clone: clone$1,
    length: length$1,
    fromValues: fromValues$1,
    copy: copy$1,
    set: set$1,
    add: add$1,
    subtract: subtract$1,
    multiply: multiply$1,
    divide: divide$1,
    ceil: ceil$1,
    floor: floor$1,
    min: min$1,
    max: max$1,
    round: round$2,
    scale: scale$1,
    scaleAndAdd: scaleAndAdd$1,
    distance: distance$1,
    squaredDistance: squaredDistance$1,
    squaredLength: squaredLength$1,
    negate: negate$1,
    inverse: inverse$1,
    normalize: normalize$1,
    dot: dot$1,
    cross: cross$1,
    lerp: lerp$1,
    hermite: hermite,
    bezier: bezier,
    random: random$1,
    transformMat4: transformMat4$1,
    transformMat3: transformMat3$1,
    transformQuat: transformQuat,
    rotateX: rotateX,
    rotateY: rotateY,
    rotateZ: rotateZ,
    angle: angle$1,
    zero: zero$1,
    str: str$1,
    exactEquals: exactEquals$1,
    equals: equals$2,
    sub: sub$1,
    mul: mul$1,
    div: div$1,
    dist: dist$1,
    sqrDist: sqrDist$1,
    len: len$1,
    sqrLen: sqrLen$1,
    forEach: forEach$1
});

const ORIGIN = [0, 0, 0];
const constants = {};
class Vector3 extends Vector {
  static get ZERO() {
    return constants.ZERO = constants.ZERO || Object.freeze(new Vector3(0, 0, 0, 0));
  }

  constructor(x = 0, y = 0, z = 0) {
    super(-0, -0, -0);

    if (arguments.length === 1 && isArray(x)) {
      this.copy(x);
    } else {
      if (config.debug) {
        checkNumber(x);
        checkNumber(y);
        checkNumber(z);
      }

      this[0] = x;
      this[1] = y;
      this[2] = z;
    }
  }

  set(x, y, z) {
    this[0] = x;
    this[1] = y;
    this[2] = z;
    return this.check();
  }

  copy(array) {
    this[0] = array[0];
    this[1] = array[1];
    this[2] = array[2];
    return this.check();
  }

  fromObject(object) {
    if (config.debug) {
      checkNumber(object.x);
      checkNumber(object.y);
      checkNumber(object.z);
    }

    this[0] = object.x;
    this[1] = object.y;
    this[2] = object.z;
    return this.check();
  }

  toObject(object) {
    object.x = this[0];
    object.y = this[1];
    object.z = this[2];
    return object;
  }

  get ELEMENTS() {
    return 3;
  }

  get z() {
    return this[2];
  }

  set z(value) {
    this[2] = checkNumber(value);
  }

  angle(vector) {
    return angle$1(this, vector);
  }

  cross(vector) {
    cross$1(this, this, vector);
    return this.check();
  }

  rotateX({
    radians,
    origin = ORIGIN
  }) {
    rotateX(this, this, origin, radians);
    return this.check();
  }

  rotateY({
    radians,
    origin = ORIGIN
  }) {
    rotateY(this, this, origin, radians);
    return this.check();
  }

  rotateZ({
    radians,
    origin = ORIGIN
  }) {
    rotateZ(this, this, origin, radians);
    return this.check();
  }

  transform(matrix4) {
    return this.transformAsPoint(matrix4);
  }

  transformAsPoint(matrix4) {
    transformMat4$1(this, this, matrix4);
    return this.check();
  }

  transformAsVector(matrix4) {
    vec3_transformMat4AsVector(this, this, matrix4);
    return this.check();
  }

  transformByMatrix3(matrix3) {
    transformMat3$1(this, this, matrix3);
    return this.check();
  }

  transformByMatrix2(matrix2) {
    vec3_transformMat2(this, this, matrix2);
    return this.check();
  }

  transformByQuaternion(quaternion) {
    transformQuat(this, this, quaternion);
    return this.check();
  }

}

const constants$1 = {};
class Vector4 extends Vector {
  static get ZERO() {
    return constants$1.ZERO = constants$1.ZERO || Object.freeze(new Vector4(0, 0, 0, 0));
  }

  constructor(x = 0, y = 0, z = 0, w = 0) {
    super(-0, -0, -0, -0);

    if (isArray(x) && arguments.length === 1) {
      this.copy(x);
    } else {
      if (config.debug) {
        checkNumber(x);
        checkNumber(y);
        checkNumber(z);
        checkNumber(w);
      }

      this[0] = x;
      this[1] = y;
      this[2] = z;
      this[3] = w;
    }
  }

  set(x, y, z, w) {
    this[0] = x;
    this[1] = y;
    this[2] = z;
    this[3] = w;
    return this.check();
  }

  copy(array) {
    this[0] = array[0];
    this[1] = array[1];
    this[2] = array[2];
    this[3] = array[3];
    return this.check();
  }

  fromObject(object) {
    if (config.debug) {
      checkNumber(object.x);
      checkNumber(object.y);
      checkNumber(object.z);
      checkNumber(object.w);
    }

    this[0] = object.x;
    this[1] = object.y;
    this[2] = object.z;
    this[3] = object.w;
    return this;
  }

  toObject(object) {
    object.x = this[0];
    object.y = this[1];
    object.z = this[2];
    object.w = this[3];
    return object;
  }

  get ELEMENTS() {
    return 4;
  }

  get z() {
    return this[2];
  }

  set z(value) {
    this[2] = checkNumber(value);
  }

  get w() {
    return this[3];
  }

  set w(value) {
    this[3] = checkNumber(value);
  }

  transform(matrix4) {
    transformMat4$1(this, this, matrix4);
    return this.check();
  }

  transformByMatrix3(matrix3) {
    vec4_transformMat3(this, this, matrix3);
    return this.check();
  }

  transformByMatrix2(matrix2) {
    vec4_transformMat2(this, this, matrix2);
    return this.check();
  }

  transformByQuaternion(quaternion) {
    transformQuat(this, this, quaternion);
    return this.check();
  }

  applyMatrix4(m) {
    m.transform(this, this);
    return this;
  }

}

class Matrix extends MathArray {
  get ELEMENTS() {
    assert(false);
    return 0;
  }

  get RANK() {
    assert(false);
    return 0;
  }

  toString() {
    let string = '[';

    if (config.printRowMajor) {
      string += 'row-major:';

      for (let row = 0; row < this.RANK; ++row) {
        for (let col = 0; col < this.RANK; ++col) {
          string += ` ${this[col * this.RANK + row]}`;
        }
      }
    } else {
      string += 'column-major:';

      for (let i = 0; i < this.ELEMENTS; ++i) {
        string += ` ${this[i]}`;
      }
    }

    string += ']';
    return string;
  }

  getElementIndex(row, col) {
    return col * this.RANK + row;
  }

  getElement(row, col) {
    return this[col * this.RANK + row];
  }

  setElement(row, col, value) {
    this[col * this.RANK + row] = checkNumber(value);
    return this;
  }

  getColumn(columnIndex, result = new Array(this.RANK).fill(-0)) {
    const firstIndex = columnIndex * this.RANK;

    for (let i = 0; i < this.RANK; ++i) {
      result[i] = this[firstIndex + i];
    }

    return result;
  }

  setColumn(columnIndex, columnVector) {
    const firstIndex = columnIndex * this.RANK;

    for (let i = 0; i < this.RANK; ++i) {
      this[firstIndex + i] = columnVector[i];
    }

    return this;
  }

}

/**
 * 3x3 Matrix
 * @module mat3
 */

/**
 * Creates a new identity mat3
 *
 * @returns {mat3} a new 3x3 matrix
 */

function create$2() {
  var out = new ARRAY_TYPE(9);

  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
  }

  out[0] = 1;
  out[4] = 1;
  out[8] = 1;
  return out;
}
/**
 * Copies the upper-left 3x3 values into the given mat3.
 *
 * @param {mat3} out the receiving 3x3 matrix
 * @param {ReadonlyMat4} a   the source 4x4 matrix
 * @returns {mat3} out
 */

function fromMat4(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[4];
  out[4] = a[5];
  out[5] = a[6];
  out[6] = a[8];
  out[7] = a[9];
  out[8] = a[10];
  return out;
}
/**
 * Creates a new mat3 initialized with values from an existing matrix
 *
 * @param {ReadonlyMat3} a matrix to clone
 * @returns {mat3} a new 3x3 matrix
 */

function clone$2(a) {
  var out = new ARRAY_TYPE(9);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}
/**
 * Copy the values from one mat3 to another
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function copy$2(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}
/**
 * Create a new mat3 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} A new mat3
 */

function fromValues$2(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
  var out = new ARRAY_TYPE(9);
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m10;
  out[4] = m11;
  out[5] = m12;
  out[6] = m20;
  out[7] = m21;
  out[8] = m22;
  return out;
}
/**
 * Set the components of a mat3 to the given values
 *
 * @param {mat3} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} out
 */

function set$2(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m10;
  out[4] = m11;
  out[5] = m12;
  out[6] = m20;
  out[7] = m21;
  out[8] = m22;
  return out;
}
/**
 * Set a mat3 to the identity matrix
 *
 * @param {mat3} out the receiving matrix
 * @returns {mat3} out
 */

function identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 1;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
/**
 * Transpose the values of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function transpose(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache some values
  if (out === a) {
    var a01 = a[1],
        a02 = a[2],
        a12 = a[5];
    out[1] = a[3];
    out[2] = a[6];
    out[3] = a01;
    out[5] = a[7];
    out[6] = a02;
    out[7] = a12;
  } else {
    out[0] = a[0];
    out[1] = a[3];
    out[2] = a[6];
    out[3] = a[1];
    out[4] = a[4];
    out[5] = a[7];
    out[6] = a[2];
    out[7] = a[5];
    out[8] = a[8];
  }

  return out;
}
/**
 * Inverts a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function invert(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  var b01 = a22 * a11 - a12 * a21;
  var b11 = -a22 * a10 + a12 * a20;
  var b21 = a21 * a10 - a11 * a20; // Calculate the determinant

  var det = a00 * b01 + a01 * b11 + a02 * b21;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = b01 * det;
  out[1] = (-a22 * a01 + a02 * a21) * det;
  out[2] = (a12 * a01 - a02 * a11) * det;
  out[3] = b11 * det;
  out[4] = (a22 * a00 - a02 * a20) * det;
  out[5] = (-a12 * a00 + a02 * a10) * det;
  out[6] = b21 * det;
  out[7] = (-a21 * a00 + a01 * a20) * det;
  out[8] = (a11 * a00 - a01 * a10) * det;
  return out;
}
/**
 * Calculates the adjugate of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function adjoint(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  out[0] = a11 * a22 - a12 * a21;
  out[1] = a02 * a21 - a01 * a22;
  out[2] = a01 * a12 - a02 * a11;
  out[3] = a12 * a20 - a10 * a22;
  out[4] = a00 * a22 - a02 * a20;
  out[5] = a02 * a10 - a00 * a12;
  out[6] = a10 * a21 - a11 * a20;
  out[7] = a01 * a20 - a00 * a21;
  out[8] = a00 * a11 - a01 * a10;
  return out;
}
/**
 * Calculates the determinant of a mat3
 *
 * @param {ReadonlyMat3} a the source matrix
 * @returns {Number} determinant of a
 */

function determinant(a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
/**
 * Multiplies two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */

function multiply$2(out, a, b) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  var b00 = b[0],
      b01 = b[1],
      b02 = b[2];
  var b10 = b[3],
      b11 = b[4],
      b12 = b[5];
  var b20 = b[6],
      b21 = b[7],
      b22 = b[8];
  out[0] = b00 * a00 + b01 * a10 + b02 * a20;
  out[1] = b00 * a01 + b01 * a11 + b02 * a21;
  out[2] = b00 * a02 + b01 * a12 + b02 * a22;
  out[3] = b10 * a00 + b11 * a10 + b12 * a20;
  out[4] = b10 * a01 + b11 * a11 + b12 * a21;
  out[5] = b10 * a02 + b11 * a12 + b12 * a22;
  out[6] = b20 * a00 + b21 * a10 + b22 * a20;
  out[7] = b20 * a01 + b21 * a11 + b22 * a21;
  out[8] = b20 * a02 + b21 * a12 + b22 * a22;
  return out;
}
/**
 * Translate a mat3 by the given vector
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to translate
 * @param {ReadonlyVec2} v vector to translate by
 * @returns {mat3} out
 */

function translate(out, a, v) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a10 = a[3],
      a11 = a[4],
      a12 = a[5],
      a20 = a[6],
      a21 = a[7],
      a22 = a[8],
      x = v[0],
      y = v[1];
  out[0] = a00;
  out[1] = a01;
  out[2] = a02;
  out[3] = a10;
  out[4] = a11;
  out[5] = a12;
  out[6] = x * a00 + y * a10 + a20;
  out[7] = x * a01 + y * a11 + a21;
  out[8] = x * a02 + y * a12 + a22;
  return out;
}
/**
 * Rotates a mat3 by the given angle
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */

function rotate$1(out, a, rad) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a10 = a[3],
      a11 = a[4],
      a12 = a[5],
      a20 = a[6],
      a21 = a[7],
      a22 = a[8],
      s = Math.sin(rad),
      c = Math.cos(rad);
  out[0] = c * a00 + s * a10;
  out[1] = c * a01 + s * a11;
  out[2] = c * a02 + s * a12;
  out[3] = c * a10 - s * a00;
  out[4] = c * a11 - s * a01;
  out[5] = c * a12 - s * a02;
  out[6] = a20;
  out[7] = a21;
  out[8] = a22;
  return out;
}
/**
 * Scales the mat3 by the dimensions in the given vec2
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {ReadonlyVec2} v the vec2 to scale the matrix by
 * @returns {mat3} out
 **/

function scale$2(out, a, v) {
  var x = v[0],
      y = v[1];
  out[0] = x * a[0];
  out[1] = x * a[1];
  out[2] = x * a[2];
  out[3] = y * a[3];
  out[4] = y * a[4];
  out[5] = y * a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.translate(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyVec2} v Translation vector
 * @returns {mat3} out
 */

function fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 1;
  out[5] = 0;
  out[6] = v[0];
  out[7] = v[1];
  out[8] = 1;
  return out;
}
/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.rotate(dest, dest, rad);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */

function fromRotation(out, rad) {
  var s = Math.sin(rad),
      c = Math.cos(rad);
  out[0] = c;
  out[1] = s;
  out[2] = 0;
  out[3] = -s;
  out[4] = c;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.scale(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyVec2} v Scaling vector
 * @returns {mat3} out
 */

function fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = v[1];
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
/**
 * Copies the values from a mat2d into a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat2d} a the matrix to copy
 * @returns {mat3} out
 **/

function fromMat2d(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = 0;
  out[3] = a[2];
  out[4] = a[3];
  out[5] = 0;
  out[6] = a[4];
  out[7] = a[5];
  out[8] = 1;
  return out;
}
/**
 * Calculates a 3x3 matrix from the given quaternion
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyQuat} q Quaternion to create matrix from
 *
 * @returns {mat3} out
 */

function fromQuat(out, q) {
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var yx = y * x2;
  var yy = y * y2;
  var zx = z * x2;
  var zy = z * y2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - yy - zz;
  out[3] = yx - wz;
  out[6] = zx + wy;
  out[1] = yx + wz;
  out[4] = 1 - xx - zz;
  out[7] = zy - wx;
  out[2] = zx - wy;
  out[5] = zy + wx;
  out[8] = 1 - xx - yy;
  return out;
}
/**
 * Calculates a 3x3 normal matrix (transpose inverse) from the 4x4 matrix
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyMat4} a Mat4 to derive the normal matrix from
 *
 * @returns {mat3} out
 */

function normalFromMat4(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  return out;
}
/**
 * Generates a 2D projection matrix with the given bounds
 *
 * @param {mat3} out mat3 frustum matrix will be written into
 * @param {number} width Width of your gl context
 * @param {number} height Height of gl context
 * @returns {mat3} out
 */

function projection(out, width, height) {
  out[0] = 2 / width;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = -2 / height;
  out[5] = 0;
  out[6] = -1;
  out[7] = 1;
  out[8] = 1;
  return out;
}
/**
 * Returns a string representation of a mat3
 *
 * @param {ReadonlyMat3} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */

function str$2(a) {
  return "mat3(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ")";
}
/**
 * Returns Frobenius norm of a mat3
 *
 * @param {ReadonlyMat3} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */

function frob(a) {
  return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
}
/**
 * Adds two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */

function add$2(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  out[6] = a[6] + b[6];
  out[7] = a[7] + b[7];
  out[8] = a[8] + b[8];
  return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */

function subtract$2(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  out[6] = a[6] - b[6];
  out[7] = a[7] - b[7];
  out[8] = a[8] - b[8];
  return out;
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat3} out
 */

function multiplyScalar(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  out[6] = a[6] * b;
  out[7] = a[7] * b;
  out[8] = a[8] * b;
  return out;
}
/**
 * Adds two mat3's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat3} out the receiving vector
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat3} out
 */

function multiplyScalarAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  out[4] = a[4] + b[4] * scale;
  out[5] = a[5] + b[5] * scale;
  out[6] = a[6] + b[6] * scale;
  out[7] = a[7] + b[7] * scale;
  out[8] = a[8] + b[8] * scale;
  return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat3} a The first matrix.
 * @param {ReadonlyMat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function exactEquals$2(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat3} a The first matrix.
 * @param {ReadonlyMat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function equals$3(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5],
      a6 = a[6],
      a7 = a[7],
      a8 = a[8];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3],
      b4 = b[4],
      b5 = b[5],
      b6 = b[6],
      b7 = b[7],
      b8 = b[8];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8));
}
/**
 * Alias for {@link mat3.multiply}
 * @function
 */

var mul$2 = multiply$2;
/**
 * Alias for {@link mat3.subtract}
 * @function
 */

var sub$2 = subtract$2;

var mat3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    create: create$2,
    fromMat4: fromMat4,
    clone: clone$2,
    copy: copy$2,
    fromValues: fromValues$2,
    set: set$2,
    identity: identity,
    transpose: transpose,
    invert: invert,
    adjoint: adjoint,
    determinant: determinant,
    multiply: multiply$2,
    translate: translate,
    rotate: rotate$1,
    scale: scale$2,
    fromTranslation: fromTranslation,
    fromRotation: fromRotation,
    fromScaling: fromScaling,
    fromMat2d: fromMat2d,
    fromQuat: fromQuat,
    normalFromMat4: normalFromMat4,
    projection: projection,
    str: str$2,
    frob: frob,
    add: add$2,
    subtract: subtract$2,
    multiplyScalar: multiplyScalar,
    multiplyScalarAndAdd: multiplyScalarAndAdd,
    exactEquals: exactEquals$2,
    equals: equals$3,
    mul: mul$2,
    sub: sub$2
});

/**
 * 4x4 Matrix<br>Format: column-major, when typed out it looks like row-major<br>The matrices are being post multiplied.
 * @module mat4
 */

/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */

function create$3() {
  var out = new ARRAY_TYPE(16);

  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
  }

  out[0] = 1;
  out[5] = 1;
  out[10] = 1;
  out[15] = 1;
  return out;
}
/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {ReadonlyMat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */

function clone$3(a) {
  var out = new ARRAY_TYPE(16);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function copy$3(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Create a new mat4 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} A new mat4
 */

function fromValues$3(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  var out = new ARRAY_TYPE(16);
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}
/**
 * Set the components of a mat4 to the given values
 *
 * @param {mat4} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} out
 */

function set$3(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}
/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */

function identity$1(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Transpose the values of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function transpose$1(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache some values
  if (out === a) {
    var a01 = a[1],
        a02 = a[2],
        a03 = a[3];
    var a12 = a[6],
        a13 = a[7];
    var a23 = a[11];
    out[1] = a[4];
    out[2] = a[8];
    out[3] = a[12];
    out[4] = a01;
    out[6] = a[9];
    out[7] = a[13];
    out[8] = a02;
    out[9] = a12;
    out[11] = a[14];
    out[12] = a03;
    out[13] = a13;
    out[14] = a23;
  } else {
    out[0] = a[0];
    out[1] = a[4];
    out[2] = a[8];
    out[3] = a[12];
    out[4] = a[1];
    out[5] = a[5];
    out[6] = a[9];
    out[7] = a[13];
    out[8] = a[2];
    out[9] = a[6];
    out[10] = a[10];
    out[11] = a[14];
    out[12] = a[3];
    out[13] = a[7];
    out[14] = a[11];
    out[15] = a[15];
  }

  return out;
}
/**
 * Inverts a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function invert$1(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
  out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
  out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
  out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
  out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
  out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
  out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
  return out;
}
/**
 * Calculates the adjugate of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function adjoint$1(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
  out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
  out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
  out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
  out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
  out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
  out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
  out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
  out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
  out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
  out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
  out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
  out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
  out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
  out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
  out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
  return out;
}
/**
 * Calculates the determinant of a mat4
 *
 * @param {ReadonlyMat4} a the source matrix
 * @returns {Number} determinant of a
 */

function determinant$1(a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
/**
 * Multiplies two mat4s
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function multiply$3(out, a, b) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15]; // Cache only the current line of the second matrix

  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[4];
  b1 = b[5];
  b2 = b[6];
  b3 = b[7];
  out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[8];
  b1 = b[9];
  b2 = b[10];
  b3 = b[11];
  out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[12];
  b1 = b[13];
  b2 = b[14];
  b3 = b[15];
  out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  return out;
}
/**
 * Translate a mat4 by the given vector
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to translate
 * @param {ReadonlyVec3} v vector to translate by
 * @returns {mat4} out
 */

function translate$1(out, a, v) {
  var x = v[0],
      y = v[1],
      z = v[2];
  var a00, a01, a02, a03;
  var a10, a11, a12, a13;
  var a20, a21, a22, a23;

  if (a === out) {
    out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
    out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
    out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
    out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
  } else {
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a03;
    out[4] = a10;
    out[5] = a11;
    out[6] = a12;
    out[7] = a13;
    out[8] = a20;
    out[9] = a21;
    out[10] = a22;
    out[11] = a23;
    out[12] = a00 * x + a10 * y + a20 * z + a[12];
    out[13] = a01 * x + a11 * y + a21 * z + a[13];
    out[14] = a02 * x + a12 * y + a22 * z + a[14];
    out[15] = a03 * x + a13 * y + a23 * z + a[15];
  }

  return out;
}
/**
 * Scales the mat4 by the dimensions in the given vec3 not using vectorization
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to scale
 * @param {ReadonlyVec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/

function scale$3(out, a, v) {
  var x = v[0],
      y = v[1],
      z = v[2];
  out[0] = a[0] * x;
  out[1] = a[1] * x;
  out[2] = a[2] * x;
  out[3] = a[3] * x;
  out[4] = a[4] * y;
  out[5] = a[5] * y;
  out[6] = a[6] * y;
  out[7] = a[7] * y;
  out[8] = a[8] * z;
  out[9] = a[9] * z;
  out[10] = a[10] * z;
  out[11] = a[11] * z;
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Rotates a mat4 by the given angle around the given axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @returns {mat4} out
 */

function rotate$2(out, a, rad, axis) {
  var x = axis[0],
      y = axis[1],
      z = axis[2];
  var len = Math.hypot(x, y, z);
  var s, c, t;
  var a00, a01, a02, a03;
  var a10, a11, a12, a13;
  var a20, a21, a22, a23;
  var b00, b01, b02;
  var b10, b11, b12;
  var b20, b21, b22;

  if (len < EPSILON) {
    return null;
  }

  len = 1 / len;
  x *= len;
  y *= len;
  z *= len;
  s = Math.sin(rad);
  c = Math.cos(rad);
  t = 1 - c;
  a00 = a[0];
  a01 = a[1];
  a02 = a[2];
  a03 = a[3];
  a10 = a[4];
  a11 = a[5];
  a12 = a[6];
  a13 = a[7];
  a20 = a[8];
  a21 = a[9];
  a22 = a[10];
  a23 = a[11]; // Construct the elements of the rotation matrix

  b00 = x * x * t + c;
  b01 = y * x * t + z * s;
  b02 = z * x * t - y * s;
  b10 = x * y * t - z * s;
  b11 = y * y * t + c;
  b12 = z * y * t + x * s;
  b20 = x * z * t + y * s;
  b21 = y * z * t - x * s;
  b22 = z * z * t + c; // Perform rotation-specific matrix multiplication

  out[0] = a00 * b00 + a10 * b01 + a20 * b02;
  out[1] = a01 * b00 + a11 * b01 + a21 * b02;
  out[2] = a02 * b00 + a12 * b01 + a22 * b02;
  out[3] = a03 * b00 + a13 * b01 + a23 * b02;
  out[4] = a00 * b10 + a10 * b11 + a20 * b12;
  out[5] = a01 * b10 + a11 * b11 + a21 * b12;
  out[6] = a02 * b10 + a12 * b11 + a22 * b12;
  out[7] = a03 * b10 + a13 * b11 + a23 * b12;
  out[8] = a00 * b20 + a10 * b21 + a20 * b22;
  out[9] = a01 * b20 + a11 * b21 + a21 * b22;
  out[10] = a02 * b20 + a12 * b21 + a22 * b22;
  out[11] = a03 * b20 + a13 * b21 + a23 * b22;

  if (a !== out) {
    // If the source and destination differ, copy the unchanged last row
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  }

  return out;
}
/**
 * Rotates a matrix by the given angle around the X axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateX$1(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a10 = a[4];
  var a11 = a[5];
  var a12 = a[6];
  var a13 = a[7];
  var a20 = a[8];
  var a21 = a[9];
  var a22 = a[10];
  var a23 = a[11];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged rows
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[4] = a10 * c + a20 * s;
  out[5] = a11 * c + a21 * s;
  out[6] = a12 * c + a22 * s;
  out[7] = a13 * c + a23 * s;
  out[8] = a20 * c - a10 * s;
  out[9] = a21 * c - a11 * s;
  out[10] = a22 * c - a12 * s;
  out[11] = a23 * c - a13 * s;
  return out;
}
/**
 * Rotates a matrix by the given angle around the Y axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateY$1(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a00 = a[0];
  var a01 = a[1];
  var a02 = a[2];
  var a03 = a[3];
  var a20 = a[8];
  var a21 = a[9];
  var a22 = a[10];
  var a23 = a[11];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged rows
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[0] = a00 * c - a20 * s;
  out[1] = a01 * c - a21 * s;
  out[2] = a02 * c - a22 * s;
  out[3] = a03 * c - a23 * s;
  out[8] = a00 * s + a20 * c;
  out[9] = a01 * s + a21 * c;
  out[10] = a02 * s + a22 * c;
  out[11] = a03 * s + a23 * c;
  return out;
}
/**
 * Rotates a matrix by the given angle around the Z axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateZ$1(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a00 = a[0];
  var a01 = a[1];
  var a02 = a[2];
  var a03 = a[3];
  var a10 = a[4];
  var a11 = a[5];
  var a12 = a[6];
  var a13 = a[7];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged last row
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[0] = a00 * c + a10 * s;
  out[1] = a01 * c + a11 * s;
  out[2] = a02 * c + a12 * s;
  out[3] = a03 * c + a13 * s;
  out[4] = a10 * c - a00 * s;
  out[5] = a11 * c - a01 * s;
  out[6] = a12 * c - a02 * s;
  out[7] = a13 * c - a03 * s;
  return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Translation vector
 * @returns {mat4} out
 */

function fromTranslation$1(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.scale(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Scaling vector
 * @returns {mat4} out
 */

function fromScaling$1(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = v[1];
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = v[2];
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a given angle around a given axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotate(dest, dest, rad, axis);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @returns {mat4} out
 */

function fromRotation$1(out, rad, axis) {
  var x = axis[0],
      y = axis[1],
      z = axis[2];
  var len = Math.hypot(x, y, z);
  var s, c, t;

  if (len < EPSILON) {
    return null;
  }

  len = 1 / len;
  x *= len;
  y *= len;
  z *= len;
  s = Math.sin(rad);
  c = Math.cos(rad);
  t = 1 - c; // Perform rotation-specific matrix multiplication

  out[0] = x * x * t + c;
  out[1] = y * x * t + z * s;
  out[2] = z * x * t - y * s;
  out[3] = 0;
  out[4] = x * y * t - z * s;
  out[5] = y * y * t + c;
  out[6] = z * y * t + x * s;
  out[7] = 0;
  out[8] = x * z * t + y * s;
  out[9] = y * z * t - x * s;
  out[10] = z * z * t + c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the X axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateX(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromXRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = c;
  out[6] = s;
  out[7] = 0;
  out[8] = 0;
  out[9] = -s;
  out[10] = c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the Y axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateY(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromYRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = c;
  out[1] = 0;
  out[2] = -s;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = s;
  out[9] = 0;
  out[10] = c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the Z axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateZ(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromZRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = c;
  out[1] = s;
  out[2] = 0;
  out[3] = 0;
  out[4] = -s;
  out[5] = c;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a quaternion rotation and vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @returns {mat4} out
 */

function fromRotationTranslation(out, q, v) {
  // Quaternion math
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - (yy + zz);
  out[1] = xy + wz;
  out[2] = xz - wy;
  out[3] = 0;
  out[4] = xy - wz;
  out[5] = 1 - (xx + zz);
  out[6] = yz + wx;
  out[7] = 0;
  out[8] = xz + wy;
  out[9] = yz - wx;
  out[10] = 1 - (xx + yy);
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a new mat4 from a dual quat.
 *
 * @param {mat4} out Matrix
 * @param {ReadonlyQuat2} a Dual Quaternion
 * @returns {mat4} mat4 receiving operation result
 */

function fromQuat2(out, a) {
  var translation = new ARRAY_TYPE(3);
  var bx = -a[0],
      by = -a[1],
      bz = -a[2],
      bw = a[3],
      ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7];
  var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense

  if (magnitude > 0) {
    translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
    translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
    translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
  } else {
    translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
    translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
    translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
  }

  fromRotationTranslation(out, a, translation);
  return out;
}
/**
 * Returns the translation vector component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslation,
 *  the returned vector will be the same as the translation vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive translation component
 * @param  {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */

function getTranslation(out, mat) {
  out[0] = mat[12];
  out[1] = mat[13];
  out[2] = mat[14];
  return out;
}
/**
 * Returns the scaling factor component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslationScale
 *  with a normalized Quaternion paramter, the returned vector will be
 *  the same as the scaling vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive scaling factor component
 * @param  {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */

function getScaling(out, mat) {
  var m11 = mat[0];
  var m12 = mat[1];
  var m13 = mat[2];
  var m21 = mat[4];
  var m22 = mat[5];
  var m23 = mat[6];
  var m31 = mat[8];
  var m32 = mat[9];
  var m33 = mat[10];
  out[0] = Math.hypot(m11, m12, m13);
  out[1] = Math.hypot(m21, m22, m23);
  out[2] = Math.hypot(m31, m32, m33);
  return out;
}
/**
 * Returns a quaternion representing the rotational component
 *  of a transformation matrix. If a matrix is built with
 *  fromRotationTranslation, the returned quaternion will be the
 *  same as the quaternion originally supplied.
 * @param {quat} out Quaternion to receive the rotation component
 * @param {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {quat} out
 */

function getRotation(out, mat) {
  var scaling = new ARRAY_TYPE(3);
  getScaling(scaling, mat);
  var is1 = 1 / scaling[0];
  var is2 = 1 / scaling[1];
  var is3 = 1 / scaling[2];
  var sm11 = mat[0] * is1;
  var sm12 = mat[1] * is2;
  var sm13 = mat[2] * is3;
  var sm21 = mat[4] * is1;
  var sm22 = mat[5] * is2;
  var sm23 = mat[6] * is3;
  var sm31 = mat[8] * is1;
  var sm32 = mat[9] * is2;
  var sm33 = mat[10] * is3;
  var trace = sm11 + sm22 + sm33;
  var S = 0;

  if (trace > 0) {
    S = Math.sqrt(trace + 1.0) * 2;
    out[3] = 0.25 * S;
    out[0] = (sm23 - sm32) / S;
    out[1] = (sm31 - sm13) / S;
    out[2] = (sm12 - sm21) / S;
  } else if (sm11 > sm22 && sm11 > sm33) {
    S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
    out[3] = (sm23 - sm32) / S;
    out[0] = 0.25 * S;
    out[1] = (sm12 + sm21) / S;
    out[2] = (sm31 + sm13) / S;
  } else if (sm22 > sm33) {
    S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
    out[3] = (sm31 - sm13) / S;
    out[0] = (sm12 + sm21) / S;
    out[1] = 0.25 * S;
    out[2] = (sm23 + sm32) / S;
  } else {
    S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
    out[3] = (sm12 - sm21) / S;
    out[0] = (sm31 + sm13) / S;
    out[1] = (sm23 + sm32) / S;
    out[2] = 0.25 * S;
  }

  return out;
}
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @param {ReadonlyVec3} s Scaling vector
 * @returns {mat4} out
 */

function fromRotationTranslationScale(out, q, v, s) {
  // Quaternion math
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  var sx = s[0];
  var sy = s[1];
  var sz = s[2];
  out[0] = (1 - (yy + zz)) * sx;
  out[1] = (xy + wz) * sx;
  out[2] = (xz - wy) * sx;
  out[3] = 0;
  out[4] = (xy - wz) * sy;
  out[5] = (1 - (xx + zz)) * sy;
  out[6] = (yz + wx) * sy;
  out[7] = 0;
  out[8] = (xz + wy) * sz;
  out[9] = (yz - wx) * sz;
  out[10] = (1 - (xx + yy)) * sz;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale, rotating and scaling around the given origin
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     mat4.translate(dest, origin);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *     mat4.translate(dest, negativeOrigin);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @param {ReadonlyVec3} s Scaling vector
 * @param {ReadonlyVec3} o The origin vector around which to scale and rotate
 * @returns {mat4} out
 */

function fromRotationTranslationScaleOrigin(out, q, v, s, o) {
  // Quaternion math
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  var sx = s[0];
  var sy = s[1];
  var sz = s[2];
  var ox = o[0];
  var oy = o[1];
  var oz = o[2];
  var out0 = (1 - (yy + zz)) * sx;
  var out1 = (xy + wz) * sx;
  var out2 = (xz - wy) * sx;
  var out4 = (xy - wz) * sy;
  var out5 = (1 - (xx + zz)) * sy;
  var out6 = (yz + wx) * sy;
  var out8 = (xz + wy) * sz;
  var out9 = (yz - wx) * sz;
  var out10 = (1 - (xx + yy)) * sz;
  out[0] = out0;
  out[1] = out1;
  out[2] = out2;
  out[3] = 0;
  out[4] = out4;
  out[5] = out5;
  out[6] = out6;
  out[7] = 0;
  out[8] = out8;
  out[9] = out9;
  out[10] = out10;
  out[11] = 0;
  out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
  out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
  out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
  out[15] = 1;
  return out;
}
/**
 * Calculates a 4x4 matrix from the given quaternion
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyQuat} q Quaternion to create matrix from
 *
 * @returns {mat4} out
 */

function fromQuat$1(out, q) {
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var yx = y * x2;
  var yy = y * y2;
  var zx = z * x2;
  var zy = z * y2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - yy - zz;
  out[1] = yx + wz;
  out[2] = zx - wy;
  out[3] = 0;
  out[4] = yx - wz;
  out[5] = 1 - xx - zz;
  out[6] = zy + wx;
  out[7] = 0;
  out[8] = zx + wy;
  out[9] = zy - wx;
  out[10] = 1 - xx - yy;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Generates a frustum matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Number} left Left bound of the frustum
 * @param {Number} right Right bound of the frustum
 * @param {Number} bottom Bottom bound of the frustum
 * @param {Number} top Top bound of the frustum
 * @param {Number} near Near bound of the frustum
 * @param {Number} far Far bound of the frustum
 * @returns {mat4} out
 */

function frustum(out, left, right, bottom, top, near, far) {
  var rl = 1 / (right - left);
  var tb = 1 / (top - bottom);
  var nf = 1 / (near - far);
  out[0] = near * 2 * rl;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = near * 2 * tb;
  out[6] = 0;
  out[7] = 0;
  out[8] = (right + left) * rl;
  out[9] = (top + bottom) * tb;
  out[10] = (far + near) * nf;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[14] = far * near * 2 * nf;
  out[15] = 0;
  return out;
}
/**
 * Generates a perspective projection matrix with the given bounds.
 * Passing null/undefined/no value for far will generate infinite projection matrix.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum, can be null or Infinity
 * @returns {mat4} out
 */

function perspective(out, fovy, aspect, near, far) {
  var f = 1.0 / Math.tan(fovy / 2),
      nf;
  out[0] = f / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[15] = 0;

  if (far != null && far !== Infinity) {
    nf = 1 / (near - far);
    out[10] = (far + near) * nf;
    out[14] = 2 * far * near * nf;
  } else {
    out[10] = -1;
    out[14] = -2 * near;
  }

  return out;
}
/**
 * Generates a perspective projection matrix with the given field of view.
 * This is primarily useful for generating projection matrices to be used
 * with the still experiemental WebVR API.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Object} fov Object containing the following values: upDegrees, downDegrees, leftDegrees, rightDegrees
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function perspectiveFromFieldOfView(out, fov, near, far) {
  var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
  var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
  var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
  var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
  var xScale = 2.0 / (leftTan + rightTan);
  var yScale = 2.0 / (upTan + downTan);
  out[0] = xScale;
  out[1] = 0.0;
  out[2] = 0.0;
  out[3] = 0.0;
  out[4] = 0.0;
  out[5] = yScale;
  out[6] = 0.0;
  out[7] = 0.0;
  out[8] = -((leftTan - rightTan) * xScale * 0.5);
  out[9] = (upTan - downTan) * yScale * 0.5;
  out[10] = far / (near - far);
  out[11] = -1.0;
  out[12] = 0.0;
  out[13] = 0.0;
  out[14] = far * near / (near - far);
  out[15] = 0.0;
  return out;
}
/**
 * Generates a orthogonal projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function ortho(out, left, right, bottom, top, near, far) {
  var lr = 1 / (left - right);
  var bt = 1 / (bottom - top);
  var nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 2 * nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt;
  out[14] = (far + near) * nf;
  out[15] = 1;
  return out;
}
/**
 * Generates a look-at matrix with the given eye position, focal point, and up axis.
 * If you want a matrix that actually makes an object look at another object, you should use targetTo instead.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {ReadonlyVec3} eye Position of the viewer
 * @param {ReadonlyVec3} center Point the viewer is looking at
 * @param {ReadonlyVec3} up vec3 pointing up
 * @returns {mat4} out
 */

function lookAt(out, eye, center, up) {
  var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
  var eyex = eye[0];
  var eyey = eye[1];
  var eyez = eye[2];
  var upx = up[0];
  var upy = up[1];
  var upz = up[2];
  var centerx = center[0];
  var centery = center[1];
  var centerz = center[2];

  if (Math.abs(eyex - centerx) < EPSILON && Math.abs(eyey - centery) < EPSILON && Math.abs(eyez - centerz) < EPSILON) {
    return identity$1(out);
  }

  z0 = eyex - centerx;
  z1 = eyey - centery;
  z2 = eyez - centerz;
  len = 1 / Math.hypot(z0, z1, z2);
  z0 *= len;
  z1 *= len;
  z2 *= len;
  x0 = upy * z2 - upz * z1;
  x1 = upz * z0 - upx * z2;
  x2 = upx * z1 - upy * z0;
  len = Math.hypot(x0, x1, x2);

  if (!len) {
    x0 = 0;
    x1 = 0;
    x2 = 0;
  } else {
    len = 1 / len;
    x0 *= len;
    x1 *= len;
    x2 *= len;
  }

  y0 = z1 * x2 - z2 * x1;
  y1 = z2 * x0 - z0 * x2;
  y2 = z0 * x1 - z1 * x0;
  len = Math.hypot(y0, y1, y2);

  if (!len) {
    y0 = 0;
    y1 = 0;
    y2 = 0;
  } else {
    len = 1 / len;
    y0 *= len;
    y1 *= len;
    y2 *= len;
  }

  out[0] = x0;
  out[1] = y0;
  out[2] = z0;
  out[3] = 0;
  out[4] = x1;
  out[5] = y1;
  out[6] = z1;
  out[7] = 0;
  out[8] = x2;
  out[9] = y2;
  out[10] = z2;
  out[11] = 0;
  out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
  out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
  out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
  out[15] = 1;
  return out;
}
/**
 * Generates a matrix that makes something look at something else.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {ReadonlyVec3} eye Position of the viewer
 * @param {ReadonlyVec3} center Point the viewer is looking at
 * @param {ReadonlyVec3} up vec3 pointing up
 * @returns {mat4} out
 */

function targetTo(out, eye, target, up) {
  var eyex = eye[0],
      eyey = eye[1],
      eyez = eye[2],
      upx = up[0],
      upy = up[1],
      upz = up[2];
  var z0 = eyex - target[0],
      z1 = eyey - target[1],
      z2 = eyez - target[2];
  var len = z0 * z0 + z1 * z1 + z2 * z2;

  if (len > 0) {
    len = 1 / Math.sqrt(len);
    z0 *= len;
    z1 *= len;
    z2 *= len;
  }

  var x0 = upy * z2 - upz * z1,
      x1 = upz * z0 - upx * z2,
      x2 = upx * z1 - upy * z0;
  len = x0 * x0 + x1 * x1 + x2 * x2;

  if (len > 0) {
    len = 1 / Math.sqrt(len);
    x0 *= len;
    x1 *= len;
    x2 *= len;
  }

  out[0] = x0;
  out[1] = x1;
  out[2] = x2;
  out[3] = 0;
  out[4] = z1 * x2 - z2 * x1;
  out[5] = z2 * x0 - z0 * x2;
  out[6] = z0 * x1 - z1 * x0;
  out[7] = 0;
  out[8] = z0;
  out[9] = z1;
  out[10] = z2;
  out[11] = 0;
  out[12] = eyex;
  out[13] = eyey;
  out[14] = eyez;
  out[15] = 1;
  return out;
}
/**
 * Returns a string representation of a mat4
 *
 * @param {ReadonlyMat4} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */

function str$3(a) {
  return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
/**
 * Returns Frobenius norm of a mat4
 *
 * @param {ReadonlyMat4} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */

function frob$1(a) {
  return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
/**
 * Adds two mat4's
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function add$3(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  out[6] = a[6] + b[6];
  out[7] = a[7] + b[7];
  out[8] = a[8] + b[8];
  out[9] = a[9] + b[9];
  out[10] = a[10] + b[10];
  out[11] = a[11] + b[11];
  out[12] = a[12] + b[12];
  out[13] = a[13] + b[13];
  out[14] = a[14] + b[14];
  out[15] = a[15] + b[15];
  return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function subtract$3(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  out[6] = a[6] - b[6];
  out[7] = a[7] - b[7];
  out[8] = a[8] - b[8];
  out[9] = a[9] - b[9];
  out[10] = a[10] - b[10];
  out[11] = a[11] - b[11];
  out[12] = a[12] - b[12];
  out[13] = a[13] - b[13];
  out[14] = a[14] - b[14];
  out[15] = a[15] - b[15];
  return out;
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat4} out
 */

function multiplyScalar$1(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  out[6] = a[6] * b;
  out[7] = a[7] * b;
  out[8] = a[8] * b;
  out[9] = a[9] * b;
  out[10] = a[10] * b;
  out[11] = a[11] * b;
  out[12] = a[12] * b;
  out[13] = a[13] * b;
  out[14] = a[14] * b;
  out[15] = a[15] * b;
  return out;
}
/**
 * Adds two mat4's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat4} out the receiving vector
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat4} out
 */

function multiplyScalarAndAdd$1(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  out[4] = a[4] + b[4] * scale;
  out[5] = a[5] + b[5] * scale;
  out[6] = a[6] + b[6] * scale;
  out[7] = a[7] + b[7] * scale;
  out[8] = a[8] + b[8] * scale;
  out[9] = a[9] + b[9] * scale;
  out[10] = a[10] + b[10] * scale;
  out[11] = a[11] + b[11] * scale;
  out[12] = a[12] + b[12] * scale;
  out[13] = a[13] + b[13] * scale;
  out[14] = a[14] + b[14] * scale;
  out[15] = a[15] + b[15] * scale;
  return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function exactEquals$3(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function equals$4(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var a4 = a[4],
      a5 = a[5],
      a6 = a[6],
      a7 = a[7];
  var a8 = a[8],
      a9 = a[9],
      a10 = a[10],
      a11 = a[11];
  var a12 = a[12],
      a13 = a[13],
      a14 = a[14],
      a15 = a[15];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  var b4 = b[4],
      b5 = b[5],
      b6 = b[6],
      b7 = b[7];
  var b8 = b[8],
      b9 = b[9],
      b10 = b[10],
      b11 = b[11];
  var b12 = b[12],
      b13 = b[13],
      b14 = b[14],
      b15 = b[15];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
/**
 * Alias for {@link mat4.multiply}
 * @function
 */

var mul$3 = multiply$3;
/**
 * Alias for {@link mat4.subtract}
 * @function
 */

var sub$3 = subtract$3;

var mat4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    create: create$3,
    clone: clone$3,
    copy: copy$3,
    fromValues: fromValues$3,
    set: set$3,
    identity: identity$1,
    transpose: transpose$1,
    invert: invert$1,
    adjoint: adjoint$1,
    determinant: determinant$1,
    multiply: multiply$3,
    translate: translate$1,
    scale: scale$3,
    rotate: rotate$2,
    rotateX: rotateX$1,
    rotateY: rotateY$1,
    rotateZ: rotateZ$1,
    fromTranslation: fromTranslation$1,
    fromScaling: fromScaling$1,
    fromRotation: fromRotation$1,
    fromXRotation: fromXRotation,
    fromYRotation: fromYRotation,
    fromZRotation: fromZRotation,
    fromRotationTranslation: fromRotationTranslation,
    fromQuat2: fromQuat2,
    getTranslation: getTranslation,
    getScaling: getScaling,
    getRotation: getRotation,
    fromRotationTranslationScale: fromRotationTranslationScale,
    fromRotationTranslationScaleOrigin: fromRotationTranslationScaleOrigin,
    fromQuat: fromQuat$1,
    frustum: frustum,
    perspective: perspective,
    perspectiveFromFieldOfView: perspectiveFromFieldOfView,
    ortho: ortho,
    lookAt: lookAt,
    targetTo: targetTo,
    str: str$3,
    frob: frob$1,
    add: add$3,
    subtract: subtract$3,
    multiplyScalar: multiplyScalar$1,
    multiplyScalarAndAdd: multiplyScalarAndAdd$1,
    exactEquals: exactEquals$3,
    equals: equals$4,
    mul: mul$3,
    sub: sub$3
});

/**
 * 4 Dimensional Vector
 * @module vec4
 */

/**
 * Creates a new, empty vec4
 *
 * @returns {vec4} a new 4D vector
 */

function create$4() {
  var out = new ARRAY_TYPE(4);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
  }

  return out;
}
/**
 * Creates a new vec4 initialized with values from an existing vector
 *
 * @param {ReadonlyVec4} a vector to clone
 * @returns {vec4} a new 4D vector
 */

function clone$4(a) {
  var out = new ARRAY_TYPE(4);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}
/**
 * Creates a new vec4 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} a new 4D vector
 */

function fromValues$4(x, y, z, w) {
  var out = new ARRAY_TYPE(4);
  out[0] = x;
  out[1] = y;
  out[2] = z;
  out[3] = w;
  return out;
}
/**
 * Copy the values from one vec4 to another
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the source vector
 * @returns {vec4} out
 */

function copy$4(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}
/**
 * Set the components of a vec4 to the given values
 *
 * @param {vec4} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} out
 */

function set$4(out, x, y, z, w) {
  out[0] = x;
  out[1] = y;
  out[2] = z;
  out[3] = w;
  return out;
}
/**
 * Adds two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function add$4(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function subtract$4(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  return out;
}
/**
 * Multiplies two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function multiply$4(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  out[2] = a[2] * b[2];
  out[3] = a[3] * b[3];
  return out;
}
/**
 * Divides two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function divide$2(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  out[2] = a[2] / b[2];
  out[3] = a[3] / b[3];
  return out;
}
/**
 * Math.ceil the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to ceil
 * @returns {vec4} out
 */

function ceil$2(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  out[2] = Math.ceil(a[2]);
  out[3] = Math.ceil(a[3]);
  return out;
}
/**
 * Math.floor the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to floor
 * @returns {vec4} out
 */

function floor$2(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  out[2] = Math.floor(a[2]);
  out[3] = Math.floor(a[3]);
  return out;
}
/**
 * Returns the minimum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function min$2(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  out[2] = Math.min(a[2], b[2]);
  out[3] = Math.min(a[3], b[3]);
  return out;
}
/**
 * Returns the maximum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function max$2(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  out[2] = Math.max(a[2], b[2]);
  out[3] = Math.max(a[3], b[3]);
  return out;
}
/**
 * Math.round the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to round
 * @returns {vec4} out
 */

function round$3(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  out[2] = Math.round(a[2]);
  out[3] = Math.round(a[3]);
  return out;
}
/**
 * Scales a vec4 by a scalar number
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec4} out
 */

function scale$4(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  return out;
}
/**
 * Adds two vec4's after scaling the second operand by a scalar value
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec4} out
 */

function scaleAndAdd$2(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  return out;
}
/**
 * Calculates the euclidian distance between two vec4's
 *
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {Number} distance between a and b
 */

function distance$2(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  var w = b[3] - a[3];
  return Math.hypot(x, y, z, w);
}
/**
 * Calculates the squared euclidian distance between two vec4's
 *
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {Number} squared distance between a and b
 */

function squaredDistance$2(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  var w = b[3] - a[3];
  return x * x + y * y + z * z + w * w;
}
/**
 * Calculates the length of a vec4
 *
 * @param {ReadonlyVec4} a vector to calculate length of
 * @returns {Number} length of a
 */

function length$2(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var w = a[3];
  return Math.hypot(x, y, z, w);
}
/**
 * Calculates the squared length of a vec4
 *
 * @param {ReadonlyVec4} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function squaredLength$2(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var w = a[3];
  return x * x + y * y + z * z + w * w;
}
/**
 * Negates the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to negate
 * @returns {vec4} out
 */

function negate$2(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  out[3] = -a[3];
  return out;
}
/**
 * Returns the inverse of the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to invert
 * @returns {vec4} out
 */

function inverse$2(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  out[2] = 1.0 / a[2];
  out[3] = 1.0 / a[3];
  return out;
}
/**
 * Normalize a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to normalize
 * @returns {vec4} out
 */

function normalize$2(out, a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var w = a[3];
  var len = x * x + y * y + z * z + w * w;

  if (len > 0) {
    len = 1 / Math.sqrt(len);
  }

  out[0] = x * len;
  out[1] = y * len;
  out[2] = z * len;
  out[3] = w * len;
  return out;
}
/**
 * Calculates the dot product of two vec4's
 *
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {Number} dot product of a and b
 */

function dot$2(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
/**
 * Returns the cross-product of three vectors in a 4-dimensional space
 *
 * @param {ReadonlyVec4} result the receiving vector
 * @param {ReadonlyVec4} U the first vector
 * @param {ReadonlyVec4} V the second vector
 * @param {ReadonlyVec4} W the third vector
 * @returns {vec4} result
 */

function cross$2(out, u, v, w) {
  var A = v[0] * w[1] - v[1] * w[0],
      B = v[0] * w[2] - v[2] * w[0],
      C = v[0] * w[3] - v[3] * w[0],
      D = v[1] * w[2] - v[2] * w[1],
      E = v[1] * w[3] - v[3] * w[1],
      F = v[2] * w[3] - v[3] * w[2];
  var G = u[0];
  var H = u[1];
  var I = u[2];
  var J = u[3];
  out[0] = H * F - I * E + J * D;
  out[1] = -(G * F) + I * C - J * B;
  out[2] = G * E - H * C + J * A;
  out[3] = -(G * D) + H * B - I * A;
  return out;
}
/**
 * Performs a linear interpolation between two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec4} out
 */

function lerp$2(out, a, b, t) {
  var ax = a[0];
  var ay = a[1];
  var az = a[2];
  var aw = a[3];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  out[2] = az + t * (b[2] - az);
  out[3] = aw + t * (b[3] - aw);
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec4} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec4} out
 */

function random$2(out, scale) {
  scale = scale || 1.0; // Marsaglia, George. Choosing a Point from the Surface of a
  // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
  // http://projecteuclid.org/euclid.aoms/1177692644;

  var v1, v2, v3, v4;
  var s1, s2;

  do {
    v1 = RANDOM() * 2 - 1;
    v2 = RANDOM() * 2 - 1;
    s1 = v1 * v1 + v2 * v2;
  } while (s1 >= 1);

  do {
    v3 = RANDOM() * 2 - 1;
    v4 = RANDOM() * 2 - 1;
    s2 = v3 * v3 + v4 * v4;
  } while (s2 >= 1);

  var d = Math.sqrt((1 - s1) / s2);
  out[0] = scale * v1;
  out[1] = scale * v2;
  out[2] = scale * v3 * d;
  out[3] = scale * v4 * d;
  return out;
}
/**
 * Transforms the vec4 with a mat4.
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec4} out
 */

function transformMat4$2(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2],
      w = a[3];
  out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
  out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
  out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
  out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
  return out;
}
/**
 * Transforms the vec4 with a quat
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the vector to transform
 * @param {ReadonlyQuat} q quaternion to transform with
 * @returns {vec4} out
 */

function transformQuat$1(out, a, q) {
  var x = a[0],
      y = a[1],
      z = a[2];
  var qx = q[0],
      qy = q[1],
      qz = q[2],
      qw = q[3]; // calculate quat * vec

  var ix = qw * x + qy * z - qz * y;
  var iy = qw * y + qz * x - qx * z;
  var iz = qw * z + qx * y - qy * x;
  var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat

  out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
  out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
  out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
  out[3] = a[3];
  return out;
}
/**
 * Set the components of a vec4 to zero
 *
 * @param {vec4} out the receiving vector
 * @returns {vec4} out
 */

function zero$2(out) {
  out[0] = 0.0;
  out[1] = 0.0;
  out[2] = 0.0;
  out[3] = 0.0;
  return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec4} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function str$4(a) {
  return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec4} a The first vector.
 * @param {ReadonlyVec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function exactEquals$4(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec4} a The first vector.
 * @param {ReadonlyVec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function equals$5(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
/**
 * Alias for {@link vec4.subtract}
 * @function
 */

var sub$4 = subtract$4;
/**
 * Alias for {@link vec4.multiply}
 * @function
 */

var mul$4 = multiply$4;
/**
 * Alias for {@link vec4.divide}
 * @function
 */

var div$2 = divide$2;
/**
 * Alias for {@link vec4.distance}
 * @function
 */

var dist$2 = distance$2;
/**
 * Alias for {@link vec4.squaredDistance}
 * @function
 */

var sqrDist$2 = squaredDistance$2;
/**
 * Alias for {@link vec4.length}
 * @function
 */

var len$2 = length$2;
/**
 * Alias for {@link vec4.squaredLength}
 * @function
 */

var sqrLen$2 = squaredLength$2;
/**
 * Perform some operation over an array of vec4s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec4. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec4s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var forEach$2 = function () {
  var vec = create$4();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 4;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      vec[2] = a[i + 2];
      vec[3] = a[i + 3];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
      a[i + 2] = vec[2];
      a[i + 3] = vec[3];
    }

    return a;
  };
}();

var vec4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    create: create$4,
    clone: clone$4,
    fromValues: fromValues$4,
    copy: copy$4,
    set: set$4,
    add: add$4,
    subtract: subtract$4,
    multiply: multiply$4,
    divide: divide$2,
    ceil: ceil$2,
    floor: floor$2,
    min: min$2,
    max: max$2,
    round: round$3,
    scale: scale$4,
    scaleAndAdd: scaleAndAdd$2,
    distance: distance$2,
    squaredDistance: squaredDistance$2,
    length: length$2,
    squaredLength: squaredLength$2,
    negate: negate$2,
    inverse: inverse$2,
    normalize: normalize$2,
    dot: dot$2,
    cross: cross$2,
    lerp: lerp$2,
    random: random$2,
    transformMat4: transformMat4$2,
    transformQuat: transformQuat$1,
    zero: zero$2,
    str: str$4,
    exactEquals: exactEquals$4,
    equals: equals$5,
    sub: sub$4,
    mul: mul$4,
    div: div$2,
    dist: dist$2,
    sqrDist: sqrDist$2,
    len: len$2,
    sqrLen: sqrLen$2,
    forEach: forEach$2
});

const IDENTITY = Object.freeze([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
const ZERO = Object.freeze([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
const INDICES = Object.freeze({
  COL0ROW0: 0,
  COL0ROW1: 1,
  COL0ROW2: 2,
  COL0ROW3: 3,
  COL1ROW0: 4,
  COL1ROW1: 5,
  COL1ROW2: 6,
  COL1ROW3: 7,
  COL2ROW0: 8,
  COL2ROW1: 9,
  COL2ROW2: 10,
  COL2ROW3: 11,
  COL3ROW0: 12,
  COL3ROW1: 13,
  COL3ROW2: 14,
  COL3ROW3: 15
});
const constants$2 = {};
class Matrix4 extends Matrix {
  static get IDENTITY() {
    constants$2.IDENTITY = constants$2.IDENTITY || Object.freeze(new Matrix4(IDENTITY));
    return constants$2.IDENTITY;
  }

  static get ZERO() {
    constants$2.ZERO = constants$2.ZERO || Object.freeze(new Matrix4(ZERO));
    return constants$2.ZERO;
  }

  get INDICES() {
    return INDICES;
  }

  get ELEMENTS() {
    return 16;
  }

  get RANK() {
    return 4;
  }

  constructor(array) {
    super(-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0);

    if (arguments.length === 1 && Array.isArray(array)) {
      this.copy(array);
    } else {
      this.identity();
    }
  }

  copy(array) {
    this[0] = array[0];
    this[1] = array[1];
    this[2] = array[2];
    this[3] = array[3];
    this[4] = array[4];
    this[5] = array[5];
    this[6] = array[6];
    this[7] = array[7];
    this[8] = array[8];
    this[9] = array[9];
    this[10] = array[10];
    this[11] = array[11];
    this[12] = array[12];
    this[13] = array[13];
    this[14] = array[14];
    this[15] = array[15];
    return this.check();
  }

  set(m00, m10, m20, m30, m01, m11, m21, m31, m02, m12, m22, m32, m03, m13, m23, m33) {
    this[0] = m00;
    this[1] = m10;
    this[2] = m20;
    this[3] = m30;
    this[4] = m01;
    this[5] = m11;
    this[6] = m21;
    this[7] = m31;
    this[8] = m02;
    this[9] = m12;
    this[10] = m22;
    this[11] = m32;
    this[12] = m03;
    this[13] = m13;
    this[14] = m23;
    this[15] = m33;
    return this.check();
  }

  setRowMajor(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    this[0] = m00;
    this[1] = m10;
    this[2] = m20;
    this[3] = m30;
    this[4] = m01;
    this[5] = m11;
    this[6] = m21;
    this[7] = m31;
    this[8] = m02;
    this[9] = m12;
    this[10] = m22;
    this[11] = m32;
    this[12] = m03;
    this[13] = m13;
    this[14] = m23;
    this[15] = m33;
    return this.check();
  }

  toRowMajor(result) {
    result[0] = this[0];
    result[1] = this[4];
    result[2] = this[8];
    result[3] = this[12];
    result[4] = this[1];
    result[5] = this[5];
    result[6] = this[9];
    result[7] = this[13];
    result[8] = this[2];
    result[9] = this[6];
    result[10] = this[10];
    result[11] = this[14];
    result[12] = this[3];
    result[13] = this[7];
    result[14] = this[11];
    result[15] = this[15];
    return result;
  }

  identity() {
    return this.copy(IDENTITY);
  }

  fromQuaternion(q) {
    fromQuat$1(this, q);
    return this.check();
  }

  frustum({
    left,
    right,
    bottom,
    top,
    near,
    far
  }) {
    if (far === Infinity) {
      Matrix4._computeInfinitePerspectiveOffCenter(this, left, right, bottom, top, near);
    } else {
      frustum(this, left, right, bottom, top, near, far);
    }

    return this.check();
  }

  static _computeInfinitePerspectiveOffCenter(result, left, right, bottom, top, near) {
    const column0Row0 = 2.0 * near / (right - left);
    const column1Row1 = 2.0 * near / (top - bottom);
    const column2Row0 = (right + left) / (right - left);
    const column2Row1 = (top + bottom) / (top - bottom);
    const column2Row2 = -1.0;
    const column2Row3 = -1.0;
    const column3Row2 = -2.0 * near;
    result[0] = column0Row0;
    result[1] = 0.0;
    result[2] = 0.0;
    result[3] = 0.0;
    result[4] = 0.0;
    result[5] = column1Row1;
    result[6] = 0.0;
    result[7] = 0.0;
    result[8] = column2Row0;
    result[9] = column2Row1;
    result[10] = column2Row2;
    result[11] = column2Row3;
    result[12] = 0.0;
    result[13] = 0.0;
    result[14] = column3Row2;
    result[15] = 0.0;
    return result;
  }

  lookAt(eye, center, up) {
    if (arguments.length === 1) {
      ({
        eye,
        center,
        up
      } = eye);
    }

    center = center || [0, 0, 0];
    up = up || [0, 1, 0];
    lookAt(this, eye, center, up);
    return this.check();
  }

  ortho({
    left,
    right,
    bottom,
    top,
    near = 0.1,
    far = 500
  }) {
    ortho(this, left, right, bottom, top, near, far);
    return this.check();
  }

  orthographic({
    fovy = 45 * Math.PI / 180,
    aspect = 1,
    focalDistance = 1,
    near = 0.1,
    far = 500
  }) {
    if (fovy > Math.PI * 2) {
      throw Error('radians');
    }

    const halfY = fovy / 2;
    const top = focalDistance * Math.tan(halfY);
    const right = top * aspect;
    return new Matrix4().ortho({
      left: -right,
      right,
      bottom: -top,
      top,
      near,
      far
    });
  }

  perspective({
    fovy = undefined,
    fov = 45 * Math.PI / 180,
    aspect = 1,
    near = 0.1,
    far = 500
  } = {}) {
    fovy = fovy || fov;

    if (fovy > Math.PI * 2) {
      throw Error('radians');
    }

    perspective(this, fovy, aspect, near, far);
    return this.check();
  }

  determinant() {
    return determinant$1(this);
  }

  getScale(result = [-0, -0, -0]) {
    result[0] = Math.sqrt(this[0] * this[0] + this[1] * this[1] + this[2] * this[2]);
    result[1] = Math.sqrt(this[4] * this[4] + this[5] * this[5] + this[6] * this[6]);
    result[2] = Math.sqrt(this[8] * this[8] + this[9] * this[9] + this[10] * this[10]);
    return result;
  }

  getTranslation(result = [-0, -0, -0]) {
    result[0] = this[12];
    result[1] = this[13];
    result[2] = this[14];
    return result;
  }

  getRotation(result = [-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0], scaleResult = null) {
    const scale = this.getScale(scaleResult || [-0, -0, -0]);
    const inverseScale0 = 1 / scale[0];
    const inverseScale1 = 1 / scale[1];
    const inverseScale2 = 1 / scale[2];
    result[0] = this[0] * inverseScale0;
    result[1] = this[1] * inverseScale1;
    result[2] = this[2] * inverseScale2;
    result[3] = 0;
    result[4] = this[4] * inverseScale0;
    result[5] = this[5] * inverseScale1;
    result[6] = this[6] * inverseScale2;
    result[7] = 0;
    result[8] = this[8] * inverseScale0;
    result[9] = this[9] * inverseScale1;
    result[10] = this[10] * inverseScale2;
    result[11] = 0;
    result[12] = 0;
    result[13] = 0;
    result[14] = 0;
    result[15] = 1;
    return result;
  }

  getRotationMatrix3(result = [-0, -0, -0, -0, -0, -0, -0, -0, -0], scaleResult = null) {
    const scale = this.getScale(scaleResult || [-0, -0, -0]);
    const inverseScale0 = 1 / scale[0];
    const inverseScale1 = 1 / scale[1];
    const inverseScale2 = 1 / scale[2];
    result[0] = this[0] * inverseScale0;
    result[1] = this[1] * inverseScale1;
    result[2] = this[2] * inverseScale2;
    result[3] = this[4] * inverseScale0;
    result[4] = this[5] * inverseScale1;
    result[5] = this[6] * inverseScale2;
    result[6] = this[8] * inverseScale0;
    result[7] = this[9] * inverseScale1;
    result[8] = this[10] * inverseScale2;
    return result;
  }

  transpose() {
    transpose$1(this, this);
    return this.check();
  }

  invert() {
    invert$1(this, this);
    return this.check();
  }

  multiplyLeft(a) {
    multiply$3(this, a, this);
    return this.check();
  }

  multiplyRight(a) {
    multiply$3(this, this, a);
    return this.check();
  }

  rotateX(radians) {
    rotateX$1(this, this, radians);
    return this.check();
  }

  rotateY(radians) {
    rotateY$1(this, this, radians);
    return this.check();
  }

  rotateZ(radians) {
    rotateZ$1(this, this, radians);
    return this.check();
  }

  rotateXYZ([rx, ry, rz]) {
    return this.rotateX(rx).rotateY(ry).rotateZ(rz);
  }

  rotateAxis(radians, axis) {
    rotate$2(this, this, radians, axis);
    return this.check();
  }

  scale(factor) {
    if (Array.isArray(factor)) {
      scale$3(this, this, factor);
    } else {
      scale$3(this, this, [factor, factor, factor]);
    }

    return this.check();
  }

  translate(vec) {
    translate$1(this, this, vec);
    return this.check();
  }

  transform(vector, result) {
    if (vector.length === 4) {
      result = transformMat4$2(result || [-0, -0, -0, -0], vector, this);
      checkVector(result, 4);
      return result;
    }

    return this.transformAsPoint(vector, result);
  }

  transformAsPoint(vector, result) {
    const {
      length
    } = vector;

    switch (length) {
      case 2:
        result = transformMat4(result || [-0, -0], vector, this);
        break;

      case 3:
        result = transformMat4$1(result || [-0, -0, -0], vector, this);
        break;

      default:
        throw new Error('Illegal vector');
    }

    checkVector(result, vector.length);
    return result;
  }

  transformAsVector(vector, result) {
    switch (vector.length) {
      case 2:
        result = vec2_transformMat4AsVector(result || [-0, -0], vector, this);
        break;

      case 3:
        result = vec3_transformMat4AsVector(result || [-0, -0, -0], vector, this);
        break;

      default:
        throw new Error('Illegal vector');
    }

    checkVector(result, vector.length);
    return result;
  }

  makeRotationX(radians) {
    return this.identity().rotateX(radians);
  }

  makeTranslation(x, y, z) {
    return this.identity().translate([x, y, z]);
  }

  transformPoint(vector, result) {
    deprecated('Matrix4.transformPoint', '3.0');
    return this.transformAsPoint(vector, result);
  }

  transformVector(vector, result) {
    deprecated('Matrix4.transformVector', '3.0');
    return this.transformAsPoint(vector, result);
  }

  transformDirection(vector, result) {
    deprecated('Matrix4.transformDirection', '3.0');
    return this.transformAsVector(vector, result);
  }

}

/**
 * Quaternion
 * @module quat
 */

/**
 * Creates a new identity quat
 *
 * @returns {quat} a new quaternion
 */

function create$5() {
  var out = new ARRAY_TYPE(4);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
  }

  out[3] = 1;
  return out;
}
/**
 * Set a quat to the identity quaternion
 *
 * @param {quat} out the receiving quaternion
 * @returns {quat} out
 */

function identity$2(out) {
  out[0] = 0;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  return out;
}
/**
 * Sets a quat from the given angle and rotation axis,
 * then returns it.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyVec3} axis the axis around which to rotate
 * @param {Number} rad the angle in radians
 * @returns {quat} out
 **/

function setAxisAngle(out, axis, rad) {
  rad = rad * 0.5;
  var s = Math.sin(rad);
  out[0] = s * axis[0];
  out[1] = s * axis[1];
  out[2] = s * axis[2];
  out[3] = Math.cos(rad);
  return out;
}
/**
 * Gets the rotation axis and angle for a given
 *  quaternion. If a quaternion is created with
 *  setAxisAngle, this method will return the same
 *  values as providied in the original parameter list
 *  OR functionally equivalent values.
 * Example: The quaternion formed by axis [0, 0, 1] and
 *  angle -90 is the same as the quaternion formed by
 *  [0, 0, 1] and 270. This method favors the latter.
 * @param  {vec3} out_axis  Vector receiving the axis of rotation
 * @param  {ReadonlyQuat} q     Quaternion to be decomposed
 * @return {Number}     Angle, in radians, of the rotation
 */

function getAxisAngle(out_axis, q) {
  var rad = Math.acos(q[3]) * 2.0;
  var s = Math.sin(rad / 2.0);

  if (s > EPSILON) {
    out_axis[0] = q[0] / s;
    out_axis[1] = q[1] / s;
    out_axis[2] = q[2] / s;
  } else {
    // If s is zero, return any axis (no rotation - axis does not matter)
    out_axis[0] = 1;
    out_axis[1] = 0;
    out_axis[2] = 0;
  }

  return rad;
}
/**
 * Gets the angular distance between two unit quaternions
 *
 * @param  {ReadonlyQuat} a     Origin unit quaternion
 * @param  {ReadonlyQuat} b     Destination unit quaternion
 * @return {Number}     Angle, in radians, between the two quaternions
 */

function getAngle(a, b) {
  var dotproduct = dot$3(a, b);
  return Math.acos(2 * dotproduct * dotproduct - 1);
}
/**
 * Multiplies two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @returns {quat} out
 */

function multiply$5(out, a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var bx = b[0],
      by = b[1],
      bz = b[2],
      bw = b[3];
  out[0] = ax * bw + aw * bx + ay * bz - az * by;
  out[1] = ay * bw + aw * by + az * bx - ax * bz;
  out[2] = az * bw + aw * bz + ax * by - ay * bx;
  out[3] = aw * bw - ax * bx - ay * by - az * bz;
  return out;
}
/**
 * Rotates a quaternion by the given angle about the X axis
 *
 * @param {quat} out quat receiving operation result
 * @param {ReadonlyQuat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */

function rotateX$2(out, a, rad) {
  rad *= 0.5;
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var bx = Math.sin(rad),
      bw = Math.cos(rad);
  out[0] = ax * bw + aw * bx;
  out[1] = ay * bw + az * bx;
  out[2] = az * bw - ay * bx;
  out[3] = aw * bw - ax * bx;
  return out;
}
/**
 * Rotates a quaternion by the given angle about the Y axis
 *
 * @param {quat} out quat receiving operation result
 * @param {ReadonlyQuat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */

function rotateY$2(out, a, rad) {
  rad *= 0.5;
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var by = Math.sin(rad),
      bw = Math.cos(rad);
  out[0] = ax * bw - az * by;
  out[1] = ay * bw + aw * by;
  out[2] = az * bw + ax * by;
  out[3] = aw * bw - ay * by;
  return out;
}
/**
 * Rotates a quaternion by the given angle about the Z axis
 *
 * @param {quat} out quat receiving operation result
 * @param {ReadonlyQuat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */

function rotateZ$2(out, a, rad) {
  rad *= 0.5;
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var bz = Math.sin(rad),
      bw = Math.cos(rad);
  out[0] = ax * bw + ay * bz;
  out[1] = ay * bw - ax * bz;
  out[2] = az * bw + aw * bz;
  out[3] = aw * bw - az * bz;
  return out;
}
/**
 * Calculates the W component of a quat from the X, Y, and Z components.
 * Assumes that quaternion is 1 unit in length.
 * Any existing W component will be ignored.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate W component of
 * @returns {quat} out
 */

function calculateW(out, a) {
  var x = a[0],
      y = a[1],
      z = a[2];
  out[0] = x;
  out[1] = y;
  out[2] = z;
  out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
  return out;
}
/**
 * Calculate the exponential of a unit quaternion.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate the exponential of
 * @returns {quat} out
 */

function exp(out, a) {
  var x = a[0],
      y = a[1],
      z = a[2],
      w = a[3];
  var r = Math.sqrt(x * x + y * y + z * z);
  var et = Math.exp(w);
  var s = r > 0 ? et * Math.sin(r) / r : 0;
  out[0] = x * s;
  out[1] = y * s;
  out[2] = z * s;
  out[3] = et * Math.cos(r);
  return out;
}
/**
 * Calculate the natural logarithm of a unit quaternion.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate the exponential of
 * @returns {quat} out
 */

function ln(out, a) {
  var x = a[0],
      y = a[1],
      z = a[2],
      w = a[3];
  var r = Math.sqrt(x * x + y * y + z * z);
  var t = r > 0 ? Math.atan2(r, w) / r : 0;
  out[0] = x * t;
  out[1] = y * t;
  out[2] = z * t;
  out[3] = 0.5 * Math.log(x * x + y * y + z * z + w * w);
  return out;
}
/**
 * Calculate the scalar power of a unit quaternion.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate the exponential of
 * @param {Number} b amount to scale the quaternion by
 * @returns {quat} out
 */

function pow(out, a, b) {
  ln(out, a);
  scale$5(out, out, b);
  exp(out, out);
  return out;
}
/**
 * Performs a spherical linear interpolation between two quat
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {quat} out
 */

function slerp(out, a, b, t) {
  // benchmarks:
  //    http://jsperf.com/quaternion-slerp-implementations
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var bx = b[0],
      by = b[1],
      bz = b[2],
      bw = b[3];
  var omega, cosom, sinom, scale0, scale1; // calc cosine

  cosom = ax * bx + ay * by + az * bz + aw * bw; // adjust signs (if necessary)

  if (cosom < 0.0) {
    cosom = -cosom;
    bx = -bx;
    by = -by;
    bz = -bz;
    bw = -bw;
  } // calculate coefficients


  if (1.0 - cosom > EPSILON) {
    // standard case (slerp)
    omega = Math.acos(cosom);
    sinom = Math.sin(omega);
    scale0 = Math.sin((1.0 - t) * omega) / sinom;
    scale1 = Math.sin(t * omega) / sinom;
  } else {
    // "from" and "to" quaternions are very close
    //  ... so we can do a linear interpolation
    scale0 = 1.0 - t;
    scale1 = t;
  } // calculate final values


  out[0] = scale0 * ax + scale1 * bx;
  out[1] = scale0 * ay + scale1 * by;
  out[2] = scale0 * az + scale1 * bz;
  out[3] = scale0 * aw + scale1 * bw;
  return out;
}
/**
 * Generates a random unit quaternion
 *
 * @param {quat} out the receiving quaternion
 * @returns {quat} out
 */

function random$3(out) {
  // Implementation of http://planning.cs.uiuc.edu/node198.html
  // TODO: Calling random 3 times is probably not the fastest solution
  var u1 = RANDOM();
  var u2 = RANDOM();
  var u3 = RANDOM();
  var sqrt1MinusU1 = Math.sqrt(1 - u1);
  var sqrtU1 = Math.sqrt(u1);
  out[0] = sqrt1MinusU1 * Math.sin(2.0 * Math.PI * u2);
  out[1] = sqrt1MinusU1 * Math.cos(2.0 * Math.PI * u2);
  out[2] = sqrtU1 * Math.sin(2.0 * Math.PI * u3);
  out[3] = sqrtU1 * Math.cos(2.0 * Math.PI * u3);
  return out;
}
/**
 * Calculates the inverse of a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate inverse of
 * @returns {quat} out
 */

function invert$2(out, a) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
  var invDot = dot ? 1.0 / dot : 0; // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0

  out[0] = -a0 * invDot;
  out[1] = -a1 * invDot;
  out[2] = -a2 * invDot;
  out[3] = a3 * invDot;
  return out;
}
/**
 * Calculates the conjugate of a quat
 * If the quaternion is normalized, this function is faster than quat.inverse and produces the same result.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate conjugate of
 * @returns {quat} out
 */

function conjugate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  out[3] = a[3];
  return out;
}
/**
 * Creates a quaternion from the given 3x3 rotation matrix.
 *
 * NOTE: The resultant quaternion is not normalized, so you should be sure
 * to renormalize the quaternion yourself where necessary.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyMat3} m rotation matrix
 * @returns {quat} out
 * @function
 */

function fromMat3(out, m) {
  // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
  // article "Quaternion Calculus and Fast Animation".
  var fTrace = m[0] + m[4] + m[8];
  var fRoot;

  if (fTrace > 0.0) {
    // |w| > 1/2, may as well choose w > 1/2
    fRoot = Math.sqrt(fTrace + 1.0); // 2w

    out[3] = 0.5 * fRoot;
    fRoot = 0.5 / fRoot; // 1/(4w)

    out[0] = (m[5] - m[7]) * fRoot;
    out[1] = (m[6] - m[2]) * fRoot;
    out[2] = (m[1] - m[3]) * fRoot;
  } else {
    // |w| <= 1/2
    var i = 0;
    if (m[4] > m[0]) i = 1;
    if (m[8] > m[i * 3 + i]) i = 2;
    var j = (i + 1) % 3;
    var k = (i + 2) % 3;
    fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
    out[i] = 0.5 * fRoot;
    fRoot = 0.5 / fRoot;
    out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
    out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
    out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
  }

  return out;
}
/**
 * Creates a quaternion from the given euler angle x, y, z.
 *
 * @param {quat} out the receiving quaternion
 * @param {x} Angle to rotate around X axis in degrees.
 * @param {y} Angle to rotate around Y axis in degrees.
 * @param {z} Angle to rotate around Z axis in degrees.
 * @returns {quat} out
 * @function
 */

function fromEuler(out, x, y, z) {
  var halfToRad = 0.5 * Math.PI / 180.0;
  x *= halfToRad;
  y *= halfToRad;
  z *= halfToRad;
  var sx = Math.sin(x);
  var cx = Math.cos(x);
  var sy = Math.sin(y);
  var cy = Math.cos(y);
  var sz = Math.sin(z);
  var cz = Math.cos(z);
  out[0] = sx * cy * cz - cx * sy * sz;
  out[1] = cx * sy * cz + sx * cy * sz;
  out[2] = cx * cy * sz - sx * sy * cz;
  out[3] = cx * cy * cz + sx * sy * sz;
  return out;
}
/**
 * Returns a string representation of a quatenion
 *
 * @param {ReadonlyQuat} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function str$5(a) {
  return "quat(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
/**
 * Creates a new quat initialized with values from an existing quaternion
 *
 * @param {ReadonlyQuat} a quaternion to clone
 * @returns {quat} a new quaternion
 * @function
 */

var clone$5 = clone$4;
/**
 * Creates a new quat initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} a new quaternion
 * @function
 */

var fromValues$5 = fromValues$4;
/**
 * Copy the values from one quat to another
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the source quaternion
 * @returns {quat} out
 * @function
 */

var copy$5 = copy$4;
/**
 * Set the components of a quat to the given values
 *
 * @param {quat} out the receiving quaternion
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} out
 * @function
 */

var set$5 = set$4;
/**
 * Adds two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @returns {quat} out
 * @function
 */

var add$5 = add$4;
/**
 * Alias for {@link quat.multiply}
 * @function
 */

var mul$5 = multiply$5;
/**
 * Scales a quat by a scalar number
 *
 * @param {quat} out the receiving vector
 * @param {ReadonlyQuat} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {quat} out
 * @function
 */

var scale$5 = scale$4;
/**
 * Calculates the dot product of two quat's
 *
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @returns {Number} dot product of a and b
 * @function
 */

var dot$3 = dot$2;
/**
 * Performs a linear interpolation between two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {quat} out
 * @function
 */

var lerp$3 = lerp$2;
/**
 * Calculates the length of a quat
 *
 * @param {ReadonlyQuat} a vector to calculate length of
 * @returns {Number} length of a
 */

var length$3 = length$2;
/**
 * Alias for {@link quat.length}
 * @function
 */

var len$3 = length$3;
/**
 * Calculates the squared length of a quat
 *
 * @param {ReadonlyQuat} a vector to calculate squared length of
 * @returns {Number} squared length of a
 * @function
 */

var squaredLength$3 = squaredLength$2;
/**
 * Alias for {@link quat.squaredLength}
 * @function
 */

var sqrLen$3 = squaredLength$3;
/**
 * Normalize a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quaternion to normalize
 * @returns {quat} out
 * @function
 */

var normalize$3 = normalize$2;
/**
 * Returns whether or not the quaternions have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyQuat} a The first quaternion.
 * @param {ReadonlyQuat} b The second quaternion.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

var exactEquals$5 = exactEquals$4;
/**
 * Returns whether or not the quaternions have approximately the same elements in the same position.
 *
 * @param {ReadonlyQuat} a The first vector.
 * @param {ReadonlyQuat} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

var equals$6 = equals$5;
/**
 * Sets a quaternion to represent the shortest rotation from one
 * vector to another.
 *
 * Both vectors are assumed to be unit length.
 *
 * @param {quat} out the receiving quaternion.
 * @param {ReadonlyVec3} a the initial vector
 * @param {ReadonlyVec3} b the destination vector
 * @returns {quat} out
 */

var rotationTo = function () {
  var tmpvec3 = create$1();
  var xUnitVec3 = fromValues$1(1, 0, 0);
  var yUnitVec3 = fromValues$1(0, 1, 0);
  return function (out, a, b) {
    var dot = dot$1(a, b);

    if (dot < -0.999999) {
      cross$1(tmpvec3, xUnitVec3, a);
      if (len$1(tmpvec3) < 0.000001) cross$1(tmpvec3, yUnitVec3, a);
      normalize$1(tmpvec3, tmpvec3);
      setAxisAngle(out, tmpvec3, Math.PI);
      return out;
    } else if (dot > 0.999999) {
      out[0] = 0;
      out[1] = 0;
      out[2] = 0;
      out[3] = 1;
      return out;
    } else {
      cross$1(tmpvec3, a, b);
      out[0] = tmpvec3[0];
      out[1] = tmpvec3[1];
      out[2] = tmpvec3[2];
      out[3] = 1 + dot;
      return normalize$3(out, out);
    }
  };
}();
/**
 * Performs a spherical linear interpolation with two control points
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @param {ReadonlyQuat} c the third operand
 * @param {ReadonlyQuat} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {quat} out
 */

var sqlerp = function () {
  var temp1 = create$5();
  var temp2 = create$5();
  return function (out, a, b, c, d, t) {
    slerp(temp1, a, d, t);
    slerp(temp2, b, c, t);
    slerp(out, temp1, temp2, 2 * t * (1 - t));
    return out;
  };
}();
/**
 * Sets the specified quaternion with values corresponding to the given
 * axes. Each axis is a vec3 and is expected to be unit length and
 * perpendicular to all other specified axes.
 *
 * @param {ReadonlyVec3} view  the vector representing the viewing direction
 * @param {ReadonlyVec3} right the vector representing the local "right" direction
 * @param {ReadonlyVec3} up    the vector representing the local "up" direction
 * @returns {quat} out
 */

var setAxes = function () {
  var matr = create$2();
  return function (out, view, right, up) {
    matr[0] = right[0];
    matr[3] = right[1];
    matr[6] = right[2];
    matr[1] = up[0];
    matr[4] = up[1];
    matr[7] = up[2];
    matr[2] = -view[0];
    matr[5] = -view[1];
    matr[8] = -view[2];
    return normalize$3(out, fromMat3(out, matr));
  };
}();

var quat = /*#__PURE__*/Object.freeze({
    __proto__: null,
    create: create$5,
    identity: identity$2,
    setAxisAngle: setAxisAngle,
    getAxisAngle: getAxisAngle,
    getAngle: getAngle,
    multiply: multiply$5,
    rotateX: rotateX$2,
    rotateY: rotateY$2,
    rotateZ: rotateZ$2,
    calculateW: calculateW,
    exp: exp,
    ln: ln,
    pow: pow,
    slerp: slerp,
    random: random$3,
    invert: invert$2,
    conjugate: conjugate,
    fromMat3: fromMat3,
    fromEuler: fromEuler,
    str: str$5,
    clone: clone$5,
    fromValues: fromValues$5,
    copy: copy$5,
    set: set$5,
    add: add$5,
    mul: mul$5,
    scale: scale$5,
    dot: dot$3,
    lerp: lerp$3,
    length: length$3,
    len: len$3,
    squaredLength: squaredLength$3,
    sqrLen: sqrLen$3,
    normalize: normalize$3,
    exactEquals: exactEquals$5,
    equals: equals$6,
    rotationTo: rotationTo,
    sqlerp: sqlerp,
    setAxes: setAxes
});

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/**
 * @file 自定义事件模块
 * @author quda
 */

/**
 * 判断目标参数是否string类型或String对象
 * @param {Any} source 目标参数
 * @return {boolean} 类型判断结果
 */
var isString = function isString(source) {
  return '[object String]' === Object.prototype.toString.call(source);
};
/**
 * 判断目标参数是否为function或Function实例
 * @param {Any} source 目标参数
 * @return {boolean} 类型判断结果
 */

var isFunction$1 = function isFunction(source) {
  // chrome下,'function' == typeof /a/ 为true，同时注意async function
  var isFn = '[object Function]' === Object.prototype.toString.call(source);
  var isAsyncFn = '[object AsyncFunction]' === Object.prototype.toString.call(source);
  return isFn || isAsyncFn;
};
var eventID = 0x5942b;
/**
  * 返回当前事件的唯一标识字符串。
  * 采用计数自增的方式
  * 注意eventID的全局性
  * @return {string} 唯一标识字符串
  */

function guid() {
  return (++eventID).toString();
}
/**
  * 自定义的事件对象。
  * @param {string} type - 事件类型名称。为了方便区分事件和一个普通的方法，事件类型名称必须以"on"(小写)开头。
  * @param {Object} [target] - 触发事件的对象
  */


function Event(type, target) {
  this.type = type;
  this.returnValue = true;
  this.target = target || null;
  this.currentTarget = null;
}
/**
  * 自定义事件类
  * @remark 引入该模块，会自动为Class引入3个事件扩展方法：addEventListener、removeEventListener和dispatchEvent。
  */

var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    this.__listeners = void 0;
  }

  var _proto = EventEmitter.prototype;

  /**
   * addEventListener alias
   * @grammar obj.on(type, handler[, key])
   * @param {...number} arg 参考addEventListener
   */
  _proto.on = function on() {
    for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
      arg[_key] = arguments[_key];
    }

    this.alias('addEventListener')(arg);
  }
  /**
   * removeEventListener alias
   * @grammar obj.off(type, handler)
   * @param {...number} arg 参考removeEventListener
   */
  ;

  _proto.off = function off() {
    for (var _len2 = arguments.length, arg = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      arg[_key2] = arguments[_key2];
    }

    this.alias('removeEventListener')(arg);
  }
  /**
   * dispatchEvent alias
   * @grammar obj.emit(event, payload)
   * @param {...number} arg 参考dispatchEvent
   */
  ;

  _proto.emit = function emit() {
    for (var _len3 = arguments.length, arg = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      arg[_key3] = arguments[_key3];
    }

    this.alias('dispatchEvent')(arg);
  }
  /**
   * 注册对象的事件监听器。继承Event后，Class的子类实例才会获得该方法。
   * @grammar obj.addEventListener(type, handler[, key])
   * @param {string} type 自定义事件的名称
   * @param {Function} handler 自定义事件被触发时应该调用的回调函数
   * @param {string=} key 为事件监听函数指定的名称，可在移除时使用。如果不提供，方法会默认为它生成一个全局唯一的key。
   * @remark    事件类型区分大小写。如果自定义事件名称不是以小写"on"开头，该方法会给它加上"on"再进行判断，即"click"和"onclick"会被认为是同一种事件。
   */
  ;

  _proto.addEventListener = function addEventListener(type, handler, key) {
    if (!isFunction$1(handler)) {
      return; // throw("addEventListener:" + handler + " is not a function");
    }

    !this.__listeners && (this.__listeners = {});
    var id;
    var t = this.__listeners;

    if (typeof key === 'string' && key) {
      if (/[^\w-]/.test(key)) {
        throw 'nonstandard key:' + key;
      } else {
        handler.hashCode = key;
        id = key;
      }
    }

    !type.startsWith('on') && (type = 'on' + type);
    _typeof(t[type]) !== 'object' && (t[type] = {});
    id = id || guid();
    handler.hashCode = id;
    t[type][id] = handler;
  }
  /**
   * 移除对象的事件监听器。继承Event后，Class的子类实例才会获得该方法。
   * @grammar obj.removeEventListener(type, handler)
   * @param {string} type 事件类型
   * @param {(Function | string)} handler  要移除的事件监听函数或者监听函数的key
   * @remark 如果第二个参数handler没有被绑定到对应的自定义事件中，什么也不做。
   */
  ;

  _proto.removeEventListener = function removeEventListener(type, handler) {
    if (isFunction$1(handler)) {
      handler = handler.hashCode;
    } else if (!isString(handler)) {
      return;
    }

    !this.__listeners && (this.__listeners = {});
    !type.startsWith('on') && (type = 'on' + type);
    var t = this.__listeners;

    if (!t[type]) {
      return;
    }

    t[type][handler] && delete t[type][handler];
  }
  /**
   * 派发自定义事件，使得绑定到自定义事件上面的函数都会被执行。继承Event后，Class的子类实例才会获得该方法。
   * @grammar obj.dispatchEvent(event, payload)
   * @param {Event|string} event Event对象，或事件名称
   * @param {*} payload 扩展参数,所含属性键值会扩展到Event对象上
   * @remark 处理会调用通过addEventListenr绑定的自定义事件回调函数之外，还会调用直接绑定到对象上面的自定义事件。
   */
  ;

  _proto.dispatchEvent = function dispatchEvent(event, payload) {
    if (isString(event)) {
      event = new Event(event);
    }

    !this.__listeners && (this.__listeners = {});
    var t = this.__listeners;
    var p = event.type;
    var realPayload = payload || event;
    event.target = event.target || this;
    event.currentTarget = this;
    p.indexOf('on') !== 0 && (p = "on".concat(p));
    isFunction$1(t[p]) && t[p].call(this, realPayload);

    if (_typeof(t[p]) === 'object') {
      for (var i in t[p]) {
        if (Object.prototype.hasOwnProperty.call(t[p], i)) {
          t[p][i].call(this, realPayload);
        }
      }
    }

    return event.returnValue;
  }
  /**
   * Alias a method while keeping the context correct, to allow for overwriting of target method.
   *
   * @private
   * @param {string} name The name of the target method.
   * @return {Function} The aliased method
   */
  ;

  _proto.alias = function alias(name) {
    var _this = this;

    var aliasClosure = function aliasClosure(arg) {
      return _this[name].apply(_this, arg);
    };

    return aliasClosure;
  };

  return EventEmitter;
}();

/**
 * @file 矩阵运算
 * @author quda
 */
/**
 * 四元数转欧拉角，默认XYZ顺序
 * @param  {vec3} out Euler angles, pitch-yaw-roll
 * @param  {quat} mat Quaternion
 * @return {vec3} out
 */

function quatToEuler(out, quat) {
  var qz = quat[2];
  var qx = quat[0];
  var qy = quat[1];
  var qw = quat[3];
  var sqw = qw * qw;
  var sqz = qz * qz;
  var sqx = qx * qx;
  var sqy = qy * qy;
  var zAxisY = qy * qz - qx * qw;
  var limit = .4999999;

  if (zAxisY < -limit) {
    out[0] = Math.PI / 2;
    out[1] = 2 * Math.atan2(qy, qw);
    out[2] = 0;
  } else if (zAxisY > limit) {
    out[0] = -Math.PI / 2;
    out[1] = 2 * Math.atan2(qy, qw);
    out[2] = 0;
  } else {
    out[0] = Math.asin(-2.0 * (qz * qy - qx * qw));
    out[1] = Math.atan2(2.0 * (qz * qx + qy * qw), sqz - sqx - sqy + sqw);
    out[2] = Math.atan2(2.0 * (qx * qy + qz * qw), -sqz - sqx + sqy + sqw);
  }

  return out;
}

var Euler =
/*#__PURE__*/
function () {
  function Euler() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Euler.DefaultOrder;
    this.isEuler = true;
    this._x = void 0;
    this._y = void 0;
    this._z = void 0;
    this._order = void 0;
    this._onChangeCallback = void 0;

    /**
     * X轴角度（单位为角度)
     * @type {number}
     */
    this._x = x;
    /**
     * Y轴角度（单位为角度)
     * @type {number}
     */

    this._y = y;
    /**
     * Z轴角度（单位为角度)
     * @type {number}
     */

    this._z = z;
    /**
     * 一个用来表示旋转顺序的字符串，默认为 'XYZ'（必须是大写）。
     * 目前欧拉角只用来更直观的表达旋转，不用来做与四元数或者旋转矩阵的转换
     * 所以order暂时无用
     * @type {string}
     */

    this._order = order;
    /**
     * 发生变化时内部的回调方法
     * 外部可以通过onChange方法设置自定义回调
     * @private
     * @type {Function}
     */

    this._onChangeCallback = function () {// do nothing
    };
  }

  var _proto = Euler.prototype;

  /**
   * 设置欧拉角
   * @public
   * @param {number} x - X轴角度（单位为角度)
   * @param {number} y - Y轴角度（单位为角度)
   * @param {number} z - Z轴角度（单位为角度)
   * @param {boolean} update - 是否触发更新，默认true
   * @return {Euler} - 当前欧拉角实例，用于链式调用
   */
  _proto.set = function set(x, y, z) {
    var update = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    this._x = x;
    this._y = y;
    this._z = z;
    update && this._onChangeCallback();
    return this;
  }
  /**
   * 克隆当前欧拉角
   * @public
   * @return {Euler} - 当前欧拉角实例，用于链式调用
   */
  ;

  _proto.clone = function clone() {
    return new Euler(this._x, this._y, this._z, this._order);
  }
  /**
   * 复制
   * @param {Eluer} euler - 目标欧拉角
   * @return {Euler} - 当前欧拉角实例，用于链式调用
   */
  ;

  _proto.copy = function copy(euler) {
    if (!euler.isEuler) {
      return this;
    }

    this._x = euler._x;
    this._y = euler._y;
    this._z = euler._z;
    this._order = euler._order;

    this._onChangeCallback();

    return this;
  }
  /**
   * 比较两个欧拉角是否相等
   * @public
   * @param {Eluer} euler - 要对比的欧拉角
   * @return {boolean} - 是否相等
   */
  ;

  _proto.equals = function equals(euler) {
    return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
  }
  /**
   * 欧拉角转三维向量
   * @public
   * @return {Vec3} - 三维向量
   */
  ;

  _proto.toVector3 = function toVector3() {
    return fromValues$1(this._x, this._y, this._z);
  }
  /**
   * 设置欧拉角发生变化时的回调函数
   * @public
   * @param {Function} cb - 回调函数
   */
  ;

  _proto.onChange = function onChange(cb) {
    if (typeof cb === 'function') {
      this._onChangeCallback = cb;
    }
  };

  createClass(Euler, [{
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      this._x = value;

      this._onChangeCallback();
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      this._y = value;

      this._onChangeCallback();
    }
  }, {
    key: "z",
    get: function get() {
      return this._z;
    },
    set: function set(value) {
      this._z = value;

      this._onChangeCallback();
    }
  }, {
    key: "order",
    get: function get() {
      return this._order;
    },
    set: function set(value) {
      this._order = value;

      this._onChangeCallback();
    }
  }]);

  return Euler;
}();

Euler.DefaultOrder = 'XYZ';

/**
 * @file UUIDs工具类
 * @author quda
 */

/**
 * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
 * Be aware Math.random() could cause collisions, but:
 * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
 * @return {string} - a pseudo random id
 */
function genUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0; // 0 ~ 15向下取整

    var v = c === 'x' ? r : r & 0x3 | 0x8; // 为了保证y是8~11之间，即16进制的8~A

    return v.toString(16);
  });
}

/**
 * @file 工具函数集合
 * @author quda
 */
/**
 * 弧度转角度
 * @method radToDeg
 * @param  {number} rad - 弧度
 * @return {number} - 角度
 */

var radToDeg$1 = function radToDeg(rad) {
  return rad * 180 / Math.PI;
};
/**
 * 获取一个数组中的最大和最小值
 *     {
 *         min:'',
 *         max:''
 *     }
 * @param  {Array} arr 求最大和最小值的数组
 * @return {Object}     包含最大和最小值的对象
 */

var getMinAndMax$1 = function getMinAndMax(arr) {
  var min = Number.MAX_VALUE;
  var max = -Number.MAX_VALUE;
  var iterator;

  for (var i = arr.length - 1; i >= 0; i--) {
    iterator = arr[i];

    if (min > iterator) {
      min = iterator;
    }

    if (max < iterator) {
      max = iterator;
    }
  }

  return {
    min: min,
    max: max
  };
};

var Object3D =
/*#__PURE__*/
function (_Event) {
  inheritsLoose(Object3D, _Event);

  /**
   * Object3D标识
   * @type {boolean}
   */

  /**
   * 图形对象唯一编号
   */

  /**
   * 图形对象 名称，便于调试
   */

  /**
   * 该对象在场景图中的父对象
   */

  /**
   * 该对象附属的子对象
   */

  /**
   * 当前对象可见性
   */

  /**
   * 记录当前对象的位移变化
   */

  /**
   * 记录当前对象的位移变化
   * 不参与矩阵运算
   */

  /**
   * 记录当前对象的缩放变化
   */

  /**
   * 旋转以四元数形式参与矩阵运算
   */

  /**
   * 几何体的上方向（up axis）
   * @type {Vec3}
   */

  /**
   * 当前对象的模型矩阵
   * @description 描述了当前对象从局部坐标系到世界坐标系的变换过程
   */

  /**
   * 世界坐标系中的模型矩阵
   * 注意: 这个矩阵最终参与了MVP计算
   * @type {Mat4}
   * @description 如果当前对象存在父对象，worldMatrix为父对象的模型矩阵，否则与modelMatrix一致
   */

  /**
   * 是否需要更新模型矩阵，
   * 默认情况不需要手动设置是否需要更新。
   */

  /**
   * 自身矩阵更新后需要更新世界坐标系中的矩阵
   */
  function Object3D() {
    var _this;

    _this = _Event.call(this) || this;
    /**
     * 监听旋转属性的变化
     */

    _this.isObject3D = true;
    _this.uuid = genUUID();
    _this.name = '';
    _this.parent = null;
    _this.children = [];
    _this.visible = true;
    _this.position = create$1();
    _this.rotation = new Euler();
    _this.scale = fromValues$1(1, 1, 1);
    _this.quaternion = create$5();
    _this.up = clone$1(Object3D.DefaultUp);
    _this.modelMatrix = create$3();
    _this.worldMatrix = create$3();
    _this.modelMatrixNeedUpdate = false;
    _this.worldMatrixNeedsUpdate = false;

    _this.rotation.onChange(function () {
      _this.modelMatrixNeedUpdate = true;
    });

    return _this;
  }
  /**
   * 绕X轴旋转一定的角度
   * @public
   * @param {number} deg 角度制
   */


  var _proto = Object3D.prototype;

  _proto.rotateX = function rotateX(deg) {
    this.rotation.x = deg;
  }
  /**
   * 绕Y轴旋转一定的角度
   * @public
   * @param {number} deg 角度制
   */
  ;

  _proto.rotateY = function rotateY(deg) {
    this.rotation.y = deg;
  }
  /**
   * 绕Z轴旋转一定的角度
   * @public
   * @param {number} deg 角度制
   */
  ;

  _proto.rotateZ = function rotateZ(deg) {
    this.rotation.z = deg;
  }
  /**
   * 沿着某个向量移动
   * @public
   * @param {number} x - X轴位移
   * @param {number} y - Y轴位移
   * @param {number} z - Z轴位移
   * @return {Object3D} - 3D对象实例
   */
  ;

  _proto.translate = function translate(x, y, z) {
    var pos = fromValues$1(x, y, z);
    this.position = add$1(this.position, this.position, pos);
    this.modelMatrixNeedUpdate = true;
    return this;
  }
  /**
   * 设置指定位置
   * @param {number} x - X轴位移
   * @param {number} y - Y轴位移
   * @param {number} z - Z轴位移
   * @return {Object3D} - 3D对象实例
   */
  ;

  _proto.setPosition = function setPosition(x, y, z) {
    var pos = fromValues$1(x, y, z);

    if (!equals$2(this.position, pos)) {
      this.position = pos;
      this.modelMatrixNeedUpdate = true;
    }

    return this;
  }
  /**
   * 几何体观察点
   * @param {number} x - 目标点X坐标
   * @param {number} y - 目标点Y坐标
   * @param {number} z - 目标点Z坐标
   */
  ;

  _proto.lookAt = function lookAt(x, y, z) {
    var up = this.up;
    var position = this.position;
    var focalPoint = fromValues$1(x, y, z); // 这里计算当前几何看向目标所需要的变换矩阵

    var lookAtMatrix = targetTo(create$3(), position, focalPoint, up); // 分解出旋转四元数

    var quat$1 = getRotation(create$5(), lookAtMatrix); // 回填旋转信息，并自动触发矩阵计算

    var rotation = quatToEuler(create$1(), quat$1);
    this.rotation.set(radToDeg$1(rotation[0]), radToDeg$1(rotation[1]), radToDeg$1(rotation[2]));
  }
  /**
   * 设置3D对象可见性
   * @public
   * @param {boolean} visible - 可见性
   * @param {boolean} recursive - 是否同步更新子对象
   */
  ;

  _proto.setVisible = function setVisible(visible) {
    var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (this.visible === visible) {
      return;
    }

    this.visible = visible;

    if (recursive) {
      for (var i = 0, len = this.children.length; i < len; i++) {
        this.children[i].setVisible(visible, recursive);
      }
    }
  }
  /**
   * 设置3D对象缩放信息
   * @param {number} x - X轴缩放比例
   * @param {number} y - Y轴缩放比例
   * @param {number} z - Z轴缩放比例
   * @return {Object3D} - 3D对象实例
   */
  ;

  _proto.setScale = function setScale(x, y, z) {
    var scale = fromValues$1(x, y, z);

    if (!equals$2(this.scale, scale)) {
      this.scale = scale;
      this.modelMatrixNeedUpdate = true;
    }

    return this;
  }
  /**
   *
   * 根据旋转矩阵、缩放矩阵、位置，更新模型矩阵
   * 移动->旋转->缩放
   *
   * @method updateMatrix
   * @public
   */
  ;

  _proto.updateMatrix = function updateMatrix() {
    // 先移动再旋转后缩放
    identity$1(this.modelMatrix);
    identity$2(this.quaternion); // 这里使用的角度制

    fromEuler(this.quaternion, this.rotation.x, this.rotation.y, this.rotation.z);
    fromRotationTranslationScale(this.modelMatrix, this.quaternion, this.position, this.scale); // 更新过矩阵后就不需要继续更新

    this.modelMatrixNeedUpdate = false; // 自己的矩阵更新后需要更新世界坐标系中的矩阵

    this.worldMatrixNeedsUpdate = true;
  }
  /**
   * 根据父亲的模型矩阵更新当前对象的模型矩阵
   * @public
   * @param {boolean} force - 是否强制更新
   */
  ;

  _proto.updateWorldMatrix = function updateWorldMatrix() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (true === this.modelMatrixNeedUpdate || true === force) {
      this.updateMatrix();
    }

    if (true === this.worldMatrixNeedsUpdate) {
      if (!this.parent) {
        copy$3(this.worldMatrix, this.modelMatrix);
      } else {
        multiply$3(this.worldMatrix, this.parent.worldMatrix, this.modelMatrix);
      }

      this.worldMatrixNeedsUpdate = false;
      force = true;
    } // update children
    // FIXME: 如果父对象存在children，children的模型矩阵为初始矩阵
    // 这时更新父对象的世界矩阵，children的世界矩阵不会更新
    // case => 在球模型mesh对象上修正球模型姿态
    // 2020.11.30 update: 目前通过mesh.updateWorldMatrix(true);可以解决


    for (var i = 0, len = this.children.length; i < len; i++) {
      this.children[i].updateWorldMatrix(force);
    }
  }
  /**
   * 添加子对象
   * @param  {...Object3D} objects - Object3D对象集合
   * @example Object3D.add(obj) or Object3D.add([obj1, obj2])
   * @return {Object3D} - 供链式调用
   */
  ;

  _proto.add = function add(object) {
    if (object === this) {
      console.error("object3D.add: object can't be added as a child of itself. ==> ".concat(object));
      return this;
    }

    if (object instanceof Array) {
      for (var i = 0, len = object.length; i < len; i++) {
        this.add(object[i]);
      }

      return this;
    }

    if (object && object.isObject3D) {
      // 保证一个子对象只属于一个父对象
      if (object.parent !== null) {
        object.parent.remove(object);
      }

      object.parent = this; // TODO: 派发子对象的被添加事件

      this.children.push(object);
    } else {
      console.error('Object3D.add: object not an instance of Object3D.', object);
    }

    return this;
  }
  /**
   * 删除子对象
   * @param  {Object3D | Object3D[]} objects - Object3D对象集合
   * @example Object3D.remove(obj) or Object3D.remove([obj1, obj2, obj3])
   * @return {Object3D} - 供链式调用
   */
  ;

  _proto.remove = function remove(object) {
    if (object instanceof Array) {
      for (var i = 0, len = object.length; i < len; i++) {
        this.remove(object[i]);
      }

      return this;
    }

    var index = this.children.indexOf(object);

    if (index !== -1) {
      object.parent = null; // TODO: 派发子对象的被删除事件

      this.children.splice(index, 1);
    }

    return this;
  }
  /**
   * 递归遍历对象
   * @param {Function} cb 回调方法
   */
  ;

  _proto.traverse = function traverse(cb) {
    cb(this);

    if (this.children && this.children.length > 0) {
      this.children.forEach(function (item) {
        item.traverse(cb);
      });
    }
  }
  /**
   * 克隆对象
   * @public
   * @param {boolean} recursive - 是否需要克隆子对象，默认false
   * @return {Object3D} - 克隆结果
   */
  ;

  _proto.clone = function clone() {
    var recursive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    // 克隆结果
    var object = new Object3D();
    object.up = clone$1(this.up);
    object.scale = clone$1(this.scale);
    object.position = clone$1(this.position);
    object.rotation = this.rotation.clone();
    object.quaternion = clone$5(this.quaternion);
    object.modelMatrix = clone$3(this.modelMatrix);
    object.worldMatrix = clone$3(this.worldMatrix);
    object.visible = this.visible;

    if (this.children.length && recursive) {
      for (var i = 0, len = this.children.length; i < len; i++) {
        object.add(this.children[i].clone());
      }
    }

    return object;
  }
  /**
   * 射线拾取
   * @param ray - 射线
   * @return - 拾取结果
   */
  ;

  _proto.raycast = function raycast(ray) {
    // do nothing...
    return null;
  };

  return Object3D;
}(EventEmitter);
Object3D.DefaultUp = fromValues$1(0, 1, 0);

/**
 * @file 立方包围盒
 * @author quda
 */
var Box3 =
/*#__PURE__*/
function () {
  function Box3(min, max) {
    this.isBox = true;
    this.min = void 0;
    this.max = void 0;
    this.min = min !== undefined ? min : fromValues$1(+Infinity, +Infinity, +Infinity);
    this.max = max !== undefined ? max : fromValues$1(-Infinity, -Infinity, -Infinity);
  }

  var _proto = Box3.prototype;

  _proto.set = function set(min, max) {
    copy$1(this.min, min);
    copy$1(this.max, max);
    return this;
  };

  _proto.setFromBufferAttribute = function setFromBufferAttribute(attribute) {
    var minX = +Infinity;
    var minY = +Infinity;
    var minZ = +Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    var maxZ = -Infinity;
    var array = attribute.array;
    var count = attribute.count,
        itemSize = attribute.itemSize;

    for (var i = 0; i < count; i++) {
      var x = array[i * itemSize];
      var y = array[i * itemSize + 1];
      var z = array[i * itemSize + 2];

      if (x < minX) {
        minX = x;
      }

      if (y < minY) {
        minY = y;
      }

      if (z < minZ) {
        minZ = z;
      }

      if (x > maxX) {
        maxX = x;
      }

      if (y > maxY) {
        maxY = y;
      }

      if (z > maxZ) {
        maxZ = z;
      }
    }

    var min = fromValues$1(minX, minY, minZ);
    var max = fromValues$1(maxX, maxY, maxZ);
    this.set(min, max);
    return this;
  };

  _proto.getCenter = function getCenter() {
    return this.isInvalid() ? create$1() : fromValues$1((this.max[0] + this.min[0]) / 2, (this.max[1] + this.min[1]) / 2, (this.max[2] + this.min[2]) / 2);
  };

  _proto.isInvalid = function isInvalid() {
    return this.max[0] < this.min[0] || this.max[1] < this.min[1] || this.max[2] < this.min[2];
  };

  return Box3;
}();

/**
 * @file 常量
 * @author quda
 */
var StaticDrawUsage = 35044;

var BufferAttribute =
/*#__PURE__*/
function () {
  /**
   * The byte type.
   */

  /**
   * The unsigned byte type.
   */

  /**
   * The short type.
   */

  /**
   * The unsigned short type.
   */

  /**
   * The integer type.
   */

  /**
   * The unsigned integer type.
   */

  /**
   * The float type.
   */

  /**
   * 顶点属性标识
   */

  /**
   * 顶点数据集，长度为 itemSize * count
   */

  /**
   * 单个顶点的数据量
   */

  /**
   * 顶点数量
   */

  /**
   * 当转换为浮点数时是否应该将整数数值归一化到特定的范围。
   * 对于类型gl.BYTE和gl.SHORT，如果是true则将值归一化为[-1, 1]
   * 对于类型gl.UNSIGNED_BYTE和gl.UNSIGNED_SHORT，如果是true则将值归一化为[0, 1]
   * 对于类型gl.FLOAT和gl.HALF_FLOAT，此参数无效
   */

  /**
   * 数据存储区的使用方法
   */

  /**
   * 是否需要更新
   */
  function BufferAttribute(array, itemSize, type) {
    var normalized = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    this.isBufferAttribute = true;
    this.name = '';
    this.type = void 0;
    this.array = void 0;
    this.itemSize = void 0;
    this.count = void 0;
    this.normalized = void 0;
    this.usage = void 0;
    this.needUpdate = void 0;

    if (Array.isArray(array)) {
      throw new TypeError('BufferAttribute: array should be a Typed Array.');
    }

    this.name = 'BufferAttribute';
    this.array = array;
    this.itemSize = itemSize;
    this.count = array !== undefined ? array.length / itemSize : 0;
    this.normalized = normalized === true;
    this.usage = StaticDrawUsage;
    this.needUpdate = true;

    if (type === undefined) {
      var data = this.array;
      this.type = BufferAttribute.FLOAT;

      if (data instanceof Int8Array) {
        this.type = BufferAttribute.BYTE;
      } else if (data instanceof Uint8Array) {
        this.type = BufferAttribute.UNSIGNED_BYTE;
      } else if (data instanceof Int16Array) {
        this.type = BufferAttribute.SHORT;
      } else if (data instanceof Uint16Array) {
        this.type = BufferAttribute.UNSIGNED_SHORT;
      } else if (data instanceof Int32Array) {
        this.type = BufferAttribute.INT;
      } else if (data instanceof Uint32Array) {
        this.type = BufferAttribute.UNSIGNED_INT;
      }
    } else {
      this.type = type;
    }
  }

  BufferAttribute.isBufferAttribute = function isBufferAttribute(target) {
    var checker = false;

    if (target && target instanceof BufferAttribute) {
      checker = true;
    }

    return checker;
  }
  /**
   * 设置数据存储区的使用方法
   * @public
   * @param {number} usage - 使用方法
   * @return {BufferAttribute} - 当前实例
   */
  ;

  var _proto = BufferAttribute.prototype;

  _proto.setUsage = function setUsage(usage) {
    this.usage = usage;
    return this;
  }
  /**
   * 设置顶点数据集
   * @public
   * @param {Array | TypedArray} array -
   * @return {BufferAttribute} -
   */
  ;

  _proto.setArray = function setArray(array) {
    this.array.set(array);
    return this;
  };

  return BufferAttribute;
}();
BufferAttribute.BYTE = 5120;
BufferAttribute.UNSIGNED_BYTE = 5121;
BufferAttribute.SHORT = 5122;
BufferAttribute.UNSIGNED_SHORT = 5123;
BufferAttribute.INT = 5124;
BufferAttribute.UNSIGNED_INT = 5125;
BufferAttribute.FLOAT = 5126;
var Uint8BufferAttribute =
/*#__PURE__*/
function (_BufferAttribute) {
  inheritsLoose(Uint8BufferAttribute, _BufferAttribute);

  function Uint8BufferAttribute(array, itemSize, type, normalized) {
    var _this;

    _this = _BufferAttribute.call(this, new Uint8Array(array), itemSize, type, normalized) || this;
    _this.name = 'Uint8BufferAttribute';
    return _this;
  }

  return Uint8BufferAttribute;
}(BufferAttribute);
var Uint16BufferAttribute =
/*#__PURE__*/
function (_BufferAttribute2) {
  inheritsLoose(Uint16BufferAttribute, _BufferAttribute2);

  function Uint16BufferAttribute(array, itemSize, type, normalized) {
    var _this2;

    _this2 = _BufferAttribute2.call(this, new Uint16Array(array), itemSize, type, normalized) || this;
    _this2.name = 'Uint16BufferAttribute';
    return _this2;
  }

  return Uint16BufferAttribute;
}(BufferAttribute);
var Uint32BufferAttribute =
/*#__PURE__*/
function (_BufferAttribute3) {
  inheritsLoose(Uint32BufferAttribute, _BufferAttribute3);

  function Uint32BufferAttribute(array, itemSize, type, normalized) {
    var _this3;

    _this3 = _BufferAttribute3.call(this, new Uint32Array(array), itemSize, type, normalized) || this;
    _this3.name = 'Uint32BufferAttribute';
    return _this3;
  }

  return Uint32BufferAttribute;
}(BufferAttribute);
var Float32ArrayAttribute =
/*#__PURE__*/
function (_BufferAttribute4) {
  inheritsLoose(Float32ArrayAttribute, _BufferAttribute4);

  function Float32ArrayAttribute(array, itemSize, type, normalized) {
    var _this4;

    _this4 = _BufferAttribute4.call(this, new Float32Array(array), itemSize, type, normalized) || this;
    _this4.name = 'Float32ArrayAttribute';
    return _this4;
  }

  return Float32ArrayAttribute;
}(BufferAttribute);
var UintBufferAttribute =
/*#__PURE__*/
function (_BufferAttribute5) {
  inheritsLoose(UintBufferAttribute, _BufferAttribute5);

  function UintBufferAttribute(array, itemSize, type, normalized) {
    var typedArray;

    if (Array.isArray(array)) {
      // Math.max只支持10⁷ 以内的数字，会引发Maximum call stack size exceeded
      var _getMinAndMax = getMinAndMax$1(array),
          max = _getMinAndMax.max;

      var T = max > 65535 ? Uint32Array : Uint16Array;
      typedArray = new T(array);
    } else {
      typedArray = array;
    }

    return _BufferAttribute5.call(this, typedArray, itemSize, type, normalized) || this;
  }

  return UintBufferAttribute;
}(BufferAttribute);

var geometryIdCount = 0;
var BufferGeometry =
/*#__PURE__*/
function (_Event) {
  inheritsLoose(BufferGeometry, _Event);

  function BufferGeometry() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Event.call.apply(_Event, [this].concat(args)) || this;
    _this.id = geometryIdCount++;
    _this.uuid = genUUID();
    _this.name = '';
    _this.type = 'BufferGeometry';
    _this.indexes = null;
    _this.attributes = {};
    _this.__webglInit = false;
    _this.groupsNeedUpdate = false;
    _this.boundingBox = null;
    return _this;
  }

  var _proto = BufferGeometry.prototype;

  /**
   * 获取顶点索引数据
   * @return {BufferAttribute | null} - 顶点索引
   */
  _proto.getIndexes = function getIndexes() {
    return this.indexes;
  }
  /**
   * 获取模型中心点
   * @return - 模型中心点
   */
  ;

  _proto.getCenter = function getCenter() {
    this.computeBoundingBox();
    return this.boundingBox ? this.boundingBox.getCenter() : undefined;
  }
  /**
   * 设置顶点索引
   * @param {Array|TypedArray|BufferAttribute} indexes - 顶点索引数据
   * @return {BufferGeometry} -
   */
  ;

  _proto.setIndexes = function setIndexes(indexes) {
    if (Array.isArray(indexes) || ArrayBuffer.isView(indexes)) {
      this.indexes = new UintBufferAttribute(indexes, 1);
    } else if (UintBufferAttribute.isBufferAttribute(indexes)) {
      this.indexes = indexes;
    }

    return this;
  }
  /**
   * 获取属性信息，不指定name获取全量
   * @param {string} name - 指定属性名
   * @return {BufferAttribute | Object} - 属性信息
   */
  ;

  _proto.getAttribute = function getAttribute(name) {
    if (!name) {
      return this.attributes;
    }

    return this.attributes[name];
  }
  /**
   * 设置属性信息
   * @param {string} name - 属性名称
   * @param {BufferAttribute} attribute - 属性信息
   * @return {BufferGeometry} -
   */
  ;

  _proto.setAttribute = function setAttribute(name, attribute) {
    if (name && BufferAttribute.isBufferAttribute(attribute)) {
      this.attributes[name] = attribute;
    }

    return this;
  }
  /**
   * 删除属性信息
   * @param {string} name - 属性名称
   * @return {BufferGeometry} -
   */
  ;

  _proto.deleteAttribute = function deleteAttribute(name) {
    if (this.attributes[name]) {
      delete this.attributes[name];
    }

    return this;
  }
  /**
   * 计算几何包围盒
   */
  ;

  _proto.computeBoundingBox = function computeBoundingBox() {
    if (this.boundingBox === null) {
      this.boundingBox = new Box3();
    }

    var position = this.attributes.position;

    if (position && position.isBufferAttribute) {
      this.boundingBox.setFromBufferAttribute(position);
    }
  };

  return BufferGeometry;
}(EventEmitter);

var tmp1 = new Vector3();
var tmp2 = new Vector3();
var tmp3 = new Vector3();
var Mesh =
/*#__PURE__*/
function (_Object3D) {
  inheritsLoose(Mesh, _Object3D);

  /**
   * 网格类型
   * 其他衍生Mesh类可以进行重写
   */

  /**
   * 网格对象对应的几何
   */

  /**
   * 网格对象对应的材质
   */

  /**
   * 材质是否发生了改变
   * @type {boolean}
   */

  /**
   * 是否初始化标识
   */
  function Mesh(geometry, material) {
    var _this;

    _this = _Object3D.call(this) || this;
    _this.type = 'Mesh';
    _this.geometry = void 0;
    _this.material = void 0;
    _this.materialChanged = void 0;
    _this.__webglInit = false;
    _this.geometry = void 0 !== geometry ? geometry : new BufferGeometry();
    _this.material = void 0 !== material ? material : null;
    _this.materialChanged = false;
    return _this;
  }
  /**
   * 更新材质信息
   * @public
   * @param {Material} material - 目标材质
   */


  var _proto = Mesh.prototype;

  _proto.updateMaterial = function updateMaterial(material) {
    if (this.material && material.isMaterial && material.uuid !== this.material.uuid) {
      this.material = material;
      this.materialChanged = true;
    }
  }
  /**
   * 射线拾取
   * @param ray - 射线
   * @return - 拾取结果
   */
  ;

  _proto.raycast = function raycast(ray) {
    var geometry = this.geometry;
    var indexes = geometry.indexes && geometry.indexes.array;
    var position = geometry.attributes.position.array;

    if (!indexes) {
      return null;
    }

    for (var i = 0; i < indexes.length; i += 3) {
      var offsetA = indexes[i] * 3;
      var offsetB = indexes[i + 1] * 3;
      var offsetC = indexes[i + 2] * 3;
      var a = tmp1.set(position[offsetA], position[offsetA + 1], position[offsetA + 2]).transform(this.worldMatrix);
      var b = tmp2.set(position[offsetB], position[offsetB + 1], position[offsetB + 2]).transform(this.worldMatrix);
      var c = tmp3.set(position[offsetC], position[offsetC + 1], position[offsetC + 2]).transform(this.worldMatrix);
      var res = ray.intersectTriangle(a, b, c);

      if (res) {
        return {
          distance: res.distance,
          point: res.point,
          object: this
        };
      }
    }

    return null;
  };

  return Mesh;
}(Object3D);

var Scene =
/*#__PURE__*/
function (_Object3D) {
  inheritsLoose(Scene, _Object3D);

  function Scene() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Object3D.call.apply(_Object3D, [this].concat(args)) || this;
    _this.type = 'Scene';
    _this.isScene = true;
    _this.autoUpdate = true;
    return _this;
  }

  var _proto = Scene.prototype;

  /**
   * 更新当前Scene下的子对象
   * @public
   * @param {boolean} force - 是否强制更新
   */
  _proto.updateWorldMatrix = function updateWorldMatrix() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (true === this.autoUpdate) {
      _Object3D.prototype.updateWorldMatrix.call(this, force);
    }
  }
  /**
   * 克隆场景
   * @public
   * @param {Scene} scene - 克隆当前场景对象的场景
   * @return {Scene} - 目标场景
   */
  ;

  _proto.clone = function clone(scene) {
    if (undefined === scene) {
      scene = new Scene();
    }

    _Object3D.prototype.clone.call(this, scene);

    scene.autoUpdate = this.autoUpdate;
    return scene;
  };

  return Scene;
}(Object3D);

/**
 * Geometry是场景中由顶点和三角面构成的几何体对象的基类
 * 如果需要判断是否与鼠标有交点，则需要triangles；
 * 渲染所需要的基本属性为verticesBufferData、uvtsBufferData和indicesBufferData；
 * 如果涉及到的模型有多张纹理或者顶点很多，则需要支持分组渲染，需要额外属性triangles、triangleVertexUvs
 * @class Geometry
 * @constructor
 */

var Geometry =
/*#__PURE__*/
function (_Event) {
  inheritsLoose(Geometry, _Event);

  function Geometry() {
    var _this;

    _this = _Event.call(this) || this;
    /**
     * 几何类型
     * 其他衍生几何类可以进行重写
     * @type {string}
     */

    _this.type = 'Geometry';
    _this.vertices = [];
    /**
     * 顶点数据缓存，每三个元素组成一个顶点，初始化为FLoat32Array
     * @property
     */

    _this.verticesBufferData = new Float32Array();
    /**
     * 顶点索引数组，每个元素为一个顶点的索引，每三个元素是组成一个三角形的三个顶点的索引，初始化为Unit16Array
     * @property
     */

    _this.indicesBufferData = new Uint16Array();
    /**
     * 顶点UV坐标数组，每两个元素组成一个UV坐标，初始化为Float32Array
     * 属于一个几何中不变的原始顶点对应的UV存储
     * @property
     */

    _this.uvtsBufferData = new Float32Array();
    /**
     * 是否需要更新geometry group
     * 如果需要重新分组，则需要设置为true
     * @property
     */

    _this.groupsNeedUpdate = false;
    return _this;
  }

  return Geometry;
}(EventEmitter);

/**
 * @file 射线
 * @author quda
 */
var tmp1$1 = new Vector3();
var tmp2$1 = new Vector3();
var tmp3$1 = new Vector3();
var tmp4 = new Vector3();
var tmp5 = new Vector3();
var Ray =
/*#__PURE__*/
function () {
  function Ray(origin, direction) {
    this.origin = void 0;
    this.direction = void 0;
    this.origin = origin || new Vector3();
    this.direction = direction || new Vector3(0, 0, -1);
  }
  /**
   * 更新射线属性
   * @param origin - 起点
   * @param direction - 方向
   */


  var _proto = Ray.prototype;

  _proto.set = function set(origin, direction) {
    // Vec3.copy(this.origin, origin);
    // Vec3.copy(this.direction, direction);
    this.origin.copy(origin);
    this.direction.copy(direction);
    return this;
  }
  /**
   * 使用相机参数更新射线
   * @param coords - 输入事件的二维坐标(NDC)
   * @param camera - 射线所来源的相机
   */
  ;

  _proto.setFromCamera = function setFromCamera(coords, camera) {
    var origin = new Vector3(camera.position[0], camera.position[1], camera.position[2]); // unproject direction

    var pMatrixInvert = new Matrix4().fromArray(camera.projectionMatrix);
    var viewMatrixInvert = camera.worldMatrix; // TODO: 优化类型

    var _transform$transform = new Vector4(coords[0], coords[1], 0.5, 1).transform(pMatrixInvert).transform(viewMatrixInvert),
        x = _transform$transform.x,
        y = _transform$transform.y,
        z = _transform$transform.z;

    var direction = new Vector3(x, y, z).sub(origin).normalize();
    this.set(origin, direction);
  }
  /**
   * 返回沿当前射线方向的从端点起长度为t的点
   * @param t - 目标长度
   * @param point3D - 指定Vec3对象[可选]
   */
  ;

  _proto.getPointByLen = function getPointByLen(t, point3D) {
    var result = undefined !== point3D ? point3D : new Vector3();
    result.copy(this.direction);
    result.scale(t);
    result.add(this.origin);
    return result;
  }
  /**
   * 射线与三角形相交测试
   * @deprecated
   *
   * @param a - Triangle Point 1
   * @param b - Triangle Point 2
   * @param c - Triangle Point 3
   * @param backfaceCulling - 是否开启背面剔除，默认开启
   * @param intersectionPoint - 指定Vec3对象[可选]
   * @see => 参考博客 http://www.cnblogs.com/graphics/archive/2010/08/09/1795348.html
   * @see => https://docs.ros.org/en/kinetic/api/geometric_tools_engine/html/GteIntrRay3Triangle3_8h_source.html
   */
  ;

  _proto.intersectTriangle_Old = function intersectTriangle_Old(a, b, c) {
    var backfaceCulling = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var intersectionPoint = arguments.length > 4 ? arguments[4] : undefined;
    var edge1 = tmp1$1.copy(b).subtract(a);
    var edge2 = tmp2$1.copy(c).subtract(a);
    var normal = tmp3$1.copy(edge1).cross(edge2);
    var diff = tmp4.copy(this.origin).subtract(a); // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
    // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
    //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
    //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
    //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)

    var DdN = this.direction.dot(normal);
    var sign; // 下面的这些是判断射线的原点在Triangle三角形的前后左右,还是体内,还是永不相交.如果射线原点在立方体后面或者不相交,返回null

    if (0 < DdN) {
      if (backfaceCulling) {
        return null;
      }

      sign = 1;
    } else if (0 > DdN) {
      sign = -1;
      DdN = -DdN;
    } else {
      return null;
    }

    edge2.copy(new Vector3().copy(diff).cross(edge2));
    var DdQxE2 = sign * this.direction.dot(edge2); // b1小于0,表示不相交

    if (0 > DdQxE2) {
      return null;
    }

    var DdE1xQ = sign * this.direction.dot(new Vector3().copy(diff).cross(edge1)); // b2小于0，表示不相交

    if (0 > DdE1xQ) {
      return null;
    } // b1+b2 > 1 ,不相交


    if (DdQxE2 + DdE1xQ > DdN) {
      return null;
    }

    var QdN = -sign * diff.dot(normal); // t小于0，表示不相交

    if (0 > QdN) {
      return null;
    }

    return this.getPointByLen(QdN / DdN, intersectionPoint);
  }
  /**
   * 射线与三角形相交测试
   *
   * @param a - Triangle Point 1
   * @param b - Triangle Point 2
   * @param c - Triangle Point 3
   * @param backfaceCulling - 是否开启背面剔除，默认开启
   * @param intersectionPoint - 指定Vec3对象[可选]
   * @see => http://ku.baidu-int.com/knowledge/HFVrC7hq1Q/bC_f_7topr/x4omnH0jtd/X9CU-ntykuNY2k
   */
  ;

  _proto.intersectTriangle = function intersectTriangle(a, b, c) {
    var intersectionPoint = arguments.length > 4 ? arguments[4] : undefined;
    var EPSILON = 0.000001;
    var e1 = tmp1$1.subVectors(b, a);
    var e2 = tmp2$1.subVectors(c, a);
    var P = tmp3$1.copy(this.direction).cross(e2);
    var det = e1.dot(P);

    if (det > -EPSILON && det < EPSILON) {
      return null;
    }

    var inv_det = 1 / det;
    var T = tmp4.subVectors(this.origin, a);
    var u = inv_det * T.dot(P);

    if (u < 0 || u > 1) {
      return null;
    }

    var Q = tmp5.copy(T).cross(e1);
    var v = inv_det * this.direction.dot(Q);

    if (v < 0 || u + v > 1) {
      return null;
    }

    var t = e2.dot(Q) * inv_det;

    if (t > EPSILON) {
      // 相交
      return {
        distance: t,
        point: this.getPointByLen(t, intersectionPoint)
      };
    }

    return null;
  }
  /**
   * 射线与球相交测试
   * @param sphereCenter - 球心坐标
   * @param radius - 半径
   * @param intersectionPoint - 指定Vec3对象[可选]
   * @see => http://www.scratchapixel.com/lessons/3d-basic-lessons/lesson-7-intersecting-simple-shapes/ray-sphere-intersection/
   */
  ;

  _proto.intersectSphere = function intersectSphere(sphereCenter, radius, intersectionPoint) {
    var v1 = new Vector3().subtract(sphereCenter, this.origin);
    var tca = v1.dot(this.direction);
    var d2 = v1.dot(v1) - tca * tca;
    var radius2 = radius * radius; // 不相交

    if (d2 > radius2) {
      return null;
    }

    var thc = Math.sqrt(radius2 - d2); // t0射线与球体的第一个交点,从球体的前面进入

    var t0 = tca - thc; // t1射线与球体的第二个交点,从球体的背面射出

    var t1 = tca + thc; // 如果t0,t1都小于0,说明球体在射线端点的后面,返回null.

    if (0 > t0 && 0 > t1) {
      return null;
    } // 如果t0射线与球体的第一个交点在射线端点的后面，说明射线端点在球体的内部，所以返回射线与球体表面的交点是t1，从球体的背面射出的交点。


    if (0 > t0) {
      return this.getPointByLen(t1, intersectionPoint);
    } // 另一种情况，球体在射线的前面，返回t0，射线从球体体正面射入的交点。


    return this.getPointByLen(t0, intersectionPoint);
  };

  return Ray;
}();

/**
 * @file 射线拾取
 * @author quda
 */
var Raycaster =
/*#__PURE__*/
function () {
  function Raycaster(origin, direction, near, far) {
    this.ray = void 0;
    this.near = void 0;
    this.far = void 0;
    this.ray = new Ray(origin, direction);
    this.near = near || 0;
    this.far = far || Infinity;
  }
  /**
   * 更新射线
   * @param origin - 新原点
   * @param direction - 新方向
   */


  var _proto = Raycaster.prototype;

  _proto.set = function set(origin, direction) {
    this.ray.set(origin, direction);
  }
  /**
   * 使用相机参数更新射线
   * @param coords - 输入事件的二维坐标(NDC)
   * @param camera - 射线所来源的相机
   */
  ;

  _proto.setFromCamera = function setFromCamera(coords, camera) {
    var origin = new Vector3(camera.position[0], camera.position[1], camera.position[2]); // unproject direction

    var pMatrixInvert = new Matrix4().fromArray(camera.projectionMatrix).invert();
    var viewMatrixInvert = camera.worldMatrix;

    var _transform$transform = new Vector4(coords[0], coords[1], 0.5, 1).transform(pMatrixInvert).transform(viewMatrixInvert),
        x = _transform$transform.x,
        y = _transform$transform.y,
        z = _transform$transform.z;

    var direction = new Vector3(x, y, z).sub(origin).normalize();
    this.set(origin, direction);
  }
  /**
   * 射线拾取
   * @param object - 目标几何
   * @return - 拾取信息
   */
  ;

  _proto.pick = function pick(object) {
    var ray = this.ray;
    var pickInfos = [];
    var objects = [].concat(object);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = objects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _object = _step.value;

        var res = _object.raycast(ray);

        res && pickInfos.push(res);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    pickInfos.sort(function (a, b) {
      return a.distance - b.distance;
    });
    return pickInfos;
  };

  return Raycaster;
}();

/**
 * WebGLTexture
 * @class
 *
 * @constructor
 * @param {Image} image - 承载图片资源的Image对象
 */

var Texture =
/*#__PURE__*/
function (_EventEmitter) {
  inheritsLoose(Texture, _EventEmitter);

  /**
   * webgl 纹理，左下角为(0,0),右上角为(1,1),HTML DOM，左上角为(0,0),右下角为(1,1),需要在Y轴上翻转
   * @type {boolean}
   */

  /**
   * 将alpha通道预先与其他颜色通道相乘
   * @type {boolean}
   */

  /**
   * 纹理是否需要更新。
   * @public
   * @property
   */

  /**
   * WebGL Texture
   * @property
   */

  /**
   * 纹理类标识
   * @type {boolean}
   */

  /**
   * 纹理初始化标识
   */
  function Texture(image) {
    var _this;

    _this = _EventEmitter.call(this) || this;
    _this.image = void 0;
    _this.flipY = true;
    _this.premultiplyAlpha = false;
    _this.needsUpdate = true;
    _this.glTexture = null;
    _this.isTexture = true;
    _this.gl = null;
    _this.__textureInit = false;

    _this.clone = function (texture) {
      if (undefined === texture) {
        texture = new Texture();
      }

      texture.image = _this.image;
      texture.flipY = _this.flipY;
      return texture;
    };

    _this.destory = function () {
      _this.emit('destory', _this.glTexture);
    };

    _this.destoryTexture = function () {
      if (_this.glTexture && _this.gl) {
        _this.off('destory', _this.destoryTexture);

        _this.gl.deleteTexture(_this.glTexture);
      }
    };

    if (image !== undefined) {
      _this.image = image;
    }

    return _this;
  }
  /**
   * 初始化纹理对象
   * @param gl - gl上下文
   */


  var _proto = Texture.prototype;

  _proto.init = function init(gl) {
    if (this.__textureInit === true) {
      return;
    }

    this.gl = gl;
    this.glTexture = gl.createTexture();
    this.on('destory', this.destoryTexture);
    this.__textureInit = true;
  }
  /**
   * 克隆纹理对象对象。
   * @public
   * @param {Texture} texture - 克隆的接受对象
   * @return {WebGLTexture} - 纹理实例
   */
  ;

  return Texture;
}(EventEmitter);

/**
 * WebGLTexture
 * @class
 *
 * @constructor
 * @param {Image} image - 承载图片资源的Image对象
 */

var CubeTexture =
/*#__PURE__*/
function (_Texture) {
  inheritsLoose(CubeTexture, _Texture);

  /**
   * 立方体纹理标识
   */
  function CubeTexture(image) {
    var _this;

    _this = _Texture.call(this) || this;
    _this.isCube = true;
    _this.image = image || [];
    _this.flipY = false;
    return _this;
  }

  return CubeTexture;
}(Texture);

/**
 * @file WebGL纹理相关操作
 * @author quda
 */
/**
 * TextureOperation
 * @class
 *
 * @constructor
 * @param {WebGLRenderingContext} gl - WebGLRenderingContext
 */

var TextureOperation =
/*#__PURE__*/
function () {
  function TextureOperation(_gl, maxTextures, maxTextureSize) {
    var _this = this;

    this.gl = void 0;
    this.maxTextureSize = void 0;
    this.maxTextures = void 0;
    this.usedTextureUnits = 0;

    this.getTextureUnit = function () {
      var resultUnit = _this.usedTextureUnits; // 大于最大可用纹理单元数，GPU会默认从第一个纹理单元开始用

      if (_this.usedTextureUnits >= _this.maxTextures) {
        _this.usedTextureUnits = 0;
      } else {
        _this.usedTextureUnits += 1;
      }

      return resultUnit;
    };

    this.resetUsedTextureUnits = function () {
      _this.usedTextureUnits = 0;
    };

    this.setTexture = function (texture) {
      var slot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (texture instanceof CubeTexture) {
        _this.setCubeTexture(texture, slot);

        return;
      }

      var gl = _this.gl;
      gl.activeTexture(gl.TEXTURE0 + slot); // Log.log('[TextureOperation] Select active texture unit: ' + (gl.TEXTURE0 + slot));

      if (texture.needsUpdate) {
        // 初始化纹理对象
        texture.init(gl);

        _this.uploadTexture(gl, texture);
      } else {
        gl.bindTexture(gl.TEXTURE_2D, texture.glTexture); // Log.log('[TextureOperation] 绑定纹理');
      }
    };

    this.setTextureForRenderTarget = function (renderTarget) {
      var gl = _this.gl; // 创建贴图对象，并设置为当前贴图对象

      renderTarget.glTexture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, renderTarget.glTexture);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, renderTarget.flipY);
      gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, renderTarget.premultiplyAlpha); // 设置贴图对象状态

      _this.setTextureParameter(gl); // define size and format of level 0


      var level = 0; // 指定详细级别. 0级是基本图像等级，n级是第n个金字塔简化级.

      var internalFormat = gl.RGBA; // 指定纹理中的颜色组件.

      var border = 0; // 指定纹理的边框宽度。必须为 0

      var format = gl.RGBA; // 指定texel数据格式。在 WebGL 1中，它必须与 internalformat 相同

      var type = gl.UNSIGNED_BYTE; // 指定texel数据的数据类型

      var data = null; // 把贴图对象的图片数据指针注销（交给帧缓冲管理）

      gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, renderTarget.width, renderTarget.height, border, format, type, data);
    };

    this.uploadTexture = function (gl, texture) {
      // 初始化纹理对象
      texture.init(gl);
      gl.bindTexture(gl.TEXTURE_2D, texture.glTexture);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
      gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);

      _this.setTextureParameter(gl);

      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, texture.image); // 设置纹理为不需要更新

      texture.needsUpdate = false;
    };

    this.setTextureParameter = function (gl) {
      // TODO: 暂时把参数写死，后续根据场景扩展
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    };

    this.gl = _gl;
    this.maxTextureSize = maxTextureSize;
    this.maxTextures = maxTextures;
  }
  /**
   * 获取可用的纹理单元
   * @return {number} 当前可用的纹理单元
   */


  var _proto = TextureOperation.prototype;

  _proto.setCubeTexture = function setCubeTexture(texture) {
    var slot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var images = texture.image;

    if (images.length !== 6) {
      throw new Error("[setCubeTexture] CubeTexture need six images, but get\n                ".concat(images.length, "\n            "));
    }

    var gl = this.gl;

    if (texture.needsUpdate) {
      // 初始化纹理对象
      texture.init(gl);
      gl.activeTexture(gl.TEXTURE0 + slot);
      gl.bindTexture(gl.TEXTURE_CUBE_MAP, texture.glTexture);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, texture.flipY); // this.setTextureParameter(gl);

      gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE); // gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_R, gl.CLAMP_TO_EDGE);
      // gl.generateMipmap(gl.TEXTURE_CUBE_MAP);

      for (var i = 0; i < 6; i++) {
        var mipmap = images[i];
        gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, mipmap);
      }

      texture.needsUpdate = false;
    } else {
      gl.bindTexture(gl.TEXTURE_CUBE_MAP, texture.glTexture); // Log.log('[TextureOperation] 绑定纹理');
    }
  }
  /**
   * 设置帧缓冲区纹理
   * @public
   * @param {WebGLRenderTarget} renderTarget - 帧缓冲区对象
   */
  ;

  return TextureOperation;
}();

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var arrayWithoutHoles = _arrayWithoutHoles;

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

var iterableToArray = _iterableToArray;

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var nonIterableSpread = _nonIterableSpread;

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray;

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles = _arrayWithHoles;

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit = _iterableToArrayLimit;

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var nonIterableRest = _nonIterableRest;

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray;

/**
 * @file 着色器Unform操作工具集，主要是针对材质自带的unifrom属性
 * @author quda
 */
// import {Texture} from '../texture/Texture';

/**
 * 加载材质uniforms数组中的所有的Uniform元素
 * @param  {WebGLRenderContext} gl    WebGLRenderContext
 * @param  {Array} uniforms  材质的Uniform数组
 * @param  {TextureOperation} textureOperation  纹理管理器
 */
var loadUniformsGeneric = function loadUniformsGeneric(gl, uniforms, textureOperation) {
  if (!gl || !uniforms || !uniforms.length) {
    return;
  }

  var len = uniforms.length;

  for (var i = 0; i < len; i++) {
    var texture = void 0;
    var textureUnit = void 0;
    var textureUnits = void 0;
    var uniform = uniforms[i];

    var _uniform = slicedToArray(uniform, 2),
        uniformInfos = _uniform[0],
        location = _uniform[1];

    var type = uniformInfos.type,
        value = uniformInfos.value; // TODO: 目前只覆盖主要场景，还需要考虑uniform[1234][fi][v]数组时的情况
    // @see => https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/uniform

    switch (uniformInfos.type) {
      case '1i':
      case '1f':
        gl["uniform".concat(type)](location, uniformInfos.value);
        break;

      case '2f':
      case '3f':
      case '4f':
        // @ts-ignore
        gl["uniform".concat(type)].apply(gl, [location].concat(toConsumableArray(value)));
        break;

      case 't':
        // single Texture
        texture = uniformInfos.value; // 纹理不存在，直接略过

        if (!texture || !texture.image && !texture.glTexture) {
          break;
        }

        textureUnit = textureOperation.getTextureUnit(); // 纹理单元编号

        gl.uniform1i(location, textureUnit);
        textureOperation.setTexture(texture, textureUnit);
        break;

      case 'tv':
        // TODO: 这里逻辑着重覆盖
        // array of Texture (2d)
        textureUnits = [];
        var ts = uniformInfos.value;

        for (var _i = 0, il = ts.length; _i < il; _i++) {
          textureUnits[_i] = textureOperation.getTextureUnit();
        }

        gl.uniform1iv(location, textureUnits);

        for (var _i2 = 0, _il = ts.length; _i2 < _il; _i2++) {
          texture = ts[_i2]; // 纹理不存在，直接略过

          if (!texture || !texture.image && !texture.glTexture) {
            continue;
          }

          textureUnit = textureUnits[_i2];
          textureOperation.setTexture(texture, textureUnit);
        }

        break;

      case 'mat4fv':
        gl.uniformMatrix4fv(location, false, uniformInfos.value);
        break;

      default:
        console.warn("[UniformOperation] Unknown uniform type: ".concat(type));
    }
  }
};
/**
 * 深拷贝一致变量
 * @public
 * @param {Object} uniforms - 一致变量信息
 */

function cloneUniform(uniforms) {
  var value;
  var result = {};

  for (var name in uniforms) {
    if (Object.prototype.hasOwnProperty.call(uniforms, name)) {
      result[name] = {};

      for (var p in uniforms[name]) {
        if (Object.prototype.hasOwnProperty.call(uniforms[name], p)) {
          value = uniforms[name][p];

          if (value && value.isTexture) {
            result[name][p] = value.clone();
          } else if (value instanceof Array) {
            // TODO: 这里需要考虑Texture Array 的情况
            result[name][p] = value.slice(0);
          } else {
            result[name][p] = value;
          }
        }
      }
    }
  }

  return result;
}

var DEFAULT_VERTEX_SHADER = "\nvoid main() {\n    gl_Position = mvpMatrix * vec4(position, 1.0);\n}\n";

var DEFAULT_FRAGMENT_SHADER = "\nvoid main() {\n    gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0);\n}\n";

var materialIdCount = 0;
var Material =
/*#__PURE__*/
function (_Event) {
  inheritsLoose(Material, _Event);

  function Material() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Event.call.apply(_Event, [this].concat(args)) || this;
    _this.isMaterial = true;
    _this.id = materialIdCount++;
    _this.type = 'Material';
    _this.name = '';
    _this.uuid = genUUID();
    _this.uniforms = {};
    _this.vertexShader = DEFAULT_VERTEX_SHADER;
    _this.fragmentShader = DEFAULT_FRAGMENT_SHADER;
    _this.program = null;
    _this.depthTest = true;
    _this.visible = true;
    _this.opacity = 1;
    _this.needsUpdate = true;
    _this.uniformsList = [];
    return _this;
  }

  var _proto = Material.prototype;

  /**
   * 设置材质属性
   * @public
   * @param {Object} values - 待设置属性集合
   */
  _proto.setValues = function setValues(values) {
    if (values === undefined) {
      return;
    }

    for (var key in values) {
      if (Object.prototype.hasOwnProperty.call(values, key)) {
        var newValue = values[key];

        if (newValue === undefined) {
          console.warn("Material: '" + key + "' parameter is undefined.");
          continue;
        }

        var currentValue = this[key];

        if (currentValue === undefined) {
          console.warn("".concat(this.type, ": ").concat(key, " is not a property of this material."));
          continue;
        }

        var setFnName = 'set' + key.charAt(0).toUpperCase() + key.slice(1);

        if (typeof this[setFnName] === 'function') {
          this[setFnName](newValue);
        } else {
          this[key] = newValue;
        }
      }
    }
  }
  /**
   * 克隆当前材质
   * @public
   *
   * @return {Material} - 克隆的材质
   */
  ;

  _proto.clone = function clone() {
    return new Material().copy(this);
  }
  /**
   * 复制目标材质
   * @public
   *
   * @param {Material} material - 目标材质
   * @return {Material} - 自身实例
   */
  ;

  _proto.copy = function copy(material) {
    this.uniforms = cloneUniform(material.uniforms);
    this.depthTest = material.depthTest;
    this.visible = material.visible;
    this.fragmentShader = material.fragmentShader;
    this.vertexShader = material.vertexShader;
    return this;
  };

  createClass(Material, [{
    key: "defines",

    /**
     * @TODO: 优化defines的定义，考虑后续自定义设置define是的情况
     */
    get: function get() {
      return '';
    }
  }]);

  return Material;
}(EventEmitter);

/**
 * @flie 材质预处理定义管理
 * @author quda
 */
// 名称映射
var DEFINE_MAP = {
  useColor: 'USE_COLOR',
  useUV: 'NEED_UV'
};
var MaterialDefines =
/*#__PURE__*/
function () {
  function MaterialDefines() {
    this.useColor = false;
    this.useUV = false;
  }

  var _proto = MaterialDefines.prototype;

  /**
   * 获取材质shader预处理定义
   * @return {string} - 预处理定义
   */
  _proto.getDefines = function getDefines() {
    var defines = [];
    var keys = Object.keys(this);

    for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
      var key = _keys[_i];

      if (DEFINE_MAP[key] && this[key] === true) {
        defines.push("#define ".concat(DEFINE_MAP[key]));
      }
    }

    defines.push(''); // 保留一个空行，防止shader解析异常

    return defines.join('\n');
  };

  return MaterialDefines;
}();

var BASE_VS_SHADER_TEXT = "\n#ifdef NEED_UV\n    varying vec2 vUV;\n#endif\nvoid main(void) {\n    gl_Position = mvpMatrix * vec4(position, 1.0);\n    #ifdef NEED_UV\n        vUV = uv;\n    #endif\n}\n";

var BASE_FS_SHADER_TEXT = "\nprecision mediump float;\n#ifdef NEED_UV\n    varying vec2 vUV;\n    uniform sampler2D uSampler;\n#endif\n#ifdef USE_COLOR\n    uniform vec4 uColor;\n#endif\nuniform float uOpacity;\nvoid main(void) {\n    vec4 finalColor;\n    vec4 defaultColor = vec4(1.0, 0.0, 0.0, 1.0);\n    finalColor = defaultColor;\n    #ifdef USE_COLOR\n        finalColor = uColor;\n    #endif\n    #ifdef NEED_UV\n        finalColor = texture2D(uSampler, vUV);\n    #endif\n    gl_FragColor = vec4(finalColor.rgb, finalColor.a * uOpacity);\n}\n";

/**
 * 基础网孔材质类
 * @class
 * @constructor
 *
 * @param {Object} parameters - 配置信息，也可包含Material基类的属性
 * @param {Array} parameters.color - 片元颜色，默认[1.0, 0.0, 0.0, 1.0]
 * @param {Texture | Promise} parameters.map - 基础纹理，也可为异步获取纹理的Promise对象
 */
var BasicMaterial =
/*#__PURE__*/
function (_Material) {
  inheritsLoose(BasicMaterial, _Material);

  function BasicMaterial() {
    var _this;

    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _this = _Material.call(this) || this;
    _this.map = null;
    _this.color = [1.0, 0.0, 0.0, 1.0];
    _this.type = 'BasicMaterial';
    _this.opacity = 1.0;
    _this.depthTest = true;
    _this.vertexShader = BASE_VS_SHADER_TEXT;
    _this.fragmentShader = BASE_FS_SHADER_TEXT;
    _this.uniforms = {
      uSampler: {
        type: 't',
        value: null
      },
      uColor: {
        type: '4f',
        value: [1.0, 0.0, 0.0, 1.0]
      },
      uOpacity: {
        type: '1f',
        value: _this.opacity
      }
    };

    _this.setValues(parameters);

    return _this;
  }
  /**
   * 获取材质shader预处理定义
   * @TODO: 优化defines的定义，考虑后续自定义设置define是的情况
   * @return {string} - 预处理定义
   */


  var _proto = BasicMaterial.prototype;

  _proto.setOpacity = function setOpacity(v) {
    this.uniforms.uOpacity.value = v;
    this.opacity = v;
  };

  _proto.setColor = function setColor(color) {
    if (!Array.isArray(color) || color.length < 4) {
      return;
    }

    this.uniforms.uColor.value = color;
    this.color = color;
  };

  _proto.setMap = function setMap(map) {
    var _this2 = this;

    if (!map) {
      return;
    }

    if (map instanceof Promise) {
      map.then(function (res) {
        _this2.uniforms.uSampler.value = res instanceof Texture === true ? res : new Texture(res);
      })["catch"](function (e) {
        return console.error(e);
      });
    } else if (map.isTexture === true) {
      this.uniforms.uSampler.value = map;
    }

    this.map = map;
  };

  createClass(BasicMaterial, [{
    key: "defines",
    get: function get() {
      var defines = new MaterialDefines();
      defines.useColor = !!this.color;
      defines.useUV = !!this.map;
      return defines.getDefines();
    }
  }]);

  return BasicMaterial;
}(Material);

/**
 * @file WebGL的状态管理
 * @author quda
 */
var WebGLState =
/**
 * 是否开启深度测试
 * 默认关闭
 */

/**
 * 是否开启写入深度缓冲区
 * default true
 */

/**
 * Lets you set whether individual colors can be written when drawing or rendering to a framebuffer.
 * default true
 */
function WebGLState(_gl) {
  var _this = this;

  this.gl = void 0;
  this.newAttributes = new Uint8Array(16);
  this.enabledAttributes = new Uint8Array(16);
  this.currentDepthTest = false;
  this.currentDepthWrite = true;
  this.currentColorWrite = true;
  this.currentDoubleSided = false;
  this.currentFlipSided = false;

  this.initAttributes = function () {
    for (var i = 0, l = _this.newAttributes.length; i < l; i++) {
      _this.newAttributes[i] = 0;
    }
  };

  this.enableAttribute = function (attribute) {
    var gl = _this.gl,
        newAttributes = _this.newAttributes,
        enabledAttributes = _this.enabledAttributes;
    newAttributes[attribute] = 1;

    if (0 === enabledAttributes[attribute]) {
      gl.enableVertexAttribArray(attribute);
      enabledAttributes[attribute] = 1;
    }
  };

  this.disableAttribute = function (attribute) {
    var gl = _this.gl,
        newAttributes = _this.newAttributes,
        enabledAttributes = _this.enabledAttributes;
    newAttributes[attribute] = 0;

    if (1 === enabledAttributes[attribute]) {
      gl.disableVertexAttribArray(attribute);
      enabledAttributes[attribute] = 0;
    }
  };

  this.disableUnusedAttributes = function () {
    var gl = _this.gl,
        newAttributes = _this.newAttributes,
        enabledAttributes = _this.enabledAttributes;

    for (var i = 0, l = enabledAttributes.length; i < l; i++) {
      if (enabledAttributes[i] !== newAttributes[i]) {
        gl.disableVertexAttribArray(i);
        enabledAttributes[i] = 0;
      }
    }
  };

  this.setDepthTest = function (depthTest) {
    var gl = _this.gl,
        currentDepthTest = _this.currentDepthTest;

    if (currentDepthTest !== depthTest) {
      if (depthTest) {
        gl.enable(gl.DEPTH_TEST);
      } else {
        gl.disable(gl.DEPTH_TEST);
      }

      _this.currentDepthTest = depthTest;
    }
  };

  this.setDepthWrite = function (depthWrite) {
    var gl = _this.gl,
        currentDepthWrite = _this.currentDepthWrite;

    if (currentDepthWrite !== depthWrite) {
      gl.depthMask(depthWrite);
      _this.currentDepthWrite = depthWrite;
    }
  };

  this.setColorWrite = function (colorWrite) {
    var gl = _this.gl,
        currentColorWrite = _this.currentColorWrite;

    if (currentColorWrite !== colorWrite) {
      gl.colorMask(colorWrite, colorWrite, colorWrite, colorWrite);
      _this.currentColorWrite = colorWrite;
    }
  };

  this.setDefaultGLState = function (x, y, viewWidth, viewHeight) {
    var gl = _this.gl; // pecifies color values to use by the clear method to clear the color buffer

    gl.clearColor(229 / 255, 227 / 255, 223 / 255, 1.0);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT); // Clears the depth buffer to a specific value.

    gl.clearDepth(1); // Specifies the clear value to be used by the clear method to clear the stencil buffer.

    gl.clearStencil(0); // gl.enable(gl.DEPTH_TEST);

    gl.disable(gl.DEPTH_TEST);
    gl.depthFunc(gl.LEQUAL); // 逆时针为正面

    gl.frontFace(gl.CCW); // gl.cullFace(gl.BACK);

    gl.disable(gl.CULL_FACE);
    gl.depthMask(true); // 默认值为true

    gl.enable(gl.BLEND); // TODO: 确定混色模式的默认写法
    // gl.blendEquation(gl.FUNC_ADD); // 指定混色的操作方式，相加是默认行为

    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    gl.viewport(x, y, viewWidth, viewHeight);
  };

  this.setDoubleSided = function (doubleSided) {
    var gl = _this.gl,
        currentDoubleSided = _this.currentDoubleSided;

    if (currentDoubleSided !== doubleSided) {
      if (doubleSided) {
        gl.disable(gl.CULL_FACE);
      } else {
        gl.enable(gl.CULL_FACE);
      }

      _this.currentDoubleSided = doubleSided;
    }
  };

  this.setFlipSided = function (flipSided) {
    var gl = _this.gl,
        currentFlipSided = _this.currentFlipSided;

    if (currentFlipSided !== flipSided) {
      if (flipSided) {
        gl.frontFace(gl.CW);
      } else {
        gl.frontFace(gl.CCW);
      }

      _this.currentFlipSided = flipSided;
    }
  };

  this.reset = function () {
    var enabledAttributes = _this.enabledAttributes;

    for (var i = 0; i < enabledAttributes.length; i++) {
      enabledAttributes[i] = 0;
    }

    _this.currentDepthTest = false;
    _this.currentDepthWrite = true;
    _this.currentColorWrite = true;
    _this.currentDoubleSided = false;
    _this.currentFlipSided = false;
  };

  this.gl = _gl;
}
/**
 * 初始化属性
 */
;

/**
 * @file gl支持能力检测
 * @author mawenjie01
 */

/**
 * WebGLCapability
 * @class
 *
 * @constructor
 * @param {WebGLRenderingContext} gl - WebGLRenderingContext
 */
var WebGLCapability = function WebGLCapability(_gl) {
  var _this = this;

  this.maxTextures = void 0;
  this.maxTextureSize = void 0;
  this.maxVerticesOneDraw = void 0;
  this.maxVertexShaderTextureUnits = void 0;
  this.maxFragmentShaderTextureUnits = void 0;
  this.gl = void 0;

  this.getMaxTextures = function () {
    var gl = _this.gl;
    return gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
  };

  this.getLineWidthRange = function () {
    var gl = _this.gl;
    return gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE);
  };

  this.getMaxVertexShaderTextureUnits = function () {
    var gl = _this.gl;
    return gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
  };

  this.getMaxFragmentShaderTextureUnits = function () {
    var gl = _this.gl;
    return gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
  };

  this.getMaxTextureSize = function () {
    var gl = _this.gl;
    return gl.getParameter(gl.MAX_TEXTURE_SIZE);
  };

  this.getMaxVerticesOneDraw = function () {
    var gl = _this.gl;
    return gl.getExtension('OES_element_index_uint') ? 4294967296 : 65535;
  };

  this.getLegalPrecision = function (precision) {
    var gl = _this.gl; // 检查Shader的精度

    var vertexShaderPrecisionHighpFloat = gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT);
    var vertexShaderPrecisionMediumpFloat = gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT);
    var fragmentShaderPrecisionHighpFloat = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
    var fragmentShaderPrecisionMediumpFloat = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT);
    var highpAvailable = vertexShaderPrecisionHighpFloat && fragmentShaderPrecisionHighpFloat && vertexShaderPrecisionHighpFloat.precision > 0 && fragmentShaderPrecisionHighpFloat.precision > 0;
    var mediumpAvailable = vertexShaderPrecisionMediumpFloat && fragmentShaderPrecisionMediumpFloat && vertexShaderPrecisionMediumpFloat.precision > 0 && fragmentShaderPrecisionMediumpFloat.precision > 0;

    if ('highp' === precision && !highpAvailable) {
      if (mediumpAvailable) {
        precision = 'mediump';
        console.warn('[WebGLCapability] highp is not supported, using mediump by default.');
      } else {
        precision = 'lowp';
        console.warn('[WebGLCapability] highp and mediump is not supported, using lowp by default.');
      }
    } else if ('mediump' === precision && !mediumpAvailable) {
      precision = 'lowp';
      console.warn('[WebGLCapability] mediump is not supported, using lowp by default.');
    }

    return precision;
  };

  this.gl = _gl;
  /**
   * 最大纹理单元数量，同时运行的最大纹理单元数量不能大于这个值
   * 这意味这，如果你有两个纹理单元被用在顶点着色器中，那么还剩6个可以使用在片段着色器中，因为最多能使用的纹理单元只有8个。
   */

  this.maxTextures = this.getMaxTextures(); // 最大顶点着色器支持的纹理单元数量

  this.maxVertexShaderTextureUnits = this.getMaxVertexShaderTextureUnits(); // 最大片段着色器支持的纹理单元数量

  this.maxFragmentShaderTextureUnits = this.getMaxFragmentShaderTextureUnits(); // 最大的纹理尺寸

  this.maxTextureSize = this.getMaxTextureSize(); // 一次允许绘制的最大顶点数量

  this.maxVerticesOneDraw = this.getMaxVerticesOneDraw();
}
/**
 * 获取GPU中gl.TEXTURE的最大个数
 * @param {WebGLRenderingContext} gl webgl渲染上下文环境
 * @return {number} 每次渲染支持最大的纹理单元数量
 */
;

/**
 * @file webgl program gen
 * @author quda
 */

/**
 * shader uniform变量位置指针信息集合
 */

/**
 * shader attributes 属性位置下标信息集合
 */
var programIdCount = 0;
/**
 * 获取Uniform的地址指针
 * @param {WebGLRenderingContext} gl - webGL上下文
 * @param {WebGLProgram} program - WebGLProgram
 * @param {Array} identifiers - 变量名称集合
 * @return {IUniforms} - Uniform地址指针集合
 */

var getUniformLocations = function getUniformLocations(gl, program) {
  var identifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var id;
  var uniforms = {};
  var len = identifiers.length;

  if (!len) {
    return uniforms;
  }

  for (var i = 0; i < len; i++) {
    id = identifiers[i]; // The uniform variable is returned as a WebGLUniformLocation object

    uniforms[id] = gl.getUniformLocation(program, id);
  }

  return uniforms;
};
/**
 * 构造着色器，编译
 * @param {WebGLRenderingContext} gl - webGL上下文
 * @param {string} - shader代码
 * @param {const enum} - 着色器类型
 */

var makeShader = function makeShader(gl, src, type) {
  // compile the vertex shader
  var shader = gl.createShader(type);

  if (!shader) {
    throw new Error('Something went wrong while compile the shader.');
  }

  gl.shaderSource(shader, src);
  gl.compileShader(shader); // shader debug
  // const shaderDebugger = gl.getExtension('WEBGL_debug_shaders').getTranslatedShaderSource(shader);

  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    console.error("Error compiling shader: ".concat(gl.getShaderInfoLog(shader)));
  }

  return shader;
};
/**
 * WebGL Program创建类
 * @class WebGLProgram
 * @constructor
 *
 * @param {WebGLRenderingContext} gl - webGL上下文
 * @param {Object} parameters - 材质对象
 * @param {Array} parameters.uniforms - Uniforms变量名称集合
 * @param {string} parameters.vertexShader - vertexShader
 * @param {string} parameters.fragmentShader - fragmentShader
 * @param {Object} options - 可选属性
 * @param {string} options.precision - 精度
 */


var Program =
/*#__PURE__*/
function () {
  function Program(gl, parameters, options) {
    this.usedTimes = void 0;
    this.id = void 0;
    this.code = void 0;
    this.program = void 0;
    this.attributes = void 0;
    this.uniforms = void 0;
    this.gl = void 0;
    this.parameters = void 0;
    this.precision = void 0;
    this.gl = gl;
    this.parameters = parameters;
    this.precision = options.precision || 'highp';
    this.usedTimes = 1; // 引用次数

    this.id = programIdCount++;
    var _parameters$defines = parameters.defines,
        defines = _parameters$defines === void 0 ? '' : _parameters$defines,
        vertexShader = parameters.vertexShader,
        fragmentShader = parameters.fragmentShader;
    this.code = defines + vertexShader + fragmentShader; // 唯一标识

    this.program = this.createProgram(gl, parameters, this.precision);
    this.attributes = this.fetchAttributes(gl, this.program);
    this.uniforms = getUniformLocations(gl, this.program, this.getFullUniforms(parameters.uniforms));
  }
  /**
   * 获取顶点属性存储位置信息
   * @public
   * @return {Object} -
   */


  var _proto = Program.prototype;

  _proto.getAttributes = function getAttributes() {
    return this.attributes;
  }
  /**
   * 获取一致变量存储位置信息
   * @public
   * @return {Object} -
   */
  ;

  _proto.getUniforms = function getUniforms() {
    return this.uniforms;
  }
  /**
   * 创建着色器程序
   * @private
   *
   * @param {WebGLContext} gl - gl上下文
   * @param {Object} param - 着色器
   * @param {string} parameters.defines - 预处理定义
   * @param {string} parameters.vertexShader - vertexShader
   * @param {string} parameters.fragmentShader - fragmentShader
   * @param {string} precision - 精度
   * @return {WebGLProgram} - 着色器程序
   */
  ;

  _proto.createProgram = function createProgram(gl, parameters) {
    var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'highp';
    var vertexShader = parameters.vertexShader,
        fragmentShader = parameters.fragmentShader,
        _parameters$defines2 = parameters.defines,
        defines = _parameters$defines2 === void 0 ? '' : _parameters$defines2;
    var preVertexShader = ["precision ".concat(precision, " float;"), 'uniform mat4 modelMatrix;', 'uniform mat4 projectionMatrix;', 'uniform mat4 viewMatrix;', 'uniform mat4 mvpMatrix;', 'attribute vec3 position;', 'attribute vec2 uv;', ''].join('\n');
    var program = gl.createProgram();
    var preFragmentShader = ["precision ".concat(precision, " float;"), ''].join('\n');
    var glVertexShader = makeShader(gl, preVertexShader + defines + vertexShader, gl.VERTEX_SHADER);
    var glFragmentShader = makeShader(gl, preFragmentShader + defines + fragmentShader, gl.FRAGMENT_SHADER);

    if (!program) {
      throw new Error('Something went wrong while createProgram.');
    }

    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    gl.linkProgram(program);
    return program;
  }
  /**
   * 获取当前程序中用到的顶点属性下标信息
   * @private
   * @param {WebGLContext} gl - gl上下文
   * @param {WebGLProgram} param - 着色器
   * @return {IAttributes} - 顶点属性下标信息
   */
  ;

  _proto.fetchAttributes = function fetchAttributes(gl, program) {
    var attributes = {};
    var n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);

    for (var i = 0; i < n; i++) {
      var info = gl.getActiveAttrib(program, i);

      if (!info) {
        throw new Error('Something went wrong while getActiveAttrib.');
      }

      var name = info.name;
      attributes[name] = gl.getAttribLocation(program, name);
    }

    return attributes;
  }
  /**
   * 获取当前程序中用到的一致变量集合
   * @private
   *
   * @param {Object} uniforms - 材质中定义的一致变量
   * @return {Array} - 一致变量集合
   */
  ;

  _proto.getFullUniforms = function getFullUniforms(uniforms) {
    var uniformsIdentifiers = ['mvpMatrix', 'modelMatrix', 'projectionMatrix', 'viewMatrix'];

    for (var u in uniforms) {
      if (Object.prototype.hasOwnProperty.call(uniforms, u)) {
        uniformsIdentifiers.push(u);
      }
    }

    return uniformsIdentifiers;
  };

  return Program;
}();

/**
 * @file 设置WebGL环境
 * @author quda
 */

/**
 * 默认参数集合
 */
var defaultParameters = {
  /**
   * A Canvas where the renderer draws its output.
   * @type {Canvas}
   */
  canvas: document.createElement('canvas'),

  /**
   * A WebGLContext.
   * @type {WebGLContext}
   */
  context: undefined,

  /**
   * 画布宽度
   * @type {number}
   */
  width: 0,

  /**
   * 画布高度
   * @type {number}
   */
  height: 0,

  /**
   * For Mobile
   * @type {number}
   */
  pixelRatio: 1,

  /**
   * shader precision. Can be 'highp', 'mediump' or 'lowp'.
   * @type {string}
   */
  precision: 'highp',

  /**
   * 是否有Alpha通道处理
   * @type {boolean}
   */
  alpha: false,

  /**
   * Whether the colors in the drawing buffer are premultiplied alpha values.
   * This property is ignored if the alpha property is false.
   * @type {boolean}
   */
  premultipliedAlpha: true,

  /**
   * 抗锯齿
   * @type {boolean}
   */
  antialias: true,

  /**
   * 是否包含一个深度至少为8位的模版缓冲区
   * @type {boolean}
   */
  stencil: true,

  /**
   * 绘制缓冲区是否包含一个深度至少为16位的缓冲区
   */
  depth: true,

  /**
   * Whether the drawing buffer's is cleared once content is presented.
   * @type {boolean}
   */
  preserveDrawingBuffer: false
};
// 集中设置webgl环境，统一对外暴露canvas gl
var WebGLRenderer =
/*#__PURE__*/
function () {
  /**
   * Current WebGLContext.
   */

  /**
   * 是否需要自动删除不再使用的Program
   */
  function WebGLRenderer() {
    var _this = this;

    var _parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.state = void 0;
    this.domElement = void 0;
    this.capability = void 0;
    this.textureOperation = void 0;
    this._gl = void 0;
    this.parameters = void 0;
    this.programs = void 0;
    this.viewportInfo = void 0;
    this.autoDisposeProgram = true;
    this.currentCacheState = void 0;

    this.setSize = function (width, height) {
      var _this$parameters = _this.parameters,
          canvas = _this$parameters.canvas,
          pixelRatio = _this$parameters.pixelRatio;
      canvas.style.width = "".concat(width, "px");
      canvas.style.height = "".concat(height, "px");
      canvas.width = width * pixelRatio;
      canvas.height = height * pixelRatio;

      _this.setViewport(0, 0, width, height);
    };

    this.setViewport = function (x, y, width, height) {
      var pixelRatio = _this.parameters.pixelRatio;
      var viewportInfo = _this.viewportInfo;
      viewportInfo.x = x * pixelRatio;
      viewportInfo.y = y * pixelRatio;
      viewportInfo.width = width * pixelRatio;
      viewportInfo.height = height * pixelRatio; // this._gl.viewport(viewportInfo.x, viewportInfo.y, viewportInfo.width, viewportInfo.height);

      _this._gl.viewport.apply(_this._gl, Object.values(viewportInfo));
    };

    this.setClearColor = function (r, g, b) {
      var alpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      if (true === _this.parameters.premultipliedAlpha) {
        r *= alpha;
        g *= alpha;
        b *= alpha;
      }

      _this._gl.clearColor(r, g, b, alpha);
    };

    this.getContext = function () {
      return _this._gl;
    };

    this.forceContextLoss = function () {
      try {
        var extension = _this._gl.getExtension('WEBGL_lose_context');

        if (extension) {
          extension.loseContext();
        }
      } catch (e) {
        console.error('[WebGLRenderer] WEBGL_lose_context error: ', e);
      }
    };

    this.initScene = function (scene) {
      // 如果场景不可见则直接不做任何处理
      if (true !== scene.visible) {
        return;
      } // TODO: 注意这里的性能


      scene.traverse(function (object) {
        if (true !== object.visible) {
          return;
        }

        if (object instanceof Mesh) {
          _this.initMesh(object);
        }
      });
    };

    this.initMesh = function (mesh) {
      if (true !== mesh.visible) {
        return;
      }

      if (true !== mesh.__webglInit) {
        mesh.__webglInit = true;
        mesh.addEventListener('removed', _this.onObjectRemoved);
      }

      if (mesh.geometry) {
        _this.checkAndUpdateGeometry(mesh.geometry);
      } // 递归处理所有的子项
      // TODO: 这里的子项并不一定是Mesh??


      if (mesh.children && mesh.children.length > 0) {
        mesh.children.forEach(function (item) {
          _this.initMesh(item);
        });
      }
    };

    this.checkAndUpdateGeometry = function (geometry) {
      // 如果Geometry还没有标识为WebGL初始化，则标识并添加销毁事件监听
      if (true !== geometry.__webglInit) {
        geometry.__webglInit = true;
        geometry.addEventListener('removed', _this.onGeometryRemove); // 刚标识为WebGL初始化的Geometry，肯定需要更新几何信息

        geometry.groupsNeedUpdate = true;
      }

      if (true === geometry.groupsNeedUpdate) {
        if (geometry.type === 'BufferGeometry') {
          _this.updateBufferGeometry(geometry);
        } else {
          _this.updateGeometryBuffer(geometry, _this._gl.STATIC_DRAW);
        }

        geometry.groupsNeedUpdate = false;
      }
    };

    this.updateGeometryBuffer = function (geometry, usage) {
      var verticesBufferData = geometry.verticesBufferData;
      var uvtsBufferData = geometry.uvtsBufferData;
      var indicesBufferData = geometry.indicesBufferData;
      var borderVerticesBufferData = geometry.borderVerticesBufferData;
      var gl = _this._gl;

      if (0 < verticesBufferData.length) {
        geometry.glVerticesBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, geometry.glVerticesBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, verticesBufferData, usage);
      }

      if (0 < uvtsBufferData.length) {
        geometry.glUvtsBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, geometry.glUvtsBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, uvtsBufferData, usage);
      }

      if (0 < indicesBufferData.length) {
        geometry.glIndicesBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, geometry.glIndicesBuffer);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indicesBufferData, usage);
      }
      /* eslint-disable */


      if (true === geometry.showBorder && undefined !== borderVerticesBufferData && 0 < borderVerticesBufferData.length) {
        geometry.glBorderVerticesBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, geometry.glBorderVerticesBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, geometry.borderVerticesBufferData, usage);
      }
      /* eslint-enable */

    };

    this.renderScene = function (scene, camera) {
      // 如果场景不可见则直接不做任何处理
      if (true !== scene.visible) {
        return;
      }

      scene.traverse(function (item) {
        if (item instanceof Mesh) {
          _this.renderObject(item, camera);

          if (item.children.length) {
            item.children.forEach(function (mesh) {
              _this.renderObject(mesh, camera);
            });
          }
        }
      });
    };

    this.renderObject = function (object, camera) {
      var material = object.material;
      var geometry = object.geometry;

      if (true !== object.visible || !material || !geometry || true !== material.visible) {
        return;
      } // 设置材质对应的状态


      _this.state.setDepthTest(material.depthTest);

      var updateBuffers = false;

      var program = _this.setProgram(camera, material, object);

      if (geometry.type === 'BufferGeometry') {
        updateBuffers = _this.updateVerticesAttribute2(program, geometry, false);
      } else {
        updateBuffers = _this.updateVerticesAttribute(program, geometry, false);
      }

      _this.renderGeometryWithProgram(program, geometry, material, updateBuffers);
    };

    this.setProgram = function (camera, material, object) {
      var updateUniforms = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var gl = _this._gl;

      _this.textureOperation.resetUsedTextureUnits();

      _this.checkAndUpdateMaterial(object.material);

      var program = material.program;
      var programUniforms = program.getUniforms(); // 如果cache中的programId与当前programid不一致则更新programID

      if (program.id !== _this.currentCacheState.programId) {
        gl.useProgram(program.program);
        _this.currentCacheState.programId = program.id;
      } // 加载Material中uniform，更新值


      if (false !== updateUniforms) {
        loadUniformsGeneric(gl, material.uniformsList, _this.textureOperation);
      }

      _this.updateMVPMatrix(programUniforms, camera, object);

      return program;
    };

    this.checkAndUpdateMaterial = function (material) {
      if (undefined === material) {
        return;
      }

      if (true !== material.__webglInit) {
        material.__webglInit = true;
        material.addEventListener('removed', _this.onMaterialRomove); // 刚标识为WebGL初始化的material，肯定需要更新材质信息

        material.needsUpdate = true;
      }

      if (true === material.needsUpdate) {
        _this.updateMaterial(material);

        material.needsUpdate = false;
      }
    };

    this.updateMaterial = function (material) {
      if (material.program) {
        _this.removeMaterial(material);
      }

      var program = null;
      var programsLen = _this.programs.length;
      var _material$defines = material.defines,
          defines = _material$defines === void 0 ? '' : _material$defines,
          vertexShader = material.vertexShader,
          fragmentShader = material.fragmentShader;
      var code = defines + vertexShader + fragmentShader; // 通过着色器的组合来找program

      for (var i = programsLen - 1; i >= 0; i--) {
        var programIterator = _this.programs[i];

        if (programIterator.code === code) {
          program = programIterator;
          program.usedTimes++;
          break;
        }
      }

      if (null === program) {
        var parameters = {
          uniforms: material.uniforms,
          defines: material.defines || '',
          vertexShader: material.vertexShader,
          fragmentShader: material.fragmentShader
        };
        program = new Program(_this._gl, parameters, {
          precision: _this.parameters.precision
        });

        _this.programs.push(program);
      }

      material.program = program;
      material.uniformsList = [];
      var offset = 0;
      var programUniforms = program.uniforms;
      var materialUniforms = material.uniforms;

      for (var u in materialUniforms) {
        if (Object.prototype.hasOwnProperty.call(materialUniforms, u)) {
          var location = programUniforms[u];

          if (location) {
            material.uniformsList[offset] = [materialUniforms[u], location];
            offset++;
          }
        }
      }
    };

    this.updateMVPMatrix = function (programUniforms, camera, mesh) {
      // mvpMatrix是内置的uniforms，理论上不会出现undefined
      if (undefined !== programUniforms.mvpMatrix) {
        // 模型视图投影矩阵
        var mvpMatrix = clone$3(camera.projectionMatrix);
        multiply$3(mvpMatrix, mvpMatrix, camera.viewMatrix);
        multiply$3(mvpMatrix, mvpMatrix, mesh.worldMatrix);

        _this._gl.uniformMatrix4fv(programUniforms.mvpMatrix, false, mvpMatrix);

        _this._gl.uniformMatrix4fv(programUniforms.modelMatrix, false, mesh.worldMatrix);

        _this._gl.uniformMatrix4fv(programUniforms.viewMatrix, false, camera.viewMatrix);

        _this._gl.uniformMatrix4fv(programUniforms.projectionMatrix, false, camera.projectionMatrix);
      }

      _this.currentCacheState.camera = camera;
    };

    this.renderGeometryWithProgram = function (program, geometry, material) {
      var gl = _this._gl;
      var curRenderTarget = _this.currentCacheState.curRenderTarget; // 禁用辅助线，主要重置上一次渲染时可能对showDebugLine的更新

      if (program.uniforms.showDebugLine) {
        gl.uniform1i(program.uniforms.showDebugLine, 0);
      }

      if (geometry.type === 'BufferGeometry') {
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, geometry.indexesBuffer);
      } else {
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, geometry.glIndicesBuffer);
      } // console.log('[WebGLRenderer] 绑定索引数组');
      // 如果当前为渲染到帧缓冲，需要检查帧缓冲是否完整


      if (null !== curRenderTarget && undefined !== curRenderTarget.glFrameBuffer) {
        // 如果帧缓冲不完整，无法继续渲染到纹理的
        var fbStatus = gl.checkFramebufferStatus(gl.FRAMEBUFFER);

        if (gl.FRAMEBUFFER_COMPLETE !== fbStatus) {
          _this.removeRenderTarget(curRenderTarget);

          _this.currentCacheState.curRenderTarget = null;
          return;
        }
      } // 开始渲染三角形


      if (geometry.indexes && geometry.indexes.count > 0) {
        gl.drawElements(gl.TRIANGLES, geometry.indexes.count, gl.UNSIGNED_SHORT, 0);
      } else {
        // TODO: 增加非顶点索引方式渲染（gl.drawArrays）
        gl.drawArrays(gl.TRIANGLES, 0, geometry.attributes.position.count);
      } // 选择性渲染边框
      /* eslint-enable */

    };

    this.onObjectRemoved = function (event) {
      var object = event.target;
      object.traverse(function (child) {
        child.removeEventListener('removed', _this.onObjectRemoved);

        _this.removeObject(child);
      });
    };

    this.onGeometryRemove = function (event) {
      var geometry = event.target;
      geometry.removeEventListener('removed', _this.onGeometryRemove);

      _this.removeGeometry(geometry);
    };

    this.onMaterialRomove = function (event) {
      var material = event.target;
      material.removeEventListener('removed', _this.onMaterialRomove);

      _this.removeMaterial(material);
    };

    this.onRenderTargetRemove = function (event) {
      var renderTarget = event.target;
      renderTarget.removeEventListener('removed', _this.onRenderTargetRemove);

      _this.removeRenderTarget(renderTarget);
    };

    this.removeObject = function (object) {
      if (object.geometry) {
        delete object.geometry.__webglInit;
      }

      delete object.__webglInit;
    };

    this.removeGeometry = function (geometry) {
      delete geometry.__webglInit;

      _this.deleteBuffers(geometry); // 将当前的缓存的几何数据设置为空


      _this.currentCacheState.geometryProgramId = null;
    };

    this.deleteBuffers = function (geometry) {
      var buffers = ['glVerticesBuffer', 'glUvtsBuffer', 'glIndicesBuffer', 'glBorderVerticesBuffer'];
      buffers.forEach(function (bufferName) {
        _this._gl.deleteBuffer(geometry[bufferName]);

        if (undefined !== geometry[bufferName] && 0 < geometry[bufferName]) {
          delete geometry[bufferName];
        }
      });
    };

    this.removeMaterial = function (material) {
      var program = material.program.program; // program为gl.createProgram的返回，理论上不会为空

      if (!program) {
        return;
      }

      material.program = null;
      var programs = _this.programs;
      var programsLen = programs.length;

      for (var i = programsLen - 1; i >= 0; i--) {
        var programIterator = programs[i];

        if (programIterator.program === program) {
          programIterator.usedTimes--;

          if (0 === programIterator.usedTimes && false !== _this.autoDisposeProgram) {
            programs.splice(i, 1);

            _this._gl.deleteProgram(program);
          }

          break;
        }
      }
    };

    this.removeRenderTarget = function (renderTarget) {
      _this._gl.deleteRenderbuffer(renderTarget.glDepthBuffer);

      renderTarget.glDepthBuffer = null;

      _this._gl.deleteTexture(renderTarget.glTexture);

      renderTarget.glTexture = null;

      _this._gl.deleteFramebuffer(renderTarget.glFrameBuffer);

      renderTarget.glFrameBuffer = null;
    };

    /**
     * Current WebGLContext.
     * @type {WebGLContext}
     * @private
     */
    this.parameters = Object.assign({}, defaultParameters, _parameters);

    if (_parameters && !_parameters.canvas) {
      this.parameters.canvas = document.createElement('canvas');
    }

    this.initGL();
    this.programs = []; // 画布视口信息

    this.viewportInfo = {
      x: 0,
      // 视口起点的x轴坐标值
      y: 0,
      // 视口起点的y轴坐标值
      width: this.parameters.canvas.width,
      // 视口的宽度
      height: this.parameters.canvas.height // 视口的高度

    };

    if (this.parameters.width && this.parameters.height) {
      this.setSize(this.parameters.width, this.parameters.height);
    }
    /**
     * 用于外部获取canvas画布
     */


    this.domElement = this.parameters.canvas; // 创建并初始化当前WebGL的状态

    this.state = new WebGLState(this._gl);
    this.state.setDefaultGLState.apply(this.state, Object.values(this.viewportInfo));
    /**
     * 当前渲染帧用到的状态缓存
     * @private
     */

    this.currentCacheState = {
      programId: null,
      geometryProgramId: null,
      materialId: null,
      camera: null,
      curRenderTarget: null
    };
    this.capability = new WebGLCapability(this._gl);
    var maxTextures = this.capability.maxTextures;
    var maxTextureSize = this.capability.maxTextureSize;
    this.textureOperation = new TextureOperation(this._gl, maxTextures, maxTextureSize); // TODO: 注册纹理操作事件回调
  }
  /**
   *  设置画布的大小
   * @param {number} width  - 视口的宽度
   * @param {number} height - 视口的高度
   * @public
   */


  var _proto = WebGLRenderer.prototype;

  /**
   * 清除缓冲区，当前只用到了颜色缓冲区和深度缓冲区
   */
  _proto.clearBuffer = function clearBuffer() {
    var gl = this._gl;
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
  }
  /**
   * WebGL初始化
   * @private
   */
  ;

  _proto.initGL = function initGL() {
    var _this2 = this;

    var _this$parameters2 = this.parameters,
        canvas = _this$parameters2.canvas,
        context = _this$parameters2.context,
        alpha = _this$parameters2.alpha,
        depth = _this$parameters2.depth,
        stencil = _this$parameters2.stencil,
        antialias = _this$parameters2.antialias,
        premultipliedAlpha = _this$parameters2.premultipliedAlpha,
        preserveDrawingBuffer = _this$parameters2.preserveDrawingBuffer;

    try {
      var attributes = {
        alpha: alpha,
        depth: depth,
        stencil: stencil,
        antialias: antialias,
        premultipliedAlpha: premultipliedAlpha,
        preserveDrawingBuffer: preserveDrawingBuffer
      };

      var _gl = context || canvas.getContext('webgl', attributes) || canvas.getContext('experimental-webgl', attributes) || canvas.getContext('moz-webgl', attributes) || canvas.getContext('webkit-3d', attributes);

      if (!_gl) {
        if (null !== canvas.getContext) {
          // TODO: 发送事件
          throw 'Error creating WebGL context with your provided attributes.';
        } else {
          // TODO: 发送事件
          throw 'Error creating WebGL context.';
        }
      }

      this._gl = _gl;
      canvas.addEventListener('webglcontextlost', function (event) {
        event.preventDefault();

        if (undefined !== _this2.state) {
          _this2.resetGLState();

          _this2.state.setDefaultGLState.apply(_this2.state, Object.values(_this2.viewportInfo));
        }
      }, false);
    } catch (error) {
      console.error('[WebGLRenderer] Create webgl error: ', error);
    }
  }
  /**
   * 重置当前的状态
   * @private
   */
  ;

  _proto.resetGLState = function resetGLState() {
    this.currentCacheState = {
      programId: null,
      geometryProgramId: null,
      materialId: null,
      camera: null,
      curRenderTarget: null
    };
    this.state.reset();
  }
  /**
   * 更新渲染对象，为渲染到帧缓冲做准备
   * @param {WebGLRenderTarget} renderTarget 渲染目标对象
   */
  ;

  _proto.setRenderTarget = function setRenderTarget(renderTarget) {
    var gl = this._gl;

    if (renderTarget === undefined) {
      return;
    } // renderTarget第一次渲染


    if (renderTarget.glFrameBuffer === null) {
      renderTarget.addEventListener('removed', this.onRenderTargetRemove); // 创建帧缓冲区对象

      renderTarget.glFrameBuffer = gl.createFramebuffer(); // 绑定为当前工作的帧缓冲区

      gl.bindFramebuffer(gl.FRAMEBUFFER, renderTarget.glFrameBuffer); // 创建纹理并更新纹理状态

      this.textureOperation.setTextureForRenderTarget(renderTarget); // 创建渲染缓冲

      renderTarget.glDepthBuffer = gl.createRenderbuffer(); // 绑定渲染缓冲区对象

      gl.bindRenderbuffer(gl.RENDERBUFFER, renderTarget.glDepthBuffer); // 设置渲染缓冲区尺寸

      gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, renderTarget.width, renderTarget.height); // 把贴图对象也绑定到帧缓冲中

      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, renderTarget.glTexture, 0); // 将渲染缓冲区关联到帧缓冲区对象上

      gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, renderTarget.glDepthBuffer);
      gl.bindTexture(gl.TEXTURE_2D, null);
      gl.bindRenderbuffer(gl.RENDERBUFFER, null);
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    }
  }
  /**
   * 渲染方法的入口
   * @public
   *
   * @param  {Scene} scene                          要渲染的场景
   * @param  {Camera} camera                        渲染时用到的相机
   * @param  {WebGLRenderTarget} renderTarget       渲染到纹理时的目标对象
   */
  ;

  _proto.render = function render(scene, camera, renderTarget) {
    if (!camera.isCamera) {
      console.error('[WebGLRenderer]  Camera is not leagal.');
      return;
    }

    var gl = this._gl; // 更新场景点中所有对象的模型矩阵，是否需要更新有scene自己控制

    scene.updateWorldMatrix(); // 更新相机的视图矩阵，是否需要更新有camera自己控制

    camera.updateWorldMatrix();
    camera.updateProjectionMatrix();
    this.currentCacheState.camera = null; // 渲染到帧缓冲对象

    if (undefined !== renderTarget) {
      this.setRenderTarget(renderTarget);
      this.currentCacheState.curRenderTarget = renderTarget; // 把帧缓冲设置成当前工作帧缓冲，绘制的东西就是往帧缓冲里面绘制

      gl.bindFramebuffer(gl.FRAMEBUFFER, renderTarget.glFrameBuffer);
      gl.viewport(0, 0, renderTarget.width, renderTarget.height);
    } else {
      var _this$viewportInfo = this.viewportInfo,
          viewportWidth = _this$viewportInfo.width,
          viewportHeight = _this$viewportInfo.height;
      this.currentCacheState.curRenderTarget = null; // 当直接绘制到屏幕上的时候，就要取消当前工作帧缓冲

      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.viewport(0, 0, viewportWidth, viewportHeight);
    }

    this.initScene(scene);
    this.renderScene(scene, camera);
  }
  /**
   * 初始化场景
   * @param {Scene} scene    待初始化的场景
   * @param {Camera} camera  相机
   */
  ;

  /**
   * 更新BufferGeometry 缓冲区
   * @private
   * @param {BufferGeometry} bufferGeometry -
   * @TODO: 可以使用Buffer实例抽象、优化
   * @FIXME: 待优化
   */
  _proto.updateBufferGeometry = function updateBufferGeometry(bufferGeometry) {
    var gl = this._gl;
    var indexes = bufferGeometry.getIndexes();
    var attributes = bufferGeometry.getAttribute();

    for (var attribute in attributes) {
      if (Object.prototype.hasOwnProperty.call(attributes, attribute)) {
        var bufferName = attribute + 'Buffer';
        var _attributes$attribute = attributes[attribute],
            array = _attributes$attribute.array,
            usage = _attributes$attribute.usage;
        bufferGeometry[bufferName] = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, bufferGeometry[bufferName]);
        gl.bufferData(gl.ARRAY_BUFFER, array, usage);
      }
    }

    if (indexes) {
      bufferGeometry.indexesBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, bufferGeometry.indexesBuffer);
      gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indexes.array, indexes.usage);
    } // 边框buffer
    // const showBorder = true === bufferGeometry.showBorder;
    // const borderVerticesBufferData = bufferGeometry.borderVerticesBufferData;
    // const hasBorderVerticesBufferData = borderVerticesBufferData && borderVerticesBufferData.length;
    // if (showBorder && hasBorderVerticesBufferData) {
    //     bufferGeometry.glBorderVerticesBuffer = gl.createBuffer();
    //     gl.bindBuffer(gl.ARRAY_BUFFER, bufferGeometry.glBorderVerticesBuffer);
    //     gl.bufferData(gl.ARRAY_BUFFER, bufferGeometry.borderVerticesBufferData, gl.STATIC_DRAW);
    // }

  }
  /**
   * 为几何对象创建Buffer并写入数据
   * @param  {Geometry} geometry - 几何对象
   * @param  {number} usage - 如何使用缓冲区对象中的数据
   */
  ;

  /**
   * 更新顶点属性
   * @param {Program} program - 渲染程序
   * @param {Geometry} geometry - 几何信息
   * @param {boolean} useLastVerticesBuffer - 复用顶点buffer
   * @return {boolean}
   */
  _proto.updateVerticesAttribute2 = function updateVerticesAttribute2(program, geometry) {
    var useLastVerticesBuffer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var gl = this._gl;
    var updateBuffers = false;
    var geometryProgramId = "".concat(geometry.id, "_").concat(program.id); // 如果是新的几何对象和材质对象的组合，则需要重新开启attribute变量，
    // 并将缓冲区对象的指针分配给attribute变量

    if (geometryProgramId !== this.currentCacheState.geometryProgramId) {
      this.currentCacheState.geometryProgramId = geometryProgramId;
      this.state.initAttributes();
      updateBuffers = true;
      var attributes = geometry.getAttribute();

      for (var attribute in attributes) {
        if (Object.prototype.hasOwnProperty.call(attributes, attribute)) {
          var bufferName = attribute + 'Buffer';
          var _attributes$attribute2 = attributes[attribute],
              itemSize = _attributes$attribute2.itemSize,
              type = _attributes$attribute2.type,
              normalized = _attributes$attribute2.normalized;

          if (0 <= program.attributes[attribute]) {
            if (true !== useLastVerticesBuffer) {
              gl.bindBuffer(gl.ARRAY_BUFFER, geometry[bufferName]);
              /**
               * TODO: stride & offset值需要动态处理，目前都是0
               * @see => https://developer.mozilla.org/zh-CN/docs/Web/API/WebGLRenderingContext/vertexAttribPointer
               */

              gl.vertexAttribPointer(program.attributes[attribute], itemSize, type, normalized, 0, 0);
            }

            this.state.enableAttribute(program.attributes[attribute]);
          }
        }
      }
    }

    this.state.disableUnusedAttributes();
    return updateBuffers;
  }
  /**
   * 更新顶点属性
   * @param {Program} program - 渲染程序
   * @param {Geometry} geometry - 几何信息
   * @param {boolean} useLastVerticesBuffer - 复用顶点buffer
   * @return {boolean}
   */
  ;

  _proto.updateVerticesAttribute = function updateVerticesAttribute(program, geometry) {
    var useLastVerticesBuffer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var gl = this._gl;
    var updateBuffers = false; // FIXME: 没有实现id

    var geometryProgramId = "".concat(geometry.id, "_").concat(program.id); // 如果是新的几何对象和材质对象的组合，则需要重新开启attribute变量，
    // 并将缓冲区对象的指针分配给attribute变量
    // TODO: 这里只针对position和uv做了绑定启用，其他的attributes如何处理？？

    if (geometryProgramId !== this.currentCacheState.geometryProgramId) {
      this.currentCacheState.geometryProgramId = geometryProgramId;
      this.state.initAttributes();
      updateBuffers = true;
      var attributes = program.getAttributes();

      if (0 <= attributes.position) {
        // buffer需要更新，在tile中如果tile无法复用的话，直接更新
        if (true !== useLastVerticesBuffer) {
          gl.bindBuffer(gl.ARRAY_BUFFER, geometry.glVerticesBuffer);
          gl.vertexAttribPointer(attributes.position, 3, gl.FLOAT, false, 0, 0);
        }

        this.state.enableAttribute(attributes.position);
      } // 如果需要进行纹理坐标的绑定


      if (0 <= attributes.uv && undefined !== geometry.glUvtsBuffer) {
        gl.bindBuffer(gl.ARRAY_BUFFER, geometry.glUvtsBuffer);
        gl.vertexAttribPointer(attributes.uv, 2, gl.FLOAT, false, 0, 0);
        this.state.enableAttribute(attributes.uv);
      }
    }

    this.state.disableUnusedAttributes();
    return updateBuffers;
  }
  /**
   * 通过program来在几何上进行纹理材质的渲染
   * @param {Program} program        渲染程序
   * @param {Geometry} geometry      渲染几何
   * @param {Material} material      渲染材质
   * @param {boolean} updateBuffers  是否更新缓存
   */
  ;

  return WebGLRenderer;
}();

var ZERO_AXIS_X = 'x';
var ZERO_AXIS_Y = 'y';
var ZERO_AXIS_Z = 'z';
/**
 * PlaneGeometry
 * @class
 *
 * @constructor
 * @param {number} width          平面的宽
 * @param {number} height         平面的高
 * @param {number} widthSegments  平面的宽分段数量
 * @param {number} heightSegments 平面的高分段数量
 * @param {string} zeroAxis       零轴为哪个轴
 * @param {Object} options        边框选项
 */

var PlaneGeometry =
/*#__PURE__*/
function (_Geometry) {
  inheritsLoose(PlaneGeometry, _Geometry);

  function PlaneGeometry(width, height, widthSegments, heightSegments, _zeroAxis, options) {
    var _this;

    _this = _Geometry.call(this) || this;

    _this.addIntoBuffer = function (buffer, data, offset) {
      buffer[offset] = data[0];
      buffer[offset + 1] = data[1];
      buffer[offset + 2] = data[2];
    };

    _this.get3DVertex = function (vec2, zeroAxis) {
      var result;

      switch (zeroAxis) {
        case 'x':
          result = fromValues$1(0, vec2[0], vec2[1]);
          break;

        case 'y':
          result = fromValues$1(vec2[0], 0, vec2[1]);
          break;

        case 'z':
          result = fromValues$1(vec2[0], vec2[1], 0);
          break;

        default:
          result = fromValues$1(vec2[0], vec2[1], 0);
      }

      return result;
    };

    _this.zeroAxis = undefined !== _zeroAxis ? _zeroAxis : ZERO_AXIS_Z;

    switch (_this.zeroAxis) {
      case ZERO_AXIS_X:
        _this.normal = fromValues$1(-1, 0, 0);
        break;

      case ZERO_AXIS_Y:
        _this.normal = fromValues$1(0, -1, 0);
        break;

      case ZERO_AXIS_Z:
        _this.normal = fromValues$1(0, 0, -1);
        break;

      default:
        _this.normal = fromValues$1(0, -1, 0);
    }

    options = undefined !== options ? options : {};
    _this.showBorder = !(false === options.showBorder);
    _this.borderWidth = undefined !== options.borderWidth ? options.borderWidth : 1;
    _this.borderColor = undefined !== options.borderColor ? options.borderColor : [0, 0, 0, 1];
    var halfWidth = width * 0.5;
    var halfHeight = height * 0.5;
    var segX = widthSegments || 1;
    var segY = heightSegments || 1;
    var segWidth = width / segX;
    var segHeight = height / segY;
    var verticesNum = (segX + 1) * (segY + 1);
    _this.verticesBufferData = new Float32Array(verticesNum * 3);
    _this.uvtsBufferData = new Float32Array(verticesNum * 2);
    _this.indicesBufferData = new (verticesNum > 65535 ? Uint32Array : Uint16Array)(segX * segY * 6);
    var x;
    var y;
    var vertex;

    var _vec;

    var offsetVertex = 0;
    var offsetUV = 0;

    for (var i = 0; i <= segY; i++) {
      y = i * segHeight - halfHeight;

      for (var j = 0; j <= segX; j++) {
        x = j * segWidth - halfWidth;
        _vec = fromValues(x, y);
        vertex = _this.get3DVertex(_vec, _this.zeroAxis);

        _this.vertices.push(vertex);

        _this.addIntoBuffer(_this.verticesBufferData, vertex, offsetVertex);

        _this.uvtsBufferData[offsetUV] = j / segX;
        _this.uvtsBufferData[offsetUV + 1] = 1 - i / segY;
        offsetVertex += 3;
        offsetUV += 2;
      }
    }

    var offsetIndex = 0;
    var a;
    var b;
    var c;
    var d;

    for (var _i = 0; _i < segY; _i++) {
      for (var _j = 0; _j < segX; _j++) {
        a = _j + (segX + 1) * _i;
        b = _j + (segX + 1) * (_i + 1);
        c = _j + 1 + (segX + 1) * (_i + 1);
        d = _j + 1 + (segX + 1) * _i;

        _this.addIntoBuffer(_this.indicesBufferData, [a, b, c], offsetIndex);

        _this.addIntoBuffer(_this.indicesBufferData, [a, c, d], offsetIndex + 3);

        offsetIndex += 6;
      }
    }

    _this.borderIndicesBufferData = new Uint16Array(4);
    _this.borderIndicesBufferData[0] = 0;
    _this.borderIndicesBufferData[1] = segX;
    _this.borderIndicesBufferData[2] = (segX + 1) * segY;
    _this.borderIndicesBufferData[3] = (segX + 1) * (segY + 1) - 1; // 更边框的顶点数组

    var offsetBorderVertex = 0;
    _this.borderVerticesBufferData = new Float32Array((segX + segY) * 6); // 逆时针左边界

    for (var _i2 = 0; _i2 < verticesNum; _i2 += segX + 1) {
      _this.addIntoBuffer(_this.borderVerticesBufferData, _this.vertices[_i2], offsetBorderVertex);

      offsetBorderVertex += 3;
    } // 逆时针下边界


    for (var _i3 = (segX + 1) * segY + 1; _i3 < verticesNum; _i3++) {
      _this.addIntoBuffer(_this.borderVerticesBufferData, _this.vertices[_i3], offsetBorderVertex);

      offsetBorderVertex += 3;
    } // 逆时针右边界


    for (var _i4 = (segX + 1) * segY - 1; _i4 > 0; _i4 -= segX + 1) {
      _this.addIntoBuffer(_this.borderVerticesBufferData, _this.vertices[_i4], offsetBorderVertex);

      offsetBorderVertex += 3;
    } // 逆时针上边界


    for (var _i5 = segX - 1; _i5 > 0; _i5--) {
      _this.addIntoBuffer(_this.borderVerticesBufferData, _this.vertices[_i5], offsetBorderVertex);

      offsetBorderVertex += 3;
    }

    return _this;
  }
  /**
   * 顺序的把数组中的值赋值给ArrayBuffer。
   *
   * @param {ArrayBuffer}  buffer    ArrayBuffer，需要更新值得对象
   * @param {Array}           data      数组或者ArrayBuffer
   * @param {number}       offset    偏移量
   */


  return PlaneGeometry;
}(Geometry);

var AXIS_X = 'x';
var AXIS_Y = 'y';
var AXIS_Z = 'z';

/**
 * PlaneBufferGeometry
 * @class
 *
 * @constructor
 * @param {number} width - 平面的宽
 * @param {number} height - 平面的高
 * @param {number} widthSegments - 平面的宽分段数量
 * @param {number} heightSegments - 平面的高分段数量
 * @param {string} normalAxis - 零轴为哪个轴
 * @param {Object} options - 边框选项
 */
var PlaneBufferGeometry =
/*#__PURE__*/
function (_BufferGeometry) {
  inheritsLoose(PlaneBufferGeometry, _BufferGeometry);

  function PlaneBufferGeometry(width, height, widthSegments, heightSegments) {
    var _this;

    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    _this = _BufferGeometry.call(this) || this;
    var res = PlaneBufferGeometry.buildPlane(width, height, widthSegments, heightSegments, options);
    var uvs = res.uvs,
        indices = res.indices,
        normals = res.normals,
        vertices = res.vertices;
    _this.name = 'PlaneBufferGeometry'; // 显示设置顶点属性

    _this.setAttribute('position', new Float32ArrayAttribute(vertices, 3));

    _this.setAttribute('normals', new Float32ArrayAttribute(normals, 3));

    _this.setAttribute('uv', new Float32ArrayAttribute(uvs, 2));

    _this.setIndexes(indices);

    return _this;
  }
  /**
   * 构建平面
   * @param {number} width - 平面的宽
   * @param {number} height - 平面的高
   * @param {number} widthSegments - 平面的宽分段数量
   * @param {number} heightSegments - 平面的高分段数量
   * @param {IOpts} options - 可选参数
   */


  PlaneBufferGeometry.buildPlane = function buildPlane(width, height, widthSegments, heightSegments) {
    var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
        _ref$normalAxis = _ref.normalAxis,
        normalAxis = _ref$normalAxis === void 0 ? AXIS_Z : _ref$normalAxis,
        _ref$useBack = _ref.useBack,
        useBack = _ref$useBack === void 0 ? false : _ref$useBack,
        _ref$normalDest = _ref.normalDest,
        normalDest = _ref$normalDest === void 0 ? 0 : _ref$normalDest;

    var halfWidth = width * 0.5;
    var halfHeight = height * 0.5;
    var segX = widthSegments || 1;
    var segY = heightSegments || 1;
    var segWidth = width / segX;
    var segHeight = height / segY;
    var normal = PlaneBufferGeometry.getNormal(normalAxis, useBack); // const verticesNum = (segX + 1) * (segY + 1);

    var uvs = []; // 纹理坐标集合

    var indices = []; // 顶点索引集合

    var vertices = []; // 顶点坐标集合

    var normals = []; // 法向量集合

    for (var i = 0; i <= segY; i++) {
      var y = i * segHeight - halfHeight;

      for (var j = 0; j <= segX; j++) {
        var x = j * segWidth - halfWidth;
        var vertex = PlaneBufferGeometry.get3DVertex([x, y], normalAxis, normalDest); // 顶点坐标

        vertices.push.apply(vertices, toConsumableArray(vertex)); // 纹理坐标 Y轴翻转

        uvs.push(j / segX, 1 - i / segY); // 法向量

        normals.push.apply(normals, toConsumableArray(normal));
      }
    }

    for (var _i = 0; _i < segY; _i++) {
      for (var _j = 0; _j < segX; _j++) {
        var a = _j + (segX + 1) * _i;
        var b = _j + (segX + 1) * (_i + 1);
        var c = _j + 1 + (segX + 1) * (_i + 1);
        var d = _j + 1 + (segX + 1) * _i; // 索引坐标

        indices.push(a, b, c);
        indices.push(a, c, d);
      }
    }

    return {
      uvs: uvs,
      indices: indices,
      vertices: vertices,
      normals: normals
    };
  }
  /**
   * 获取面法向量
   * @public
   * @param {boolean} useBack - 是否启动背面，默认正向与轴正向一致
   */
  ;

  PlaneBufferGeometry.getNormal = function getNormal(normalAxis) {
    var useBack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var normal;
    var v = useBack ? -1 : 1;

    switch (normalAxis) {
      case AXIS_X:
        normal = [v, 0, 0];
        break;

      case AXIS_Z:
        normal = [0, 0, v];
        break;

      case AXIS_Y:
      default:
        normal = [0, v, 0];
    }

    return normal;
  }
  /**
   * 通过2D坐标和规定的为0的坐标轴，获取一个3D坐标
   * @param  {Vec2} vec2        2D坐标
   * @param  {string} normalAxis  基于哪个坐标轴
   * @return {Vec3}
   */
  ;

  return PlaneBufferGeometry;
}(BufferGeometry);

PlaneBufferGeometry.get3DVertex = function (_ref2, normalAxis) {
  var _ref3 = slicedToArray(_ref2, 2),
      u = _ref3[0],
      v = _ref3[1];

  var normalDest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var result;

  switch (normalAxis) {
    case 'x':
      result = [normalDest, u, v];
      break;

    case 'y':
      result = [u, normalDest, v];
      break;

    case 'z':
    default:
      result = [u, v, normalDest];
  }

  return result;
};

var BoxGeometry =
/*#__PURE__*/
function (_BufferGeometry) {
  inheritsLoose(BoxGeometry, _BufferGeometry);

  function BoxGeometry(width, height, depth, widthSegments, heightSegments, depthSegments) {
    var _this;

    _this = _BufferGeometry.call(this) || this;
    _this.name = 'BoxGeometry';

    var boxRes = _this.initBox(width, height, depth, widthSegments, heightSegments, depthSegments);

    var uvs = boxRes.uvs,
        normals = boxRes.normals,
        vertices = boxRes.vertices,
        indices = boxRes.indices; // 显示设置顶点属性

    _this.setAttribute('position', new Float32ArrayAttribute(vertices, 3));

    _this.setAttribute('normals', new Float32ArrayAttribute(normals, 3));

    _this.setAttribute('uv', new Float32ArrayAttribute(uvs, 2));

    _this.setIndexes(indices);

    return _this;
  }

  var _proto = BoxGeometry.prototype;

  _proto.initBox = function initBox(width, height, depth, widthSegments, heightSegments, depthSegments) {
    var res = [];
    var buildPlane = PlaneBufferGeometry.buildPlane; // build each side of the box geometry

    var px = buildPlane(depth, height, depthSegments, heightSegments, {
      normalAxis: 'x',
      normalDest: width / 2
    }); // px

    var nx = buildPlane(depth, height, depthSegments, heightSegments, {
      normalAxis: 'x',
      useBack: true,
      normalDest: -width / 2
    }); // nx

    var py = buildPlane(width, depth, widthSegments, depthSegments, {
      normalAxis: 'y',
      normalDest: height / 2
    }); // py

    var ny = buildPlane(width, depth, widthSegments, depthSegments, {
      normalAxis: 'y',
      useBack: true,
      normalDest: -height / 2
    }); // ny

    var pz = buildPlane(width, height, widthSegments, heightSegments, {
      normalAxis: 'z',
      normalDest: depth / 2
    }); // pz

    var nz = buildPlane(width, height, widthSegments, heightSegments, {
      normalAxis: 'z',
      useBack: true,
      normalDest: -depth / 2
    }); // nz

    res.push(px, nx, py, ny, pz, nz);
    var vertexCounter = 0;
    var boxUvs = [];
    var boxVertices = [];
    var boxNormals = [];
    var boxIndices = [];

    var _loop = function _loop(i) {
      var _res$i = res[i],
          uvs = _res$i.uvs,
          vertices = _res$i.vertices,
          normals = _res$i.normals,
          indices = _res$i.indices;
      var base = vertexCounter;
      boxUvs = boxUvs.concat(uvs);
      boxVertices = boxVertices.concat(vertices);
      boxNormals = boxNormals.concat(normals);
      boxIndices = boxIndices.concat(indices.map(function (v) {
        return base + v;
      }));
      vertexCounter += vertices.length / 3;
    };

    for (var i = 0; i < 6; i++) {
      _loop(i);
    }

    return {
      uvs: boxUvs,
      vertices: boxVertices,
      normals: boxNormals,
      indices: boxIndices
    };
  };

  return BoxGeometry;
}(BufferGeometry);

var WebGLRenderTarget =
/*#__PURE__*/
function (_Event) {
  inheritsLoose(WebGLRenderTarget, _Event);

  /**
   * Frame buffer
   */

  /**
   * 渲染缓冲
   */

  /**
   * 纹理是否需要在Y轴上翻转
   */

  /**
   * 将alpha通道预先与其他颜色通道相乘
   * @type {boolean}
   */

  /**
   * WebGL Texture
   */
  function WebGLRenderTarget(width, height) {
    var _this;

    _this = _Event.call(this) || this;
    _this.width = void 0;
    _this.height = void 0;
    _this.glFrameBuffer = null;
    _this.glDepthBuffer = null;
    _this.flipY = false;
    _this.premultiplyAlpha = false;
    _this.glTexture = null;
    _this.width = width;
    _this.height = height;
    return _this;
  }

  return WebGLRenderTarget;
}(EventEmitter);

/**
 * @file 网络请求工具
 * @author quda
 */

/**
 * get请求
 * @param {string} url - 请求路径
 * @return {Promise} -
 */
function request(url) {
  var request = new XMLHttpRequest();
  request.open('GET', url, true);
  request.send(null);
  return new Promise(function (resolve) {
    request.addEventListener('load', function () {
      resolve(request.responseText);
    }, false); // request.addEventListener(
    //     'progress',
    //     function(event) {
    //         //scope.dispatchEvent( { type: 'progress', loaded: event.loaded, total: event.total } );
    //     },
    //     false
    // );
  }, function (reject) {
    request.addEventListener('error', function (e) {
      console.error('request error');
      reject(e);
    }, false);
  });
}

/**
 * @file OBJ文件加载器
 * @author quda
 * @see => http://paulbourke.net/dataformats/obj/
 */
var OBJLoader =
/*#__PURE__*/
function () {
  function OBJLoader() {
    this.faceCount = 0;
    this.verticesCoords = [];
    this.textureCoords = [];
    this.uvs = [];
    this.vertices = [];
    this.normals = [];
    this.indexes = [];
  }

  var _proto = OBJLoader.prototype;

  // 顶点索引

  /**
   * 加载方法
   * @param url - 模型路径
   * @return Promise，返回解析后的模型文件
   */
  _proto.load = function load(url) {
    var _this = this;

    return new Promise(function (resolve) {
      void request(url).then(function (text) {
        _this.parse(text);

        var object = _this.genObject3D();

        resolve(object);
      });
    });
  };

  _proto.genObject3D = function genObject3D() {
    // 显示设置顶点属性
    var geometry = new BufferGeometry();
    geometry.setAttribute('position', new Float32ArrayAttribute(this.vertices, 3));

    if (this.uvs.length) {
      geometry.setAttribute('uv', new Float32ArrayAttribute(this.uvs, 2));
    } // TODO: 考虑无顶点索引的情况


    geometry.setIndexes(this.indexes); // TODO: 后面可以根据模型信息进行一些颜色或纹理的预设

    var material = new BasicMaterial();
    var mesh = new Mesh(geometry, material);
    return mesh;
  }
  /**
   * OBJ文件解析
   * @param {string} data - OBJ文件原始文本内容
   */
  ;

  _proto.parse = function parse(data) {
    var lines = data.split('\n');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var line = _step.value;
        var commentStart = line.indexOf('#');

        if (commentStart !== -1) {
          line = line.substring(0, commentStart);
        }

        line = line.trim();
        var splitedLine = line.split(/\s+/); // 按空白字符分割

        switch (splitedLine[0]) {
          // 顶点
          case 'v':
            this.verticesCoords.push(parseFloat(splitedLine[1]), parseFloat(splitedLine[2]), parseFloat(splitedLine[3])); // TODO: 处理顶点颜色信息
            // see => http://paulbourke.net/dataformats/obj/colour.html

            break;
          // 顶点法向量

          case 'vn':
            this.normals.push(parseFloat(splitedLine[1]), parseFloat(splitedLine[2]), parseFloat(splitedLine[3]));
            break;
          // 顶点纹理坐标

          case 'vt':
            this.textureCoords.push(parseFloat(splitedLine[1]), parseFloat(splitedLine[2]));
            break;
          // TODO: 点信息

          case 'p':
            break;
          // TODO: 线信息

          case 'l':
            break;
          // 面信息

          case 'f':
            splitedLine.shift();
            this.parseFaceLine(splitedLine);
            break;
          // 材质信息

          case 'usemtl':
            break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  /**
   * 格式化面信息
   * @param {Array} vertexData - 按空白字符分割后的行信息 ['v1/vt1/vn1', 'v2/vt2/vn2', 'v3/vt3/vn3']
   */
  ;

  _proto.parseFaceLine = function parseFaceLine(vertexData) {
    var faceVertices = [];
    var len = vertexData.length;

    for (var j = 0; j < len; j++) {
      var vertex = vertexData[j];

      if (vertex.length > 0) {
        var vertexParts = vertex.split('/');
        faceVertices.push(vertexParts); // 二维数组 [['v1','vt1','vn1'], ['v2','vt2','vn2'], ['v3','vt3','vn3']]
      }
    } // 第一个点依次与其余点组成三角形


    var v1 = faceVertices[0];

    for (var _j = 1, jl = faceVertices.length - 1; _j < jl; _j++) {
      var v2 = faceVertices[_j];
      var v3 = faceVertices[_j + 1];
      this.addFace(v1, v2, v3);
    }
  }
  /**
   * 按三角形面更新顶点索引、纹理、法向量
   * @param {Array} v1 - 三角形顶点 [v, vt, vn]
   * @param {Array} v2 - 三角形顶点 [v, vt, vn]
   * @param {Array} v3 - 三角形顶点 [v, vt, vn]
   */
  ;

  _proto.addFace = function addFace(v1, v2, v3) {
    var verticesCoords = this.verticesCoords;
    var vLen = verticesCoords.length / 3; // this.indexes.push(
    //     this.parseVertexIndex(parseFloat(v1[0]), vLen),
    //     this.parseVertexIndex(parseFloat(v2[0]), vLen),
    //     this.parseVertexIndex(parseFloat(v3[0]), vLen)
    // );

    var _v1 = this.parseVertexIndex(v1[0], vLen);

    var _v2 = this.parseVertexIndex(v2[0], vLen);

    var _v3 = this.parseVertexIndex(v3[0], vLen);

    this.vertices.push(verticesCoords[_v1], verticesCoords[_v1 + 1], verticesCoords[_v1 + 2], verticesCoords[_v2], verticesCoords[_v2 + 1], verticesCoords[_v2 + 2], verticesCoords[_v3], verticesCoords[_v3 + 1], verticesCoords[_v3 + 2]);
    var indexesBase = this.faceCount * 3;
    this.indexes.push(indexesBase, indexesBase + 1, indexesBase + 2);
    this.faceCount++;

    if (v1[1] !== '') {
      // 处理顶点纹理坐标
      var textureCoords = this.textureCoords;
      var vtLen = textureCoords.length;
      var vt1 = this.parseUVIndex(v1[1], vtLen);
      var vt2 = this.parseUVIndex(v2[1], vtLen);
      var vt3 = this.parseUVIndex(v3[1], vtLen);
      this.uvs.push(textureCoords[vt1], textureCoords[vt1 + 1], textureCoords[vt2], textureCoords[vt2 + 1], textureCoords[vt3], textureCoords[vt3 + 1]);
    }

    if (v1[2] !== '') ;
  }
  /**
   * 修正顶点索引
   * 如果一个索引是正值则表示相对于顶点序列从1开始的偏移
   * 如果一个索引是负的，表示从顶点序列结尾的偏移
   * @private
   *
   * @param {number} value - 顶点索引
   * @param {number} len - 顶点集合容量
   * @return {number} - 修正的顶点索引
   */
  ;

  _proto.parseVertexIndex = function parseVertexIndex(value, len) {
    var index = parseInt(value, 10); // return index >= 0 ? index - 1 : index + len;

    return (index >= 0 ? index - 1 : index + len / 3) * 3;
  }
  /**
   * 修正纹理索引
   * 如果一个索引是正值则表示相对于顶点序列从1开始的偏移
   * 如果一个索引是负的，表示从顶点序列结尾的偏移
   * @private
   *
   * @param {number} value - 顶点索引
   * @param {number} len - 顶点集合容量
   * @return {number} - 修正的顶点索引
   */
  ;

  _proto.parseUVIndex = function parseUVIndex(value, len) {
    var index = parseInt(value, 10);
    return (index >= 0 ? index - 1 : index + len / 2) * 2;
  };

  return OBJLoader;
}();

/**
 * @file 纹理加载器
 * @author quda
 */
/**
 * 加载图片
 * @param url - 图片url
 * @return {Promise<HTMLImageElement>}
 */

function loadImage(url) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.src = url;
    img.crossOrigin = 'Anonymous';

    img.onload = function () {
      resolve(img);
    };

    img.onerror = function (e) {
      reject(e);
    };
  });
}
/**
 * 加载纹理
 * @param url - 纹理图片url
 * @param onLoad - 加载成功回调
 * @param onError - 加载失败回调
 * @return {Promise<Texture>}
 */

function loadTexture(url, onLoad, onError) {
  return loadImage(url).then(function (img) {
    var texture = new Texture(img);
    onLoad && onLoad(texture);
    return texture;
  })["catch"](function (e) {
    onError && onError(e);
  });
}
/**
 * 立方体纹理加载器
 * @param urls - 立方体六个面纹理url, 顺序为 右、左、上、下、后、前
 */

function loadCubeTexture(urls) {
  var LEN = 6;

  if (urls.length !== LEN) {
    throw new Error('[loadCubeTexture] param urls need len six. [px, nx, py, ny, pz, nz]');
  }

  return new Promise(function (resolve, reject) {
    var loaded = 0;
    var texture = new CubeTexture();
    var images = texture.image;

    var _loop = function _loop(i) {
      // eslint-disable-next-line no-loop-func
      loadImage(urls[i]).then(function (img) {
        loaded++;
        images[i] = img;
        var curLoaded = loaded;

        if (curLoaded === LEN) {
          texture.needsUpdate = true;
          resolve(texture);
        }
      })["catch"](function (e) {
        console.error(e);
        reject(e);
      });
    };

    for (var i = 0; i < LEN; i++) {
      _loop(i);
    }
  });
}

/**
 * 相机的抽象基类
 * 相机的投影矩阵和视图矩阵是延迟更新的，以避免多次更新矩阵的情况发生；
 * 如果需要用相机做相应的变换时，需要先更新投影矩阵和视图矩阵。
 * Camera内含了与投影和视图相关的更新触发机制。
 *
 * @class Camera
 * @extends {Object3D}
 *
 * @constructor
 * @param {number} near - 相对于深度裁剪面的近距离
 * @param {number} far - 相对于深度剪切面的远距离
 */

var Camera =
/*#__PURE__*/
function (_Object3D) {
  inheritsLoose(Camera, _Object3D);

  /**
   * 场景的视图矩阵，即相机本身worldMatrix的逆矩阵
   */

  /**
   * 场景的透视矩阵
   */

  /**
   * 是否需要更新投影矩阵，
   * 默认情况不需要手动设置是否需要更新。
   */

  /**
   * 相对于深度裁剪面的近距离
   */

  /**
   * 相对于深度剪切面的远距离
   */
  function Camera() {
    var _this;

    var near = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.1;
    var far = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
    _this = _Object3D.call(this) || this;
    _this.isCamera = true;
    _this.viewMatrix = create$3();
    _this.projectionMatrix = create$3();
    _this.projectionMatrixNeedUpdate = false;
    _this._far = void 0;
    _this._near = void 0;
    _this._far = far;
    _this._near = near;
    return _this;
  }

  var _proto = Camera.prototype;

  /**
   * 根据父亲的模型矩阵更新当前对象的模型矩阵
   * 需要更新视图矩阵
   * @public
   * @param {boolean} force - 是否强制更新
   */
  _proto.updateWorldMatrix = function updateWorldMatrix() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _Object3D.prototype.updateWorldMatrix.call(this, force); // 获取视图矩阵, 即自身模型矩阵的逆矩阵


    invert$1(this.viewMatrix, this.worldMatrix);
  };

  createClass(Camera, [{
    key: "near",
    get: function get() {
      return this._near;
    },
    set: function set(near) {
      this._near = near;
      this.projectionMatrixNeedUpdate = true;
    }
  }, {
    key: "far",
    get: function get() {
      return this._far;
    },
    set: function set(far) {
      this._far = far;
      this.projectionMatrixNeedUpdate = true;
    }
  }]);

  return Camera;
}(Object3D);

/**
 * 正交投影相机
 * @class OrthographicCamera
 * @extends {Camera}
 * @constructor
 *
 * @param  {number} left - 指明相对于垂直平面的左侧坐标位置
 * @param  {number} right - 指明相对于垂直平面的右侧坐标位置
 * @param  {number} top - 指明相对于垂直平面的上侧坐标位置
 * @param  {number} bottom - 指明相对于垂直平面的下侧坐标位置
 * @param  {number} near - 相对于深度裁剪面的近距离
 * @param  {number} far - 相对于深度剪切面的远距离
 */

var OrthographicCamera =
/*#__PURE__*/
function (_Camera) {
  inheritsLoose(OrthographicCamera, _Camera);

  /**
   * 相对于垂直平面的左侧坐标位置
   */

  /**
   * 相对于垂直平面的右侧坐标位置
   */

  /**
   * 相对于垂直平面的上侧坐标位置
   */

  /**
   * 相对于垂直平面的下侧坐标位置
   */
  function OrthographicCamera(left, right, top, bottom, near, far) {
    var _this;

    _this = _Camera.call(this, near, far) || this;
    _this._left = void 0;
    _this._right = void 0;
    _this._top = void 0;
    _this._bottom = void 0;
    _this._top = top;
    _this._left = left;
    _this._right = right;
    _this._bottom = bottom;

    _this.updateProjectionMatrix(true);

    return _this;
  }

  var _proto = OrthographicCamera.prototype;

  /**
   * 更新正交投影矩阵
   * @public
   * @param {boolean} force - 是否强制更新投影矩阵
   */
  _proto.updateProjectionMatrix = function updateProjectionMatrix() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (true !== force && true !== this.projectionMatrixNeedUpdate) {
      return;
    } // TODO: 这里计算的意义是什么？


    var dx = (this.right - this.left) / 2;
    var dy = (this.top - this.bottom) / 2;
    var cx = (this.right + this.left) / 2;
    var cy = (this.top + this.bottom) / 2;
    var left = cx - dx;
    var right = cx + dx;
    var top = cy + dy;
    var bottom = cy - dy;
    identity$1(this.projectionMatrix);
    ortho(this.projectionMatrix, left, right, top, bottom, this.near, this.far);
    this.projectionMatrixNeedUpdate = false;
  }
  /**
   * 克隆相机对象。
   * @public
   * @param {Camera} oCamera - 克隆的接受对象
   * @return {Camera} - 返回克隆的对象
   */
  ;

  _proto.clone = function clone(oCamera) {
    if (undefined === oCamera) {
      oCamera = new OrthographicCamera(0, 0, 0, 0, 0, 0);
    }

    _Camera.prototype.clone.call(this, oCamera);

    oCamera.left = this.left;
    oCamera.right = this.right;
    oCamera.top = this.top;
    oCamera.bottom = this.bottom;
    oCamera.near = this.near;
    oCamera.far = this.far;
    oCamera.updateProjectionMatrix();
    oCamera.updateWorldMatrix();
    return oCamera;
  };

  createClass(OrthographicCamera, [{
    key: "top",
    get: function get() {
      return this._top;
    },
    set: function set(top) {
      if (top === this._top) {
        return;
      }

      this._top = top;
      this.projectionMatrixNeedUpdate = true;
    }
  }, {
    key: "left",
    get: function get() {
      return this._left;
    },
    set: function set(left) {
      if (left === this._left) {
        return;
      }

      this._left = left;
      this.projectionMatrixNeedUpdate = true;
    }
  }, {
    key: "right",
    get: function get() {
      return this._right;
    },
    set: function set(right) {
      if (right === this._right) {
        return;
      }

      this._right = right;
      this.projectionMatrixNeedUpdate = true;
    }
  }, {
    key: "bottom",
    get: function get() {
      return this._bottom;
    },
    set: function set(bottom) {
      if (bottom === this._bottom) {
        return;
      }

      this._bottom = bottom;
      this.projectionMatrixNeedUpdate = true;
    }
  }]);

  return OrthographicCamera;
}(Camera);

/**
 * 透视投影相机
 * @class PerspectiveCamera
 * @extends {Camera}
 * @constructor
 *
 * @param  {number} fov - 相机的视口角度的角度值
 * @param  {number} aspect - 相机视口的宽高比
 * @param  {number} near - 相对于深度裁剪面的近距离
 * @param  {number} far - 相对于深度剪切面的远距离
 */

var PerspectiveCamera =
/*#__PURE__*/
function (_Camera) {
  inheritsLoose(PerspectiveCamera, _Camera);

  /**
   * 相机的视口角度的角度值
   */

  /**
   * 相机视口的宽高比
   */
  function PerspectiveCamera(fov, aspect, near, far) {
    var _this;

    _this = _Camera.call(this, near, far) || this;
    _this.type = 'PerspectiveCamera';
    _this._fov = void 0;
    _this._aspect = void 0;
    _this._fov = fov;
    _this._aspect = aspect;

    _this.updateProjectionMatrix(true);

    return _this;
  }

  var _proto = PerspectiveCamera.prototype;

  /**
   * 更新透视投影矩阵
   * @public
   * @param {boolean} force - 是否强制更新投影矩阵
   */
  _proto.updateProjectionMatrix = function updateProjectionMatrix() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (true !== force && true !== this.projectionMatrixNeedUpdate) {
      return;
    }

    identity$1(this.projectionMatrix);
    perspective(this.projectionMatrix, this.fov * Math.PI / 180, this.aspect, this.near, this.far);
    this.projectionMatrixNeedUpdate = false;
  }
  /**
   * 克隆相机对象
   * @public
   * @param {Camera} pCamera - 克隆的接受对象
   * @return {Camera} - 返回克隆的对象
   */
  ;

  _proto.clone = function clone(pCamera) {
    if (undefined === pCamera) {
      pCamera = new PerspectiveCamera(0, 0, 0, 0);
    }

    _Camera.prototype.clone.call(this, pCamera);

    pCamera.fov = this.fov;
    pCamera.aspect = this.aspect;
    pCamera.near = this.near;
    pCamera.far = this.far;
    pCamera.updateProjectionMatrix();
    pCamera.updateWorldMatrix();
    return pCamera;
  };

  createClass(PerspectiveCamera, [{
    key: "fov",
    get: function get() {
      return this._fov;
    },
    set: function set(fov) {
      if (fov === this._fov) {
        return;
      }

      this._fov = fov;
      this.projectionMatrixNeedUpdate = true;
    }
  }, {
    key: "aspect",
    get: function get() {
      return this._aspect;
    },
    set: function set(aspect) {
      if (aspect === this._aspect) {
        return;
      }

      this._aspect = aspect;
      this.projectionMatrixNeedUpdate = true;
    }
  }]);

  return PerspectiveCamera;
}(Camera);

/**
 * @file 引擎入口
 * @author quda
 * @module Engines
 */

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Mesh: Mesh,
    Scene: Scene,
    Geometry: Geometry,
    Object3D: Object3D,
    Raycaster: Raycaster,
    Texture: Texture,
    CubeTexture: CubeTexture,
    TextureOperation: TextureOperation,
    Material: Material,
    BasicMaterial: BasicMaterial,
    BufferGeometry: BufferGeometry,
    WebGLRenderer: WebGLRenderer,
    PlaneGeometry: PlaneGeometry,
    BoxGeometry: BoxGeometry,
    WebGLRenderTarget: WebGLRenderTarget,
    PlaneBufferGeometry: PlaneBufferGeometry,
    Box3: Box3,
    OBJLoader: OBJLoader,
    loadImage: loadImage,
    loadTexture: loadTexture,
    loadCubeTexture: loadCubeTexture,
    Vec2: vec2,
    Vec3: vec3,
    Vec4: vec4,
    Mat3: mat3,
    Mat4: mat4,
    Quat: quat,
    quatToEuler: quatToEuler,
    BufferAttribute: BufferAttribute,
    Uint8BufferAttribute: Uint8BufferAttribute,
    Uint16BufferAttribute: Uint16BufferAttribute,
    Uint32BufferAttribute: Uint32BufferAttribute,
    Float32ArrayAttribute: Float32ArrayAttribute,
    UintBufferAttribute: UintBufferAttribute,
    OrthographicCamera: OrthographicCamera,
    PerspectiveCamera: PerspectiveCamera
});

var BaseRender =
/*#__PURE__*/
function () {
  createClass(BaseRender, [{
    key: "camera",

    /**
     * 全景引擎实例
     */

    /**
     * 全景数据
     */

    /**
     * 当前渲染器网格
     */
    // eslint-disable-next-line @typescript-eslint/prefer-readonly

    /**
     * 全景相机实例
     * @private
     * @property {Camera}
     */
    get: function get() {
      return this.pano.camera;
    }
    /**
     * 对外统一暴露，用于获取网格 添加至Scene
     */

  }, {
    key: "meshs",
    get: function get() {
      return this._meshs;
    },
    set: function set(mesh) {
      this._meshs = mesh;
    }
  }]);

  function BaseRender(pano) {
    this.pano = void 0;
    this.panoData = void 0;
    this._meshs = new Mesh();
    this.pano = pano;
  }
  /**
   * 设置全景数据
   * @param {Object} data - 全景数据
   */


  return BaseRender;
}();

var uvVertexShader = ['varying vec3 v_normal;', 'void main(void){', '   gl_Position = mvpMatrix * vec4(position, 1.0);', '   v_normal = normalize(position.xyz);', '}'].join('\n');
var textureFragmentShader = ['uniform samplerCube uSampler;', 'uniform float uOpacity;', 'varying vec3 v_normal;', 'void main(void){', '    vec4 textureColor = textureCube(uSampler, normalize(v_normal));', '    gl_FragColor = vec4(textureColor.rgb, textureColor.a * uOpacity);', '}'].join('\n');

var SkyboxRender =
/*#__PURE__*/
function (_BaseRender) {
  inheritsLoose(SkyboxRender, _BaseRender);

  function SkyboxRender(pano) {
    var _this;

    _this = _BaseRender.call(this, pano) || this;

    _this.initMesh();

    return _this;
  }

  var _proto = SkyboxRender.prototype;

  _proto.initMesh = function initMesh() {
    var boxGeometry = new BoxGeometry(8, 8, 8, 1, 1, 1);
    var material = new Material();
    material.vertexShader = uvVertexShader;
    material.fragmentShader = textureFragmentShader;
    material.uniforms = {
      vColor: {
        type: '4f',
        value: [1, 0, 0, 1]
      },
      uSampler: {
        type: 't',
        value: null
      },
      uOpacity: {
        type: '1f',
        value: 1.0
      }
    };
    var meshs = new Mesh(boxGeometry, material);
    meshs.visible = false;
    meshs.setScale(-1, 1, 1); // 因为从内部看，处理图像左右镜像翻转

    this.meshs = meshs;
  };

  _proto.setData = function setData(data) {
    var _this2 = this;

    if (!data.image || data.image.length !== 6) {
      throw new Error("\u5929\u7A7A\u76D2\u6A21\u578B\u9700\u89816\u5F20\u7EB9\u7406\uFF0C\u4F46\u53EA\u83B7\u53D6\u5230 ".concat(data.image ? data.image.length : 0, "\u5F20"));
    }

    this.panoData = data;
    var meshs = this.meshs;
    loadCubeTexture(data.image).then(function (res) {
      meshs.material.uniforms.uSampler.value = res;
      meshs.visible = true;

      _this2.pano.emit({
        type: EVENT_TYPE.REFRESH,
        log: '[Refresh Log] 立方贴图加载完成， 渲染一帧'
      });
    })["catch"](function (e) {
      return console.error(e);
    });
  };

  _proto.update = function update() {// do nothing
  };

  _proto.draw = function draw() {// do nothing
  };

  return SkyboxRender;
}(BaseRender);

/**
 * @file 变换效果函数库
 * @author quda
 */
var linear = function linear(t) {
  return t;
};
var reverse = function reverse(t) {
  return 1 - t;
};
var easeInQuad = function easeInQuad(t) {
  return t * t;
};
var easeInCubic = function easeInCubic(t) {
  return Math.pow(t, 3);
};
var easeOutQuad = function easeOutQuad(t) {
  return -(t * (t - 2));
};
var easeOutCubic = function easeOutCubic(t) {
  return Math.pow(t - 1, 3) + 1;
};
var easeInOutQuad = function easeInOutQuad(t) {
  if (t < 0.5) {
    return t * t * 2;
  }

  return -2 * (t - 2) * t - 1;
};
var easeInOutCubic = function easeInOutCubic(t) {
  if (t < 0.5) {
    return Math.pow(t, 3) * 4;
  }

  return Math.pow(t - 1, 3) * 4 + 1;
};
var easeInOutSine = function easeInOutSine(t) {
  return (1 - Math.cos(Math.PI * t)) / 2;
}; // alias for easeInQuad

var easeIn = easeInQuad; // alias for easeOutQuad

var easeOut = easeOutQuad;

var Transitions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    linear: linear,
    reverse: reverse,
    easeInQuad: easeInQuad,
    easeInCubic: easeInCubic,
    easeOutQuad: easeOutQuad,
    easeOutCubic: easeOutCubic,
    easeInOutQuad: easeInOutQuad,
    easeInOutCubic: easeInOutCubic,
    easeInOutSine: easeInOutSine,
    easeIn: easeIn,
    easeOut: easeOut
});

/**
 * @file Tween动画
 * @author quda
 */

// empty fn
var noop = function noop() {};
/**
  * Tween动画类
  * @class
  *
  * @param {number} from - 起始值
  * @param {number} to - 最终值
  * @param {number} duration - 持续时间
  * @param {Function} easingFn - 缓动函数
  */


var Tween = /*#__PURE__*/function () {
  /**
   * 动画启动标识
   * @private
   */
  // 自动更新时的raf timer

  /**
   * 动画启动时间
   * @private
   * @type {Date | null}
   */

  /**
   * 动画更新回调函数
   * @private
   * @type {Function}
   */

  /**
   * 动画完成回调函数
   * @private
   * @type {Function}
   */
  function Tween(_from, _to, duration) {
    var _this = this;

    var _easingFn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : linear;

    this.from = void 0;
    this.to = void 0;
    this.duration = void 0;
    this.easingFn = void 0;
    this._isPlaying = false;
    this._autoTimer = null;
    this._startTime = null;
    this._onUpdateCallback = noop;
    this._onEndCallback = noop;

    this.start = function () {
      if (_this._isPlaying) {
        return _this;
      }

      _this._isPlaying = true;
      _this._startTime = _this.getNow();
      return _this;
    };

    this.stop = function () {
      _this._isPlaying = false;
      return _this;
    };

    this.startAndAutoUpdate = function () {
      if (_this._isPlaying) {
        return _this;
      }

      _this.start();

      _this._autoTimer = null;

      var step = function step() {
        _this.update();

        _this._autoTimer = requestAnimationFrame(step);
      };

      step();
      return _this;
    };

    this.onEnd = function (callback) {
      if (typeof callback === 'function') {
        _this._onEndCallback = callback;
      } else {
        console.warn('[Warning] onUpdate required a funtion');
      }

      return _this;
    };

    this.onUpdate = function (callback) {
      if (typeof callback === 'function') {
        _this._onUpdateCallback = callback;
      } else {
        console.warn('[Warning] onUpdate required a funtion');
      }

      return _this;
    };

    this.update = function () {
      if (!_this._isPlaying) {
        return false;
      }

      var from = _this.from,
          to = _this.to;

      var now = _this.getNow();

      var easingFn = _this.easingFn;
      var startTime = _this._startTime;

      if (startTime > now) {
        return false;
      }

      var elapsed = (now - startTime) / _this.duration;
      elapsed = _this.duration === 0 || elapsed > 1 ? 1 : elapsed;
      var schedule = easingFn(elapsed);
      var curValue = from + (to - from) * schedule;

      _this._onUpdateCallback(curValue);

      if (elapsed === 1) {
        // 动画结束
        _this.handleEnd();
      }

      return true;
    };

    this.from = _from;
    this.to = _to;
    this.duration = duration;
    this.easingFn = _easingFn;
  }
  /**
   * 启动动画
   * @public
   * @return {Tween} - 链式调用
   */


  var _proto = Tween.prototype;

  /**
   * 获取当前时间（毫秒）
   * @private
   * @return {number} - 当前时间（毫秒）
   */
  _proto.getNow = function getNow() {
    return Date.now();
  }
  /**
   * 设置动画更新回调
   * @public
   *
   * @return {boolean} - 是否更新成功
   */
  ;

  /**
   * 动画结束时的内部处理
   * @private
   */
  _proto.handleEnd = function handleEnd() {
    this._isPlaying = false;
    this._autoTimer = null;

    this._onEndCallback();
  };

  return Tween;
}();

/**
 * 屏幕坐标转为投影之后的归一化坐标(x:[-1, 1], y:[-1, 1])；
 * @public
 *
 * @param {Vec2} vec2D 屏幕坐标
 * @param {number} viewWidth 视口宽度
 * @param {number} viewHeight 视口高度
 * @return {Vec2} 归一化坐标
 */

var viewportToNormalizeProjection = function viewportToNormalizeProjection(vec2D, viewWidth, viewHeight) {
  // 屏幕坐标转投影之后的归一化坐标；
  var halfWidth = viewWidth * 0.5;
  var halfHeight = viewHeight * 0.5;
  var x = (vec2D[0] - halfWidth) / halfWidth;
  var y = (halfHeight - vec2D[1]) / halfHeight;
  return fromValues(x, y);
};
/**
 * 投影之后的归一化转为坐标屏幕坐标
 * @public
 *
 * @param {Vec2} vec2D 屏幕坐标
 * @param {number} viewWidth 视口宽度
 * @param {number} viewHeight 视口高度
 * @return {Vec2} 归一化坐标
 */

var normalizeProjectionToViewport = function normalizeProjectionToViewport(vec2D, viewWidth, viewHeight) {
  // 屏幕坐标转投影之后的归一化坐标；
  var halfWidth = viewWidth * 0.5;
  var halfHeight = viewHeight * 0.5;
  var x = (vec2D[0] + 1) * halfWidth;
  var y = (-vec2D[1] + 1) * halfHeight;
  return fromValues(x, y);
};
/**
 * 屏幕坐标转世界坐标
 * @public
 *
 * @param {Vec2} vec2D - 屏幕坐标
 * @param {Camera} camera - 相机实例
 * @param {number} viewWidth - 视口宽度
 * @param {number} viewHeight - 视口高度
 * @param {number} distance - 视口的坐标转换为世界坐标，只能是表示一个方向，需要一个长度来取得一个点
 *
 * @return {Vec4} - 世界坐标（齐次）
 */

var viewportToWorld = function viewportToWorld(vec2D, camera, viewWidth, viewHeight) {
  var distance = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 100;
  var worldCoord = create$4();
  var ndc = viewportToNormalizeProjection(vec2D, viewWidth, viewHeight);
  var vCoord = fromValues$4(ndc[0], ndc[1], distance, 1); // 给定一个Z轴距离，创建一个虚拟3D坐标

  var pMatrixInvert = create$3();
  var viewMatrixInvert = camera.worldMatrix;
  invert$1(pMatrixInvert, camera.projectionMatrix); // Mat4.multiply(worldCoord, pMatrixInvert, vCoord);
  // Mat4.multiply(worldCoord, viewMatrixInvert, worldCoord);

  transformMat4$2(worldCoord, vCoord, pMatrixInvert);
  transformMat4$2(worldCoord, worldCoord, viewMatrixInvert);
  return worldCoord;
};
/**
 * 世界坐标转屏幕坐标
 * @param {Camera} camera - 物体应用的相机
 * @param {Vec3} vec3D - 点坐标
 * @param {number} viewWidth - 视口宽度
 * @param {number} viewHeight - 视口高度
 * @param {boolean} needBackPoint 是否需要背向的投影坐标，默认为false；
 * @return {Vec2}  屏幕坐标
 */

var worldToViewport = function worldToViewport(camera, vec3D, viewWidth, viewHeight) {
  var needBackPoint = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var transVec4 = fromValues$4(vec3D[0], vec3D[1], vec3D[2], 1);
  transformMat4$2(transVec4, transVec4, camera.viewMatrix); // 背后的点

  if (0 < transVec4[2] && true !== needBackPoint) {
    return null;
  }

  transformMat4$2(transVec4, transVec4, camera.projectionMatrix); // FIXME: 会存在transVec4[3]为0 的badcase

  transVec4[0] = transVec4[0] / transVec4[3];
  transVec4[1] = transVec4[1] / transVec4[3];
  transVec4[2] = transVec4[2] / transVec4[3];
  transVec4[3] = 1;
  var npVec2 = fromValues(transVec4[0], transVec4[1]);
  return normalizeProjectionToViewport(npVec2, viewWidth, viewHeight);
};
/**
 * 判断3D坐标是否在当前视野内可见
 * @param {Array} coord - 3D坐标 [x, y, z]
 * @param {Camera} camera - 相机实例
 * @param {number} viewWidth - 视口宽度
 * @param {number} viewHeight - 视口高度
 * @return {boolean} - true表示可见，false表示不可见
 */

var isCoordsInView = function isCoordsInView(coord, camera, viewWidth, viewHeight) {
  var _ref = worldToViewport(camera, coord, viewWidth, viewHeight) || [-1, -1],
      _ref2 = slicedToArray(_ref, 2),
      x = _ref2[0],
      y = _ref2[1];

  var isInView = false;

  if (x >= 0 && x <= viewWidth && y >= 0 && y <= viewHeight) {
    isInView = true;
  }

  return isInView;
};

var Convert = /*#__PURE__*/Object.freeze({
    __proto__: null,
    viewportToNormalizeProjection: viewportToNormalizeProjection,
    normalizeProjectionToViewport: normalizeProjectionToViewport,
    viewportToWorld: viewportToWorld,
    worldToViewport: worldToViewport,
    isCoordsInView: isCoordsInView
});

var GLSphere =
/*#__PURE__*/
function () {
  /**
   * 默认全景图片列数，按照5级图建立模型
   */
  // 16

  /**
   * 球面分隔的段数
   */
  function GLSphere() {
    var _this = this;

    var _radius2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;

    this.getVertexs = function () {
      return _this.vertexs;
    };

    this.getFacesVertex = function () {
      return _this.facesVertex;
    };

    this.generateTextureCoord = function (row, col, imageZoom) {
      // 选择中间一个面作为中间层纹理坐标的范本
      var vertex = _this.facesVertex[Math.round(_this.facesVertex.length / 2)];

      if (!vertex) {
        return;
      }

      var result = []; // 计算该面在当前图片内部的行列号和索引，以便决定纹理坐标

      var factor = Math.pow(2, 5 - imageZoom);
      var innerCol = col % factor;
      var innerRow = row % factor;
      var faceSegs = GLSphere.H_SEGS / _this.cols; // 每个图块需要划分的小面数

      var step = 1 / faceSegs;
      var vStep = 1 / ((GLSphere.V_SEGS - 1) / _this.rows);

      for (var i = 0; i < vertex.length / 3; i++) {
        var xValue = i % (faceSegs + 1) * step;
        var yValue = Math.floor(i / (faceSegs + 1)) * vStep;
        xValue = xValue / factor + innerCol * 1 / factor;
        yValue = yValue / factor + innerRow * 1 / factor;

        if (imageZoom === 1) {
          yValue *= 2;
        }

        result.push(xValue, yValue);
      }

      return result;
    };

    this.getFaceIndex = function (coords) {
      var row = 0;

      var _coords = slicedToArray(coords, 3),
          x = _coords[0],
          y = _coords[1],
          z = _coords[2];

      var delta = Math.round(Math.atan(Math.abs(z) / Math.abs(x)) * 180 / Math.PI);

      if (x > 0) {
        if (z < 0) {
          delta = 360 - delta;
        }
      } else {
        if (z > 0) {
          delta = 180 - delta;
        } else {
          delta = 180 + delta;
        }
      }

      delta = delta % 360; // [0, 360)

      if (y > _this._x3) {
        row = 7;
      } else if (y > _this._x2) {
        row = 6;
      } else if (y > _this._x1) {
        row = 5;
      } else if (y > 0) {
        row = 4;
      } else if (y > -_this._x1) {
        row = 3;
      } else if (y > -_this._x2) {
        row = 2;
      } else if (y > -_this._x3) {
        row = 1;
      } else {
        row = 0;
      }

      var col = Math.floor(delta / 22.5);
      var horizonSegs = GLSphere.H_SEGS;
      var lengthEach = horizonSegs / _this.cols;
      var segmentsCount = horizonSegs / lengthEach;
      return [col, row, col + row * segmentsCount];
    };

    this.viewportToSphereCoord = function (vec2D, viewWidth, viewHeight, camera) {
      var radius = _this.radius;

      var _viewportToWorld = viewportToWorld(vec2D, camera, viewWidth, viewHeight),
          _viewportToWorld2 = slicedToArray(_viewportToWorld, 3),
          x = _viewportToWorld2[0],
          y = _viewportToWorld2[1],
          z = _viewportToWorld2[2];

      var vRadius = Math.sqrt(x * x + y * y + z * z); // 虚拟半径

      var ratio = radius / vRadius;
      var sphereCoord = [x * ratio, y * ratio, z * ratio];
      return sphereCoord;
    };

    this.getFaceVertex = function (row, col) {
      var lengthEach = GLSphere.H_SEGS / _this.cols;
      var segmentsCount = GLSphere.H_SEGS / lengthEach;
      var index = col + row * segmentsCount;
      return _this.facesVertex[index];
    };

    /**
     * 球模型半径
     * @property
     * @type {number}
     */
    this.radius = _radius2;
    /**
     * 球模型行数
     * @property
     * @type {number}
     */

    this.rows = GLSphere.DEFAULT_COLS / 2;
    /**
     * 球模型列数
     * @property
     * @type {number}
     */

    this.cols = GLSphere.DEFAULT_COLS;
    /**
     * 球面上的点集合
     * @private
     */

    this.vertexs = null;
    /**
     * 面顶点信息
     * 二维数组，每个item包含当前面的顶点集合
     * @private
     */

    this.facesVertex = [];
    /**
     * 面索引坐标
     * 每个小面的三角形分解
     * @private
     */

    this.facesVertexIndice = [];
    this.init();
  }
  /**
   * 球模型初始化
   * @private
   */


  var _proto = GLSphere.prototype;

  _proto.init = function init() {
    var vertexInfo = this.getSphereVertexInfo();
    this.facesVertexIndice = this.getSphereFacesIndices();
    this.vertexs = vertexInfo.vertexs;
    this.facesVertex = vertexInfo.facesVertex;
    this.calcConst();
  }
  /**
   * 对外暴露获取接口
   * @public
   * @return {Array} - 顶点信息
   */
  ;

  /**
   * 计算常用量
   * @private
   */
  _proto.calcConst = function calcConst() {
    var angleUnit = 360 / this.cols;
    this._x1 = Math.cos(degToRad(angleUnit * 3)) * this.radius;
    this._x2 = Math.cos(degToRad(angleUnit * 2)) * this.radius;
    this._x3 = Math.cos(degToRad(angleUnit * 1)) * this.radius;
  }
  /**
   * 生成球面上的顶点，同时将球面划分成若干小面（小面划分与街景图块有关），并生成对应点数组
   * @private
   *
   * @return {Object} vertexInfo - 点坐标数组
   * @return {Array} vertexInfo.vertexs - 球面坐标
   * @return {Array} vertexInfo.facesVertex - 面顶点
   */
  ;

  _proto.getSphereVertexInfo = function getSphereVertexInfo() {
    var vertexs = [];
    var facesVertex = [];
    var radius = this.radius;
    var horizonSegs = GLSphere.H_SEGS;
    var verticalSegs = GLSphere.V_SEGS;
    var horizonStep = 360 / horizonSegs; // 5.625

    var verticalStep = 180 / (verticalSegs - 1); // 5.625

    var lengthEach = horizonSegs / this.cols; // 4

    var segmentsCount = horizonSegs / lengthEach; // 16

    var index;
    var row = 0;
    var col = 0;
    var firstTriVertex = [];

    for (var i = 0; i < verticalSegs; i++) {
      // y轴由负到正进行遍历，即从下顶点到上顶点
      var y = Math.sin(degToRad(i * verticalStep - 90)) * radius;

      var _radius = Math.cos(degToRad(i * verticalStep - 90)) * radius;

      y = Math.round(y * 100) / 100;
      _radius = Math.round(_radius * 100) / 100;
      row = Math.floor(i / lengthEach); // console.log('========================');
      // console.log('loop i: ', i, 'row: ', row);

      for (var j = 0; j < horizonSegs; j++) {
        var x = Math.cos(degToRad(j * horizonStep)) * _radius;

        var z = Math.sin(degToRad(j * horizonStep)) * _radius;

        x = Math.round(x * 100) / 100;
        z = Math.round(z * 100) / 100;
        vertexs.push(x, y, z);
        col = Math.floor(j / lengthEach); // 0 ~ 15

        index = col + row * segmentsCount;

        if (row < this.rows) {
          if (!facesVertex[index]) {
            facesVertex[index] = [];
          }

          facesVertex[index].push(x, y, z);
        } // 补充共用的临界点
        // 竖直方向补充每个小面最上面一层的点


        if (row > 0 && i % lengthEach === 0) {
          var adjIndex = col + (row - 1) * segmentsCount; // 需要补充点的面所在的index
          // 补充的点实际上就是当前一层的点

          facesVertex[adjIndex].push(x, y, z);

          if (j > 0 && j % lengthEach === 0) {
            // 给左边相邻的面补充最后一个点
            if (facesVertex[adjIndex - 1]) {
              facesVertex[adjIndex - 1].push(x, y, z);
            }
          }

          if (j === horizonSegs - 1) {
            // 最后一个面右侧补充第一个点
            // console.log('--补充最有右侧的一个点')
            facesVertex[adjIndex].push(firstTriVertex[0], firstTriVertex[1], firstTriVertex[2]);
          }
        } // 水平方向处理


        if (col === 0 && j === 0) {
          /* j % this._cols == 0 */
          // 先将第一个面左边的点保存起来
          firstTriVertex = [x, y, z];
        }

        if (j > 0 && j % lengthEach === 0) {
          // 给左边相邻的面补充右侧最后一个点
          // console.log('补充左边面最右侧的点');
          // console.log('补充左边面最右侧的点index', index, 'j', j);
          if (facesVertex[index - 1]) {
            facesVertex[index - 1].push(x, y, z);
          }
        }

        if (row < this.rows) {
          if (j === horizonSegs - 1
          /* && segmentsCount > 1 */
          ) {
              // 最后一个面右侧补充第一个点
              // console.log('index 2', index, 'j', j);
              // console.log(firstTriVertex);
              facesVertex[index].push(firstTriVertex[0], firstTriVertex[1], firstTriVertex[2]);
            }
        }
      }
    }

    return {
      vertexs: vertexs,
      facesVertex: facesVertex
    };
  }
  /**
   * 对单个小面进行三角形分解
   * @private
   * @return {Array} - 每个面的索引信息
   */
  ;

  _proto.getSphereFacesIndices = function getSphereFacesIndices() {
    var facesVertexIndice = [];
    var horizonSegs = GLSphere.H_SEGS;
    var lengthEach = horizonSegs / this.cols;
    var vertexLengthEach = lengthEach + 1;

    for (var i = 0; i < lengthEach; i++) {
      // bottom-to-up
      for (var j = 0; j < lengthEach; j++) {
        var levelBase = i * vertexLengthEach; // 下半个三角形

        var sec = levelBase + j + 1;
        var third = levelBase + j + 1 + vertexLengthEach;
        facesVertexIndice.push(levelBase + j, sec, third); // 上半个三角形

        sec = levelBase + j + 1 + vertexLengthEach;
        facesVertexIndice.push(levelBase + j, sec, levelBase + vertexLengthEach + j);
      }
    } // console.log('每个面的索引数量：', facesVertexIndice.length, facesVertexIndice);


    return facesVertexIndice;
  }
  /**
   * 计算指定层级下的单张纹理所覆盖的球面小面索引信息
   * @public
   * @param {number} imageZoom - 瓦片层级
   * @return {Array} - 索引信息
   */
  ;

  _proto.getSphereFacesIndicesByimageZoom = function getSphereFacesIndicesByimageZoom(imageZoom) {
    var _this2 = this;

    var facesVertexIndice = [];
    var horizonSegs = GLSphere.H_SEGS;
    var factor = Math.pow(2, 5 - imageZoom);
    var lengthEach = horizonSegs / this.cols;
    var vertexLengthEach = lengthEach + 1;
    var totalEach = vertexLengthEach * vertexLengthEach;

    var _loop = function _loop(i) {
      var _loop2 = function _loop2(j) {
        _this2.facesVertexIndice.forEach(function (item) {
          facesVertexIndice.push(item + totalEach * j + totalEach * i * 2);
        });
      };

      // bottom-to-up
      for (var j = 0; j < factor; j++) {
        _loop2(j);
      }
    };

    for (var i = 0; i < factor; i++) {
      _loop(i);
    } // console.log('每个面的索引数量1：', facesVertexIndice.length, facesVertexIndice);


    return facesVertexIndice;
  }
  /**
   * 每个图块生成纹理贴图坐标
   * @public
   *
   * @param {number} row - 当前小面在整个球模型中的行号
   * @param {number} col - 当前小面在整个球模型中的列号
   * @param {number} imageZoom - 图片级别
   *
   * @return {Array} 当前图块纹理坐标
   */
  ;

  return GLSphere;
}();

GLSphere.DEFAULT_COLS = Math.pow(2, 5 - 1);
GLSphere.H_SEGS = 64;
GLSphere.V_SEGS = 33;

/**
 * @file 图像资源管理，避免频繁创建图像
 * @author mawenjie01
 */
var ImagePool =
/*#__PURE__*/
function () {
  function ImagePool() {
    this._counter = 0;
    this._imageCollection = {};
  }

  var _proto = ImagePool.prototype;

  /**
   * 获取图片
   * @public
   *
   * @return {Image} image对象
   */
  _proto.getImageInstance = function getImageInstance() {
    var img = null;

    for (var _key in this._imageCollection) {
      if (this._imageCollection[_key] && this._imageCollection[_key]._free === true) {
        this._imageCollection[_key]._free = false;
        return this._imageCollection[_key];
      }
    }

    img = new Image();
    var key = this.getGUID();
    this._imageCollection[key] = img;
    return img;
  }
  /**
   * 删除图片方法
   * @public
   *
   * @param {Image} img 需要删除的图片
   */
  ;

  _proto.freeImage = function freeImage(img) {
    if (!img) {
      return;
    }

    img._free = true;
    img.src = '';
    img.onload = img.onerror = null; // TODO: 后续考虑增加重试策略
    // if (img._reloadTimer) {
    //     clearTimeout(img._reloadTimer);
    // }
  }
  /**
   * 获取图片的GUID
   * @private
   *
   * @return {string} 返回的图片GUID串
   */
  ;

  _proto.getGUID = function getGUID() {
    this._counter++;
    return "img_".concat(this._counter);
  };

  return ImagePool;
}();

/**
 * @file 纹理资源管理器
 * @author quda
 */

/**
 * 一次加载的最大重试次数
 * @type {int}
 */
var MAX_LOAD_COUNT = 2;
/**
 * @class TextureManager
 * @constructor
 * @param {Pano} pano - 全景引擎实例
 * @param {string | Array<string>} cdnList - 全景瓦片cdn list
 * @param {string} udtVersion - 全景数据版本号，暂时无用
 */

var TextureManager =
/*#__PURE__*/
function () {
  /**
   * 瓦片的最大缓存个数
   * 默认值 160 = 8 * 4 + 16 * 8
   * @type {int}
   */

  /**
   * Image实例池，避免过多的创建Image
   * @property
   */

  /**
   * 瓦片资源管理
   * @property
   */

  /**
   * 纹理资源管理
   * @property
   */

  /**
   * 全景数据版本号
   * @property
   * @description 后端目前未对该字段进行解析 2020.07.17
   */

  /**
   * 全景瓦片cdn list
   * @property
   */
  function TextureManager(pano, cdnList) {
    var _this = this;

    var udtVersion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    this.imageInstancePool = void 0;
    this.tileImagesCache = void 0;
    this.textureInfo = void 0;
    this.pano = void 0;
    this.udtVersion = void 0;
    this.cdnList = void 0;

    this.calcTileKey = function (id, x, y, zoom) {
      return "".concat(id, "_").concat(x, "_").concat(y, "_").concat(zoom);
    };

    this.loadImage = function (panoId, tileX, tileY, zoom) {
      var tileKey = _this.calcTileKey(panoId, tileX, tileY, zoom);

      var imgUrl = _this.getTilesUrl(panoId, {
        x: tileX,
        y: tileY
      }, zoom);

      var img = _this.tileImagesCache.getData(tileKey);

      return new Promise(function (resole, reject) {
        if (img) {
          // 非 _loaded 表示命中缓存， 但是图片未加载
          resole(img._loaded ? img : null);
        } else {
          // console.log('未命中缓存 ！！！', tileKey, this.tileImagesCache);
          img = _this.imageInstancePool.getImageInstance();
          img.crossOrigin = 'anonymous';
          img._loaded = false;

          img.onload = function () {
            img._loaded = true;
            resole(img);
          }; // TODO: retry?


          img.onerror = function (e) {
            console.error("Tile ".concat(tileKey, " load error => "), e);
            reject(e);
          };

          img.src = imgUrl;

          _this.tileImagesCache.setData(tileKey, img);
        }
      });
    };

    this.loadTexture = function (panoId, tileX, tileY, zoom) {
      var tileKey = _this.calcTileKey(panoId, tileX, tileY, zoom);

      var curTextureInfo = _this.textureInfo.getData(tileKey);

      return new Promise(function (resole, reject) {
        if (curTextureInfo && curTextureInfo.loaded) {
          resole(curTextureInfo);
        } else {
          _this.loadImage(panoId, tileX, tileY, zoom).then(function (img) {
            if (!img) {
              // img is loading
              return null;
            }

            var texture = new Texture(img); // texture.done = true;
            // texture.key = tileKey;
            // 一级图作为兜底展示，如果参与缓存会有被清掉的风险，展示会有异常

            if (zoom !== 1) {
              _this.textureInfo.setData(tileKey, texture);
            }

            resole(texture);
          })["catch"](function (e) {
            console.error("[TextureManager] loadTexture fail => ".concat(e));
            reject(null);
          });
        }
      });
    };

    this.loadTopoTexture = function (url) {
      var loadTopoImageCount = 0;
      var image = new Image();
      return new Promise(function (resole) {
        image.onload = function () {
          var texture = new Texture(image);
          texture.flipY = false;
          resole(texture);
        }; // 请求出错处理


        image.onerror = function () {
          if (MAX_LOAD_COUNT > loadTopoImageCount) {
            loadTopoImageCount++;
            image.src = "".concat(url, "&random=").concat(new Date().getTime());
          } else {
            resole(null);
          }
        };

        image.crossOrigin = 'anonymous';
        image.src = url;
      });
    };

    this.clear = function () {
      _this.textureInfo.clear();
    };

    this.pano = pano;
    this.udtVersion = udtVersion;
    this.cdnList = cdnList || pano.opts.tileBaseUrls;
    this.imageInstancePool = new ImagePool();
    this.tileImagesCache = new CachePool(TextureManager.MAX_TILE_CACHED, {
      clearCallback: function clearCallback(img) {
        _this.imageInstancePool.freeImage(img);
      }
    });
    this.textureInfo = new CachePool(TextureManager.MAX_TILE_CACHED, {
      clearCallback: function clearCallback(curTexture) {
        curTexture.destory();
      }
    });
  }
  /**
   * 计算图块id编号
   * @public
   *
   * @param {string} id - 全景id
   * @param {number} x - 图块行号
   * @param {number} y - 图块列号
   * @param {number} zoom - 图块级别
   * @return {string} 图块编号id
   */


  var _proto = TextureManager.prototype;

  /**
   * 从CDN列表中获取一个随机的作为请求地址
   * @private
   *
   * @param {Array} cdnList - cdnlist
   * @return {string} - 地址
   */
  _proto.getRandomCDN = function getRandomCDN() {
    var cdnList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var cdnLen = cdnList.length;
    return cdnList[Math.floor(Math.random() * cdnLen)];
  }
  /**
   * 生成瓦片url
   * @param {string} id - 全景id
   * @param {Object} tileCoord - 瓦片坐标 {x, y}
   * @param {number} zoom - 瓦片级别
   * @return {string} 瓦片url
   */
  ;

  _proto.getTilesUrl = function getTilesUrl(id, tileCoord, zoom) {
    var basePath = this.getRandomCDN(this.cdnList);
    var mainPath = TextureManager.TILE_URL_TEMPLATE.replace('{udt}', this.udtVersion).replace('{sid}', id).replace('{x}', "".concat(tileCoord.x)).replace('{y}', "".concat(tileCoord.y)).replace('{zoom}', "".concat(zoom));
    return basePath + mainPath;
  }
  /**
   * 加载图片
   * 发起图片请求，并缓存结果。如果已在缓存内，则从缓存中获取。
   * @private
   *
   * @param {string} panoId - 全景ID
   * @param {number} tileX - 瓦片行号
   * @param {number} tileY - 瓦片列号
   * @param {number} zoom - 瓦片级别
   * @return {Promise} - 图片加载的回调
   */
  ;

  return TextureManager;
}();

TextureManager.MAX_TILE_CACHED = 160;
TextureManager.TILE_URL_TEMPLATE = '?qt=pdata&sid={sid}&pos={y}_{x}&z={zoom}&udt={udt}&from=H5';

/**
 * @file 着色器集合
 * @author quda
 */
/**
 * 球模型顶点着色器
 */

var VS_SHADER_TEXT_NEW = [// 'attribute vec3 position;',
'attribute vec2 uvBack;', // 'attribute vec2 uv;',
'varying mediump vec2 vTextureCoordBack;', 'varying mediump vec2 vTextureCoord;', 'void main(void) {', '    gl_Position = mvpMatrix * vec4(position, 1.0);', '    vTextureCoordBack = uvBack;', '    vTextureCoord = uv;', '}'].join('\n');
/**
 * 球模型片元着色器
 */

var FS_SHADER_TEXT = ['precision mediump float;', 'varying vec2 vTextureCoordBack;', 'varying vec2 vTextureCoord;', 'uniform sampler2D uSamplerBack;', 'uniform sampler2D uSampler;', 'uniform bool uDrawThumb;', 'uniform bool uDrawBack;', 'uniform float uAlpha;', 'void main(void) {', '    if (uDrawThumb) {', '        gl_FragColor = texture2D(uSamplerBack, vTextureCoordBack);', '        return;', '    }', '    if (uAlpha == 1.0) {', '        gl_FragColor = texture2D(uSampler, vTextureCoord);', '        return;', '    }', '    if (uDrawBack) {', // eslint-disable-next-line
'        gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha + texture2D(uSamplerBack, vTextureCoordBack) * (1.0 - uAlpha);', '    } else {', '        vec4 textureColor = texture2D(uSampler, vec2(vTextureCoord.s, vTextureCoord.t));', '        gl_FragColor =  vec4(textureColor.rgb, textureColor.a * uAlpha);', '    }', '}'].join('\n');
/**
 * 拓扑箭头顶点着色器
 */

var LINK_VS_SHADER_TEXT = ['varying highp vec2 vTextureCoord;', 'void main(void) {', '    gl_Position = mvpMatrix * vec4(position, 1.0);', '    vTextureCoord = uv;', '}'].join('\n');
/**
 * 拓扑箭头片元着色器
 */

var LINK_FS_SHADER_TEXT = ['precision mediump float;', 'uniform sampler2D uSampler;', 'varying highp vec2 vTextureCoord;', 'void main(void) {', '    gl_FragColor = texture2D(uSampler, vTextureCoord);', '}'].join('\n');
/**
 * 淡出动画顶点着色器
 */

var FADE_VS_SHADER_TEXT = ['varying highp vec2 vTextureCoord;', 'void main(void) {', '    gl_Position = mvpMatrix * vec4(position, 1.0);', '    vTextureCoord = uv;', '}'].join('\n');
/**
 * 淡出动画片元着色器
 */

var FADE_FS_SHADER_TEXT = ['uniform sampler2D uSampler;', 'uniform float uOpacity;', 'varying vec2 vTextureCoord;', 'void main(void){', '    vec4 textureColor = texture2D(uSampler, vTextureCoord);', '    gl_FragColor = vec4(textureColor.rgb, textureColor.a * uOpacity);', '}'].join('\n');
var TRAVERSE_VS_SHADER_TEXT = ['varying highp vec3 vTextureCoord;', 'void main(void){', '   gl_Position = mvpMatrix  * vec4(position, 1.0);', '   vTextureCoord = vec3(uv, 1.0) * length(position);', '}'].join('\n');
var TRAVERSE_FS_SHADER_TEXT = ['uniform sampler2D uSampler;', 'uniform float uOpacity;', 'varying vec3 vTextureCoord;', 'uniform bool showDebugLine;', 'uniform vec4 vColor;', 'void main(void){', '   if (!showDebugLine) {', '       vec4 textureColor = texture2DProj(uSampler, vTextureCoord);', '       gl_FragColor = vec4(textureColor.rgb, textureColor.a * uOpacity);', '   } else {', '       gl_FragColor = vec4(vColor.rgb, vColor.a);', '   }', '}'].join('\n');
var WATERWAVE_FS_SHADER_TEXT = "\n    uniform float aspect;\n    uniform float radius;\n    uniform float amp;\n    uniform float band;\n    uniform float waves;\n    uniform float speed;\n    uniform float progress;\n    uniform vec2 uCenter;\n    uniform sampler2D uSampler;\n    uniform float uOpacity;\n\n    varying vec2 vTextureCoord;\n\n    void main() {\n        vec2 tc = vTextureCoord;\n        vec2 uv = vec2(0.0, 0.0);\n        vec2 p;\n        float len;\n        vec2 uv_offset;\n        float wave_width = band * radius;\n\n        p = (tc - uCenter);\n        p.x = p.x * aspect;\n        len = length(p);\n\n        float current_radius = radius * progress;\n        float damp_factor = 1.0;\n        if (progress > .5) {\n            damp_factor = (1.0 - progress) * 2.0;\n        }\n\n        float cut_factor = clamp(wave_width * damp_factor - abs(current_radius - len), 0.0, 1.0);\n        float waves_factor = waves * len / radius;\n        uv_offset = (p / len) * cos((waves_factor - progress * speed) * 3.14) * amp * cut_factor;\n\n        uv += uv_offset;\n\n        vec4 t_image = texture2D(uSampler, fract(tc + uv));\n\n        // gl_FragColor = t_image;\n        gl_FragColor = vec4(t_image.rgb, t_image.a * uOpacity);\n    }\n";

/**
 * @file 用来快速获取网格分片信息
 * @author quda
 */

/**
 * @class 网格分片工具
 * @constructor
 *
 * @param {number} level - 当前层级
 * @param {number} maxLevel - 最大层级
 * @param {number} row - 当前网格行号
 * @param {number} col - 当前网格列号
 */
var TileTree =
/*#__PURE__*/
function () {
  function TileTree(level, maxLevel, row, col) {
    this.nodes = void 0;
    this.level = void 0;
    this.key = void 0;
    this.nodes = [];
    this.level = level;
    this.key = "".concat(row, "_").concat(col);

    if (level < maxLevel) {
      this.nodes[0] = new TileTree(level + 1, maxLevel, row * 2, col * 2);
      this.nodes[1] = new TileTree(level + 1, maxLevel, row * 2, col * 2 + 1);
      this.nodes[2] = new TileTree(level + 1, maxLevel, row * 2 + 1, col * 2);
      this.nodes[3] = new TileTree(level + 1, maxLevel, row * 2 + 1, col * 2 + 1);
    }
  }

  var _proto = TileTree.prototype;

  _proto.hasNodes = function hasNodes() {
    return this.nodes.length > 0;
  }
  /**
   * 获取指定层级下的节点key
   * @param {number} level - 指定层级
   * @return {Array} - 节点key集合
   */
  ;

  _proto.getNodeKeysByLevel = function getNodeKeysByLevel(level) {
    if (level < this.level) {
      console.warn("\u6307\u5B9A\u8282\u70B9".concat(level, " \u4E0D\u5728\u5F53\u524D\u8282\u70B9").concat(this.level, "\u8303\u56F4\u5185\uFF01"));
      return [];
    }

    if (this.level === level) {
      return [this.key];
    }

    var nodeKeys = [];

    for (var i = 0; i < this.nodes.length; i++) {
      if (Object.prototype.hasOwnProperty.call(this.nodes, i)) {
        var curNode = this.nodes[i];

        if (this.level === level - 1) {
          nodeKeys.push(curNode.key);
        } else if (curNode.hasNodes()) {
          var subNodeKeys = curNode.getNodeKeysByLevel(level);
          nodeKeys.push.apply(nodeKeys, toConsumableArray(subNodeKeys));
        }
      }
    }

    return nodeKeys;
  };

  return TileTree;
}();
/**
 * 生成不同级别图片的行列数信息
 * @public
 * @return {Array} - 图片行列数信息
 */

function genImgColsRowsInfo() {
  var imgColsRows = [];

  for (var i = 0; i <= 5; i++) {
    if (i < 2) {
      imgColsRows[i] = {
        cols: 1,
        rows: 1
      };
      continue;
    }

    imgColsRows[i] = {
      cols: Math.pow(2, i - 1),
      rows: Math.pow(2, i - 1) / 2
    };
  }

  return imgColsRows;
}

var SphereRender =
/*#__PURE__*/
function (_BaseRender) {
  inheritsLoose(SphereRender, _BaseRender);

  /**
   * 球模型信息
   * @private
   */

  /**
   * 纹理资源管理器
   * @property
   */

  /**
   * 瓦片行列数信息
   * @property
   */

  /**
   * 网格对象缓存
   */

  /**
   * 瓦片信息缓存
   * TODO: 这两个cache是否可以合成一个
   */

  /**
   * 纹理图片边界
   */

  /**
   * 球模型小面边界
   */
  // 当前渲染命中的纹理瓦片编号
  function SphereRender(pano) {
    var _this;

    _this = _BaseRender.call(this, pano) || this;
    /**
     * 全景查看器对象
     * @type {Pano}
     * @private
     */

    _this.name = 'SphereRender';
    _this.sphere = void 0;
    _this.textureManager = void 0;
    _this.imgColsRows = void 0;
    _this.curThumbTexture = void 0;
    _this.meshCache = {};
    _this.tileInfoCache = {};
    _this.imgRange = void 0;
    _this.faceRange = void 0;
    _this.hitTile = void 0;

    _this.setData = function (data) {
      _this.panoData = data;
      _this.curThumbTexture = null;

      _this.loadThumbTextures(data.panoId);

      _this.generateBackThumb(data.panoId);
    };

    _this.update = function () {
      _this.updateRangeInfo();

      _this.checkAndLoadTiles();
    };

    _this.checkAndLoadTiles = function () {
      if (!_this.curThumbTexture || !_this.panoData) {
        return;
      }

      var panoId = _this.panoData.panoId;
      var checkTileCamera = _this.camera; // 当前层级瓦片行列信息

      var curTileInfo = _this.imgColsRows[_this._imgZoom];
      var tileColumns = curTileInfo.cols;
      var tileRows = curTileInfo.rows;
      var maxCols = tileColumns - 1;
      var maxRows = tileRows - 1; // 当前视口信息

      var _this$pano$getContain = _this.pano.getContainerSize(),
          viewportWidth = _this$pano$getContain.width,
          viewportHeight = _this$pano$getContain.height;

      var needLoadMore = false; // 行列号边界，用来定位需要加载的瓦片
      // let [colStart, rowStart] = this.getImgIndexByFaceColRow(faceLeft, faceTop);
      // let [colEnd, rowEnd] = this.getImgIndexByFaceColRow(faceRight, faceBottom);

      var hitMesh = []; //  需要渲染的球模型小面

      var _this$imgRange = slicedToArray(_this.imgRange, 4),
          colStart = _this$imgRange[0],
          colEnd = _this$imgRange[1],
          rowStart = _this$imgRange[2],
          rowEnd = _this$imgRange[3]; // 球顶是否在视野中


      if (isCoordsInView(fromValues$1(0, 100, 0), checkTileCamera, viewportWidth, viewportHeight)) {
        // 0 ~ rowStart 行的瓦片紧邻极点都需要加载
        for (var row = 0; row <= rowStart; row++) {
          for (var col = 0; col <= maxCols; col++) {
            _this.checkAndLoadTile(panoId, col, row, _this._imgZoom);

            hitMesh.push([row, col]);
          }
        } // 加载顶边框之外的其他三边框对应的瓦片


        if (rowStart < rowEnd) {
          rowStart += 1;
          needLoadMore = true;
        }
      } else if (isCoordsInView(fromValues$1(0, -100, 0), checkTileCamera, viewportWidth, viewportHeight)) {
        // rowEnd ~ maxRows 行的瓦片紧邻极点都需要加载
        for (var _row = rowEnd; _row <= maxRows; _row++) {
          for (var _col = 0; _col <= maxCols; _col++) {
            _this.checkAndLoadTile(panoId, _col, _row, _this._imgZoom);

            hitMesh.push([_row, _col]);
          }
        } // 加载底边框之外的其他三边框对应的瓦片


        if (rowStart < rowEnd) {
          rowEnd -= 1;
          needLoadMore = true;
        }
      } else {
        // 正常渲染
        needLoadMore = true;
      }

      if (true === needLoadMore) {
        if (colEnd > maxCols) {
          colEnd = maxCols;
        }

        for (var _col2 = colStart; _col2 <= colEnd; _col2++) {
          for (var _row2 = rowStart; _row2 <= rowEnd; _row2++) {
            var realCol = _col2 < 0 ? _col2 + tileColumns : _col2;

            _this.checkAndLoadTile(panoId, realCol, _row2, _this._imgZoom);

            hitMesh.push([_row2, realCol]);
          }
        }
      }

      _this.hitTile = hitMesh;
      hitMesh.forEach(function (_ref) {
        var _ref2 = slicedToArray(_ref, 2),
            row = _ref2[0],
            col = _ref2[1];

        // TODO: 缓存
        var key = "".concat(row, "_").concat(col, "_").concat(_this._imgZoom);

        if (_this.tileInfoCache[key] === undefined) {
          var tile = new TileTree(_this._imgZoom, 5, row, col);
          var tiles = tile.getNodeKeysByLevel(5);
          _this.tileInfoCache[key] = tiles;
        }
      });
    };

    _this.draw = function () {
      var meshs = _this.meshs;
      var faceRange = _this.faceRange;

      if (!faceRange || !_this.curThumbTexture) {
        return false;
      }

      meshs.children = [];
      /**
       * 生成当前加载的瓦片网格对象并添加到父mesh中
       * @param {number} col - 瓦片列号
       * @param {number} row - 瓦片行号
       */

      var addMesh = function addMesh(col, row) {
        // 缩略图纹理
        var thumbTexture = _this.curThumbTexture; // 高清纹理

        var highResTextureId = _this.textureManager.calcTileKey(_this.panoData.panoId, col, row, _this._imgZoom);

        var highResTexture = _this.textureManager.textureInfo.getData(highResTextureId);

        var isDrawThumb = false;
        var curTexture = null;

        if (highResTexture) {
          curTexture = highResTexture; // 执行高清纹理模糊到清晰的渐变动画

          if (!curTexture.finished && curTexture.aniInfo) {
            curTexture.aniInfo && curTexture.aniInfo.update();
          }
        } else if (thumbTexture) {
          isDrawThumb = true;
          curTexture = thumbTexture;
        }

        if (curTexture) {
          var meshKey = "".concat(row, "_").concat(col, "_").concat(_this._imgZoom);
          var curMesh = _this.meshCache[meshKey];

          if (!curMesh) {
            curMesh = _this.createTileMesh(row, col); // TODO: imgZoom的变化可能引起curMesh创建异常，临时处理

            if (!curMesh) return;
            _this.meshCache[meshKey] = curMesh;
          }

          if (!curMesh.material) {
            return;
          }

          var uniforms = curMesh.material.uniforms; // 缩略图纹理是固定不变的

          uniforms.uSamplerBack.value = thumbTexture;

          if (isDrawThumb) {
            uniforms.uDrawThumb.value = true;
          } else {
            uniforms.uDrawThumb.value = false;
            uniforms.uSampler.value = curTexture;
            uniforms.uAlpha.value = curTexture.alpha;
          }

          meshs.add(curMesh);
        }
      }; // eslint-disable-next-line @typescript-eslint/prefer-for-of


      for (var i = 0; i < _this.hitTile.length; i++) {
        var _this$hitTile$i = slicedToArray(_this.hitTile[i], 2),
            row = _this$hitTile$i[0],
            col = _this$hitTile$i[1];

        addMesh(col, row);
      }

      return true;
    };

    _this.pano = pano;
    _this.sphere = new GLSphere(pano.opts.radius);
    _this.textureManager = new TextureManager(pano);
    _this.imgColsRows = genImgColsRowsInfo();
    _this.curThumbTexture = null;
    _this.meshs = new Mesh();
    return _this;
  }

  var _proto = SphereRender.prototype;

  /**
   * 请求瓦片资源
   * @param {string} panoId - 全景ID
   * @param {number} col - 瓦片列号
   * @param {number} row - 瓦片行号
   * @param {number} tileLevel - 瓦片级别
   */
  _proto.checkAndLoadTile = function checkAndLoadTile(panoId, col, row, tileLevel) {
    var _this2 = this;

    var textureManager = this.textureManager;
    var key = textureManager.calcTileKey(panoId, col, row, tileLevel);
    var isExist = textureManager.textureInfo.getData(key) !== void 0;

    if (isExist !== true) {
      void this.textureManager.loadTexture(panoId, col, row, tileLevel).then(function (texture) {
        if (texture && !texture.done) {
          texture.aniInfo = _this2.createTextureAnimation(texture);
          texture.done = true;

          _this2.pano.dispatchEvent({
            type: EVENT_TYPE.REFRESH,
            log: '[Refresh Log] 瓦片加载完成， 渲染一帧'
          });
        }
      });
    }
  }
  /**
   * 加载当前场景缩略图纹理
   * @param {string} panoId - 全景ID
   */
  ;

  _proto.loadThumbTextures = function loadThumbTextures(panoId) {
    var _this3 = this;

    void this.textureManager.loadTexture(panoId, 0, 0, 1).then(function (texture) {
      _this3.curThumbTexture = texture;

      _this3.pano.dispatchEvent({
        type: EVENT_TYPE.THUMB_LOADED
      });

      _this3.pano.dispatchEvent({
        debug: true,
        type: EVENT_TYPE.REFRESH,
        log: '[Refresh Log] 缩略图加载完毕，渲染一帧'
      });
    });
  }
  /**
   * 创建纹理透明度渐变缓动函数
   * @param {Texture} texture - 纹理对象
   * @return {Tween} - 缓动函数
   */
  ;

  _proto.createTextureAnimation = function createTextureAnimation(texture) {
    var _this4 = this;

    texture.alpha = 0;
    return new Tween(0, 1, 300).onUpdate(function (value) {
      texture.alpha = value;

      _this4.pano.dispatchEvent({
        debug: true,
        type: EVENT_TYPE.REFRESH,
        log: '[Refresh Log] 纹理清晰度渐变动画，渲染一帧'
      });
    }).onEnd(function () {
      texture.finished = true;
    }).start();
  }
  /**
   * 球面场景每一帧渲染
   * @public
   * @return {Boolean} - 是否渲染成功
   */
  ;

  /**
   * 生成单个小面网格
   * @param {number} row - 球模型小面行号
   * @param {number} col - 球模型小面列号
   * @return {Mesh} - 单个小面网格
   */
  _proto.createTileMesh = function createTileMesh(row, col) {
    var material = new Material();
    var geometry = new BufferGeometry();
    material.depthTest = false;
    material.vertexShader = VS_SHADER_TEXT_NEW;
    material.fragmentShader = FS_SHADER_TEXT;
    material.uniforms = {
      uSampler: {
        type: 't',
        value: null
      },
      uSamplerBack: {
        type: 't',
        value: null
      },
      uDrawThumb: {
        type: '1i',
        value: 1
      },
      uDrawBack: {
        type: '1i',
        value: 1
      },
      uAlpha: {
        type: '1f',
        value: 1.0
      }
    };
    if (!this.setGeometryAttrib(geometry, row, col)) return null;
    var mesh = new Mesh(geometry, material);
    mesh.name = 'tile-mesh';
    return mesh;
  }
  /**
   * 设置指定几何顶点属性
   * @param {BufferGeometry} geometry - 几何
   * @param {number} row - 球面行号
   * @param {number} row - 球面列号
   */
  ;

  _proto.setGeometryAttrib = function setGeometryAttrib(geometry, row, col) {
    var id = "".concat(row, "_").concat(col, "_").concat(this._imgZoom);
    var info = this.tileInfoCache[id]; // 对应球模型瓦片集合

    if (!info) {
      return false;
    }

    var vertexs = [];
    var textureCoord = [];
    var textureCoordBack = []; // TODO: 是否要基于行列号进行缓存
    // eslint-disable-next-line @typescript-eslint/prefer-for-of

    for (var i = 0; i < info.length; i++) {
      var key = info[i];
      var res = key.split('_');
      var maxRows = this.sphere.rows;
      var sphereCol = Number(res[1]);
      var sphereRow = maxRows - 1 - Number(res[0]);
      vertexs.push.apply(vertexs, toConsumableArray(this.sphere.getFaceVertex(sphereRow, sphereCol)));
      textureCoord.push.apply(textureCoord, toConsumableArray(this.sphere.generateTextureCoord(sphereRow, sphereCol, this._imgZoom)));
      textureCoordBack.push.apply(textureCoordBack, toConsumableArray(this.sphere.generateTextureCoord(sphereRow, sphereCol, 1))); // TODO: 是否要基于行列号进行缓存
    }

    var vertexIndice = this.sphere.getSphereFacesIndicesByimageZoom(this._imgZoom);
    geometry.setAttribute('uv', new Float32ArrayAttribute(textureCoord, 2));
    geometry.setAttribute('uvBack', new Float32ArrayAttribute(textureCoordBack, 2));
    geometry.setAttribute('position', new Float32ArrayAttribute(vertexs, 3));
    geometry.setIndexes(vertexIndice);
    return true;
  };

  _proto.getTileBoundary = function getTileBoundary() {
    // 当前视口信息
    var _this$pano$getContain2 = this.pano.getContainerSize(),
        viewportWidth = _this$pano$getContain2.width,
        viewportHeight = _this$pano$getContain2.height; // 找8个点
    // 视口坐标，四个角和四个边的中点


    var topLeft = fromValues(0, 0);
    var topRight = fromValues(viewportWidth, 0);
    var bottomLeft = fromValues(0, viewportHeight);
    var bottomRight = fromValues(viewportWidth, viewportHeight);
    var topCenter = fromValues(viewportWidth * 0.5, 0);
    var bottomCenter = fromValues(viewportWidth * 0.5, viewportHeight);
    var leftCenter = fromValues(0, viewportHeight * 0.5);
    var rightCenter = fromValues(viewportWidth, viewportHeight * 0.5); // 球面坐标，四个角和四个边的中点

    var topLeftSphere = this.getSpherePosition(topLeft);
    var topRightSphere = this.getSpherePosition(topRight);
    var bottomLeftSphere = this.getSpherePosition(bottomLeft);
    var bottomRightSphere = this.getSpherePosition(bottomRight);
    var topCenterSphere = this.getSpherePosition(topCenter);
    var bottomCenterSphere = this.getSpherePosition(bottomCenter);
    var leftCenterSphere = this.getSpherePosition(leftCenter);
    var rightCenterSphere = this.getSpherePosition(rightCenter); // 球坐标边界，用来定位行列号边界
    // 先定位要加载的行信息

    var faceTop = Math.max(topLeftSphere[1], topCenterSphere[1], topRightSphere[1]);
    var faceBottom = Math.min(bottomLeftSphere[1], bottomCenterSphere[1], bottomRightSphere[1]);
    var leftPoints = [topLeftSphere[0], leftCenterSphere[0], bottomLeftSphere[0], topCenterSphere[0] // bottomCenterSphere[0]
    ];
    var rightPoints = [topRightSphere[0], rightCenterSphere[0], bottomRightSphere[0], // topCenterSphere[0],
    bottomCenterSphere[0]]; // console.log('左上 ==>', topLeftSphere);
    // console.log('上中 ==>', topCenterSphere);
    // console.log('右上 ==>', topRightSphere);
    // console.log('左中 ==>', leftCenterSphere);
    // console.log('右中 ==>', rightCenterSphere);
    // console.log('左下 ==>', bottomLeftSphere);
    // console.log('下中 ==>', bottomCenterSphere);
    // console.log('右下 ==>', bottomRightSphere);
    // console.log('left ==>', leftPoints);
    // console.log('right ==>', rightPoints);

    var faceLeft = Math.min.apply(Math, leftPoints);
    var faceRight = Math.max.apply(Math, rightPoints);
    var leftMaxMinInfo = getMinAndMax(leftPoints);
    var rightMaxMinInfo = getMinAndMax(rightPoints);
    var maxCols = this.sphere.cols;
    var halfMaxCols = maxCols / 2; // 处理左右各自横跨2π情况, 要考虑到上下两个中点

    /**
     * eg:
     * 14 15 0 => 14
     * 15 15 0 => 15
     */

    if (leftMaxMinInfo.max - leftMaxMinInfo.min > halfMaxCols) {
      // const copy = leftPoints.map(item => (item + halfMaxCols) % maxCols);
      // faceLeft = Math.min(...copy);
      // faceLeft -= halfMaxCols;
      faceLeft = Math.min.apply(Math, toConsumableArray(leftPoints.filter(function (item) {
        return item > halfMaxCols;
      })));
    } // eg: 15 0 1 => 1


    if (rightMaxMinInfo.max - rightMaxMinInfo.min > halfMaxCols) {
      // const copy = rightPoints.map(item => (item - halfMaxCols) % maxCols);
      // faceLeft = Math.max(...copy);
      // faceLeft += halfMaxCols;
      faceRight = Math.max.apply(Math, toConsumableArray(rightPoints.filter(function (item) {
        return item < halfMaxCols;
      })));
    } // 整体横跨2π，左侧用负数表示


    if (faceLeft > faceRight) {
      faceLeft -= maxCols;
    } // console.log(faceLeft, faceRight, faceTop, faceBottom);
    // 行列号边界，用来定位需要加载的瓦片


    var _this$getImgIndexByFa = this.getImgIndexByFaceColRow(faceLeft, faceTop),
        _this$getImgIndexByFa2 = slicedToArray(_this$getImgIndexByFa, 2),
        colStart = _this$getImgIndexByFa2[0],
        rowStart = _this$getImgIndexByFa2[1];

    var _this$getImgIndexByFa3 = this.getImgIndexByFaceColRow(faceRight, faceBottom),
        _this$getImgIndexByFa4 = slicedToArray(_this$getImgIndexByFa3, 2),
        colEnd = _this$getImgIndexByFa4[0],
        rowEnd = _this$getImgIndexByFa4[1]; // console.timeEnd('getTileBoundary'); // 0.1ms左右


    return [[faceLeft, faceRight, faceTop, faceBottom], [colStart, colEnd, rowStart, rowEnd]];
  }
  /**
   * 更新当前视口所需的瓦片图边界和球面边界
   * @private
   */
  ;

  _proto.updateRangeInfo = function updateRangeInfo() {
    var _this$getTileBoundary = this.getTileBoundary(),
        _this$getTileBoundary2 = slicedToArray(_this$getTileBoundary, 2),
        faceRange = _this$getTileBoundary2[0],
        imgRange = _this$getTileBoundary2[1];

    this.imgRange = imgRange;
    this.faceRange = faceRange;
  }
  /**
   * 根据球上的面所在行列号获取纹理图片的行列号和索引
   * @private
   * @TODO: 待优化
   *
   * @param {number} col - 球面行号
   * @param {number} row - 球面列号
   * @param {number} imgZoom - 可选，图片级别
   * @return {Array<number>} - 纹理图片的行列号和索引
   */
  ;

  _proto.getImgIndexByFaceColRow = function getImgIndexByFaceColRow(col, row, imgZoom) {
    imgZoom = imgZoom || this._imgZoom;
    var factor = Math.pow(2, 5 - imgZoom);
    var imgCol = Math.floor(col / factor);
    var imgRow = Math.floor(row / factor);
    imgRow = this.imgColsRows[imgZoom].rows - imgRow - 1; // y轴翻转

    var imgIndex = imgCol + imgRow * GLSphere.DEFAULT_COLS / factor;
    return [imgCol, imgRow, imgIndex];
  }
  /**
   * 将给定数字规范化到指定区间
   * 目前用于瓦片行列号的处理
   * @private
   * @TODO: 暂时无用，可以抽象到工具方法中
   * @param {number} targe - 目标数字
   * @param {number} maxNum - 最大边界
   * @param {number} minNum - 最小边界
   * @return {number} - 规范后的结果
   */
  ;

  _proto.normalizeNum = function normalizeNum(targe, maxNum) {
    var minNum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var t = targe;

    while (t < minNum) {
      t += maxNum;
    }

    t = t % maxNum;
    return t;
  }
  /**
   * 通过屏幕坐标返回当前2D坐标所在球模型的面信息
   * @param {Vec2} screenPos - 屏幕2D坐标
   * @return {Vec2} - 当前2D坐标所在球模型的面信息 => [col, row]
   */
  ;

  _proto.getSpherePosition = function getSpherePosition(screenPos) {
    var camera = this.camera;

    var _this$pano$getContain3 = this.pano.getContainerSize(),
        viewportWidth = _this$pano$getContain3.width,
        viewportHeight = _this$pano$getContain3.height;

    var sphereCoord = this.sphere.viewportToSphereCoord(screenPos, viewportWidth, viewportHeight, camera); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    var _this$sphere$getFaceI = this.sphere.getFaceIndex(sphereCoord),
        _this$sphere$getFaceI2 = slicedToArray(_this$sphere$getFaceI, 2),
        col = _this$sphere$getFaceI2[0],
        row = _this$sphere$getFaceI2[1];

    return fromValues(col, row);
  }
  /**
   * 生成兜底背景
   * @private
   *
   * @param {string} panoId - 全景ID
   */
  ;

  _proto.generateBackThumb = function generateBackThumb(panoId) {
    if (!panoId) {
      return;
    }

    var pano = this.pano;
    var size = pano.getContainerSize();
    var width = size.width;
    var height = size.height;
    var url = '//mapsv0.bdimg.com/scape/?udt=20140616&qt=pdata&pos=0_0&z=2&sid=' + panoId + '&from=H5';
    var tileContainer = pano.getPanes().tileLayer;
    tileContainer.style.backgroundImage = 'url("' + url + '")';
    tileContainer.style.backgroundPosition = '50% 50%';
    tileContainer.style.backgroundSize = '150% 150%';
    tileContainer.style.width = "".concat(width, "px");
    tileContainer.style.height = "".concat(height, "px");
  };

  createClass(SphereRender, [{
    key: "_imgZoom",
    get: function get() {
      return this.pano.imageZoom;
    }
    /**
     * 设置全景数据
     * @param {Object} data - 全景数据
     */

  }]);

  return SphereRender;
}(BaseRender);

/**
 * @file 单个道路箭头几何信息
 * @author quda
 */

var scale$6 = 1.8; // 箭头顶点原始坐标

var ARROW_VERTEX = [10, -20, 30, 10, -20, 10, -10, -20, 10, -10, -20, 30].map(function (item) {
  return item === -20 ? -20 : item * scale$6;
});
var ARROW_SHADOW_VERTEX = [10, -22, 30, 10, -22, 10, -10, -22, 10, -10, -22, 30].map(function (item) {
  return item === -22 ? -22 : item * scale$6;
});
/**
 * 文字顶点原始坐标
 * @TODO: 坐标待调整
 */
// const TEXT_VERTEX = [2.2, -20, 22.3, 2.2, -20, 13.7, -2.2, -20, 13.7, -2.2, -20, 22.3];

var TEXT_VERTEX = [1.8, -20, 24.9, 1.8, -20, 16.3, -1.8, -20, 16.3, -1.8, -20, 24.9].map(function (item) {
  return item === -20 ? -20 : item * scale$6;
}); // 文字纹理索引

var TEXT_COORD_DEFAULT = [0, 0, 0, 0.5, 0.25, 0.5, 0.25, 0];

var RoadArrow =
/*#__PURE__*/
function () {
  /**
   * 单个箭头网格对象
   */

  /**
   * 单个箭头材质对象
   */

  /**
   * 单个道路箭头原始数据
   */

  /**
   * 全景实例
   */

  /**
   * 指北角
   */

  /**
   * 箭头所在的Y轴位置，用于点击判断
   */
  function RoadArrow(pano, linkData, northDir) {
    var _this = this;

    this.mesh = void 0;
    this.material = void 0;
    this.linkData = void 0;
    this._pano = void 0;
    this.northDir = void 0;
    this.yAxisDis = void 0;

    this.isPosInArrow = function (x, y, camera, viewportWidth, viewportHeight) {
      var v = fromValues(x, y);
      var res = viewportToWorld(v, camera, viewportWidth, viewportHeight, -1);
      var i = res[0] * 200;
      var j = res[1] * 200;
      var k = res[2] * 200;
      var yAxis = _this.yAxisDis; // 箭头所在的Y轴平面

      var t = yAxis / j;

      if (t < 0) {
        return false; // 没有交点
      }

      var result = [i * t, j * t, k * t]; // 点击向量与Y轴的交点

      var isHit = _this.isHitLink(result);

      return isHit;
    };

    this._pano = pano;
    this.linkData = linkData;
    this.northDir = northDir;
    this.yAxisDis = 0; // 道路箭头相对图片左侧的角度

    this.linkData.refinedDir = degreeNormalized((linkData.topoDir || 0) + this.northDir);
    this.material = this.createArrowMaterial();
    this.mesh = this.initMesh();
    this.changePose();
  }
  /**
   * 初始化箭头网格
   */


  var _proto = RoadArrow.prototype;

  _proto.initMesh = function initMesh() {
    var arrowGeometry = this.createGeometry();
    var mesh = new Mesh(arrowGeometry, this.material);
    mesh.visible = false;
    mesh.name = 'link-mesh';
    return mesh;
  };

  _proto.createArrowMaterial = function createArrowMaterial() {
    var material = new Material();
    material.depthTest = false;
    material.vertexShader = LINK_VS_SHADER_TEXT;
    material.fragmentShader = LINK_FS_SHADER_TEXT;
    material.uniforms = {
      uSampler: {
        type: 't',
        value: null
      }
    };
    return material;
  }
  /**
   * 设置箭头纹理，供上层调用
   * @public
   *
   * @param {Texture} texture - 箭头纹理
   */
  ;

  _proto.setTopoTexture = function setTopoTexture(texture) {
    if (texture.isTexture) {
      // @ts-ignore
      this.material.uniforms.uSampler.value = texture;
    }
  }
  /**
   * 设置单个箭头的显隐
   * @public
   *
   * @param {Boolean} v - 显隐
   */
  ;

  _proto.setVisible = function setVisible(v) {
    this.mesh.setVisible(v, true);
  };

  _proto.createGeometry = function createGeometry() {
    var arrowGeometry = new BufferGeometry();
    var arrowTexCoords = [0, 0, 0, 0.5, 0.5, 0.5, 0.5, 0];
    var shadowArrowTexCoords = [0.5, 0, 0.5, 0.5, 1, 0.5, 1, 0];
    var arrowTextTexCoords = this.getTextCoord(this.linkData.topoDir); // 绘制顺序：箭头阴影 => 箭头 => 文字

    var vertexs = [].concat(ARROW_SHADOW_VERTEX, ARROW_VERTEX, TEXT_VERTEX);
    var texCoords = [].concat(shadowArrowTexCoords, arrowTexCoords, arrowTextTexCoords);
    var indexes = [].concat([0, 1, 2, 0, 2, 3], [4, 5, 6, 4, 6, 7], [8, 9, 11, 10, 11, 9]);
    arrowGeometry.setAttribute('position', new Float32ArrayAttribute(vertexs, 3));
    arrowGeometry.setAttribute('uv', new Float32ArrayAttribute(texCoords, 2));
    arrowGeometry.setIndexes(indexes);
    return arrowGeometry;
  }
  /**
   * 更改箭头姿态
   * @private
   * @param {Mesh} mesh - 箭头网格对象
   */
  ;

  _proto.changePose = function changePose(mesh) {
    mesh = mesh || this.mesh;
    var distance = 50; // 距离球模型中心点的距离

    var vDis = -30; // 垂直方向虚拟高度，贴地

    var cameraPitch = this._pano.getPov().pitch;

    var refinedDir = this.linkData.refinedDir; // 考虑zoom对箭头距离的影响
    // TODO: zoom对距离的影响计算公式待优化

    var viewZoom = this._pano.getZoom();

    distance += 20 * viewZoom; // 考虑pitch对箭头距离的影响

    if (cameraPitch < 0) {
      cameraPitch = Math.abs(cameraPitch);
      var ratio = (90 - cameraPitch) / 90;
      distance *= ratio;
      vDis = vDis - 20 * cameraPitch / 90;
    } // 距离在x、z方向上的拆解


    var tx = Math.cos(degToRad(refinedDir)) * distance;
    var tz = Math.sin(degToRad(refinedDir)) * distance;
    this.yAxisDis = vDis + -20;
    mesh.setPosition(tx, vDis, tz);
    mesh.rotateY(-degreeNormalized(refinedDir - 90));
    mesh.rotateX(-5); // 稍微倾斜下 使文字看的更清晰

    mesh.updateWorldMatrix(true);
  }
  /**
   * 根据箭头方向获取箭头文字纹理坐标
   * @param {number} deg - 箭头相对北的角度
   * @return {Array} - 纹理坐标
   */
  ;

  _proto.getTextCoord = function getTextCoord(deg) {
    deg = (deg + 360) % 360;
    var index = Math.ceil(Math.floor(deg / 22.5) / 2);

    if (index === 8) {
      index = 0;
    }

    var coord = TEXT_COORD_DEFAULT.slice(0);
    var col = Math.floor(index / 2);
    var row = index % 2;

    for (var i = 0; i < coord.length; i++) {
      if (i % 2 === 0) {
        coord[i] += col * 0.25;
        coord[i] = coord[i] * 0.5;
      } else {
        coord[i] += row * 0.5;
        coord[i] = coord[i] * 0.5 + 0.5;
      }
    }

    return coord;
  }
  /**
   * 屏幕上的一点(x, y)是否落在箭头区域
   * @public
   * @description 用于判断道路箭头的点击
   *
   * @param {number} x - 屏幕坐标X
   * @param {number} y - 屏幕坐标Y
   * @param {WebGLCamera} camera - 相机实例
   * @param {number} viewportWidth - 可视区宽度
   * @param {number} viewportHeight - 可视区高度
   * @return {boolean} - 是否落在箭头区域
   */
  ;

  /**
   * 点击是否命中当前箭头
   * @private
   *
   * @param {Vec3} pos - 箭头Y轴平面上的点击坐标
   * @return {boolean} - 是否命中
   */
  _proto.isHitLink = function isHitLink(pos) {
    var x = pos[0];
    var z = pos[2];
    var mesh = this.mesh;
    var worldMatrix = mesh.worldMatrix; // 选出世界坐标下的3D中心点
    // TODO: 后续用射线法代替

    var p1 = fromValues$1(ARROW_VERTEX[0], ARROW_VERTEX[1], ARROW_VERTEX[2]);
    var p2 = fromValues$1(ARROW_VERTEX[6], ARROW_VERTEX[7], ARROW_VERTEX[8]);
    var center = fromValues$1((p1[0] + p2[0]) / 2, (p1[1] + p2[1]) / 2, (p1[2] + p2[2]) / 2);
    transformMat4$1(center, center, worldMatrix);

    if (Math.abs(x - center[0]) < 12 * 1.5 && Math.abs(z - center[2]) < 12 * 1.5) {
      return true;
    }

    return false;
  };

  return RoadArrow;
}();

var PanoLinkRender =
/*#__PURE__*/
function (_BaseRender) {
  inheritsLoose(PanoLinkRender, _BaseRender);

  // 当前场景是否展示道路箭头

  /**
   * 道路箭头详情
   * @type {Array}
   */
  function PanoLinkRender(pano) {
    var _this;

    _this = _BaseRender.call(this, pano) || this;
    _this.name = 'PanoLinkRender';
    _this.linkVisible = true;
    _this.textureManager = void 0;
    _this.linkInfos = [];

    _this.setData = function (data) {
      if (data && isFunction(data.getTopos)) {
        _this.reset();

        var topoInfo = data.getTopos();
        var northDir = data.northDir;
        var isStreet = data.panoType === ConstantConfig.TYPE_STREET; // 是否为街景，街景下才渲染道路箭头

        if (topoInfo.length && isStreet) {
          /**
           * 每个箭头的渲染信息，包括顶点、纹理坐标
           */
          _this.linkInfos = topoInfo.map(function (topo) {
            return new RoadArrow(_this.pano, topo, northDir);
          });
          _this.meshs = _this.linkInfos.map(function (link) {
            return link.mesh;
          });

          _this.loadTextures();

          _this.setVisible(true);
        }
      }
    };

    _this.clickChecker = function (x, y) {
      if (!_this.linkVisible) {
        return;
      }

      var nextPanoId = _this.getIdByTouchPos(x, y);

      if (nextPanoId) {
        _this.setVisible(false); // 切换场景时隐藏当前场景箭头


        _this.pano.dispatchEvent({
          type: EVENT_TYPE.LINK_CLICK,
          id: nextPanoId
        });

        _this.pano.setId(nextPanoId, {
          animation: true
        });
      }

      return !nextPanoId;
    };

    _this.pano = pano;
    _this.meshs = [];
    _this.textureManager = new TextureManager(pano);
    return _this;
  }
  /**
   * 箭头初始化
   */


  var _proto = PanoLinkRender.prototype;

  /**
   * 重置拓扑信息
   * @TODO: 这里可以考虑用Mesh.children方式实现
   */
  _proto.reset = function reset() {
    this.meshs = [];
    this.linkInfos = [];
  }
  /**
   * 视图变更 同步调整箭头姿态
   * @public
   */
  ;

  _proto.update = function update() {
    this.linkInfos.forEach(function (link) {
      link.changePose();
    });
  }
  /**
   * 点击事件校验
   * @param {number} x - 屏幕坐标X
   * @param {number} y - 屏幕坐标Y
   * @return {boolean} - 校验结果，是否响应点击事件
   */
  ;

  /**
   * 设置道路箭头可见性
   * @public
   * @param {boolean} visible - 可见性
   */
  _proto.setVisible = function setVisible(visible) {
    var linkInfos = this.linkInfos;

    if (linkInfos.length < 1) {
      return;
    }

    var globalVisibleConfig = this.pano.opts.linksControl;
    var v = false; // 最终的显示配置
    // 以全局配置为主，若全局配置为可显示，再使用传入的配置

    if (globalVisibleConfig === true) {
      v = visible;
    }

    this.linkVisible = v;
    linkInfos.forEach(function (linkArrow) {
      return linkArrow.setVisible(v);
    });
  };

  _proto.draw = function draw() {} // do nothing

  /**
   * 加载箭头相关纹理
   * @private
   */
  ;

  _proto.loadTextures = function loadTextures() {
    var _this2 = this;

    // 三张纹理合并成一张
    var url = ConstantConfig.TOPO_ARROW_TEXTURE;
    void this.textureManager.loadTopoTexture(url).then(function (texture) {
      if (texture) {
        _this2.linkInfos.forEach(function (link) {
          link.setTopoTexture(texture);
        });
      }
    });
  }
  /**
   * 根据屏幕点击坐标判读是否命中道路箭头，并返回对应全景ID
   * @param {number} x - 屏幕坐标X
   * @param {number} y - 屏幕坐标Y
   * @return {string | null} - 对应全景ID 如果未命中返回null
   */
  ;

  _proto.getIdByTouchPos = function getIdByTouchPos(x, y) {
    var _this3 = this;

    var curId = null;

    if (!this.linkInfos.length) {
      return curId;
    }

    var _this$pano$getContain = this.pano.getContainerSize(),
        viewportWidth = _this$pano$getContain.width,
        viewportHeight = _this$pano$getContain.height;

    var curLink = this.linkInfos.filter(function (arrow) {
      return arrow.isPosInArrow(x, y, _this3.camera, viewportWidth, viewportHeight);
    });

    if (curLink.length) {
      curId = curLink[0].linkData.panoId;
    }

    return curId;
  };

  return PanoLinkRender;
}(BaseRender);

/**
 * @file 淡出动画渲染器
 * @author quda
 */

var FadeAnimation =
/*#__PURE__*/
function () {
  function FadeAnimation(pano, snapshot, handleEnd) {
    var _this = this;

    this.start = function () {
      _this.fadeAni.start();

      _this._pano.dispatchEvent({
        debug: true,
        log: '淡出动画，渲染一帧',
        type: EVENT_TYPE.REFRESH
      });
    };

    this.update = function () {
      _this.fadeAni.update();
    };

    this._pano = pano;
    this.gl = this._pano.gl;
    this.snapshot = snapshot;
    this.scene = this.initScene();
    this.camera = this.initCamera();
    var duration = 600; // 淡出动画时长
    // 淡出动画

    this.fadeAni = new Tween(1, 0, duration).onUpdate(function (value) {
      _this.material.uniforms.uOpacity.value = value;

      _this._pano.dispatchEvent({
        type: EVENT_TYPE.REFRESH
      });
    }).onEnd(function () {
      handleEnd && handleEnd();

      _this._pano.dispatchEvent({
        type: EVENT_TYPE.REFRESH,
        debug: true,
        log: '淡出动画结束，渲染一帧'
      });
    });
  }

  var _proto = FadeAnimation.prototype;

  _proto.initScene = function initScene() {
    var scene = new Scene();

    var _this$_pano$getContai = this._pano.getContainerSize(),
        viewportWidth = _this$_pano$getContai.width,
        viewportHeight = _this$_pano$getContai.height;

    var plane = new PlaneBufferGeometry(viewportWidth, viewportHeight);
    var material = this.initMaterial();
    var mesh = new Mesh(plane, material);
    scene.add(mesh);
    return scene;
  };

  _proto.initMaterial = function initMaterial() {
    var material = new Material();
    material.depthTest = false;
    material.vertexShader = FADE_VS_SHADER_TEXT;
    material.fragmentShader = FADE_FS_SHADER_TEXT;
    material.uniforms = {
      uSampler: {
        type: 't',
        value: this.snapshot
      },
      uOpacity: {
        type: '1f',
        value: 1.0
      }
    };
    this.material = material;
    return material;
  }
  /**
   * 启动淡出动画
   * @public
   */
  ;

  /**
   * 设置相机
   * @private
   * @return {WebGLCamera} - 淡出动画相机
   */
  _proto.initCamera = function initCamera() {
    var _this$_pano$getContai2 = this._pano.getContainerSize(),
        viewportWidth = _this$_pano$getContai2.width,
        viewportHeight = _this$_pano$getContai2.height;

    var halfWidth = viewportWidth / 2;
    var halfHeight = viewportHeight / 2;
    var camera = new OrthographicCamera(-halfWidth, halfWidth, halfHeight, -halfHeight, 0, 11000);
    return camera;
  };

  return FadeAnimation;
}();

/**
 * @file 水波纹效果
 * @author quda
 * @TODO: 感觉可以跟Fade合为一个
 */

var WaterWaveAnimation =
/*#__PURE__*/
function () {
  function WaterWaveAnimation(pano, snapshot, handleEnd) {
    var _this = this;

    this.start = function () {
      _this.waveAni.start();

      _this._pano.dispatchEvent({
        debug: true,
        log: '淡出动画，渲染一帧',
        type: EVENT_TYPE.REFRESH
      });
    };

    this.update = function () {
      _this.waveAni.update();
    };

    this._pano = pano;
    this.gl = this._pano.gl;
    this.snapshot = snapshot;
    this.scene = this.initScene();
    this.camera = this.initCamera();
    var duration = 800; // 淡出动画时长
    // 淡出动画

    this.waveAni = new Tween(0, 1, duration).onUpdate(function (value) {
      _this.material.uniforms.progress.value = value;
      _this.material.uniforms.uOpacity.value = 1 - value;

      _this._pano.dispatchEvent({
        type: EVENT_TYPE.REFRESH
      });
    }).onEnd(function () {
      handleEnd && handleEnd();

      _this._pano.dispatchEvent({
        type: EVENT_TYPE.REFRESH,
        debug: true,
        log: '淡出动画结束，渲染一帧'
      });
    });
  }
  /**
   * 启动淡出动画
   * @public
   */


  var _proto = WaterWaveAnimation.prototype;

  /**
   * 设置相机
   * @private
   * @return {WebGLCamera} - 淡出动画相机
   */
  _proto.initCamera = function initCamera() {
    var _this$_pano$getContai = this._pano.getContainerSize(),
        viewportWidth = _this$_pano$getContai.width,
        viewportHeight = _this$_pano$getContai.height;

    var halfWidth = viewportWidth / 2;
    var halfHeight = viewportHeight / 2;
    var camera = new OrthographicCamera(-halfWidth, halfWidth, halfHeight, -halfHeight, 0, 11000);
    return camera;
  };

  _proto.initScene = function initScene() {
    var scene = new Scene();

    var _this$_pano$getContai2 = this._pano.getContainerSize(),
        viewportWidth = _this$_pano$getContai2.width,
        viewportHeight = _this$_pano$getContai2.height;

    var plane = new PlaneBufferGeometry(viewportWidth, viewportHeight);
    var material = this.initMaterial();
    var mesh = new Mesh(plane, material);
    scene.add(mesh);
    return scene;
  };

  _proto.initMaterial = function initMaterial() {
    var material = new Material();

    var _this$_pano$getContai3 = this._pano.getContainerSize(),
        width = _this$_pano$getContai3.width,
        height = _this$_pano$getContai3.height;

    material.depthTest = false;
    material.vertexShader = FADE_VS_SHADER_TEXT;
    material.fragmentShader = WATERWAVE_FS_SHADER_TEXT;
    material.uniforms = {
      uSampler: {
        type: 't',
        value: this.snapshot
      },
      uCenter: {
        type: '2f',
        value: [0.5, 0.5]
      },
      uOpacity: {
        type: '1f',
        value: 1.0
      },
      progress: {
        type: '1f',
        value: 0
      },
      speed: {
        type: '1f',
        value: 4.0
      },
      waves: {
        type: '1f',
        value: 14.0
      },
      band: {
        type: '1f',
        value: 0.3
      },
      amp: {
        type: '1f',
        value: 0.3
      },
      aspect: {
        type: '1f',
        value: width / height
      },
      radius: {
        type: '1f',
        value: 1.0
      }
    };
    this.material = material;
    return material;
  };

  return WaterWaveAnimation;
}();

/**
 * @file 前进动画渲染器
 * @author quda
 */
/**
 * 穿梭动画
 * @class
 * @constructor
 * @param {Pano} pano - 全景实例
 * @param {number} refinedDir - 相机移动方向
 * @param {number} distance - 相机移动距离
 * @param {handleEnd} handleEnd - 动画结束的回调
 */

var JumpAnimation =
/*#__PURE__*/
function () {
  function JumpAnimation(pano, refinedDir, distance, handleEnd) {
    var _this = this;

    this.startAni = function () {
      _this.animation.start();
    };

    this.update = function () {
      _this.animation.update();
    };

    this.pano = pano;
    this.distance = distance;
    this.refinedDir = refinedDir;
    this.camera = this.pano.camera;
    this.cameraBase = this.pano.camera.clone();
    this.handleEnd = handleEnd;
    this.initAni();
  }

  var _proto = JumpAnimation.prototype;

  _proto.initAni = function initAni() {
    var _this2 = this;

    // debugger;
    // FIXME: 角度需要调整，道路箭头不在屏幕中央时移动效果不好
    var distanceBase = this.distance; // 前进距离

    var refinedDir = this.refinedDir;
    var cosDir = Math.cos(degToRad(refinedDir));
    var sinDir = Math.sin(degToRad(refinedDir));
    this.animation = new Tween(0, 1, 400, Transitions.easeOutQuad).onUpdate(function (value) {
      var distance = distanceBase * value;
      var moveX = cosDir * distance;
      var moveZ = sinDir * distance;
      /**
       * 这里是使用了相机移动的方式，但是相机往前移动的同时fov没有变化，导致看到的内容变少了
       * 如果这里在移动相机的同时能让fov变大是否能效果好点？
       * */
      // this.camera.translate(Vec3.fromValues(-moveX, 0, Math.abs(moveZ)), 'assign');
      // // this.camera.updatemodelViewMatrix();
      // Mat4.translate(
      //     this.camera.modelViewMatrix,
      //     this.camera.modelViewMatrix,
      //     Vec3.fromValues(-(moveX - lastMoveX), 0, -(moveZ - laseMoveZ))
      // );

      _this2.camera.setPosition(moveX, 0, moveZ);

      _this2.pano.dispatchEvent({
        debug: true,
        type: EVENT_TYPE.REFRESH,
        log: '[Refresh Log] 前进动画， 渲染一帧'
      });
    }).onEnd(function () {
      _this2.handleEnd && _this2.handleEnd();
    });
  }
  /**
   * 启动穿梭动画
   */
  ;

  return JumpAnimation;
}();

/**
 * @file 屏幕方框基类
 * @author mawenjie01
 */
var Rectangle = function Rectangle(x, y, width, height) {
  this.x = x || 0;
  this.y = y || 0;
  this.width = width || 0;
  this.height = height || 0;
};

/**
 * @file 街景穿梭过渡效果数据计算
 * @author mawenjie01<mawenjie01@baidu.com>
 */

var BASE_TOP_DISTANCE = 50; // 灭点到底边的距离

var BASE_BOTTOM_DISTANCE = 20; // 路宽系数，数据提供的是单向路宽，需要*2，去掉1/4的采集车偏移，保证左右面速度一致，再去掉1/4，得1.5。

var ROAD_WIDTH_RATIO = 1.5; // 最大路宽

var MAX_ROAD_WIDTH = 10; // 默认设备高度，如果panoData中没相关信息则取这个值

var DEFAULT_DEVICE_HEIGHT = 2.2; // 默认快照比例

var DEFAULT_SNAPSHOT_RATIO = 1.0; // 当前相机转向角度过大时的比例

var ANGLE_SNAPSHOT_RATIO = 1.8;
/**
 * 穿梭动画数据类
 * @class TraverseModal
 * @constructor
 * @param {PanoViwer} pano - 全景实例
 * @param {number} traverseDir - 穿梭方向
 */

var TraverseModal = function TraverseModal(pano, traverseDir) {
  var _this = this;

  this.angleDegreeDelta = function (angle1, angle2) {
    var delta = Math.abs(angle1 - angle2);
    return delta > 180 ? 360 - delta : delta;
  };

  this.getRoad = function (roadWidth, deviceHeight, pMatrix, panoWidth, panoHeight) {
    var roads = [];
    var selected3D = [[-roadWidth / 2, -deviceHeight, -10], [-roadWidth / 2, -deviceHeight, -20], [roadWidth / 2, -deviceHeight, -10], [roadWidth / 2, -deviceHeight, -20]];
    var len = selected3D.length;
    var selected;

    for (var i = 0; i < len; i++) {
      selected = selected3D[i]; // 将道路上的点透视投影到平面

      transformMat4$1(selected, selected, pMatrix);
      roads[i] = {
        x: selected[0] * panoWidth * 0.5,
        y: -selected[1] * panoHeight * 0.5
      };
    }

    return roads;
  };

  this.getIntersection = function (a1, a2, b1, b2) {
    if (a1.x === a2.x || b1.x === b2.x) {
      return null;
    }

    var k1 = (a2.y - a1.y) / (a2.x - a1.x);
    var k2 = (b2.y - b1.y) / (b2.x - b1.x); // 两条线平行

    if (k1 === k2) {
      return null;
    }

    var ix = (k2 * b1.x - k1 * a1.x + a1.y - b1.y) / (k2 - k1);
    var iy = k1 * (ix - a1.x) + a1.y;
    return {
      x: ix,
      y: iy
    };
  };

  this.calculateVanishPoint = function (roadsInfo, snapshotRatio, panoWidth, panoHeight) {
    var point = _this.getIntersection(roadsInfo[0], roadsInfo[1], roadsInfo[2], roadsInfo[3]);

    if (null === point) {
      return null;
    }

    point.x += panoWidth * snapshotRatio * 0.5;
    point.y += panoHeight * snapshotRatio * 0.5;
    return point;
  };

  this.getOuterRect = function (panoWidth, panoHeight, snapshotRatio) {
    return new Rectangle(panoWidth * (snapshotRatio - 1) * 0.5, panoHeight * (snapshotRatio - 1) * 0.5, panoWidth, panoHeight);
  };

  this.transformPoint = function (point, offsetX, offsetY) {
    if (!point || undefined === point.x || undefined === point.y) {
      return point;
    }

    var newpoint = {
      x: point.x + offsetX,
      y: point.y + offsetY
    };
    return newpoint;
  };

  this.getInnerRect = function (vanishPoint, projectionRoadInfos, panoWidth, panoHeight, snapshotRatio) {
    var vanishPointInScreen = _this.transformPoint(vanishPoint, -panoWidth * 0.5 * snapshotRatio, -panoHeight * 0.5 * snapshotRatio); // 为了求内矩形框做的辅助线


    var SupportBottomPointLeft = _this.transformPoint(vanishPointInScreen, 0, BASE_BOTTOM_DISTANCE);

    var SupportBottomPointRight = _this.transformPoint(vanishPointInScreen, 10, BASE_BOTTOM_DISTANCE); // 计算辅助线和两条道路的连线，即可得到内矩形框的下面两个交点


    var bottomLeft = _this.getIntersection(projectionRoadInfos[0], projectionRoadInfos[1], SupportBottomPointLeft, SupportBottomPointRight);

    var bottomRgiht = _this.getIntersection(projectionRoadInfos[2], projectionRoadInfos[3], SupportBottomPointLeft, SupportBottomPointRight); // 上左点即为下左点向上平移固定长度


    var topLeft = _this.transformPoint(bottomLeft, 0, -(BASE_BOTTOM_DISTANCE + BASE_TOP_DISTANCE));

    var innerRect = new Rectangle(topLeft.x + panoWidth * snapshotRatio * 0.5, topLeft.y + panoHeight * snapshotRatio * 0.5, bottomRgiht.x - bottomLeft.x, BASE_TOP_DISTANCE + BASE_BOTTOM_DISTANCE);
    innerRect = _this.fixInnerRectPosition(innerRect, vanishPoint);
    innerRect = _this.fixInnerRectSize(innerRect, vanishPoint, panoWidth);
    return innerRect;
  };

  this.fixInnerRectPosition = function (innerRect, vanishPoint) {
    var fixedInnerRect = innerRect;
    var MAX_VPX_RATIO = 0.7;
    var MIN_VPX_RATIO = 0.3;
    var VPX_RATIO = (vanishPoint.x - innerRect.x) / innerRect.width;
    var fix_vpx_ratio = 0;

    if (VPX_RATIO > MAX_VPX_RATIO) {
      fix_vpx_ratio = VPX_RATIO - MAX_VPX_RATIO;
    }

    if (VPX_RATIO < MIN_VPX_RATIO) {
      fix_vpx_ratio = MIN_VPX_RATIO - VPX_RATIO;
    }

    fixedInnerRect.x = fixedInnerRect.x + fixedInnerRect.width * fix_vpx_ratio;
    return fixedInnerRect;
  };

  this.fixInnerRectSize = function (innerRect, vanishPoint, panoWidth) {
    var x;
    var y;
    var width;
    var height;
    var fixedInnerRect = innerRect;
    var WIDTH_RATIO = fixedInnerRect.width / panoWidth;
    var MAX_WIDTH_RATIO = 0.12; // 当内矩形框过宽时

    if (WIDTH_RATIO > MAX_WIDTH_RATIO) {
      var _aspect = fixedInnerRect.width / fixedInnerRect.height;

      width = panoWidth * MAX_WIDTH_RATIO;
      height = width * _aspect; // prettier-ignore

      x = fixedInnerRect.x + (fixedInnerRect.width - width) * (vanishPoint.x - fixedInnerRect.x) / fixedInnerRect.width; // prettier-ignore

      y = fixedInnerRect.y + (fixedInnerRect.height - height) * (vanishPoint.y - fixedInnerRect.y) / fixedInnerRect.height;
      fixedInnerRect = new Rectangle(x, y, width, height);
    } // 当内矩形框长宽比过大


    var aspect = fixedInnerRect.width / fixedInnerRect.height;
    var MAX_ASPECT = 1.2;
    var MIN_ASPECT = 0.9;
    height = fixedInnerRect.height;

    if (aspect > MAX_ASPECT) {
      height = fixedInnerRect.height * aspect / MAX_ASPECT;
    }

    if (aspect < MIN_ASPECT) {
      height = fixedInnerRect.height * aspect / MIN_ASPECT;
    } // 计算新的y值


    y = fixedInnerRect.y + fixedInnerRect.height - height;
    fixedInnerRect.height = height;
    fixedInnerRect.y = y;
    return fixedInnerRect;
  };

  // @TODO 当前未启用井盖，Data使用pano数据来进行计算
  this.panoData = pano.panoData;
  this.camera = pano.camera;
  this.projectionMatrix = this.camera.projectionMatrix;
  this.fov = degToRad(this.camera.fov);
  this.traverseDir = traverseDir;
  this.cameraHeading = pano.getPov().heading || 0;
  this.isMovingForward = this.angleDegreeDelta(this.cameraHeading, this.traverseDir) <= 90; // 通过panoData获取有用的数据

  this.roadWith = Math.min(this.panoData.getRoadWidth() * ROAD_WIDTH_RATIO, MAX_ROAD_WIDTH);
  this.deviceHeight = this.panoData.deviceHeight || DEFAULT_DEVICE_HEIGHT; // 视口的宽高

  this.panoWidth = pano._container.clientWidth;
  this.panoHeight = pano._container.clientHeight; // 是否使用转向角度大时的快照比例

  var needMoreTile = this.angleDegreeDelta(this.cameraHeading, this.traverseDir) > 45;
  this.snapshotRatio = needMoreTile ? DEFAULT_SNAPSHOT_RATIO : ANGLE_SNAPSHOT_RATIO; // 经过投影后的道路信息

  this.projectionRoadInfos = this.getRoad(this.roadWith, this.deviceHeight, this.projectionMatrix, this.panoWidth, this.panoHeight);
  this.vanishPoint = this.calculateVanishPoint(this.projectionRoadInfos, this.snapshotRatio, this.panoWidth, this.panoHeight);
  this.innerRect = this.getInnerRect(this.vanishPoint, this.projectionRoadInfos, this.panoWidth, this.panoHeight, this.snapshotRatio);
  this.outerRect = this.getOuterRect(this.panoWidth, this.panoHeight, this.snapshotRatio); // 相机视距

  this.focusLength = this.panoHeight * 0.5 / Math.tan(this.fov * 0.75); // 灭点在X轴上的偏移量

  this.vanishPointDeltaX = this.vanishPoint.x - this.outerRect.x - this.outerRect.width * 0.5; // 灭点在Y轴上的偏移量

  this.vanishPointDeltaY = this.vanishPoint.y - this.outerRect.y - this.outerRect.height * 0.5;
}
/**
 * 获取两个角度向量的夹角
 * @param {number} angle1  角度1
 * @param {number} angle2  角度2
 * @return {number}
 */
;

/**
 * 穿梭动画数据类
 * @class TraverseModal
 * @constructor
 *
 * @param {TraverseModal} traverseModal - 穿梭动画数据实例
 * @param {RenderTarget} textureRect  渲染快照信息
 */
// 每个面的分块信息

var PLANE_SEG_INFO = {
  FAR: [10, 10, 0],
  LEFT: [0, 10, 30],
  RIGHT: [0, 10, 30],
  TOP: [10, 0, 30],
  BOTTOM: [10, 0, 30]
}; // 面上的顶点信息

var PLANE_VERTEX_INFO = {
  FAR: ['innerTopLeftVertex', 'innerBottomRightVertex'],
  LEFT: ['outerTopLeftVertex', 'innerBottomLeftVertex'],
  RIGHT: ['innerTopRightVertex', 'outerBottomRightVertex'],
  TOP: ['outerTopLeftVertex', 'innerTopRightVertex'],
  BOTTOM: ['innerBottomLeftVertex', 'outerBottomRightVertex']
};
var POSITION_SIZE = 3;
var PLANE_TYPE = Object.keys(PLANE_SEG_INFO);

var TraverseGeometry =
/*#__PURE__*/
function (_BufferGeometry) {
  inheritsLoose(TraverseGeometry, _BufferGeometry);

  function TraverseGeometry(traverseModal, _textureRect) {
    var _this;

    _this = _BufferGeometry.call(this) || this;

    _this.createSkeleton = function (_ref) {
      var vanishPoint = _ref.vanishPoint,
          innerRect = _ref.innerRect,
          outerRect = _ref.outerRect,
          focusLength = _ref.focusLength;
      // @TODO 这个方法太长了，后续抽短一点
      // 内矩形底边到外矩形底边距离
      var m1 = outerRect.y + outerRect.height - innerRect.y - innerRect.height; // 灭点到内矩形顶边距离

      var m2 = vanishPoint.y - innerRect.y; // 灭点到内矩形左边距离

      var p1 = vanishPoint.x - innerRect.x; // 灭点到内矩形右边距离

      var p2 = innerRect.x + innerRect.width - vanishPoint.x; // 灭点到外矩形底边距离

      var vh = outerRect.y + outerRect.height - vanishPoint.y; // 模型相对深度

      var d = m1 * focusLength / (vh - m1); // 模型高度

      var h = vh + m2 * (focusLength + d) / focusLength; // 模型宽度

      var w1 = p1 * (focusLength + d) / focusLength;
      var w2 = p2 * (focusLength + d) / focusLength; // 模型顶点所需数据

      var lx = -w1; // left x

      var rx = w2; // right x

      var ty = h - vh; // top y

      var by = -vh; // bottom y

      var endz = d / 5; // 模型前沿的深度，经验值
      // inner vertex

      var innerTopLeftVertex = {
        x: lx,
        y: ty,
        z: -d
      };
      var innerTopRightVertex = {
        x: rx,
        y: ty,
        z: -d
      };
      var innerBottomRightVertex = {
        x: rx,
        y: by,
        z: -d
      };
      var innerBottomLeftVertex = {
        x: lx,
        y: by,
        z: -d
      }; // outer vertex

      var outerTopLeftVertex = {
        x: lx,
        y: ty,
        z: endz
      };
      var outerTopRightVertex = {
        x: rx,
        y: ty,
        z: endz
      };
      var outerBottomLeftVertex = {
        x: lx,
        y: by,
        z: endz
      };
      var outerBottomRightVertex = {
        x: rx,
        y: by,
        z: endz
      }; // 立方体的8个顶点

      return {
        innerTopLeftVertex: innerTopLeftVertex,
        innerBottomLeftVertex: innerBottomLeftVertex,
        innerTopRightVertex: innerTopRightVertex,
        innerBottomRightVertex: innerBottomRightVertex,
        outerTopLeftVertex: outerTopLeftVertex,
        outerTopRightVertex: outerTopRightVertex,
        outerBottomLeftVertex: outerBottomLeftVertex,
        outerBottomRightVertex: outerBottomRightVertex
      };
    };

    _this.modelSkeleton = function (cuboidVertexes, rotationMatrix) {
      var vertice = [];
      var indice = [];
      PLANE_TYPE.forEach(function (planeType) {
        var _PLANE_VERTEX_INFO$pl = slicedToArray(PLANE_VERTEX_INFO[planeType], 2),
            FROM_VERTEX = _PLANE_VERTEX_INFO$pl[0],
            TO_VERTEX = _PLANE_VERTEX_INFO$pl[1]; // 计算顶点信息


        var startIndex = vertice.length / POSITION_SIZE;
        vertice = vertice.concat(_this.calculatePlaneVertex(cuboidVertexes[FROM_VERTEX], cuboidVertexes[TO_VERTEX], planeType, rotationMatrix));
        indice = indice.concat(_this.calculateIndices(planeType, startIndex));
      });
      return [vertice, indice];
    };

    _this.calculatePlaneVertex = function (from, to, planeType, rotationMatrix) {
      var planeVertices = [];

      var _PLANE_SEG_INFO$plane = slicedToArray(PLANE_SEG_INFO[planeType], 3),
          X_SEG = _PLANE_SEG_INFO$plane[0],
          Y_SEG = _PLANE_SEG_INFO$plane[1],
          Z_SEG = _PLANE_SEG_INFO$plane[2];

      var GRID_X = _this.linerInterpolate(from.x, to.x, X_SEG);

      var GRID_Y = _this.linerInterpolate(from.y, to.y, Y_SEG);

      var GRID_Z = _this.linerInterpolate(from.z, to.z, Z_SEG);

      var transVec4;

      for (var i = 0; i <= X_SEG; i++) {
        for (var j = 0; j <= Y_SEG; j++) {
          for (var k = 0; k <= Z_SEG; k++) {
            transVec4 = fromValues$4(GRID_X[i], GRID_Y[j], GRID_Z[k], 1);
            transformMat4$2(transVec4, transVec4, rotationMatrix);
            transVec4[0] = transVec4[0] / transVec4[3];
            transVec4[1] = transVec4[1] / transVec4[3];
            transVec4[2] = transVec4[2] / transVec4[3];
            planeVertices.push(transVec4[0], transVec4[1], transVec4[2]);
          }
        }
      }

      return planeVertices;
    };

    _this.calculateIndices = function (planeType, startIndex) {
      var indice = [];
      var segmentInfo = PLANE_SEG_INFO[planeType];
      segmentInfo = segmentInfo.filter(function (i) {
        return i > 0;
      });

      var _segmentInfo = segmentInfo,
          _segmentInfo2 = slicedToArray(_segmentInfo, 2),
          col = _segmentInfo2[0],
          row = _segmentInfo2[1];

      var index0 = 0;
      var index1 = 0;
      var index2 = 0;
      var index3 = 0;

      for (var i = 0; i < col; i++) {
        for (var j = 0; j < row; j++) {
          index0 = startIndex + (row + 1) * i + j;
          index1 = index0 + 1;
          index2 = index0 + row + 1;
          index3 = index2 + 1;
          indice.push(index0, index2, index3);
          indice.push(index0, index3, index1);
        }
      }

      return indice;
    };

    _this.linerInterpolate = function (from, to, seg) {
      var out = [];

      if (seg <= 0) {
        out.push(from);
      } else {
        var delta = (to - from) / seg;

        for (var i = 0; i <= seg; i++) {
          out[i] = from + delta * i;
        }
      }

      return out;
    };

    _this.calculateUVCoordinate = function (_ref2, textureRect, vertices) {
      var camera = _ref2.camera,
          panoWidth = _ref2.panoWidth,
          panoHeight = _ref2.panoHeight,
          vanishPointDeltaX = _ref2.vanishPointDeltaX,
          vanishPointDeltaY = _ref2.vanishPointDeltaY;
      var uvtArray = [];
      var textureWidth = textureRect.width;
      var textureHeight = textureRect.height;
      var screenX = 0;
      var screenY = 0;
      var textureX = 0;
      var textureY = 0;
      var u = 0;
      var v = 0;
      var len = vertices.length / POSITION_SIZE;
      var transVec4;

      for (var i = 0; i < len; i++) {
        transVec4 = fromValues$4(vertices[i * 3], vertices[i * 3 + 1], vertices[i * 3 + 2], 1); // 变换贴图坐标，让贴图后的立方体符合其形状

        transformMat4$2(transVec4, transVec4, camera.viewMatrix);
        transformMat4$2(transVec4, transVec4, camera.projectionMatrix); // 向量归一化

        transVec4[0] = transVec4[0] / transVec4[3];
        transVec4[1] = transVec4[1] / transVec4[3];
        transVec4[2] = transVec4[2] / transVec4[3];
        transVec4[3] = 1; // 屏幕坐标（离屏幕中心的坐标）

        screenX = transVec4[0] * panoWidth * 0.5 + vanishPointDeltaX;
        screenY = transVec4[1] * panoHeight * 0.5 + vanishPointDeltaY; // 贴图材质坐标

        textureX = screenX + textureWidth * 0.5;
        textureY = screenY + textureHeight * 0.5; // uv坐标

        u = textureX / textureWidth;
        v = textureY / textureHeight; // uv校正，然后添加到uv数组中

        uvtArray.push(_this.getValidateUV(u), _this.getValidateUV(v));
      }

      return new Float32Array(uvtArray);
    };

    _this.getValidateUV = function (value) {
      var MIN_VALUE = -0.1;
      var MAX_VALUE = 1.1;
      return Math.max(MIN_VALUE, Math.min(MAX_VALUE, value));
    };

    _this.rotationMatrix = create$3();
    _this.camera = traverseModal.camera; // 判断下是否在当前视角下点击了向后的箭头方向

    if (traverseModal.isMovingForward) {
      rotateY$1(_this.rotationMatrix, _this.rotationMatrix, degToRad(degreeNormalized(-traverseModal.traverseDir + traverseModal.panoData.heading)));
    } else {
      var newTraverseDir = degreeNormalized(180 - traverseModal.traverseDir + traverseModal.panoData.heading);
      rotateY$1(_this.rotationMatrix, _this.rotationMatrix, degToRad(newTraverseDir));
    } // 计算骨架


    _this.cuboidVertexes = _this.createSkeleton(traverseModal); // 由骨架得到几何的顶点和索引信息

    var _this$modelSkeleton = _this.modelSkeleton(_this.cuboidVertexes, _this.rotationMatrix),
        _this$modelSkeleton2 = slicedToArray(_this$modelSkeleton, 2),
        _vertice = _this$modelSkeleton2[0],
        indices = _this$modelSkeleton2[1];

    _this.verticesBufferData = new Float32Array(_vertice);
    _this.indicesBufferData = new Uint16Array(indices);
    _this.uvtsBufferData = _this.calculateUVCoordinate(traverseModal, _textureRect, _vertice, _this.rotationMatrix);

    _this.setAttribute('position', new Float32ArrayAttribute(_this.verticesBufferData, 3));

    _this.setAttribute('uv', new Float32ArrayAttribute(_this.uvtsBufferData, 2));

    _this.setIndexes(_this.indicesBufferData);

    return _this;
  }
  /**
   * 构建出立方体,输出长方体方体的8个顶点信息
   * @param {Object} vanishPoint   灭点的位置
   * @param {Object} innerRect     内矩形框
   * @param {Object} outerRect    外矩形框
   * @param {Object} focusLength  视野焦距长度
   * @return {Object}
   */


  return TraverseGeometry;
}(BufferGeometry);

/**
 * @file 街景穿梭过渡效果
 * @author mawenjie01<mawenjie01@baidu.com>
 */
var SHOW_DEBUG_LINE = true;
var DEBUG_LINE_COLOR = [0.0, 1.0, 0.0, 0.5];
/**
 * 穿梭动画类
 * @class TraverseAnimation
 * @constructor
 *
 * @param {PanoViwer} pano - 全景实例
 * @param {number} distance - 相机移动距离
 * @param {RenderTarget} snapshot   快照实例
 * @param {number} traverseDir 穿梭动画的方向
 * @param {handleEnd} handleEnd - 动画结束的回调
 */

var TraverseAnimation =
/*#__PURE__*/
function () {
  function TraverseAnimation(pano, distance, snapshot, traverseDir, handleEnd) {
    var _this = this;

    this.start = function () {
      _this.animation.start();

      _this._pano.dispatchEvent({
        debug: true,
        log: '淡出动画，渲染一帧',
        type: EVENT_TYPE.REFRESH
      });
    };

    this.update = function () {
      _this.animation.update();
    };

    this._pano = pano;
    this.distance = distance;
    this.handleEnd = handleEnd;
    this.traverseDir = traverseDir;
    this.snapshot = snapshot;
    this.camera = pano.camera;
    this.scene = this.initScene();
    this.rotationMatrix = this.traverseGeometry.rotationMatrix;
    this.initAni();
  }

  var _proto = TraverseAnimation.prototype;

  _proto.initAni = function initAni() {
    var _this2 = this;

    var targetPositionBase = fromValues$1(0, 0, this.distance);
    transformMat4$1(targetPositionBase, targetPositionBase, this.rotationMatrix);
    this.animation = new Tween(0, 1, 700, Transitions.linear).onUpdate(function (value) {
      // this.material.uniforms.uOpacity.value = 1.7 - value;
      var targetPosition = create$1();
      scale$1(targetPosition, targetPositionBase, value);

      _this2.scene.traverse(function (mesh) {
        mesh.position = targetPosition;
        mesh.updateWorldMatrix(true);
      });

      _this2._pano.dispatchEvent({
        debug: true,
        type: EVENT_TYPE.REFRESH,
        log: '[Refresh Log] 前进动画， 渲染一帧'
      });
    }).onEnd(function () {
      _this2.handleEnd && _this2.handleEnd();

      _this2._pano.dispatchEvent({
        debug: true,
        type: EVENT_TYPE.REFRESH,
        log: '[Refresh Log] 前进动画， 渲染一帧'
      });
    });
  }
  /**
   * 初始化场景
   */
  ;

  _proto.initScene = function initScene() {
    var scene = new Scene();

    var _this$_pano$getContai = this._pano.getContainerSize(),
        viewportWidth = _this$_pano$getContai.width,
        viewportHeight = _this$_pano$getContai.height; // 构建几何模型的基本参数


    var traverseModal = new TraverseModal(this._pano, this.traverseDir); // 穿梭几何需要的纹理方框

    var Rect = new Rectangle(0, 0, viewportWidth, viewportHeight);
    var traverseGeometry = new TraverseGeometry(traverseModal, Rect);
    var material = this.initMaterial();
    var mesh = new Mesh(traverseGeometry, material);
    this.traverseGeometry = traverseGeometry;
    scene.add(mesh);
    return scene;
  }
  /**
   * 初始化纹理贴图
   */
  ;

  _proto.initMaterial = function initMaterial() {
    var material = new Material();
    material.depthTest = false;
    material.vertexShader = TRAVERSE_VS_SHADER_TEXT;
    material.fragmentShader = TRAVERSE_FS_SHADER_TEXT;
    material.uniforms = {
      uSampler: {
        type: 't',
        value: this.snapshot
      },
      uOpacity: {
        type: '1f',
        value: 1.0
      },
      vColor: {
        type: '4f',
        value: DEBUG_LINE_COLOR
      },
      showDebugLine: {
        type: '1i',
        value: SHOW_DEBUG_LINE
      }
    };
    this.material = material;
    return material;
  }
  /**
   * 启动穿梭动画
   */
  ;

  return TraverseAnimation;
}();

/**
 * @file 关于像素坐标类文件.
 * @author quda
 */

/**
 * 以像素坐标表示的地图上的一点
 * @class
 * @constructor
 * @param {Number} x 屏幕像素坐标x
 * @param {Number} y 屏幕像素坐标y
 */
var Pixel =
/*#__PURE__*/
function () {
  function Pixel() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    this.x = x;
    this.y = y;
  }

  var _proto = Pixel.prototype;

  _proto.equals = function equals(other) {
    return other && other.x === this.x && other.y === this.y;
  };

  return Pixel;
}();

/**
 * @file 场景切换动效处理
 * @author quda
 */

var SceneChange =
/*#__PURE__*/
function () {
  function SceneChange(pano, snapshotFn) {
    var _this = this;

    this.setData = function (data, nextData) {
      _this.panoData = data;
      _this.nextPanoData = nextData;
    };

    this.sceneChangeHandler = function () {
      // 必须有前后场景数据才可以做切换动效
      if (!_this.panoData || !_this.nextPanoData) {
        return;
      }

      return new Promise(function (resolve) {
        var isCurStreet = _this.isStreet(_this.panoData.panoType);

        var isNextStreet = _this.isStreet(_this.nextPanoData.panoType);

        var curSnapshot = _this.snapshotFn();

        var animationType = _this.pano.animationType;
        var animationTypes = ['waterwave', 'fade'];

        if (animationType && animationTypes.indexOf(animationType) > -1) {
          switch (animationType) {
            case 'waterwave':
              _this.prepareWaterWave(curSnapshot);

              resolve();
              break;

            case 'fade':
              _this.prepareFade(curSnapshot);

              resolve();
              break;
          }

          return;
        }

        if (isNextStreet && isCurStreet) {
          // 前后均为街景才启动穿梭效果
          _this.setDir();

          _this.prepareTraverse(curSnapshot).then(function (snapshot) {
            _this.prepareFade(snapshot);

            resolve();
          }); // this.prepareJump().then(() => {
          //     this.prepareFade();
          //     resolve();
          // });

        } else {
          // 淡出效果
          _this.prepareFade(curSnapshot);

          resolve();
        }
      });
    };

    this.setSnapshot = function (snapshot) {
      _this.snapshot = snapshot;
    };

    /**
     * 全景引擎实例
     * @property
     * @type {Pano}
     */
    this.pano = pano;
    /**
     * 作为纹理的截图函数
     * @property
     * @type {Function}
     */

    this.snapshotFn = snapshotFn;
    /**
     * 当前场景全景数据
     * @property
     * @type {Object | null}
     */

    this.panoData = null;
    /**
     * 下一场景全景数据
     * @property
     * @type {Object | null}
     */

    this.nextPanoData = null;
    /**
     * 场景切换动画
     * @property
     * @type {Tween | null}
     */

    this.changeAni = null;
    /**
     * 动画朝向
     * @property
     * @type {number}
     */

    this.animateDir = 0;
  }
  /**
   * 接收当前场景和下一场景的全景数据
   * @param {PanoData} data - 当前场景数据
   * @param {PanoData} nextData - 下一场景数据
   */


  var _proto = SceneChange.prototype;

  /**
   * 响应帧渲染
   * 供主渲染器调用
   */
  _proto.draw = function draw() {
    if (this.changeAni) {
      var _this$changeAni = this.changeAni,
          scene = _this$changeAni.scene,
          camera = _this$changeAni.camera;
      this.changeAni.update();
      this.pano.renderer.render(scene, camera);
    }
  }
  /**
   * 设置动画朝向
   * 取下一场景在当前场景中的偏移角度，一般是道路箭头的方向
   * @private
   */
  ;

  _proto.setDir = function setDir() {
    // 必须有前后场景数据才可以做切换动效
    if (!this.panoData || !this.nextPanoData) {
      return;
    }

    var nextPid = this.nextPanoData.panoId;
    var curLinks = this.panoData.getTopos();
    var linkInfo = curLinks.filter(function (link) {
      return link && link.panoId === nextPid;
    });

    if (linkInfo.length) {
      var topoDir = linkInfo[0].topoDir; // const refineDir = degreeNormalized(topoDir + this.panoData.northDir);

      this.animateDir = topoDir;
    } else {
      // 没有关联关系的采用前一场景的heading 作为方向
      this.animateDir = this.pano.getPov().heading || 0;
    }
  }
  /**
   * 场景切换动画
   * @public
   * @return {Promise} - 场景切换动画状态
   */
  ;

  /**
   * 处理穿梭动画，负责相机向前移动
   * @return {Promise} - 穿梭动画状态
   */
  _proto.prepareJump = function prepareJump() {
    var _this2 = this;

    var distance = this.calcJumpDistance();
    return new Promise(function (resolve) {
      _this2.changeAni = new JumpAnimation(_this2.pano, _this2.animateDir, distance, function () {
        _this2.changeAni = null;
        resolve();
      });

      _this2.changeAni.startAni();

      _this2.pano.dispatchEvent({
        debug: true,
        log: '穿梭动画，渲染一帧',
        type: EVENT_TYPE.REFRESH
      });
    });
  }
  /**
   * 处理穿梭动画，负责相机向前移动
   * @param {WebGlRenderTarget} snapshot 获取的截屏信息
   * @return {Promise} - 穿梭动画Promise，动画结束时返回动画最后一帧截图，用作Fade输入
   */
  ;

  _proto.prepareTraverse = function prepareTraverse(snapshot) {
    var _this3 = this;

    var distance = this.calcJumpDistance();
    return new Promise(function (resolve) {
      _this3.changeAni = new TraverseAnimation(_this3.pano, distance, snapshot, _this3.animateDir, function () {
        var snapshotForFade = _this3.snapshotFn(_this3.changeAni.scene, _this3.changeAni.camera);

        resolve(snapshotForFade);
        _this3.changeAni = null;
      });

      _this3.changeAni.start();

      _this3.pano.dispatchEvent({
        debug: true,
        log: '穿梭动画，渲染一帧',
        type: EVENT_TYPE.REFRESH
      });
    });
  }
  /**
   * 准备淡出动画
   * @private
   * @param {WebGlRenderTarget} snapshot - 获取的截屏信息
   */
  ;

  _proto.prepareFade = function prepareFade(snapshot) {
    var _this4 = this;

    this.changeAni = new FadeAnimation(this.pano, snapshot, function () {
      _this4.changeAni = null; // FIXME: 暂时写死，后续优化

      _this4.pano.emit(EVENT_TYPE.SCENE_CHANGE_END);
    });
  }
  /**
   * 水波纹动画
   * @private
   * @param {WebGlRenderTarget} snapshot - 获取的截屏信息
   */
  ;

  _proto.prepareWaterWave = function prepareWaterWave(snapshot) {
    var _this5 = this;

    this.changeAni = new WaterWaveAnimation(this.pano, snapshot, function () {
      _this5.changeAni = null; // FIXME: 暂时写死，后续优化

      _this5.pano.emit(EVENT_TYPE.SCENE_CHANGE_END);
    });
  }
  /**
   * 计算穿梭距离
   * @return {number} - 距离
   */
  ;

  _proto.calcJumpDistance = function calcJumpDistance() {
    var distanceBase = 300;
    var distance = distanceBase;
    var distanceToNextPano = getDistanceByPixel(new Pixel(this.panoData.panoX, this.panoData.panoY), new Pixel(this.nextPanoData.panoX, this.nextPanoData.panoY));

    if (typeof distanceToNextPano === 'number') {
      var factor = Math.pow(distanceToNextPano, 1 / 4);
      distance *= factor;
    }

    return distance;
  }
  /**
   * 是否为街景
   * @param {string} panoType - 全景类型 street | inner
   * @return {boolean} 是否为街景
   */
  ;

  _proto.isStreet = function isStreet(panoType) {
    return panoType === ConstantConfig.TYPE_STREET;
  };

  return SceneChange;
}();

var OpeningAnimation =
/*#__PURE__*/
function () {
  function OpeningAnimation(pano, _ref) {
    var _ref$fov = _ref.fov,
        fov = _ref$fov === void 0 ? 145 : _ref$fov,
        _ref$cameraY = _ref.cameraY,
        cameraY = _ref$cameraY === void 0 ? 3000 : _ref$cameraY,
        handleEnd = _ref.handleEnd;
    this._pano = void 0;
    this.originFov = void 0;
    this.originRotateX = void 0;
    this.originRotateY = void 0;
    this.targetFov = void 0;
    this.targetCameraY = void 0;
    this.handleEnd = void 0;
    this.animate = void 0;
    this._pano = pano;
    this.originFov = this.camera.fov;
    this.originRotateX = this.camera.rotation.x;
    this.originRotateY = this.camera.rotation.y;
    this.targetFov = fov;
    this.targetCameraY = cameraY;
    this.handleEnd = handleEnd;
    this.init();
  }

  var _proto = OpeningAnimation.prototype;

  _proto.start = function start() {
    this._pano.dispatchEvent({
      type: EVENT_TYPE.REFRESH,
      debug: true,
      log: '开场动画动画起始，渲染一帧'
    });

    this.animate.start();
  };

  _proto.update = function update() {
    this.animate.update();
  }
  /**
   * 开场动画初始化
   * @private
   */
  ;

  _proto.init = function init() {
    var _this = this;

    var camera = this.camera; // 预设

    this.handleCameraChange(0);
    this.animate = new Tween(0, 1, ConstantConfig.FISHEYE_DURATION, Transitions.easeInOutQuad).onUpdate(function (value) {
      _this.handleCameraChange(value);

      _this._pano.dispatchEvent({
        type: EVENT_TYPE.REFRESH,
        debug: true,
        log: '开场动画动画，渲染一帧'
      });
    }).onEnd(function () {
      // 恢复原有设置
      camera.fov = _this.originFov;
      camera.rotateX(_this.originRotateX);
      camera.rotateY(_this.originRotateY);
      camera.setPosition(0, 0, 0);
      camera.updateWorldMatrix();
      camera.updateProjectionMatrix();

      _this._pano.dispatchEvent({
        type: EVENT_TYPE.REFRESH,
        debug: true,
        log: '开场动画动画结束，渲染一帧'
      });

      _this.handleEnd();
    });
  };

  _proto.handleCameraChange = function handleCameraChange(value) {
    var targetRotateX = -90; // 垂直向下，看球底部

    var camera = this.camera;
    var targetCameraY = this.targetCameraY;
    var fovy = this.targetFov - (this.targetFov - this.originFov) * value;
    var rotateX = targetRotateX + (this.originRotateX - targetRotateX) * value;
    var rotateY = this.originRotateY * value;
    camera.fov = fovy;
    camera.rotateX(rotateX);
    camera.rotateY(rotateY);
    camera.setPosition(0, targetCameraY - targetCameraY * value, 0);
    camera.updateWorldMatrix();
    camera.updateProjectionMatrix();
  };

  createClass(OpeningAnimation, [{
    key: "camera",
    get: function get() {
      return this._pano.camera;
    }
  }]);

  return OpeningAnimation;
}();

/**
 * @file 全景覆盖物管理类
 * @author quda
 */
var PanoOverlayManager =
/*#__PURE__*/
function () {
  /**
   * 覆盖物集合
   * @property
   */

  /**
   * 全景数据返回标识
   * @type {boolean}
   */
  function PanoOverlayManager(pano) {
    var _this = this;

    this.name = 'PanoOverlayManager';
    this.overlays = [];
    this.pano = void 0;
    this.isReady = false;

    this.clickChecker = function (x, y) {
      var checker = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _this.overlays[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var overlay = _step.value;
          var dom = overlay.dom;

          var _dom$getBoundingClien = dom.getBoundingClientRect(),
              left = _dom$getBoundingClien.left,
              right = _dom$getBoundingClien.right,
              top = _dom$getBoundingClien.top,
              bottom = _dom$getBoundingClien.bottom;

          if (x >= left && x <= right && y >= top && y <= bottom) {
            checker = false;
            overlay.handleClick();
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return checker;
    };

    this.pano = pano;
  }
  /**
   * 响应覆盖物添加事件
   * @public
   * @param {PanoOverlay} overlay - 覆盖物实例
   */


  var _proto = PanoOverlayManager.prototype;

  _proto.handleAdd = function handleAdd(overlay) {
    if (!overlay || !overlay.id) {
      return;
    }

    var isExist = this.overlays.some(function (item) {
      return item.id === overlay.id;
    });

    if (isExist) {
      return;
    }

    this.overlays.push(overlay);

    if (this.isReady) {
      overlay.init(this.pano);
    }
  }
  /**
   * 响应覆盖物移除事件
   * @public
   * @param {PanoOverlay} overlay - 覆盖物实例
   */
  ;

  _proto.handleRemove = function handleRemove(overlay) {
    for (var i = 0; i < this.overlays.length; i++) {
      if (this.overlays[i].id === overlay.id) {
        this.overlays[i].remove();
        this.overlays.splice(i, 1);
        return;
      }
    }
  }
  /**
   * 初始化全部覆盖物
   * data_load时调用
   * @public
   */
  ;

  _proto.init = function init() {
    this.isReady = true;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = this.overlays[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var overlay = _step2.value;
        overlay.init(this.pano);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
          _iterator2["return"]();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
  /**
   * 渲染覆盖物
   * 供GLRender调用
   * @public
   */
  ;

  _proto.draw = function draw() {
    if (!this.isReady) {
      return;
    }

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = this.overlays[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var overlay = _step3.value;
        overlay.draw();
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
          _iterator3["return"]();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }
  /**
   * 点击事件校验
   * @param {number} x - 屏幕坐标X
   * @param {number} y - 屏幕坐标Y
   * @return {boolean} - 校验结果，是否继续响应原生点击事件
   */
  ;

  /**
   * 销毁
   */
  _proto.destroy = function destroy() {
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = this.overlays[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var overlay = _step4.value;
        overlay.remove();
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
          _iterator4["return"]();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    this.overlays = [];
  };

  return PanoOverlayManager;
}();

var PanoGLRender =
/*#__PURE__*/
function () {
  /**
   * 全景实例
   * @private
   */

  /**
   * 渲染进程ID
   * @type {number}
   */

  /**
   * RAF ID
   * @type {number}
   */

  /**
   * 是否运行渲染进程
   * @type {boolean}
   */
  function PanoGLRender(pano) {
    var _this = this;

    this.renderer = void 0;
    this.gl = void 0;
    this.camera = void 0;
    this.cameraNoFix = null;
    this.panoData = null;
    this.scene = void 0;
    this.sceneChange = void 0;
    this.openingAni = void 0;
    this.sphereRender = void 0;
    this.linkGLRender = void 0;
    this.overlayManager = void 0;
    this.skyboxRender = void 0;
    this.pano = void 0;
    this.renderThreadId = null;
    this.requestId = null;
    this.isRAFRuning = false;

    this.setData = function _callee(data) {
      var isCube, mainRender;
      return regenerator.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (data) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (!(_this.panoData && _this.pano.useAnimation)) {
                _context.next = 8;
                break;
              }

              _this.sceneChange.setData(_this.panoData, data);

              _context.next = 6;
              return regenerator.awrap(_this.sceneChange.sceneChangeHandler());

            case 6:
              if (_this.pano.backupUseAnimation !== undefined) {
                _this.pano.useAnimation = _this.pano.backupUseAnimation;
              }

              _this.pano.animationType = '';

            case 8:
              _this.reset();

              _this.panoData = data;
              _this.pano.panoData = data; // 设置指定的默认视角

              if (_typeof_1(data.defaultHeading) !== void 0 || _typeof_1(data.defaultPitch) !== void 0) {
                _this.pano.handlePovChange({
                  heading: data.defaultHeading,
                  pitch: data.defaultPitch
                });
              }

              isCube = data.image && data.image.length === 6; // 是否为天空盒模式

              mainRender = isCube ? _this.skyboxRender : _this.sphereRender; // 主场景渲染器
              // 传递数据给子render

              mainRender.setData(data);

              _this.linkGLRender.setData(data);

              _this.overlayManager.init();

              _this.scene.add(mainRender.meshs); // 初始化当前场景相机矩阵信息


              _this.updateProjectionMatrix(_this.camera);

              _this.updateCameraHeadingAndPitch(_this.camera);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      });
    };

    this.getSnapshot = function (scene, camera) {
      scene = scene || _this.scene;
      camera = camera || _this.camera;

      var _this$pano$getContain = _this.pano.getContainerSize(),
          width = _this$pano$getContain.width,
          height = _this$pano$getContain.height;

      var renderTarget = new WebGLRenderTarget(width, height);
      renderTarget.premultiplyAlpha = true; // 渲染当前的一帧

      _this.renderer.render(scene, camera, renderTarget);

      return renderTarget;
    };

    this.update = function () {
      if (!_this.panoData) {
        return;
      }

      _this.sphereRender.update();

      _this.linkGLRender.update();

      _this.startRenderThread();
    };

    this.onThumbLoaded = function () {
      if (_this.sceneChange.changeAni) {
        _this.sceneChange.changeAni.start();
      } // // 初始化当前场景相机矩阵信息
      // this.updateProjectionMatrix(this.camera);
      // this.updateCameraHeadingAndPitch(this.camera);
      // 此时渲染道路箭头


      var linkMesh = _this.linkGLRender.meshs;
      linkMesh && _this.scene.add(linkMesh);

      _this.startFishEyeAni();
    };

    this.startRenderThread = function () {
      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;

      if (_this.renderThreadId) {
        clearTimeout(_this.renderThreadId);
        _this.renderThreadId = null;
      }

      _this.renderThreadId = window.setTimeout(function () {
        _this.isRAFRuning = false;
        _this.renderThreadId = null;
      }, duration);

      if (_this.isRAFRuning) {
        return;
      }

      _this.isRAFRuning = true;

      _this.renderFrame();
    };

    this.resize = function () {
      var container = _this.pano.getContainer();

      _this.renderer.setSize(container.clientWidth, container.clientHeight);
    };

    var pixelRatio = getDeviceRatio();

    var _container = pano.getContainer();

    this.pano = pano;
    this.renderer = new WebGLRenderer({
      premultipliedAlpha: false,
      preserveDrawingBuffer: pano.opts.enableCapture || false,
      antialias: !(pixelRatio > 1),
      pixelRatio: pixelRatio,
      width: _container.clientWidth,
      height: _container.clientHeight
    });
    this.renderer.setSize(_container.clientWidth, _container.clientHeight);
    pano.getPanes().tileLayer.appendChild(this.renderer.domElement);
    this.gl = this.renderer.getContext(); // webgl上下文

    this.camera = new PerspectiveCamera(75, _container.clientWidth / _container.clientHeight, 0.01, 67000);
    this.scene = new Scene(); // 在pano实例上注入gl & camera

    pano.gl = this.gl;
    pano.canvas = this.renderer.domElement;
    pano.scene = this.scene;
    pano.camera = this.camera;
    pano.cameraNoFix = this.cameraNoFix; // FIXME: 临时注入

    pano.renderer = this.renderer;
    pano.renders = []; // 子渲染器
    // 场景切换动画实例

    this.sceneChange = new SceneChange(pano, this.getSnapshot);
    this.initModule();
  }
  /**
   * 动画过程不响应视图更新
   * @type {boolean}
   */


  var _proto = PanoGLRender.prototype;

  /**
   * 临时方法
   * @private
   */
  _proto.initModule = function initModule() {
    var pano = this.pano;
    this.sphereRender = new SphereRender(pano);
    this.linkGLRender = new PanoLinkRender(pano);
    this.overlayManager = new PanoOverlayManager(pano);
    this.skyboxRender = new SkyboxRender(pano);
    this.pano.renders.push(this.sphereRender, this.linkGLRender, this.overlayManager, this.skyboxRender);
  }
  /**
   * 重置当前全景场景
   * @public
   */
  ;

  _proto.reset = function reset() {
    this.scene.remove(this.sphereRender.meshs);
    this.scene.remove(this.linkGLRender.meshs);
  }
  /**
   * 获取指定的渲染器实例
   * @param {string} id - 渲染器Class类名
   * @return {ModuleInstance | null} - 渲染器实例
   */
  ;

  _proto.getModule = function getModule(id) {
    var target = null;
    var renders = this.pano.renders;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = renders[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var render = _step.value;

        if (render.name === id) {
          target = render;
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return target;
  }
  /**
   * 设置数据入口
   * @param {Object} data - 街景数据
   */
  ;

  /**
   * 渲染帧
   */
  _proto.renderFrame = function renderFrame() {
    if (this.isRAFRuning === false) {
      if (this.requestId) {
        cancelAnimationFrame(this.requestId);
        this.requestId = null;
      }

      return;
    }

    if (this.openingAni) {
      this.openingAni.update();
    } // 更新球面瓦片Mesh


    this.sphereRender.draw(); // 全景主场景渲染

    this.renderer.render(this.scene, this.camera);
    /**
     * 覆盖物渲染
     * TODO: 覆盖物支持GL渲染，可以放到主场景渲染中，控制主Scene内顺序
     */

    this.overlayManager.draw(); // 过渡动画渲染

    this.sceneChange.draw();
    this.requestId = requestAnimationFrame(this.renderFrame.bind(this));
  }
  /**
   * 开启鱼眼动画
   * @private
   */
  ;

  _proto.startFishEyeAni = function startFishEyeAni() {
    var _this2 = this;

    if (this.pano.fisheye) {
      this.openingAni = new OpeningAnimation(this.pano, {
        handleEnd: function handleEnd() {
          _this2.openingAni = null;
          _this2.pano.fisheye = false;
        }
      });
      setTimeout(function () {
        _this2.openingAni.start();

        _this2.startRenderThread();
      }, ConstantConfig.FISHEYE_DELAY);
    }
  }
  /**
   * 更新相机投影矩阵
   * @private
   * @TODO: 只有场景初始化 & 缩放 & 视口resize时变更
   * @param {Camera} camera - 相机实例
   * @param {number} viewZoom - [可选]场景级别
   */
  ;

  _proto.updateProjectionMatrix = function updateProjectionMatrix(camera, viewZoom) {
    var fovy = this.pano.getFov(viewZoom);

    var _this$pano$getContain2 = this.pano.getContainerSize(),
        width = _this$pano$getContain2.width,
        height = _this$pano$getContain2.height;

    var widthHeightRatio = width / height;
    camera.fov = fovy;
    camera.aspect = widthHeightRatio;
    camera.updateProjectionMatrix();
  }
  /**
   * 更新相机模型视图矩阵
   * @param {Camera} camera - 相机实例
   */
  ;

  _proto.updateCameraHeadingAndPitch = function updateCameraHeadingAndPitch(camera) {
    var _this$pano$getPov = this.pano.getPov(),
        heading = _this$pano$getPov.heading,
        pitch = _this$pano$getPov.pitch;

    var _ref = this.panoData,
        _ref$fixHeading = _ref.fixHeading,
        fixHeading = _ref$fixHeading === void 0 ? 0 : _ref$fixHeading,
        _ref$fixPitch = _ref.fixPitch,
        fixPitch = _ref$fixPitch === void 0 ? 0 : _ref$fixPitch,
        _ref$fixRoll = _ref.fixRoll,
        fixRoll = _ref$fixRoll === void 0 ? 0 : _ref$fixRoll; // FIXME: clone()会导致camera参数异常
    // 道路箭头不需要修正 Pitch & Roll
    // this.cameraNoFix = camera.clone();
    // this.cameraNoFix.rotateY(degToRad(-fixHeading + heading));
    // this.cameraNoFix.rotateX(degToRad(-pitch));
    // this.cameraNoFix.updateWorldMatrix();

    camera.rotateX(pitch - fixPitch);
    camera.rotateY(-heading + fixHeading);
    camera.rotateZ(fixRoll); // 缩略图未加载前不会触发相机更新，此处手动触发

    camera.updateWorldMatrix();
  }
  /*
   * 安全执行,会判断该模块是否已启动,启动则使用args执行指定的command
   * @param {string} id - 模块Class类名
   * @param {string} callFunc - 函数名
   * @params {Array} args 传递给接口的参数
   * @return {undefined} 返回执行结果或undefined
   */
  ;

  _proto.safeCall = function safeCall(id, callFunc, args) {
    var m = this.getModule(id);

    if (m && m[callFunc]) {
      return m[callFunc].apply(m, args || []);
    }

    throw new Error("[safeCall] get module error => ".concat(id));
  }
  /**
   * 容器尺寸变更响应
   * @public
   */
  ;

  createClass(PanoGLRender, [{
    key: "isCanUpdate",
    get: function get() {
      var hasSceneChange = this.sceneChange.changeAni; // 场景切换动画

      var hasOpeningAni = this.openingAni; // 开场动画 - 鱼眼动画

      return this.panoData && !(hasSceneChange || hasOpeningAni);
    }
  }]);

  return PanoGLRender;
}();

/**
 * @file 全景手势操作类
 * @author quda
 */

var PanoOperation =
/*#__PURE__*/
function () {
  function PanoOperation(pano) {
    var _this = this;

    this.updateAnglePerPixel = function () {
      _this._anglePerPixel = _this._pano.calcAnglePerPixel();
    };

    this.destroy = function () {
      _this.bindEvent(false);
    };

    this._pano = pano;
    this._displayZoom = pano.getZoom();
    this._anglePerPixel = pano.calcAnglePerPixel();
    this.lock = false; // 状态锁

    this.clickTimer = null; // 双击事件定时器ID

    this.dragAni = null; // 惯性动画

    this.state = {
      initPos: null,
      initHeading: 0,
      initPitch: 0,
      lastDiffPos: null,
      moveDiffPos: null,
      isTouchDown: false,
      isTouchMove: false,
      startTime: 0,
      lastMoveTime: 0 // 最后一次移动的时间

    };
  }

  var _proto = PanoOperation.prototype;

  _proto.init = function init() {
    // init once
    if (this._initialized) {
      return;
    }

    this._initialized = true;
    this.isMobile = navigator.userAgent.toLowerCase().match(/ipod|ipad|iphone|android/);

    if (this.isMobile) {
      this.EVENTS = {
        START: 'touchstart',
        MOVING: 'touchmove',
        END: 'touchend',
        OUT: 'touchcancel',
        WHEEL: 'gesturechange',
        // 兼容火狐的滚动事件
        DOMMouseScroll: 'DOMMouseScroll'
      };

      this.getPagePosition = function (e) {
        var evt = e.touches.length > 0 ? e.touches[0] : e.changedTouches[0];
        return {
          x: evt.pageX,
          y: evt.pageY
        };
      };
    } else {
      this.EVENTS = {
        START: 'mousedown',
        MOVING: 'mousemove',
        END: 'mouseup',
        OUT: 'mouseout',
        WHEEL: 'mousewheel'
      };

      this.getPagePosition = function (e) {
        return {
          x: e.pageX,
          y: e.pageY
        };
      };
    }

    this.bindEvent();
  }
  /**
   * 事件绑定or解绑
   * @param {boolean} isBind - 绑定or解绑 默认为true
   */
  ;

  _proto.bindEvent = function bindEvent() {
    var isBind = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var body = document.body;
    var _this$EVENTS = this.EVENTS,
        START = _this$EVENTS.START,
        MOVING = _this$EVENTS.MOVING,
        END = _this$EVENTS.END;
    var _svContainer = this._pano._svContainer;
    var listenerType = isBind ? 'addEventListener' : 'removeEventListener';

    _svContainer[listenerType](START, this.handleDown.bind(this));

    _svContainer[listenerType](MOVING, this.handleMove.bind(this));

    body[listenerType](END, this.handleUp.bind(this));
  }
  /**
   * 手势点击起始事件
   * @param {Event} e - 事件参数
   */
  ;

  _proto.handleDown = function handleDown(e) {
    // TODO: tileRender moving的时候不响应点击
    // 判断当前如果有惯性效果 则停止惯性
    if (this.dragAni) {
      this.dragAni.stop();
    }

    var state = this.state;
    var pos = this.getPagePosition(e);

    var initPov = this._pano.getPov();

    state.initPos = pos;
    state.isTouchDown = true;
    state.initHeading = initPov.heading;
    state.initPitch = initPov.pitch;
    state.startTime = getNow();

    this._pano.dispatchEvent(EVENT_TYPE.TOUCH_START, e);
  }
  /**
   * 手势移动事件
   * @param {Event} e - 事件参数
   */
  ;

  _proto.handleMove = function handleMove(e) {
    if (!this.state.isTouchDown) {
      return;
    }

    this.state.isTouchMove = true;
    var diffPos = this.calcDiffPos(this.state.initPos, this.getPagePosition(e));
    this.setPov(diffPos);
    this.state.moveDiffPos = diffPos;
    this.state.lastDiffPos = diffPos;
    this.state.lastMoveTime = getNow();
    e.preventDefault();
    e.stopPropagation();
  }
  /**
   * 手势抬起事件
   * @param {Event} e - 事件参数
   */
  ;

  _proto.handleUp = function handleUp(e) {
    var _this2 = this;

    if (!this.state.isTouchDown) {
      return;
    }

    var checker = true;
    var pos = this.getPagePosition(e); // 挂载到手势事件中，方便使用

    e.pos = pos;
    this.state.isTouchDown = false;

    this._pano.dispatchEvent(EVENT_TYPE.TOUCH_END, e); // 各个子render暴露一个点击事件的checker 用来判断是否响应点击
    // 比如 linkRender 箭头的点击自行判断等...


    if (this._pano.renders.length) {
      for (var i = 0; i < this._pano.renders.length; i++) {
        var render = this._pano.renders[i];

        if (render.clickChecker) {
          checker = render.clickChecker(pos.x, pos.y); // 有命中直接跳出
          // TODO: 需要考虑renders的顺序

          if (!checker) {
            e.stopPropagation();
            break;
          }
        }
      }
    } // checker为false 表示命中了某些点击判断 比如overlay


    if (checker === false) {
      return;
    }

    if (!this.state.isTouchMove) {
      e.stopPropagation();

      if (!this.clickTimer) {
        var dblclickDelay = 300; // 双击事件中两次点击的间隔阈值

        this.clickTimer = setTimeout(function () {
          _this2.clickTimer = null; // 派发 onclick 事件

          _this2._pano.dispatchEvent(EVENT_TYPE.CLICK, e);
        }, dblclickDelay);
      } else {
        clearTimeout(this.clickTimer);
        this.clickTimer = null; // 派发 dblclick 事件

        this._pano.dispatchEvent(EVENT_TYPE.DOUBLE_CLICK, e);
      }
    } else {
      this.state.isTouchMove = false;
      this.processMotion(e);
    }
  }
  /**
   * 设置全景视角
   * @param {Object} diffPos - 位移差
   * @param {number} diffPos.x - 水平方向位移差
   * @param {number} diffPos.y - 垂直方向位移差
   */
  ;

  _proto.setPov = function setPov(_ref) {
    var diffX = _ref.x,
        diffY = _ref.y;
    var diffH = -diffX * this._anglePerPixel;
    var diffP = diffY * this._anglePerPixel;
    var newH = this.state.initHeading + diffH;
    var newP = this.state.initPitch + diffP;

    this._pano.setPov({
      heading: newH,
      pitch: newP
    });
  }
  /**
   * 处理惯性效果
   * @TODO: 惯性效果待优化
   *
   * @param {DomEvent} e - 手势事件信息
   */
  ;

  _proto.processMotion = function processMotion(e) {
    var _this3 = this;

    var state = this.state;
    var touchEndTime = getNow();
    var timeDiff = touchEndTime - state.lastMoveTime;
    var _state$moveDiffPos = state.moveDiffPos,
        moveDiffX = _state$moveDiffPos.x,
        moveDiffY = _state$moveDiffPos.y;
    var canMove = timeDiff < 300 && (Math.abs(moveDiffX) > 10 || Math.abs(moveDiffY) > 10);

    if (!canMove) {
      // 没有惯性效果
      this._pano.dispatchEvent({
        type: EVENT_TYPE.POV_CHANGED_END
      });

      return;
    }

    var diffPos = this.calcDiffPos(this.state.initPos, this.getPagePosition(e)); // 惯性距离计算

    var s1 = Math.sqrt(Math.pow(diffPos.x, 2) + Math.pow(diffPos.y, 2));
    var t1 = touchEndTime - state.startTime;
    var A = 0.008; // 摩擦系数

    var s2 = 2 * s1 / (A * t1); // 惯性距离
    // 计算移动距离和移动方向

    var dir = [diffPos.x > 0 ? 1 : -1, diffPos.y > 0 ? 1 : -1];
    var dx = Math.abs(diffPos.x);
    var dy = Math.abs(diffPos.y);
    var r = Math.atan2(dy, dx); // 在x y方向上分解惯性位移

    var moveX = Math.cos(r) * s2;
    var moveY = Math.sin(r) * s2;
    var restTime = 400; // 惯性动画时间

    if (dir[0] === -1) {
      moveX = -moveX;
    }

    if (dir[1] === -1) {
      moveY = -moveY;
    }

    if (this.dragAni) {
      this.dragAni.stop();
    } // 将touchend时的视角 作为 初始视角


    var _this$_pano$getPov = this._pano.getPov(),
        heading = _this$_pano$getPov.heading,
        pitch = _this$_pano$getPov.pitch;

    state.initHeading = heading;
    state.initPitch = pitch;

    var easingFn = function easingFn(t) {
      return t * 0.3125 - 0.15625 * t * t;
    };

    this.dragAni = new Tween(0, 1, restTime, easingFn).onUpdate(function (s) {
      s = s * 6.4; // s * (4 * u) / (rv * rv);

      var diffX = s * moveX;
      var diffY = s * moveY;

      _this3.setPov({
        x: diffX,
        y: diffY
      });
    }).onEnd(function () {
      _this3.dragAni = null;

      _this3._pano.dispatchEvent({
        type: EVENT_TYPE.POV_CHANGED_END
      });
    }).startAndAutoUpdate();
  };

  _proto.calcDiffPos = function calcDiffPos(prePos, pos) {
    if (!prePos || !pos) {
      return {
        x: 0,
        y: 0
      };
    }

    return {
      x: pos.x - prePos.x,
      y: pos.y - prePos.y
    };
  };

  return PanoOperation;
}();

/**
 * @file 全局事件派发模块
 * @author quda
 */

var EventManager =
/*#__PURE__*/
function () {
  function EventManager(pano) {
    /**
     * 全景实例
     * @private
     */
    this.pano = pano;
    /**
     * 全景缩放级别的上一值
     * 用于场景缩放动画
     * 初始值为场景级别初始值
     * @private
     */

    this.preZoom = pano.getZoom();
    /**
     * 场景缩放动画实例
     * @private
     */

    this.zoomChangeAni = null;
    /**
     * 调试开关, 供开发模式下使用
     * @private
     * @type {boolean}
     */

    this.debug = false;
    /**
     * 服务锁，防止同时多次触发setID导致的异常
     * @private
     * @type {boolean}s
     */

    this.panoServiceLock = false;
    this.bindEvent();
    this.initModule();
    this.initResize();
    this.handleContextStatus();
  }
  /**
   * 初始化依赖模块
   * @private
   */


  var _proto = EventManager.prototype;

  _proto.initModule = function initModule() {
    var p = this.pano;
    this.panoService = new PanoService(p);
    this.panoGLRender = new PanoGLRender(p);
    this.op = new PanoOperation(p);
  }
  /**
   * 容器尺寸监听事件
   * 优先使用观察者API
   */
  ;

  _proto.initResize = function initResize() {
    var _this = this;

    var oldSize = this.pano.getContainerSize();
    var $container = this.pano.getContainer();

    var handleChange = function handleChange(width, height) {
      // 在SPA场景下多个使用全景的页面组件切换时，会触发resize事件，接收为(0,0)，影响全景绘制
      if (!width || !height) {
        return;
      }

      var newSize = new Size(width, height);

      if (!newSize.equals(oldSize)) {
        _this.pano.dispatchEvent({
          type: EVENT_TYPE.SIZE_CHANGED
        });

        oldSize = newSize;
      }
    }; // 优先使用Observer API


    if (typeof window.ResizeObserver !== 'undefined') {
      var ro = new window.ResizeObserver(function (entries) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var entry = _step.value;
            var $target = entry.target;
            handleChange($target.clientWidth, $target.clientHeight);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }); // 观察全景容器

      ro.observe($container);
      this.resizeOb = ro;
    } else {
      this.checkSizeTimer = setInterval(function () {
        handleChange($container.clientWidth, $container.clientHeight);
      }, 80);
    }
  }
  /**
   * 监听全景实例事件
   * @private
   */
  ;

  _proto.bindEvent = function bindEvent() {
    var _this2 = this;

    var p = this.pano;
    p.on(EVENT_TYPE.PANO_ERROR, function () {
      _this2.panoServiceLock = false;
    });
    p.on(EVENT_TYPE.DATA_LOADED, function (e) {
      _this2.panoServiceLock = false; // 注意执行顺序

      if (e.options && e.options.animation) {
        p.backupUseAnimation = p.useAnimation;
        p.useAnimation = e.options.animation;

        if (e.options.animationType !== '') {
          p.animationType = e.options.animationType;
        }
      }

      _this2.panoGLRender.setData(e.data);

      _this2.op.init();
    });
    p.on(EVENT_TYPE.SET_POV, function (_ref) {
      var pov = _ref.pov,
          _ref$options = _ref.options,
          options = _ref$options === void 0 ? {
        animation: true
      } : _ref$options;
      var useAnimation = options.animation; // 动画时不执行

      if (!_this2.panoGLRender.isCanUpdate) {
        return;
      }

      var handlePovChange = function handlePovChange(newPov) {
        var isPovChange = p.handlePovChange(newPov);

        if (isPovChange) {
          _this2.panoGLRender.updateCameraHeadingAndPitch(p.camera);

          _this2.panoGLRender.update();

          p.dispatchEvent(EVENT_TYPE.POV_CHANGED, newPov);
        }
      };

      if (!useAnimation) {
        handlePovChange(pov);
        return;
      }

      var _p$getPov = p.getPov(),
          preHeading = _p$getPov.heading,
          prePitch = _p$getPov.pitch;

      var diffHeading = pov.heading - preHeading;
      var diffPitch = pov.pitch - prePitch;
      var duration = 400; // 移动动画时长

      if (diffHeading > 180) {
        preHeading += 360;
        diffHeading = pov.heading - preHeading;
      } else if (diffHeading < -180) {
        preHeading -= 360;
        diffHeading = pov.heading - preHeading;
      }

      var povAni = new Tween(0, 1, duration, Transitions['ease-out']).onUpdate(function (value) {
        handlePovChange({
          heading: preHeading + value * diffHeading,
          pitch: prePitch + value * diffPitch
        });
      }).onEnd(function () {
        povAni = null;
      }).startAndAutoUpdate();
    });
    p.on(EVENT_TYPE.ZOOM_CHANGED, function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // 动画时不执行
      if (!_this2.panoGLRender.isCanUpdate) {
        return;
      }

      var preZoom = _this2.preZoom;
      var targetZoom = p.getZoom();

      if (preZoom !== targetZoom) {
        var noAnimation = e.noAnimation || false;

        if (_this2.zoomChangeAni) {
          _this2.zoomChangeAni.stop();

          _this2.zoomChangeAni = null;
        }

        if (noAnimation) {
          // 无缩放动画，直接更新
          _this2.op.updateAnglePerPixel();

          _this2.panoGLRender.updateProjectionMatrix(p.camera);

          _this2.panoGLRender.update();

          _this2.preZoom = targetZoom;
          return;
        }

        var duration = 400; // 缩放动画时长

        _this2.zoomChangeAni = new Tween(preZoom, targetZoom, duration, Transitions.easeOutCubic).onUpdate(function (zoom) {
          _this2.panoGLRender.updateProjectionMatrix(p.camera, zoom);

          _this2.panoGLRender.update(zoom);
        }).onEnd(function () {
          _this2.zoomChangeAni = null;
          _this2.preZoom = targetZoom;
        }).startAndAutoUpdate();
      }
    });
    p.on(EVENT_TYPE.DOUBLE_CLICK, function () {
      // 动画时不执行
      if (!_this2.panoGLRender.isCanUpdate) {
        return;
      }

      if (plat.isMobile) {
        var curZoom = p.getZoom();

        if (curZoom === 3) {
          p.setZoom(2);
        } else {
          p.setZoom(3);
        } // TODO: 暂时不对外暴露
        // p.dispatchEvent({
        //     type: 'ondblclickzoomend'
        // });

      }
    });
    /**
     * 刷新页面视图
     */

    p.on(EVENT_TYPE.REFRESH, function (e) {
      var duration = e.duration || 200;

      _this2.panoGLRender.startRenderThread(duration);

      if (_this2.debug && e.log && e.debug) {
        console.warn(e.log);
      }
    });
    p.on(EVENT_TYPE.SET_ID, function (e) {
      if (!_this2.panoServiceLock && e.id) {
        _this2.panoServiceLock = true;

        _this2.panoService.getPanoById(e.id); // this.panoGLRender.reset();

      }
    });
    p.on(EVENT_TYPE.SIZE_CHANGED, function () {
      _this2.op.updateAnglePerPixel();

      _this2.panoGLRender.resize();

      _this2.panoGLRender.updateProjectionMatrix(p.camera);

      _this2.panoGLRender.update();
    });
    p.on(EVENT_TYPE.THUMB_LOADED, function () {
      _this2.panoGLRender.onThumbLoaded();

      _this2.panoGLRender.update();
    });
    p.on(EVENT_TYPE.OVERLAY_ADD, function (overlay) {
      _this2.panoGLRender.overlayManager.handleAdd(overlay);
    });
    p.on(EVENT_TYPE.OVERLAY_REMOVE, function (overlay) {
      _this2.panoGLRender.overlayManager.handleRemove(overlay);
    });
    p.on(EVENT_TYPE.OVERLAYS_CLEAR, function () {
      _this2.panoGLRender.overlayManager.destroy();
    });
    p.on(EVENT_TYPE.LINK_VISIBLE_CHANGE, function (e) {
      if (typeof e.value === 'boolean') {
        _this2.panoGLRender.safeCall('PanoLinkRender', 'setVisible', [e.value]);

        _this2.pano.dispatchEvent(EVENT_TYPE.REFRESH);
      }
    });
    p.on(EVENT_TYPE.DESTROY, function () {
      _this2.op.destroy();

      _this2.resizeOb && _this2.resizeOb.disconnect();
      _this2.checkSizeTimer && clearInterval(_this2.checkSizeTimer);

      _this2.panoGLRender.renderer.forceContextLoss(); // 全景销毁，移除监听 contextlost 事件监听


      p.canvas.removeEventListener('webglcontextlost', _this2.onWebGLContextLost, false); // this.panoGLRender.renderer = null;
      // this.pano.getContainer().removeChild(this.pano._svContainer);
    });
  }
  /**
   * 获取当前图片级别
   * @return {number} - 当前图片级别
   */
  ;

  _proto.getImgZoom = function getImgZoom() {
    var _this$pano$calcDispla = this.pano.calcDisplayZoom(),
        imgZoom = _this$pano$calcDispla.imgZoom;

    return imgZoom;
  }
  /**
   * 主动监听context lost事件
   * @private
   */
  ;

  _proto.handleContextStatus = function handleContextStatus() {
    var canvas = this.pano.canvas;
    canvas.addEventListener('webglcontextlost', this.onWebGLContextLost, false);
  };

  _proto.onWebGLContextLost = function onWebGLContextLost(e) {
    e.preventDefault(); // 暂时用刷新的方法解决

    setTimeout(function () {
      window.location.reload();
    }, 200);
  };

  return EventManager;
}();

var Pano =
/*#__PURE__*/
function (_Events) {
  inheritsLoose(Pano, _Events);

  /**
   * 当前全景数据
   * @type {PanoramaData | null}
   */

  /**
   * 全局配置项
   * @private
   */

  /**
   * 是否开启场景切换动画，默认关闭
   * @type {boolean}
   */

  /**
   * 用于setId & dataload 手动干预动画时 临时存储全局动画开关
   * @TODO: 待优化
   * @hidden
   */

  /**
   * 用户设置的场景切换动画类型（优先级最高）
   * 只有useAnimation为true时生效
   * 只能由setId方法和dataLoad事件干预，每次动画结束后重置
   * @type {string} - "waterwave" | "fade"
   */

  /**
   * 是否开启鱼眼入场动画，默认关闭
   * @type {boolean}
   */

  /**
   * 全景canvas画布dom元素
   */

  /**
   * 相机实例
   */

  /**
   * 渲染器实例
   */

  /**
   * 挂载常用全局变量，便于获取
   */
  // 渲染器集合 TODO: 类型优化

  /**
   * 外层容器
   * @readonly
   */

  /**
   * 全景视角
   * @private
   */

  /**
   * 当前全景pid
   * @private
   * @TODO: unussed
   */

  /**
   * 当前全景坐标
   * @private
   * @TODO: unussed
   */

  /**
   * 全景级别，默认为2级
   */

  /**
   * 用于缓存calcDisplayZoom的计算结果
   */

  /**
   * 全景DOM容器
   */

  /**
   * 全景事件派发模块实例
   */

  /**
   * 全景内部各个层
   * tile层，zindex为1
   * mask层，zindex为2
   * links层，zindex为3
   * overlay层，zindex为4
   * effect层，zindex为5
   */
  function Pano(_container2, opts) {
    var _this;

    _this = _Events.call(this) || this; // 与ConstantConfig.js 结合，配合白名单对外暴露可配置项

    _this.panoData = null;
    _this.opts = void 0;
    _this.useAnimation = false;
    _this.backupUseAnimation = _this.useAnimation;
    _this.animationType = '';
    _this.fisheye = false;
    _this.canvas = void 0;
    _this.camera = void 0;
    _this.renderer = void 0;
    _this.gl = void 0;
    _this.scene = void 0;
    _this.cameraNoFix = void 0;
    _this.renders = void 0;
    _this._container = void 0;
    _this._pov = {
      heading: 0,
      pitch: 0
    };
    _this._id = null;
    _this._position = null;
    _this._zoom = 2;
    _this._displayZoomResultsCache = {};
    _this._svContainer = void 0;
    _this._eventManager = void 0;
    _this._panes = void 0;

    _this.getContainer = function () {
      return _this._container;
    };

    _this.getContainerSize = function () {
      var container = _this._container;
      return new Size(container.clientWidth, container.clientHeight);
    };

    _this.getPanes = function () {
      return _this._panes;
    };

    _this.show = function () {
      dom.show(_this._svContainer);
    };

    _this.hide = function () {
      dom.hide(_this._svContainer);
    };

    _this.getZoom = function () {
      return _this._zoom;
    };

    _this.setZoom = function (zoom) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (zoom === _this._zoom) {
        return;
      }

      if (zoom > ConstantConfig.MAX_ZOOM) {
        zoom = ConstantConfig.MAX_ZOOM;
      }

      if (zoom < ConstantConfig.MIN_ZOOM) {
        zoom = ConstantConfig.MIN_ZOOM;
      }

      if (zoom !== _this._zoom) {
        _this._zoom = zoom;

        _this.dispatchEvent(EVENT_TYPE.ZOOM_CHANGED, {
          noAnimation: options.noAnimation || false
        });
      }
    };

    _this.getPov = function () {
      return _this._pov;
    };

    _this.setPov = function (pov, options) {
      _this.dispatchEvent(EVENT_TYPE.SET_POV, {
        pov: pov,
        options: options || {
          animation: false
        }
      });
    };

    _this.handlePovChange = function (pov) {
      if (_typeof_1(pov) !== 'object') {
        return;
      }

      var isPovChange = false;
      var heading = pov.heading,
          pitch = pov.pitch;

      if (typeof heading === 'number' && !isNaN(heading)) {
        isPovChange = true;
        heading = degreeNormalized(heading);
        _this._pov.heading = heading;
      }

      if (typeof pitch === 'number' && !isNaN(heading)) {
        isPovChange = true;
        var minAngle = _this.opts.minPitch;
        var maxAngle = _this.opts.maxPitch;

        if (pitch > maxAngle) {
          pitch = maxAngle;
        }

        if (pitch < minAngle) {
          pitch = minAngle;
        }

        _this._pov.pitch = pitch;
      }

      return isPovChange;
    };

    _this.calcDisplayZoom = function (containerSize, zoom) {
      containerSize = containerSize || _this.getContainerSize();
      zoom = zoom || _this.getZoom();
      var _containerSize = containerSize,
          width = _containerSize.width,
          height = _containerSize.height;
      var TILE_MAX_ZOOM = _this.opts.maxImageZoom;
      var TILE_MIN_ZOOM = _this.opts.minImageZoom;
      var key = "".concat(width, "_").concat(height, "_").concat(zoom); // TODO: 目前用于外部调用做缓存

      if (_this._displayZoomResultsCache[key]) {
        return _this._displayZoomResultsCache[key];
      }

      var imgZoomAdd = 2;

      var anglePerPixel = _this.calcAnglePerPixel(); // 找一个合适的图片级别


      var imageZoom = Math.floor(zoom) + imgZoomAdd;
      var tileSize = 360 / (Math.pow(2, imageZoom - 2) * 2 * anglePerPixel);

      while (tileSize > 512) {
        imageZoom++;
        tileSize = 360 / (Math.pow(2, imageZoom - 2) * 2 * anglePerPixel);
      } // TODO: 考虑网络因素 是否要对图片级别有影响


      if (imageZoom > TILE_MAX_ZOOM) {
        var diff = imageZoom - TILE_MAX_ZOOM;
        tileSize = tileSize * Math.pow(2, diff);
        imageZoom = TILE_MAX_ZOOM;
      }

      if (imageZoom < TILE_MIN_ZOOM) {
        imageZoom = TILE_MIN_ZOOM;
      }

      tileSize = Math.round(tileSize);
      var result = {
        imgZoom: imageZoom,
        displayTileSize: tileSize
      };
      _this._displayZoomResultsCache[key] = result;
      return result;
    };

    _this.calcAnglePerPixel = function () {
      // const {width, height} = this.getContainerSize();
      // const zoom = this.getZoom();
      // const displayView = 240 / Math.pow(2, zoom);
      // // TODO: 此处逻辑有疑问
      // const aspect = width / height;
      // let displayWidth;
      // if (aspect < 1) {
      //     displayWidth = width;
      // } else {
      //     displayWidth = height;
      // }
      var fovy = _this.getFov();

      var anglePerPixel = fovy / _this.getContainerSize().height;

      return anglePerPixel;
    };

    _this.getFov = function (viewZoom) {
      viewZoom = viewZoom || _this.getZoom();
      var calcFn = plat.isMobile ? _this.calcMobileFovy : _this.calcPCFovy;
      return calcFn.call(assertThisInitialized(_this), viewZoom);
    };

    _this.setId = function (id) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _this.useAnimation = options.animation || false;
      _this.fisheye = options.fisheye || false;
      _this.animationType = options.animationType || '';

      _this.dispatchEvent(EVENT_TYPE.SET_ID, {
        id: id
      });
    };

    var defaultOpts = {
      minImageZoom: ConstantConfig.TILE_MIN_ZOOM,
      maxImageZoom: ConstantConfig.TILE_MAX_ZOOM,
      minPitch: ConstantConfig.MIN_PITCH,
      maxPitch: ConstantConfig.MAX_PITCH,
      radius: ConstantConfig.RADIUS,
      tileBaseUrls: ConstantConfig.TILE_BASE_URLS,
      linksControl: true,
      enableCapture: false
    }; // TODO: 可以加一步参数校验的流程

    _this.opts = Object.assign({}, defaultOpts, opts);

    var _container = typeof _container2 === 'string' ? document.querySelector(_container2) : _container2;

    if (!_container) {
      throw new Error('全景引擎宿主容器不存在');
    }

    _this._container = _container;

    _this._init();

    return _this;
  }
  /**
   * 瓦片图展示层级
   * @type {number}
   */


  var _proto = Pano.prototype;

  /**
   * 设置全局配置项
   * @public
   * @category 全景控制
   *
   * @param {Object} options 配置项
   */
  _proto.setOptions = function setOptions(options) {
    var option;

    for (option in options) {
      if (Object.prototype.hasOwnProperty.call(options, option)) {
        var valueChanged = true;

        if (_typeof_1(options[option]) !== 'object') {
          valueChanged = options[option] !== this.opts[option];
        }

        this.opts[option] = options[option];

        if (!valueChanged) {
          continue;
        }

        switch (option) {
          case 'linksControl':
            this.dispatchEvent(EVENT_TYPE.LINK_VISIBLE_CHANGE, {
              value: options[option]
            });
            break;
        }
      }
    }
  }
  /**
   * 将当前全景内容截图
   * @public
   * @category 全景控制
   *
   * @param {Object} [options] 配置参数
   * @param {number} options.quality - 截图质量,取值 0 到 1 之间, 默认0.8
   * @param {string} options.type - 图片格式(MIME 类型), image/jpeg | image/png, 默认为 image/jpeg
   * @return {Data URLs} - 截图的base64字符串, 格式参考https://developer.mozilla.org/zh-CN/docs/Web/HTTP/data_URIs
   */
  ;

  _proto.capture = function capture() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!this.canvas) {
      return;
    }

    var glCanvas = this.canvas;
    var quality = options.quality || .8;
    var type = options.type || 'image/jpeg';
    var captureImageStr = glCanvas.toDataURL(type, quality);
    return captureImageStr;
  }
  /**
   * 添加覆盖物
   * @category 全景控制
   *
   * @param {PanoOverlay} overlay - 覆盖物
   */
  ;

  _proto.addOverlay = function addOverlay(overlay) {
    this.dispatchEvent(EVENT_TYPE.OVERLAY_ADD, overlay);
  }
  /**
   * 删除覆盖物
   * @category 全景控制
   *
   * @param {PanoOverlay} overlay - 覆盖物
   */
  ;

  _proto.removeOverlay = function removeOverlay(overlay) {
    this.dispatchEvent(EVENT_TYPE.OVERLAY_REMOVE, overlay);
  }
  /**
   * 清除所有的覆盖物
   * @category 全景控制
   */
  ;

  _proto.clearOverlays = function clearOverlays() {
    this.dispatchEvent(EVENT_TYPE.OVERLAYS_CLEAR);
  }
  /**
   * 销毁全景 WebGL 上下文, 避免频繁创建新地图实例会导致浏览器报： too many WebGL context 的警告,
   * 同时会释放当前全景实例所占用的资源,
   * 请慎用!!!
   * @public
   * @category 全景控制
   */
  ;

  _proto.destroy = function destroy() {
    this.dispatchEvent(EVENT_TYPE.DESTROY);
  }
  /**
   * 创建dom，初始化其他模块
   */
  ;

  _proto._init = function _init() {
    // 创建容器
    this._createDoms(); // 初始化全局事件模块
    // _eventManager is unused


    this._eventManager = new EventManager(this);
  }
  /**
   * 初始化全景容器
   * @private
   */
  ;

  _proto._createDoms = function _createDoms() {
    var container = this._container;
    var svContainer = dom.create('div');
    var s = svContainer.style;
    s.overflow = 'hidden';
    s.position = 'absolute';
    s.zIndex = '20';
    s.top = s.left = '0px';
    s.height = s.width = '100%';
    s.backgroundColor = '#e5e3df';
    this._svContainer = svContainer;
    this._panes = {
      tileLayer: this._createContainer('1'),
      maskLayer: this._createContainer('2'),
      linksLayer: this._createContainer('3'),
      overlayLayer: this._createContainer('4'),
      effectLayer: this._createContainer('5')
    };
    svContainer.appendChild(this._panes.tileLayer);
    svContainer.appendChild(this._panes.linksLayer);
    svContainer.appendChild(this._panes.overlayLayer);
    svContainer.appendChild(this._panes.effectLayer);

    if (!isSupportWebGL()) {
      svContainer.appendChild(this._panes.maskLayer);
      this._panes.maskLayer.style.width = "".concat(container.clientWidth, "px");
      this._panes.maskLayer.style.height = "".concat(container.clientHeight, "px");
      this._panes.maskLayer.style.overflow = 'hidden';
    }

    container.appendChild(svContainer);

    if (dom.getCurrentStyle(container).position !== 'absolute') {
      container.style.position = 'relative';
    }
  }
  /**
   * 创建pano容器的DOM元素
   * @private
   *
   * @param {string} zIndex 需要设置的container的z-index值
   * @return {Object} pano容器
   */
  ;

  _proto._createContainer = function _createContainer(zIndex) {
    var div = dom.create('div');
    var style = div.style;
    style.position = 'absolute';
    style.top = style.left = '0';
    style.zIndex = zIndex || '0';
    return div;
  }
  /**
   * 移动端根据屏幕宽高计算fovy
   * @private
   * @param {number} viewZoom - 场景级别
   * @return {number} - fovy
   */
  ;

  _proto.calcMobileFovy = function calcMobileFovy(viewZoom) {
    var _this$getContainerSiz = this.getContainerSize(),
        width = _this$getContainerSiz.width,
        height = _this$getContainerSiz.height;

    var displayView = 240 / Math.pow(2, viewZoom);
    var d = width / 2 / Math.tan(degToRad(displayView / 2)); // 视距

    var f = Math.atan2(height / 2, d); // Y方向视角一半的弧度制

    var fovy = radToDeg(f) * 2;
    return fovy;
  }
  /**
   * PC端根据屏幕尺寸计算效果不好，采用固定级别
   * @private
   * @param {number} viewZoom - 场景级别
   * @return {number} - fovy
   * zoom ~ fovy:
   * 1 => 90
   * 2 => 75
   * 3 => 60
   * 4 => 45
   */
  ;

  _proto.calcPCFovy = function calcPCFovy(viewZoom) {
    var baseFovy = 90;
    var FOV_ZOOM_STEP = 15;
    return baseFovy - (viewZoom - 1) * FOV_ZOOM_STEP;
  };

  createClass(Pano, [{
    key: "imageZoom",
    get: function get() {
      return this.calcDisplayZoom().imgZoom;
    }
    /**
     * 当前全景ID
     * @type {string}
     */

  }, {
    key: "panoId",
    get: function get() {
      return this.panoData ? this.panoData.panoId : '';
    }
    /**
     * 当前全景指北角
     * @type {number}
     */

  }, {
    key: "panoNorthDir",
    get: function get() {
      return this.panoData ? this.panoData.northDir : 0;
    }
    /**
     * 当前全景墨卡托坐标
     * @type {Point | null}
     */

  }, {
    key: "position",
    get: function get() {
      if (this.panoData && typeof this.panoData.panoX === 'number' && typeof this.panoData.panoY === 'number') {
        return new Point(this.panoData.panoX, this.panoData.panoY);
      }

      return null;
    }
    /**
     * 获取pano容器dom对象
     * @public
     * @category 信息获取
     * @return {Object} pano容器
     */

  }]);

  return Pano;
}(EventEmitter);

var DefaultOptions = {
  /**
   * 覆盖物dom节点
   */
  dom: null,
  // imageUrl: '', // 图片url

  /**
   * 锚定位置
   * 默认居中对齐
   */
  anchor: null,

  /**
   * 覆盖物宽度
   */
  width: null,

  /**
   * 覆盖物高度
   */
  height: null,

  /**
   * 海拔
   */
  altitude: 2,

  /**
   * altitude 和 sphereZ 都用来控制高度，当有 sphereZ 出现时则不用altitude
   */
  sphereZ: null,

  /**
   * 使用uv坐标方式
   */
  useUV: false
};

var PanoOverlay =
/*#__PURE__*/
function (_Event) {
  inheritsLoose(PanoOverlay, _Event);

  /**
   * 是否展示覆盖物
   * @private
   * @type {boolean}
   */

  /**
   * 覆盖物对应的空间坐标
   * @private
   * @type {Vec3}
   */

  /**
   * 覆盖物位于全景图中的视角信息
   * @private
   * @type {null | POV}
   */
  function PanoOverlay(position) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _this = _Event.call(this) || this;
    _this.visible = true;
    _this.worldCoord = void 0;
    _this.pov = void 0;
    _this.id = _this.genId();
    _this._pano = void 0;
    _this.initialized = false;
    _this.position = void 0;
    _this.options = void 0;
    _this.position = position;
    _this.options = Object.assign({}, DefaultOptions, options);
    /**
     * 覆盖物位于全景图中的视角信息
     * @private
     * @type {null | POV}
     */

    _this.pov = null;
    return _this;
  }

  var _proto = PanoOverlay.prototype;

  /**
   * 获取覆盖物位于全景图中的视角信息
   * @public
   * @return {POV} - {heading, pitch}
   */
  _proto.getPov = function getPov() {
    return this.pov;
  }
  /**
   * 生成覆盖物id
   * @param {number} len - 随机数截取长度
   * @return {string} - id
   */
  ;

  _proto.genId = function genId() {
    var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
    return Number("".concat(Math.random().toString().substr(3, len)).concat(Date.now())).toString(36);
  }
  /**
   * 覆盖物初始化，供overlayMgr调用
   * @private
   * @param {Pano} pano - 全景实例
   */
  ;

  _proto.init = function init(pano) {
    if (!pano || this.initialized) {
      return;
    }

    this._pano = pano;
    this.worldCoord = this.options.useUV ? this.calcCoordsByUV() : this.calcCoordsByMC();

    if (this.worldCoord) {
      this.initialized = true;
      this.add();
      this.draw();
    }
  }
  /**
   * 通过墨卡托坐标计算覆盖物对应3D坐标
   * @private
   * @return {Vec3} - 3D坐标
   */
  ;

  _proto.calcCoordsByMC = function calcCoordsByMC() {
    var panoPosition = this._pano.position;

    if (!panoPosition || !this.position) {
      return;
    }

    var overlayPosition = this.position;
    var xDiff = overlayPosition.lng - panoPosition.lng;
    var yDiff = overlayPosition.lat - panoPosition.lat; // 计算与X轴正向夹角

    var phi = Math.atan2(xDiff, yDiff);

    if (phi < 0) {
      phi += 2 * Math.PI;
    } // 角度制的水平方向


    phi = Math.round(radToDeg(phi)); // 根据海拔，计算覆盖物对应球上纬度

    var heightInSphere; // 覆盖物所在球面的半径，不同分享源这个值不一样，在给定sphereZ的时候需要通过覆盖物的墨卡托进行计算
    // 这里仅用于计算角度，半径可以与球模型半径不一致

    var overlaySphereRadius = 500;
    var _this$options = this.options,
        sphereZ = _this$options.sphereZ,
        altitude = _this$options.altitude;

    if (sphereZ === null) {
      heightInSphere = altitude * 25;
    } else {
      heightInSphere = sphereZ || 0;
      overlaySphereRadius = Math.sqrt(Math.pow(xDiff, 2) + Math.pow(yDiff, 2) + Math.pow(heightInSphere, 2));
    } // 垂直角度


    var lat = radToDeg(Math.asin(heightInSphere / overlaySphereRadius));
    lat = lat > 90 ? 90 : lat < -90 ? -90 : lat; // 归一化
    // 修正后的水平方向

    var refinedPhi = degreeNormalized(phi + this._pano.panoNorthDir);
    var radius = this.radius; // TODO: 这里半径与球模型一致

    var base = Math.cos(degToRad(lat)) * radius; // xy平面上的投影

    base = Math.round(base * 100) / 100;
    var x = Math.cos(degToRad(refinedPhi)) * base;
    var y = Math.sin(degToRad(lat)) * radius;
    var z = Math.sin(degToRad(refinedPhi)) * base;
    this.pov = {
      heading: phi,
      pitch: lat
    };
    return fromValues$1(x, y, z);
  }
  /**
   * 通过UV坐标计算覆盖物对应3D坐标
   * @private
   * @return {Vec3} - 3D坐标
   */
  ;

  _proto.calcCoordsByUV = function calcCoordsByUV() {
    if (!this.position) {
      return;
    }

    var r = this.radius;

    var _ref = this.position,
        _ref2 = slicedToArray(_ref, 2),
        u = _ref2[0],
        v = _ref2[1];

    var h = u * 2 * Math.PI; // (0, 2π]

    var p = (v - 0.5) * Math.PI; // (-π/2, π/2]
    // this._lat = radToDeg(p);
    // this.angle = ApiUtil.toAngle(h) - 270; // 去除270

    var x = Math.cos(p) * Math.cos(h) * r;
    var y = Math.sin(p) * r;
    var z = Math.cos(p) * Math.sin(h) * r;
    this.pov = {
      heading: degreeNormalized(radToDeg(h) - this._pano.panoNorthDir),
      pitch: radToDeg(p)
    };
    return fromValues$1(x, y, z);
  }
  /**
   * 将dom元素添加到页面
   */
  ;

  _proto.add = function add() {
    var _this$options2 = this.options,
        width = _this$options2.width,
        height = _this$options2.height;

    if (this.dom) {
      var pano = this._pano;
      var dom = this.dom;
      dom.style.position = 'absolute';
      pano.getPanes().overlayLayer.appendChild(dom);

      if (typeof width !== 'number') {
        this.options.width = dom.clientWidth;
      }

      if (typeof height !== 'number') {
        this.options.height = dom.clientHeight;
      }

      pano.dispatchEvent({
        type: 'onoverlaydomadded',
        overlay: this
      });
    }
  }
  /**
   * 移除覆盖物
   */
  ;

  _proto.remove = function remove() {
    var dom = this.dom;

    if (dom && dom.parentNode) {
      dom.parentNode.removeChild(dom);
    }
  }
  /**
   * 根据当前街景视角和poi的角度，计算屏幕像素坐标，webgl渲染方式使用
   * @return {Vec2} - 坐标
   */
  ;

  _proto.povToPointGL = function povToPointGL() {
    if (!this.worldCoord) {
      return null;
    }

    var pano = this._pano;
    var camera = pano.camera;

    var _pano$getContainerSiz = pano.getContainerSize(),
        viewportWidth = _pano$getContainerSiz.width,
        viewportHeight = _pano$getContainerSiz.height;

    var pos = worldToViewport(camera, this.worldCoord, viewportWidth, viewportHeight);
    return pos;
  }
  /**
   * 渲染
   */
  ;

  _proto.draw = function draw() {
    if (!this.initialized || !this.visible || !this._pano || !this._pano.panoData || !this.dom) {
      return;
    }

    var dom = this.dom;
    var pos = this.povToPointGL();
    dom.style.visibility = 'hidden'; // 默认不显示

    if (pos) {
      var anchor = this.calcAnchor();
      var offsetX = "".concat(pos[0] - anchor.width, "px");
      var offsetY = "".concat(pos[1] - anchor.height, "px"); // 数据中可能存在脏数据

      if (isNaN(pos[0]) || isNaN(pos[1])) {
        return;
      }

      dom.style.visibility = 'visible'; // 此处用transform优化性能，消除抖动

      dom.style.webkitTransform = "translate(".concat(offsetX, ", ").concat(offsetY, ")");
      dom.style.transform = "translate(".concat(offsetX, ", ").concat(offsetY, ")");
    }
  }
  /**
   * 响应覆盖物点击
   */
  ;

  _proto.handleClick = function handleClick() {
    this.dispatchEvent('click');
  }
  /**
   * 计算定位锚点
   * @return {Size} - 锚点位移
   */
  ;

  _proto.calcAnchor = function calcAnchor() {
    var _this$options3 = this.options,
        anchor = _this$options3.anchor,
        _this$options3$width = _this$options3.width,
        width = _this$options3$width === void 0 ? 0 : _this$options3$width,
        _this$options3$height = _this$options3.height,
        height = _this$options3$height === void 0 ? 0 : _this$options3$height;

    if (anchor) {
      return anchor;
    }

    return new Size(width / 2, height / 2);
  }
  /**
   * 显示覆盖物
   * @public
   */
  ;

  _proto.show = function show() {
    this.visible = true;

    if (this.dom) {
      this.dom.style.display = '';
    }
  }
  /**
   * 隐藏覆盖物
   * @public
   */
  ;

  _proto.hide = function hide() {
    this.visible = false;

    if (this.dom) {
      this.dom.style.display = 'none';
    }
  };

  createClass(PanoOverlay, [{
    key: "radius",
    get: function get() {
      return this._pano ? this._pano.opts.radius : 0;
    }
  }, {
    key: "dom",
    get: function get() {
      return this.options.dom;
    }
  }]);

  return PanoOverlay;
}(EventEmitter);

var createDom = function createDom(content) {
  var costomStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var div = document.createElement('div');
  var inlineStyle = {
    backgroundColor: 'rgba(29, 29, 29, 0.8)',
    fontSize: '14px',
    padding: '7px 14px',
    height: '19px',
    color: '#fff',
    whiteSpace: 'nowrap',
    borderRadius: '4px'
  };
  extend(div.style, inlineStyle, costomStyle);
  div.innerText = content;
  return div;
};

var PanoLabel =
/*#__PURE__*/
function (_PanoOverlay) {
  inheritsLoose(PanoLabel, _PanoOverlay);

  function PanoLabel(content, _ref) {
    var position = _ref.position,
        _ref$altitude = _ref.altitude,
        altitude = _ref$altitude === void 0 ? 2 : _ref$altitude,
        _ref$costomStyle = _ref.costomStyle,
        costomStyle = _ref$costomStyle === void 0 ? {} : _ref$costomStyle;
    var dom = createDom(content, costomStyle);
    return _PanoOverlay.call(this, position, {
      dom: dom,
      altitude: altitude
    }) || this;
  }

  return PanoLabel;
}(PanoOverlay);

/**
 * @file 获取街景路网图层
 * @author quda
 */

/**
 * 获取街景路网图层
 * @param {BMap} BMap - 地图API
 * @return {TileLayer} - 供底图引擎渲染的全景路网TileLayer
 */
function getStreetViewCoverageLayer(BMap) {
  var streetViewCoverageLayerHosts = ['//mapsv0.bdimg.com/tile/', '//mapsv1.bdimg.com/tile/'];

  function getUDT() {
    // return getTileVersion('ditu', 'panoUdt').udt;
    return '20150114';
  }

  var vectorTilelayer = new BMap.TileLayer({
    transparentPng: true,
    dataType: 1,
    // 1表示栅格
    cacheSize: 32
  });
  vectorTilelayer.zIndex = 110; // point为图块坐标，level为图块的级别，当地图需要显示特定级别的特定位置的图块时就会自动调用此方法，并提供这两个参数。

  vectorTilelayer.getTilesUrl = function (tileCoords, zoom) {
    var style = 'pl';
    var index = (Math.abs(tileCoords.x) + Math.abs(tileCoords.y)) % streetViewCoverageLayerHosts.length;
    var url = "".concat(streetViewCoverageLayerHosts[index], "?udt=").concat(getUDT(), "&qt=tile&styles=").concat(style, "&x=").concat(tileCoords.x, "&y=").concat(tileCoords.y, "&z=").concat(zoom);
    return url.replace(/-(\d+)/gi, 'M$1');
  };

  return vectorTilelayer;
}

/**
 * @file 全景引擎主入口
 * @author quda
 * @module Pano
 */

/**
 * 全景引擎初始化方法
 * @param container - 全景容器（元素选择器 or DOM）
 * @param opts - 引擎配置项
 */
function init(container, opts) {
  return new Pano(container, opts);
}

export { Convert as Converters, index as Engines, EVENT_TYPE as EventType, PanoLabel, PanoOverlay, Point, getStreetViewCoverageLayer, init };
